function a0_0x1142() {
  const _0x16c358 = [
    "call",
    "coreVisionWorkerInstance",
    "RUNTIME_APP_CONFIG_ERROR",
    "extractFromDataUrl",
    "IVDU",
    "putImageData",
    "getFullBlob",
    "lowAmpleCount",
    "CAMERA_DISPLAY_STARTED",
    "getWindowDimensions",
    "currentAction",
    "ES\x20Modules\x20may\x20not\x20assign\x20module.exports\x20or\x20exports.*,\x20Use\x20ESM\x20export\x20syntax,\x20instead:\x20",
    "updateMibiSessionInfo",
    "appConfig",
    "loadWithGenerator",
    "EXIF_DATE_TIME_ORIGINAL_OFFSET",
    "directFrameData",
    "voice",
    "clearAllSDKIntegratorListeners",
    "RUNTIME_WINDOW_RESIZE_ERROR\x20",
    "RUNTIME_IMAGE_NORMALIZATION_ERROR",
    "getSettings",
    "debuggingRecognizedEvaluation",
    "getStreamFromGUM",
    "18idymAH",
    "decodeFromBufferToText",
    "hasAudioInput",
    "PermissionDeniedError",
    "SIGNED_DATA_NOT_FOUND",
    "_previousRecognizedData",
    "952RPOJJA",
    "imageHeight",
    "mitekSDKPath",
    "getActionTypeRecognizerSettings",
    "calculateNormalizedDimensions",
    "customVideoSourceContainerElement",
    "CV_FINAL_IMAGE_SIZE",
    "pauseRecording",
    "disablePerpendicularCapture",
    "RUNTIME_UNKNOWN_ERROR",
    "The\x20license\x20is\x20past\x20expiry\x20date.\x20Please\x20renew\x20license",
    "isIphone",
    "width",
    "snapshots",
    "MISL",
    "drawImage",
    "setWebGLCompileErrorListener",
    "SDK_START",
    "SDK_QUIT",
    "getCVResults",
    "mozCaptureStream",
    "load",
    "abs",
    "mwbScanner",
    "phrase",
    "_guidePaddingLevel",
    "extractionCompletedThrottleSpeedMs",
    "MFC",
    "setIcon",
    "callback",
    "PARAMETER_INVALID_VALUE",
    "_phrase",
    "_debugLevel",
    "getVoiceRuntimeGumError",
    "findStatusHintMessageKey",
    "setCurrentActionMibiDataPlatformPrivateRequestedGumCanvasDimension",
    "NO_ISSUE",
    "data-webpack",
    "mitekGuide",
    "forEach",
    "could\x20not\x20load\x20image",
    "startRecording",
    "activeRecordingDuration",
    "VALIDATOR_BAD_EXTERNAL_CMD_NAME",
    "warn",
    "guideElement",
    "documentTypeCodes",
    "_0xBCA5E1",
    "CLASS_SIZE_LEVELS",
    "createPhrseElement",
    "DEFAULT_MAX_SIDE_LENGTH",
    "_horizontalFill",
    "isSmileDetectionEnabled",
    "PERMISSIONS_NOT_MET",
    "onmessage",
    "mitekScienceSDK:",
    "Face",
    "camera2\x203,\x20facing\x20back",
    "voiceRecognizerModule",
    "decrypt",
    "MITEK_ERROR_TOO_DARK",
    "WEBGL_SHADER_NOT_SUPPORTED",
    "COMPONENT_PRELOAD",
    "30px\x20arial",
    ".mic-muted-line",
    "DL_FRONT",
    "extract",
    "normalizeImageDataAspectRatio",
    "VOICE_PROCESSING_STARTED",
    "hintForceUpdate",
    "_faceFailureCountByHintMessageKey",
    "DL_BACK",
    "detectGlare",
    "setSessionInfoWarnings",
    "generateSessionInfoFace",
    "INVALID_LICENSE",
    "getDimensionsFromPoints",
    "actionTypeRecognizerSettings",
    "_mode",
    "innerHTML",
    "transformer\x20should\x20not\x20default\x20to\x20anything\x20to\x20prevent\x20coding\x20mistakes.\x20When\x20logic\x20requirements\x20elsewhere\x20can\x20be\x20kind\x20of\x20hidden\x20if\x20no\x20error\x20pops\x20up.",
    "initializeStreamElementsAndListeners",
    "environment",
    "NORMAL_EXECUTION_ENDED",
    "Check_Back",
    "fourCornerB",
    "trunc",
    "seal",
    "find",
    "bytes",
    "replace",
    "neutralFacialExpressionRecognizedData",
    "fftSize",
    "VOICE_RECORDING_STARTED",
    "CAPTURE_USER_ABANDONMENT_TIMEOUT",
    "videoSource",
    "UNKNOWN_METHOD",
    "BarcodeType",
    "INVALID_DOCUMENT_TYPE",
    "hintMessageSize",
    "setCurrentActionMibiDataSessionInfoWarnings",
    "detectMRZ",
    "DEVICE_NOT_SUPPORTED",
    "setCurrentActionMibiDataSessionInfoFourCorners",
    "isForceNextEvaluationReturn",
    "GFIUEAM",
    "createAudioUIelements",
    "audioRecordingEnabled",
    "VALIDATOR_INVALID_LICENSE",
    "error\x20no\x20image\x20data",
    "floor",
    "indexOf",
    "returnCheckIntervalObject",
    "resize",
    "RUNTIME_SESSION_RECORDING_ERROR",
    "importKey",
    "barcodeWebLicense",
    "map",
    "object",
    "recorder\x20was\x20unable\x20to\x20stop",
    "sendVoiceProcessingStartedToIntegrator",
    "ENUMS",
    "_isStoppedReason",
    "landscape",
    "RUNTIME_GUM_ERROR_USER_MEDIA_NOT_SUPPORTED",
    "padStart",
    "setSessionInfoDocumentOrientation",
    "hasFeature",
    "RUNTIME_INTEGRATOR_LISTENER_CALLBACK_EXCEPTION",
    "RUNTIME_CONVERT_TO_DATAURL_FAILED",
    "error",
    "tiff",
    "fourCornerThreshold",
    "nets",
    "AppConfigObject:\x20unable\x20to\x20read\x20actionTypeRecognizerSettings\x20for\x20action\x20type\x20",
    "neutralFacialExpressionSnapshot",
    "RUNTIME_ENVIRONMENT_VALIDATOR_FAILED",
    "verifyMessage",
    "analyzerIntervalMs",
    "_box",
    "EVENT_SUBSCRIPTION_INTEGRATION_ERROR",
    "verify",
    "state",
    "adjustElementsAccordingToStream",
    "licenseType",
    "mrz",
    "div",
    "_0xD1024",
    "testFunc",
    "isGlobalExtractionTimeExpired",
    "getDataUrl",
    "init",
    "preloadDocuments",
    "getOwnPropertySymbols",
    "response",
    "CV_MEASURE_CONFIDENCE",
    "ALL",
    "currentRipples",
    "analyserFFTSize",
    "returnReadyIntervalMs",
    "logInternalError",
    "Web",
    "_frame",
    "top",
    "status",
    "hasFoundSmilingExpressionSnapshot",
    "-preload-documents",
    "PICTURE_CAPTURED",
    "isSuccess",
    "loaderFnGenerator",
    "_hasDetectedNeutralExpression",
    "isValidImageFileType",
    "SBVM",
    "INVALID_SIG_OR_DATES",
    "RUNTIME_GUM_ERROR_UNABLE_TO_GET_AUDIO_OR_STOP_DEVICE",
    "active",
    "importPrivateKey",
    "MEDIA_RECORDER_NOT_SUPPORTED",
    "INVALID_COMMAND_SIGNATURE",
    "webgl",
    "RUNTIME_RECOGNIZER_RESET_ERROR",
    "SDK_REMOVE_LISTENERS",
    "Current\x20license\x20does\x20not\x20provide\x20this\x20feature",
    "getEncryptedRTSSignals",
    "_MiSDK.DI",
    "IVDU2",
    "_videoRecordingEnabled",
    "head",
    "setAppConfigOnce",
    "context",
    "mitek-document-guide",
    "gEDS",
    "SUCCESS",
    "setFailureConditionFilters",
    "DataUrl",
    "freeze",
    "hintText",
    "Undefined",
    "isDefined",
    "invalid\x20recognized\x20data",
    "key",
    "pow",
    "VoiceFalkorRecognizer",
    "piexif",
    "CHECK_FRONT",
    "EXIF_USER_COMMENT_TAG",
    "isIdilingBeforeStartButton",
    "STATE_RECORDING",
    "customVideoSourceContainerElementId",
    "debase64AndDecryptMessage",
    "VALIDATOR_BAD_EVENT_NAME",
    "TOTAL_CV_TIME",
    "SDK_ERROR",
    "features",
    "app:extraction:audiorecorder",
    "getImageCenterPointFromRecognizedData",
    "encodeAsUint8Array",
    "RUNTIME_ERROR_EXTACTOR_FACTORY_MISSING_CASE",
    "getCVThresholds",
    "MIBI_DOCUMENT_TYPE_BY_ACTION_TYPE",
    "loggingValues",
    "ImageData",
    "glareLeft",
    "setBackend",
    "navigator",
    "FFC",
    "loading",
    "nonce",
    "isFileFoundFromUrl",
    "Time\x20flies\x20when\x20you\x27re\x20having\x20fun.",
    "exposure",
    "snapshot",
    "MITEK_ERROR_HORIZONTAL_FILL",
    "failure",
    "NO_CAMERA_FOUND",
    "getErrorManagedCallback",
    "vnx",
    "mitek-center-offset",
    "classNameForVideoSourceElement",
    "aria-live",
    "goodAmplCount",
    "clearRect",
    "VALIDATOR_MIN_IMAGE_SIZE",
    "isInternalDebuggerEnabled",
    "SHOW_HINT",
    "guidePaddingLevel",
    "audio/wave",
    "CV_ERROR_CONFIDENCE",
    "isValidAspectRatio",
    "apply",
    "shouldNotPerformSmileLivenessCheck",
    "A\x20barcode\x20license\x20was\x20not\x20found",
    "getSha256fromBase64DataUrl",
    "CV_IMAGE_HEIGHT",
    "RUNTIME_ACTION_CONTEXT_AUTO",
    "RUNTIME_ACTION_CONTEXT_MANUAL",
    "fourCorner",
    "name",
    "getElementById",
    "waitUntilStreamReady",
    "CV_IMAGE_WIDTH",
    "setPlatformPrivateRequestedGumCanvasDimensions",
    "Chrome",
    "startTime",
    "createGuideOverlay",
    "mitek-fade-in",
    "mediaDevices",
    "RTS",
    "redactMRZOptionalDataFromImage",
    "glareTop",
    "sampleRate",
    "videoRecordingMessage",
    "getFaceOnlyBoxFromImage",
    "PARAMETER_NOT_SET",
    "\x22\x20accept=\x22image/png,\x20image/gif,\x20image/jpeg\x22/>\x0a\x20\x20\x20\x20",
    "_focus",
    "Required\x20parameter\x20not\x20provided",
    "faceExpressionNet",
    "user",
    "performMemorySafetyCheck",
    "scannerConfig",
    "__proto__",
    "RUNTIME_CRYPT_MODULE_UNKNOWN_ERROR",
    "RUNTIME_INVALID_DIRECT_IMAGE_DATA_FORMAT",
    "true",
    "setSessionInfoTotalDuration",
    "AUTOCAPTURE_CAMERA_DISPLAY",
    "type",
    "Part\x20of\x20the\x20required\x20parameters\x20are\x20missing\x20and\x20required",
    "onstart",
    "readyStream",
    "OptionalDataRedacted",
    "failedImage",
    "addListener",
    "highAmplThreshold",
    "fourCornerD",
    "setCurrentActionMibiDataSessionInfoMRZOptionalDataRedacted",
    "baseCameraPreferredLabels",
    "arrayBuffer",
    "getDimensionsFromImage",
    "handleStop",
    "actionTypes",
    "supportsWebGl",
    "maxRecordingVoiceTimeoutAllowed",
    "reduce",
    "utf-8",
    "_0x5d3xb",
    "setupDeviceIdSignal",
    "glareRight",
    "includes",
    "internal\x20timeout\x20",
    "canvasDimensions",
    "bitRate",
    "IEMobile",
    "audioBitsPerSecond",
    "removeChild",
    "getTime",
    "imageFormats",
    "VALIDATOR_BAD_EXTERNAL_CMD_PARAM_TYPE",
    "MITEK_ERROR_SKEW_ANGLE",
    "deviceInfo",
    "outerHeight",
    "attachAnalyzer",
    "Unexpected\x20data\x20type\x20for\x20provided\x20value",
    "VALIDATOR_BAD_COMMAND_OPTIONS_VALUE_OR_TYPE",
    "setSourceVideoStream",
    "getBitrateNormalized",
    "handleValidationErrorMessage",
    "takeAudioSnapshotData",
    "setPreloadPath",
    "font",
    "sort",
    "SDK_STOP",
    "stopRecordingAndGetVideo",
    "sgn",
    "convertFileToImageData",
    "WebGLRenderingContext",
    "hintMessageKey",
    "Auto",
    "message",
    "session\x20media\x20recorder",
    "getWebmBlobAsWave",
    "setCurrentActionMibiDataSessionInfoTotalDuration",
    "applyExceptionOverrides",
    "isValidDataUrl",
    "getImageData",
    "AUTOCAPTURE_START",
    "HINT_MESSAGE_SIZE",
    "isVideoStreamReady",
    "mitekDisplayContainerFull",
    "previousRecognizedData",
    "isExternalActionMode",
    "dataArray",
    "createElementFromFile",
    "once",
    "MISNAP_HEAD_OUTSIDE",
    "getRTSSignalBaseData",
    "embedCurrentActionMibiDataIntoExif",
    "bind",
    "20562yTEZZq",
    "match",
    "FRAME_PROCESSING_FEEDBACK",
    "Could\x20not\x20extract\x20image\x20data",
    "unable\x20to\x20find\x20thresholds\x20for\x20actionType\x20",
    "<!--html-->\x0a\x20\x20\x20\x20\x20\x20<div\x20id=\x22mitekDisplayContainer\x22\x20class=\x22mitek-voice-container\x22>\x0a\x20\x20\x20\x20\x20\x20\x20\x20<div\x20class=\x22mitek-voice-container-ui\x22>\x0a\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20<button\x20id=\x22mitekVoiceRecordButton\x22>\x0a\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20<div\x20id=\x22mitek-voice-mic\x22\x20class=\x22mic-muted\x22>\x0a\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20<span\x20class=\x22mic-vol\x22></span>\x0a\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20<div\x20class=\x22mic-muted-line\x22></div>\x0a\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20</div>\x0a\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20</button>\x0a\x20\x20\x20\x20\x20\x20\x20\x20</div>\x0a\x20\x20\x20\x20\x20\x20</div>\x0a\x20\x20\x20\x20\x20\x20<!--!html-->",
    "actionType",
    "convertStringToStylesheetWithId",
    "USER_ACTION_EVENT_REQUIRED",
    "imageData",
    "getPrototypeOf",
    "DESKTOP",
    "timeSlice",
    "recording",
    "getRequiresMirroring",
    "mitekVideoRecordingMessageText",
    "insertExifIntoDataURL",
    "getSessionRecorderMibiData",
    "Passport",
    "phraseText",
    "MIVB",
    "large",
    "classList",
    "debugLevel",
    "fillText",
    "MITEK_ERROR_FOCUS",
    "removeDefaulAppStyles",
    "getVoiceRecognizerSettings",
    "videoReadyAttempts",
    "filter",
    "ERROR_CODE_2",
    "ondataavailable",
    "readyState",
    "ALML",
    "The\x20listener\x20must\x20be\x20a\x20function",
    "THIS\x20ERROR\x20WILL\x20ONLY\x20SHOW\x20IN\x20DEV\x20MODE\x20ON\x20PURPOSE",
    "classNameForVideoSourceContainerElement",
    "setupWarnings",
    "stopExtractor",
    "validateExternalActionMode",
    "CONSTRAINT_NOT_SATISFIED",
    "VOICE",
    "pop",
    "INVALID_LICENSE_EXPIRED",
    "assertive",
    "INVALID_SNAPSHOT",
    "#misnapNativeCapture",
    "facingDirection",
    "RQGDIM",
    "hasNeutral",
    "_hintFrequencyMS",
    "set_scannerConfig",
    "logInternal",
    "mibiData",
    "loadAutocaptureStyles",
    "takeAudioSnapshotSaveToState",
    "RUNTIME_ERROR_GENERATING_CURRENT_ACTION",
    "onWindowResizeOrOrientationChange",
    "isBoolean",
    "takeSnapshotSaveToState",
    "externalCommandNames",
    "src",
    "WAVE",
    "return\x20this",
    "UID",
    "MIBI_MODE_BY_ACTION_MODE",
    "CEFDU",
    "MPT",
    "CAMERA_UNKNOWN_DEVICE_ISSUE",
    "MITEK_ERROR_MIN_PADDING",
    "RSASSA-PKCS1-v1_5",
    "btoa",
    "+00:00\x00",
    "target",
    "2290950biICpU",
    "unhandledrejection",
    "result",
    "isString",
    "isFailure",
    "mitek-visible",
    "calculateDistance2D",
    "spki",
    "redactMRZOptionalData",
    "incomingDataEffectsIntervalObject",
    "busyBackgroundThreshold",
    "VIDEO_RECORDING_EXCEEDED_MAX_TIME",
    "ERROR_CODE",
    "srcObject",
    "slice",
    "localhost",
    "_fourCorner",
    "transformer",
    "getTrackDimensions",
    "disableMirroring",
    "stopped",
    "handleDirectSdkErrorToIntegrator",
    "hasVideoCamera",
    "MISNAP_STOP_SMILING",
    "supportsUserMedia",
    "app:sessionrecorder",
    "numberOfChannels",
    "readAsDataURL",
    "getInvalidLicenseFeatures",
    "_appConfig",
    "Provided\x20image\x20unusable\x20for\x20analysis",
    "prototype",
    "deviceIDsignals",
    "isExternalCommandName",
    "VALIDATOR_INVALID_LICENSE_FEATURE",
    "analyzerStreamSampleRate",
    "getStreamFromVideoSource",
    "recorder",
    "MAISL",
    "PAGE_LOADED",
    "Portrait",
    "originalError",
    "MEASURED_HEIGHT",
    "_namespace",
    "uxpEventCode",
    "setSessionInfoBarcodeType",
    "click",
    "deviceTypes",
    "handleDataAvailable",
    "-preload-barcode",
    "getPermissionsCheck",
    "_0x1C0d3v",
    "Failed\x20to\x20compile",
    "description",
    "ivl",
    "classNameStreamSource",
    "integrator",
    "haltActionContextAuto",
    "isShowingHint",
    "MiSnap",
    "userAgent",
    "document",
    "extractFromImageData",
    "videoContainerId",
    "_preloadPath",
    "detectionBoxPercentage",
    "focus",
    "isValidDeviceID",
    "bcx",
    "save",
    "convertDataURLToImageData",
    "disableSmileDetection",
    "PARAMETER_REQUIRED_DATA_NOT_PROVIDED",
    "playsinline",
    "MEASURED_VIDEO_FRAME",
    "PDF417_BARCODE",
    "revokeObjectURL",
    "happy",
    "RUNTIME_CAPTURE_USER_ABANDONMENT_TIMEOUT",
    "removeAllExtractorDOMElements",
    ".bundle.js",
    "MISNAP_HEAD_SKEWED",
    "canvasElement",
    "getEyeCenter",
    "AUTOCAPTURE_FAST_SCORE",
    "_isStopped",
    "ripple-circle2",
    "removeAllListeners",
    "expiry",
    "subscribed\x20to\x20",
    "focusScore",
    "getRuntimeOutboundError",
    "metadata",
    "RUNTIME_VOICE_CONTEXT_UNKNOWN_ERROR",
    "VIDEO_RECORDING_DATA",
    "getDistanceBetweenPoints",
    "loadPiexif",
    "AUTOCAPTURE_FRAME_PROCESSED",
    "validateDocumentType",
    "faceapi",
    "charCodeAt",
    "glareBottom",
    "guideBox",
    "useDeviceIdSignal",
    "validateSnapshot",
    "resumeRecording",
    "_disableMirroring",
    "set",
    "AriaLiveText",
    "mitekVoiceRecordButton",
    "parentNode",
    "_events",
    "evaluate",
    "isIE",
    "MAVB",
    "function",
    "extractFromFile",
    "convertImageDataToDataURL",
    "currentAmpl",
    "faceDetectionLevel",
    "detectExposure",
    "RUNTIME_RECOGNIZER_FAILED",
    "mic-active",
    "TOTAL_ENCODING_TIME",
    "videoData",
    "clearSingleListener",
    "addEventListener",
    "VOICE_CAPTURED",
    "audio/mp4",
    "angry",
    "BBT",
    "dump",
    "Loading\x20chunk\x20",
    "extractFromDataURL",
    "body",
    "digest",
    "setupCurrentAction",
    "AudioContext",
    "kind",
    "recordedBlobs",
    "iterations",
    "MIME_TYPES",
    "PlatformPrivate",
    "videoSourceElement",
    "this\x20should\x20not\x20be\x20called\x20before\x20audio\x20is\x20ready.",
    "isAutoMode",
    "mitek-mobile-web",
    "tinyFaceDetector",
    "webpackChunkmitekScienceSDK",
    "videoContainer",
    "ceil_ampl",
    "Recognizer",
    "audioSnapshot",
    "getPathForSelfieFiles",
    "isLoaded",
    "getUserMedia",
    "_lastSnapshot",
    "RSA-OAEP",
    "appStyleSheetElement",
    "glareThreshold",
    "Warnings",
    "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA4kT+sJRMzF7p5eVHuqdsf62Vesh1doO9T8jQCrqSMrLSzWcnFQsKwPlJA+3EGbPvlT6XKnXb71aooLMSsnxHX7qZkSMSi8MPOAFA9tMECLOfqIfyWt9tt5Pgwdjh4vkdu9FqmMJJSUwpZ7WKXv10KxFysj5VKgqym9LP9mHi6g7hu0qgjhNjRRdjc08nc92RSVThGdi7TMxYwTzOYUn7RpHtvz41qpbLVCdQtKzHws+BmoJJkWtjChD+HmmMxrXYy0dF3oSU0D910H860y1BpBu156w4OYCU0BOds106x0xmW9pG1K+XAN5hIGV1VTzHlMoYGXMMkeiaptieRRwe9QIDAQAB",
    "isSafari",
    "preserveExifInCurrentAction",
    "Issue\x20detecting\x20audio\x20input",
    "pauseCounter",
    "SdkInfo",
    "Image\x20provided\x20does\x20not\x20meet\x20the\x20minimum\x20dimension\x20size.\x20Recommended\x20640x480",
    "value",
    "SELFIE",
    "encode",
    "Direct",
    "hasOptionalData",
    "CAPTURE_AND_PROCESS_VOICE",
    "setCurrentActionRTSStreamInfo",
    "isPerpendicularCaptureDisabled",
    "encryptedDevicesSignals",
    "CV_NO_BARCODE_FOUND",
    "DIRECT",
    "startContextExecution",
    "SessionInfo",
    "DEVICE_PERMISSION_DENIED",
    "loadFacialExpressionModels",
    "evaluateThresholds",
    "split",
    "900207gYgZFR",
    "RDF:Should\x20not\x20default\x20to\x20prevent\x20logic\x20errors\x20when\x20logic\x20changes",
    "CV_ENCODING_QUALITY",
    "offsetHeight",
    "locationPoints",
    "MISNAP_HEAD_TOO_CLOSE",
    "audio",
    "faceApiDetectionLevel",
    "angleOffsets",
    "546536qcyDak",
    "_hintAriaLive",
    "hintFrequencyMS",
    "reject",
    "updateHintMessage",
    "5.4.0",
    "Transformer",
    "sendEventImageCapturedToIntegrator",
    "MISNAP_SMILE",
    "floor_ampl_ceil",
    "ChunkLoadError",
    "<<<<",
    "isArray",
    "loadRecordingDomElements",
    "offsetWidth",
    "no\x20live\x20feed",
    "getViewPortWidth",
    "maxLowSignCountBeforeFirstPause",
    "generic",
    "TG4bvUb1QAoIr4Hva3Auve2ur8yTHOQiS5F7ZzPFckl789HXHDKf8jTZ2mQ/+JhS7",
    "2034290ysPOmW",
    "transformedImageDataSnapshot",
    "Generic",
    "faceApiStore_neutralFacialExpressionRecognizedData",
    "isFaceTooFar",
    "_videoRecordingMessage",
    "convertToInternalActionMode",
    "chunks",
    "withFaceLandmarks",
    "setItem",
    "setManateeWorksBarcodeAdditionalValues",
    "_audioRecordingEnabled",
    "createGuideElement",
    "BASE",
    "hasSessionRecordingStopped",
    "UNSUPPORTED_IMAGE_FORMAT",
    "HST",
    "deviceIdSignal",
    "left",
    "lastSnapshot",
    "Landscape",
    "VALIDATOR_BAD_EVENT_NAME_VALUE_OR_TYPE",
    "FourCorners",
    "RUNTIME_INVALID_SOURCE_FORMAT_FOR_CANVAS",
    "MITEK_ERROR_LOW_CONTRAST",
    "areDefaultModelsLoaded",
    "EXIF_DATE_TIME_ORIGINAL",
    "RUNTIME_RECOGNIZER_LOADER_FAILED",
    "encrypt",
    "recording\x20zero\x20length",
    "insertCurrentActionMibiDataUXPEvent",
    "_data",
    "audioAsBase64",
    "preloadComponents",
    "CHECK_BACK",
    "RCM",
    "unable\x20to\x20teardown\x20properly\x20in.",
    "isMaxExtractionTimerExpired",
    "deviceId",
    "snapShot",
    "createVideoAndCanvasElements",
    "recognize",
    "inP",
    "signed",
    "catch",
    "app:context",
    "thresholds",
    "USER_MEDIA_NOT_SUPPORTED",
    "postMessage",
    "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789/+",
    "\x0a\x20\x20\x20\x20\x20\x20<input\x20id=\x22misnapNativeCapture\x22\x20type=\x22file\x22\x20style=\x22display:none\x22\x20capture=\x22",
    "SIGNATURE_INVALID_UNABLE_TO_PARSE",
    "Manual",
    "maxSoundFeedbackRipples",
    "MEASURED_FOUR_CORNERS",
    "currentActionStartTime",
    "files",
    "sendEventFeedbackMessageToIntegrator",
    "isAudioStreamReady",
    "video/webm",
    "landmarks",
    "height",
    "convertObjectToStringBlocks",
    "VALIDATOR_LICENSE_IN_GRACE_PERIOD",
    "rotatePoint",
    "<<<<<<<<<<<<<<",
    "mitek-generic-guide",
    "Extractor",
    "INVALID_LICENSE_FEATURE",
    "_putImageOnCanvasForRecognizer",
    "str2ab",
    "getAudioTracks",
    "calculateSHA256",
    "CV_MEASURE_BRIGHTNESS",
    "isStopped",
    "getItem",
    "updateRecordingUIMicToDone",
    "InternalDebuggerLogSettings",
    "subtle",
    "autoplay",
    "IU.RCWNI2",
    "mrzThreshold",
    "CommandOptionsDictionary",
    "throw",
    "location",
    "test",
    "setEventListener",
    "crypto",
    "mitekMediaStreamSourceCustom",
    "faceAPIStore",
    "style",
    "_videoQuality",
    "HIDE_HINT",
    "fillStyle",
    "maxLowSignCountBeforeConsecutivePause",
    "validateExternalCommandName",
    "success",
    "_exposure",
    "sobelBlurLevel",
    "log",
    "VALIDATOR_BAD_IMAGE_TYPE_CONVERSION",
    "removeItem",
    "hasFoundNeutralExpressionSnapshot",
    "Back\x20Ultra\x20Wide\x20Camera",
    "AUTOCAPTURE_ROTATE",
    "webpackPublicPath",
    "validateHintMessageSizeParams",
    "validateEventName",
    "expressions",
    "horizontalFill",
    "mediaRecorder",
    "setSessionInfoClassificationType",
    "getDetectionBoxPercentOfGuideBox",
    "getTrackInfoForRTSSignal",
    "hintMessageElement",
    "removeListener",
    "IMAGE_CAPTURED",
    "getBlob",
    "face",
    "Back\x20Dual\x20Wide\x20Camera",
    "isValidExtractionDimensions",
    "CV_ERROR_TOO_FAR",
    "mki",
    "convertFileToCanvas",
    "isLoading",
    "_0xDA857",
    "inputSize",
    "hostname",
    "public",
    "fmt\x20",
    "next",
    "hintAriaLive",
    "getDetectionBoxNormalized",
    "_videoContainerId",
    "_currentAction",
    "MIC_UNKNOWN_DEVICE_ISSUE",
    "-preload-selfie",
    "externalActionModes",
    "stopStream",
    "MIN_SIDE_LENGTH",
    "mitekDisplayContainer",
    "FRAME_CAPTURE_RESULT",
    "incrementFaceFailureCountByHintMessageKey",
    "stopRecording",
    "LCT",
    "score",
    "INVALID_IMAGE_DATA",
    "path\x20issue",
    "generateSessionInfoVoice",
    "preloadPath",
    "now",
    "_hasSessionRecordingStopped",
    "listenerCount",
    "resume",
    "_isFaceInGuideOverlay",
    "_hasFoundSmilingExpressionSnapshot",
    "onloadend",
    "fearful",
    "validateComponentPreloadOption",
    "create",
    "removelistener",
    "actionMode",
    "qualityPercent",
    "runOnce",
    "commandOptions",
    "FRAME_PROCESSING_STARTED",
    "setSessionInfoDeviceOrientation",
    "toString",
    "createMediaStreamSource",
    "setCurrentActionHasSessionRecordingStopped",
    "loadDefaultModels",
    "isNumber",
    "setCoreVisionPassportAdditionalValues",
    "getDivElementDimensions",
    "minPadding",
    "IMAGE_SMALLER_THAN_MIN_SIZE",
    "IFPDEE",
    "join",
    "detectFourCorners",
    "mic-done",
    "hasSmile",
    "textMessage",
    "isFaceShaking",
    "internalErrorMessage",
    "VID",
    "supportsWasm",
    "imageGumExtractorGlobalMaxTimeAllowed",
    "toDataURL",
    "startSessionRecorder",
    "must\x20pass\x20html\x20target\x20element",
    "__esModule",
    "detectFocus",
    "videoinput",
    "DocumentOrientation",
    "getValidator",
    "emit",
    "_0xD857",
    "recordingTimeout",
    "mitekVideoRecordingMessage",
    "keys",
    "isFaceNotCentered",
    "315GTLFJO",
    "then",
    "updateRecordingUIMicToStartRec",
    "ERROR",
    "getSpecificDeviceByLabel",
    "audioMimeType",
    "mitekVoicePhrase",
    "lastRecognizedEvaluation",
    "videoSourceContainerElement",
    "deviceType",
    "px\x27",
    "_0x6b0",
    "DOCUMENT",
    "updateVideoContainerSize",
    "RUNTIME_GUM_ERROR",
    "adjustUICaptureElementsForCustomContainer",
    "ownKeys",
    "isValidDirectProvidedImageFormat",
    "12px\x20arial",
    "averageAngleRotation",
    "convertElementToImageData",
    "extractCurrentActionExifFromDataURL",
    "maxGlobalExtractorTimeAllowed",
    "warnings",
    "getTracks",
    "_0xAF857157",
    "AMRTM",
    "mitekDisplayContainerCustom",
    "label",
    "updateSelfieGuide",
    "CV_ERROR_LOW_CONTRAST",
    "bufferLength",
    "webkitAudioContext",
    "boolean",
    "mibiVersion",
    "generateValidRecognizedDataForError",
    "remove",
    "mitekHintMessage",
    "MediaRecorder",
    "glareScore",
    "AUTOCAPTURE_TIMEOUT",
    "glare",
    "actionIdentifier",
    "internalRecorderState",
    "error\x20recording\x20stream:\x20",
    "private",
    "sendFrameProcessingStartedToIntegrator",
    "generateSessionInfoDefault",
    "sin",
    "MRSM",
    "resizeTimeoutId",
    "mrz_flat_rects",
    "_0xBCA5E",
    "isNamespaceAllowed",
    "VALIDATOR_EXIF_BAD_DATA_URL",
    "drawRotatedRect",
    "setSessionInfoFourCorners",
    "mediaStreamConstraints",
    "unshift",
    "getMergedRTSSignalData",
    "isTimerExpired",
    "enableLogging",
    "VOICE_CAPTURE_RESULT",
    "substring",
    "DATA_TYPE_LABEL",
    "SIGNATURE_NOT_FOUND",
    "CV_MEASURE_SHARPNESS",
    "live",
    "docType",
    "Not\x20able\x20to\x20use\x20camera\x20stream\x20for\x20preview",
    "START_CAPTURE",
    "MISNAP_HEAD_TOO_FAR",
    "getLicensePermissionResult",
    "cpu",
    "WASM_NOT_SUPPORTED",
    "saveEvaluationToInstance",
    "scoreThreshold",
    "INVALID_STREAM_TRACK",
    "weightId",
    "MOBILE",
    "PASSPORT",
    "MARV",
    "CoreVisionWorkerModule",
    "getSupportedMimeType",
    "max",
    "getCanvasDimensionsByActionType",
    "getRightEye",
    "setSDKStopFlags",
    "camera2\x200,\x20facing\x20back",
    "preloadBarcode",
    "doAnalysisUpdates",
    "toStringTag",
    "getBCLI",
    "DeviceInfo",
    "getTrackSettings",
    "getSDKresultWithRTS",
    "exposureScore",
    "CAPTURE_FRAME",
    "params",
    "getVersion",
    "fromCharCode",
    "setMRZOptionalDataRedacted",
    "clearRecordingIntervals",
    "listeners",
    "currentScript",
    "RUNTIME_WEBGL_NOT_SUPPORTED",
    "failureConditions",
    "mitekScienceSDK",
    "RUNTIME_LAZY_LOAD_LIBRARIES",
    "voiceScreenElement",
    "togglePauseRecording",
    "getBCLT",
    "_gli",
    "small",
    "isFailureResponse",
    "barcode",
    "deviceInputFacingDirections",
    "_hintMessageSize",
    "ClientActivityDataLog",
    "_hintForceUpdate",
    "hint\x20message\x20size",
    "getOwnPropertyNames",
    "lazyLoadLibraries",
    "enumerateDevices",
    "DISABLE_MIRRORING",
    "neutral",
    "removeEventListeners",
    "push",
    "RUNTIME_ERROR_EXIF_PRESERVATION",
    "supportsWebGL",
    "options",
    "reset",
    "span",
    "NotAllowedError",
    "createHintMessageElement",
    "no\x20recognizer\x20default\x20should\x20be\x20issued",
    "<<<",
    "isMobile",
    "polite",
    "updateCanvasSize",
    "start",
    "Back\x20Camera",
    "jpeg",
    "box",
    "1434612MvGZfh",
    "unable\x20to\x20process\x20license\x20feature\x20check",
    "reuseCanvasWithNewImage",
    "mitekMediaStreamSourceFull",
    "size",
    "namespaces",
    "onerror",
    "loaded",
    "ID_Front",
    "getDetectionBoxCenterPoint",
    "mitek-mobile-web-vbm",
    "terminate",
    "insertUXPEvent",
    "fourCornerC",
    "NO_BARCODE_FOUND",
    "loop",
    "sendCameraDisplayStartedToIntegrator",
    "innerText",
    "EAT",
    "hintMessageSizeClass",
    "WEBGL_PACK",
    "CV_LANDSCAPE_PORTRAIT",
    "applicationIdentifier",
    "defineProperty",
    "code",
    "exposureThreshold",
    "CV_ERROR_GLARE",
    "CV_ERROR_TOO_DARK",
    "recognizedData",
    "app:config:setup",
    "\x20SDK\x20WARNING\x20-\x20CMD\x20not\x20configured\x20nothing\x20processed.\x20>",
    "eBAB6A",
    "imageDimensions",
    "outerWidth",
    "toSquare",
    "getChannelData",
    "sendErrorMessageToIntegrator",
    "_glare",
    "detectSingleFace",
    "calculateDeltaTime",
    "translate",
    "cause",
    "throttleSpeed",
    "GLARE_FAILURE",
    "default",
    "mwb-config",
    "Barcode",
    "Type",
    "computeAngle",
    "there\x20should\x20be\x20no\x20default\x20AQA\x20evaluator",
    "version",
    "VALIDATOR_LICENSE_EXPIRED",
    "generateSessionInfoBarcode",
    "Check_Front",
    "chunk-",
    "RUNTIME_ERROR_EXTRACTING_DIRECT_IMAGE_DATA",
    "all",
    "getDimensionsFromFourCornerData",
    "FTFT",
    "margin:\x200;\x20padding:\x200;\x20width:\x20",
    "sessionRecordingData",
    "done",
    "maxCallsBeforeReset",
    "exports",
    "detection",
    "resetRecognizer",
    "getDeviceIdSignals",
    "videoQuality",
    "ValidateOnCallbackIsFunction",
    "isValidBase64",
    "animateRipples",
    "disgusted",
    "globalAlpha",
    "createAnalyser",
    "stringify",
    "removeStylesheet",
    "setCurrentActionToForceStopWithReason",
    "captureStream",
    "createElement",
    "onload",
    "getVideoTracks",
    "DOCUMENTS",
    "MITEK_ERROR_FOUR_CORNER",
    "cos",
    "deposit",
    "deepFreeze",
    "medium",
    "transformedAudioDataSnapshot",
    "_disableSmileDetection",
    "RECORDING",
    "forceRemoveListeners",
    "textToImageData",
    "exif",
    "shouldPause",
    "getLeftEye",
    "validateStringOrObjForHintMessageText",
    "isTypeSupported",
    "MHFMS",
    "reason",
    "currentContext",
    "insertCurrentActionExifFromDataURL",
    "mitekMediaStreamSource",
    "_qualityPercent",
    "hasEnoughRequiredAmpls",
    "VOICE_PAUSED",
    "hint\x20message",
    "sqrt",
    "outboundError",
    "withFaceExpressions",
    "selectedRecorder",
    "_mrz",
    "hintDuration",
    "createObjectURL",
    "arrayBufferToBase64",
    "undefined",
    "isAndroid",
    "_0xBF857",
    "screen",
    "stop",
    "voiceSettings",
    "requiresMirroring",
    ".mic-vol",
    "analyzer",
    "QR_BARCODE",
    "mic-vol-high",
    "hash",
    "Entry\x20Point\x20Event\x20Interface",
    "createElementFromDataURL",
    "acos",
    "audioBlob",
    "setCurrentActionMibiDataSessionInfoDeviceOrientation",
    "cmd",
    "mode",
    "parse",
    "createInputElements",
    "PROCESS_FRAME",
    "UNKNOWN_ERROR",
    "transform",
    "_documentType",
    "RUNTIME_WEBASSEMBLY_NOT_SUPPORTED",
    "getBarcodeLicenseTypeAndPath",
    "concat",
    "getIphonePreferredBackCameraLabels",
    "from",
    "AUTO",
    "isFaceBlurry",
    "totalAnimateCalls",
    "MANUAL",
    "strokeStyle",
    "MEASURED_WIDTH",
    "cameraPreferredLabels",
    "_mitekSDKPath",
    "videoRecordingEnabled",
    "set_mwbScanner",
    "adjustUICaptureElementsFullScreen",
    "hasStringOrNumber",
    "removeAutoCaptureStyles",
    "getCameraPreferredLabelsByActionType",
    "preload",
    "unhandledPromiseRejectionCallback",
    "EnvironmentValidator",
    "NO_FACE_FOUND",
    "children",
    "generateUniqueId",
    "CV_ERROR_HORIZONTAL_FILL",
    "The\x20value\x20provided\x20is\x20invalid,\x20please\x20refer\x20to\x20documentation",
    "RUNTIME_GUM_ERROR_NO_CAMERA_FOUND",
    "isExtractionCompletedIntervalObject",
    "tearDownAndCleanup",
    "validate",
    "getOrSetDeviceId",
    "inactive",
    "fourCornerScore",
    "SAT",
    "generateFinalImageURLWithExifAndMibi",
    "unable\x20to\x20bind\x20record\x20button",
    "gpo",
    "updateVideoAndContainerSize",
    "random",
    "ipk",
    "amd",
    "boundEventListenerCallbacks",
    "setCurrentActionMibiDataSessionInfoClassificationType",
    "SDK_READY",
    "setVideoDimension",
    "loadFromUri",
    "rawData",
    "CV_ERROR_FAILURE",
    "setKey",
    "OPTIONS_PARAMETER_INVALID_VALUE",
    "isIphoneAnd14ProOrMax",
    "algoSpecs",
    "PAUSED",
    "_videoSource",
    "resolve",
    "userMediaStream",
    "mitekVoiceContainerUi",
    "getRecordingData",
    "tearDownAutoIfRunningOnError",
    "image/(",
    "audioReadyAttempts",
    "VALIDATOR_INVALID_BARCODE_LICENSE",
    "_disablePerpendicularCapture",
    "atob",
    "setAttribute",
    "UNSUPPORTED_AUDIO_INPUT",
    "destroy",
    "AUTO_CAPTURE",
    "isBetween",
    "data",
    "setCurrentActionMibiDataSessionInfoDocumentOrientation",
    "scanFrame",
    "px;\x20height:\x20",
    "MibiVersion",
    "px;",
    "areFacialExpressionModelsLoaded",
    "generateFinalVoiceURLWithExifAndMibi",
    "isStoppedReason",
    "sign",
    "registerStyleSheet",
    "onWorkerError",
    "clearCurrentActionSnapshots",
    "_0xFD",
    "isValidFaceInGuideOverlay",
    "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA3ShUaKV+U705QRDP1",
    "appendVideoContainerToDom",
    "documentType",
    "getElementsByTagName",
    "hasUserCanceledAction",
    "RUNTIME_GUM_ERROR_NO_AUDIO_INPUT_FOUND",
    "getAttribute",
    "SHA-256",
    "CAPTURE_AND_PROCESS_FRAME",
    "tinyFaceDetectorSettings",
    "some",
    "preventDefault",
    "FRAME_PROCESSING_ENDED",
    "getMediaStream",
    "grayscale",
    "canplay",
    "registerEventListeners",
    "hasOwnProperty",
    "PARAMETER_TYPE_ERROR",
    "length",
    "removeDomElementSafely",
    "PROP_IMAGE_HEIGHT",
    "NoResult",
    "insert",
    "experimental-webgl",
    "TotalDuration",
    "sha-256",
    "FTCT",
    "restore",
    "Module",
    "calculateRotationAngle",
    "CV_ERROR_FOUR_CORNERS",
    "request",
    "snapshotLabel",
    "\x20!!\x20",
    "querySelector",
    "app:controller",
    "FACE_FAILURE_COUNT",
    "pause",
    "setDeviceIdAdditionalValues",
    "Permission\x20has\x20been\x20denied\x20on\x20device\x20hardware\x20or\x20feature",
    "setCoreVisionAdditionalValues",
    "getFeatureRequiredByActionType",
    "canvasForWebGLCheck",
    "getContext",
    "mitek-voice-mic",
    "embedMibiDataIntoExif",
    "error\x20caught\x20in\x20mediaRecorder",
    "getVoiceResults",
    "unable\x20to\x20subscribe\x20to\x20",
    "canvas",
    "mwb",
    "isFaceTooClose",
    "onstop",
    "_redactMRZOptionalData",
    "Integration\x20problem\x20caused\x20by\x20event\x20name",
    "Exif",
    "trim",
    "_faceDetectionLevel",
    "RIFF",
    "Only\x20to\x20transfer\x20data\x20between\x20integrators\x20and\x20SDK\x20internal\x20logic",
    "clearListeners",
    "removeWebGLCompileErrorListener",
    "_0xDC0d3",
    "hasCurrentActionSessionRecordingStopped",
    "Automatic\x20publicPath\x20is\x20not\x20supported\x20in\x20this\x20browser",
    "eventNames",
    "horizontalFillThreshold",
    "base64ToArrayBuffer",
    "publicPath",
    "add",
    "HFT",
    "PDF417",
    "masterBlob",
    "audioData",
    "_currentContext",
    "script",
    "requiredAmplTresholdCount",
    "transform:\x20translate(-50%,\x20-50%)\x20scale(0.3);\x20opacity:0;\x20top:0;\x20left:0;\x20margin:\x200;\x20padding:\x200;\x20position:\x20absolute;\x20width:\x20",
    "NOT_FOUND",
    "reader\x20could\x20not\x20convert\x20file\x20to\x20data\x20url",
    "DeviceOrientation",
    "Document",
    "setCurrentActionIsShowingHint",
    "surprised",
    "56072MtpLJS",
    "RTSTrackSignals",
    "OverconstrainedError",
    "isFaceSkewed",
    "./mitekSDK/",
    "No\x20user\x20interaction\x20received\x20within\x20internal\x20maximum\x20time\x20allowed\x20during\x20capture",
    "frame",
    "VALIDATOR_BAD_MODE",
    "skewAngleThreshold",
    "video/mp4",
    "decorateWithBase64",
    "VOICE_PAUSED_LONG",
    "busyBackground",
    "voiceRecognizerInstance",
    "recognizableData",
    "DATA_URL",
    "protectData",
    "floor_ampl",
    "determineFormat",
    "processAnalysisEffects",
    "timeout",
    "_0xBF3xD",
    "buffer",
    "stream",
    "web",
    "VALIDATOR_BAD_ON_CALLBACK",
    "AUTOCAPTURE_STOP",
    "_0xAF7157",
    "MANUAL_CAPTURE",
    "app:extraction",
    "goodAmplLog",
    "captureExtractor",
    "fourCornerA",
    "getRuntimeGumError",
    "_useDeviceIdSignal",
    "isExifSupportedFormat",
    "CV_ERROR_BUSY_BACKGROUND",
    "BARCODE",
    "imageWidth",
    "removeEventListener",
    "CAMERA_PERMISSION_DENIED",
    "recorderToUse",
    "video",
    "countryCode",
    "MST",
    "fillRect",
    "min",
    "File",
    "clearDeviceId",
    "CORRUPT_IMAGE",
    "role",
    "assign",
    "string",
    "connect",
    "isImageDataUrl",
    "mimeType",
    "appendChild",
    "sendSDKResultToIntegrator",
    "convertFileToDataURL",
    "faceLandmark68TinyNet",
    "IMAGE_DATA",
    "_eventsCount",
    "The\x20license\x20is\x20invalid",
    "hasEnoughRecordingTime",
  ];
  a0_0x1142 = function () {
    return _0x16c358;
  };
  return a0_0x1142();
}
function a0_0x1b49(_0x4b2972, _0x41b7ab) {
  const _0x1142bb = a0_0x1142();
  return (
    (a0_0x1b49 = function (_0x1b4992, _0x4fffcb) {
      _0x1b4992 = _0x1b4992 - 0x1b5;
      let _0x3acd50 = _0x1142bb[_0x1b4992];
      return _0x3acd50;
    }),
    a0_0x1b49(_0x4b2972, _0x41b7ab)
  );
}
(function (_0x31a88c, _0x3d3a2b) {
  const _0x227ae2 = a0_0x1b49,
    _0x20a2eb = _0x31a88c();
  while (!![]) {
    try {
      const _0x338f41 =
        -parseInt(_0x227ae2(0x342)) / 0x1 +
        parseInt(_0x227ae2(0x4b8)) / 0x2 +
        -parseInt(_0x227ae2(0x289)) / 0x3 +
        (parseInt(_0x227ae2(0x5ed)) / 0x4) * (parseInt(_0x227ae2(0x428)) / 0x5) +
        (parseInt(_0x227ae2(0x23f)) / 0x6) * (parseInt(_0x227ae2(0x64b)) / 0x7) +
        (-parseInt(_0x227ae2(0x34b)) / 0x8) * (parseInt(_0x227ae2(0x645)) / 0x9) +
        parseInt(_0x227ae2(0x35f)) / 0xa;
      if (_0x338f41 === _0x3d3a2b) break;
      else _0x20a2eb["push"](_0x20a2eb["shift"]());
    } catch (_0x1aa341) {
      _0x20a2eb["push"](_0x20a2eb["shift"]());
    }
  }
})(a0_0x1142, 0x729ca),
  !(function (_0x32de6a, _0x40a7a5) {
    const _0x27bd29 = a0_0x1b49;
    "object" == typeof exports && _0x27bd29(0x6c1) == typeof module
      ? (module[_0x27bd29(0x4f7)] = _0x40a7a5())
      : "function" == typeof define && define[_0x27bd29(0x56c)]
      ? define(_0x27bd29(0x493), [], _0x40a7a5)
      : _0x27bd29(0x6c1) == typeof exports
      ? (exports["mitekScienceSDK"] = _0x40a7a5())
      : (_0x32de6a[_0x27bd29(0x493)] = _0x40a7a5());
  })(window, () =>
    (() => {
      "use strict";
      const _0x1cb34a = a0_0x1b49;
      var _0x49de7c,
        _0xd181eb,
        _0x5dd476,
        _0x5ee5b8 = {
          0x2d9: (_0x45c035) => {
            const _0x12c1b0 = a0_0x1b49;
            var _0x3dc6b5 = Object[_0x12c1b0(0x2a8)][_0x12c1b0(0x5a9)],
              _0xd5a19f = "~";
            function _0x32149e() {}
            function _0x35eaf1(_0x1d760c, _0x259218, _0x5e96bd) {
              const _0x3c4951 = _0x12c1b0;
              (this["fn"] = _0x1d760c), (this[_0x3c4951(0x708)] = _0x259218), (this[_0x3c4951(0x23a)] = _0x5e96bd || !0x1);
            }
            function _0x4d5afd(_0x2f140d, _0x11e137, _0x36ec5, _0x4a887d, _0x2bb3d5) {
              const _0x266401 = _0x12c1b0;
              if (_0x266401(0x2fc) != typeof _0x36ec5) throw new TypeError(_0x266401(0x261));
              var _0x2e2676 = new _0x35eaf1(_0x36ec5, _0x4a887d || _0x2f140d, _0x2bb3d5),
                _0xa05eb8 = _0xd5a19f ? _0xd5a19f + _0x11e137 : _0x11e137;
              return (
                _0x2f140d[_0x266401(0x2f8)][_0xa05eb8]
                  ? _0x2f140d["_events"][_0xa05eb8]["fn"]
                    ? (_0x2f140d[_0x266401(0x2f8)][_0xa05eb8] = [_0x2f140d[_0x266401(0x2f8)][_0xa05eb8], _0x2e2676])
                    : _0x2f140d[_0x266401(0x2f8)][_0xa05eb8]["push"](_0x2e2676)
                  : ((_0x2f140d["_events"][_0xa05eb8] = _0x2e2676), _0x2f140d[_0x266401(0x62a)]++),
                _0x2f140d
              );
            }
            function _0x5c3b83(_0x5dbfa5, _0x39c86b) {
              const _0x315a4e = _0x12c1b0;
              0x0 == --_0x5dbfa5["_eventsCount"]
                ? (_0x5dbfa5[_0x315a4e(0x2f8)] = new _0x32149e())
                : delete _0x5dbfa5[_0x315a4e(0x2f8)][_0x39c86b];
            }
            function _0x3bb8d9() {
              const _0x2242fc = _0x12c1b0;
              (this[_0x2242fc(0x2f8)] = new _0x32149e()), (this[_0x2242fc(0x62a)] = 0x0);
            }
            Object["create"] &&
              ((_0x32149e[_0x12c1b0(0x2a8)] = Object["create"](null)), new _0x32149e()[_0x12c1b0(0x1f1)] || (_0xd5a19f = !0x1)),
              (_0x3bb8d9[_0x12c1b0(0x2a8)][_0x12c1b0(0x5da)] = function () {
                const _0x38a914 = _0x12c1b0;
                var _0x22619b,
                  _0x33ae20,
                  _0x36c48b = [];
                if (0x0 === this[_0x38a914(0x62a)]) return _0x36c48b;
                for (_0x33ae20 in (_0x22619b = this[_0x38a914(0x2f8)]))
                  _0x3dc6b5["call"](_0x22619b, _0x33ae20) && _0x36c48b["push"](_0xd5a19f ? _0x33ae20[_0x38a914(0x297)](0x1) : _0x33ae20);
                return Object[_0x38a914(0x6e4)] ? _0x36c48b[_0x38a914(0x545)](Object[_0x38a914(0x6e4)](_0x22619b)) : _0x36c48b;
              }),
              (_0x3bb8d9[_0x12c1b0(0x2a8)][_0x12c1b0(0x48f)] = function (_0x9e61dc) {
                const _0x12c857 = _0x12c1b0;
                var _0x1c020f = _0xd5a19f ? _0xd5a19f + _0x9e61dc : _0x9e61dc,
                  _0x1d86f2 = this[_0x12c857(0x2f8)][_0x1c020f];
                if (!_0x1d86f2) return [];
                if (_0x1d86f2["fn"]) return [_0x1d86f2["fn"]];
                for (
                  var _0x51a8db = 0x0, _0x49d839 = _0x1d86f2["length"], _0x254a24 = new Array(_0x49d839);
                  _0x51a8db < _0x49d839;
                  _0x51a8db++
                )
                  _0x254a24[_0x51a8db] = _0x1d86f2[_0x51a8db]["fn"];
                return _0x254a24;
              }),
              (_0x3bb8d9[_0x12c1b0(0x2a8)][_0x12c1b0(0x3f7)] = function (_0x533b98) {
                const _0x296ca2 = _0x12c1b0;
                var _0x52c387 = _0xd5a19f ? _0xd5a19f + _0x533b98 : _0x533b98,
                  _0x13f80e = this["_events"][_0x52c387];
                return _0x13f80e ? (_0x13f80e["fn"] ? 0x1 : _0x13f80e[_0x296ca2(0x5ab)]) : 0x0;
              }),
              (_0x3bb8d9[_0x12c1b0(0x2a8)]["emit"] = function (_0x4a3a44, _0x68e046, _0x682dae, _0x2eb35d, _0xf66147, _0x7a7c5b) {
                const _0x4611c3 = _0x12c1b0;
                var _0x3b4d00 = _0xd5a19f ? _0xd5a19f + _0x4a3a44 : _0x4a3a44;
                if (!this[_0x4611c3(0x2f8)][_0x3b4d00]) return !0x1;
                var _0x127ac4,
                  _0x5485fc,
                  _0x2e128f = this["_events"][_0x3b4d00],
                  _0x53161f = arguments[_0x4611c3(0x5ab)];
                if (_0x2e128f["fn"]) {
                  switch ((_0x2e128f[_0x4611c3(0x23a)] && this[_0x4611c3(0x3d2)](_0x4a3a44, _0x2e128f["fn"], void 0x0, !0x0), _0x53161f)) {
                    case 0x1:
                      return _0x2e128f["fn"][_0x4611c3(0x62d)](_0x2e128f[_0x4611c3(0x708)]), !0x0;
                    case 0x2:
                      return _0x2e128f["fn"][_0x4611c3(0x62d)](_0x2e128f["context"], _0x68e046), !0x0;
                    case 0x3:
                      return _0x2e128f["fn"][_0x4611c3(0x62d)](_0x2e128f[_0x4611c3(0x708)], _0x68e046, _0x682dae), !0x0;
                    case 0x4:
                      return _0x2e128f["fn"]["call"](_0x2e128f[_0x4611c3(0x708)], _0x68e046, _0x682dae, _0x2eb35d), !0x0;
                    case 0x5:
                      return _0x2e128f["fn"][_0x4611c3(0x62d)](_0x2e128f["context"], _0x68e046, _0x682dae, _0x2eb35d, _0xf66147), !0x0;
                    case 0x6:
                      return (
                        _0x2e128f["fn"][_0x4611c3(0x62d)](
                          _0x2e128f[_0x4611c3(0x708)],
                          _0x68e046,
                          _0x682dae,
                          _0x2eb35d,
                          _0xf66147,
                          _0x7a7c5b
                        ),
                        !0x0
                      );
                  }
                  for (_0x5485fc = 0x1, _0x127ac4 = new Array(_0x53161f - 0x1); _0x5485fc < _0x53161f; _0x5485fc++)
                    _0x127ac4[_0x5485fc - 0x1] = arguments[_0x5485fc];
                  _0x2e128f["fn"][_0x4611c3(0x1d1)](_0x2e128f[_0x4611c3(0x708)], _0x127ac4);
                } else {
                  var _0x2ac576,
                    _0x40dc7a = _0x2e128f[_0x4611c3(0x5ab)];
                  for (_0x5485fc = 0x0; _0x5485fc < _0x40dc7a; _0x5485fc++)
                    switch (
                      (_0x2e128f[_0x5485fc][_0x4611c3(0x23a)] &&
                        this[_0x4611c3(0x3d2)](_0x4a3a44, _0x2e128f[_0x5485fc]["fn"], void 0x0, !0x0),
                      _0x53161f)
                    ) {
                      case 0x1:
                        _0x2e128f[_0x5485fc]["fn"][_0x4611c3(0x62d)](_0x2e128f[_0x5485fc][_0x4611c3(0x708)]);
                        break;
                      case 0x2:
                        _0x2e128f[_0x5485fc]["fn"]["call"](_0x2e128f[_0x5485fc][_0x4611c3(0x708)], _0x68e046);
                        break;
                      case 0x3:
                        _0x2e128f[_0x5485fc]["fn"][_0x4611c3(0x62d)](_0x2e128f[_0x5485fc][_0x4611c3(0x708)], _0x68e046, _0x682dae);
                        break;
                      case 0x4:
                        _0x2e128f[_0x5485fc]["fn"][_0x4611c3(0x62d)](_0x2e128f[_0x5485fc]["context"], _0x68e046, _0x682dae, _0x2eb35d);
                        break;
                      default:
                        if (!_0x127ac4) {
                          for (_0x2ac576 = 0x1, _0x127ac4 = new Array(_0x53161f - 0x1); _0x2ac576 < _0x53161f; _0x2ac576++)
                            _0x127ac4[_0x2ac576 - 0x1] = arguments[_0x2ac576];
                        }
                        _0x2e128f[_0x5485fc]["fn"][_0x4611c3(0x1d1)](_0x2e128f[_0x5485fc]["context"], _0x127ac4);
                    }
                }
                return !0x0;
              }),
              (_0x3bb8d9[_0x12c1b0(0x2a8)]["on"] = function (_0x40254f, _0x4fe107, _0x4b77f9) {
                return _0x4d5afd(this, _0x40254f, _0x4fe107, _0x4b77f9, !0x1);
              }),
              (_0x3bb8d9["prototype"][_0x12c1b0(0x23a)] = function (_0x1939a7, _0x494bfd, _0x39da9e) {
                return _0x4d5afd(this, _0x1939a7, _0x494bfd, _0x39da9e, !0x0);
              }),
              (_0x3bb8d9["prototype"][_0x12c1b0(0x3d2)] = function (_0x39d3e9, _0x3f0bc9, _0x2c1982, _0x275bc5) {
                const _0xf4f90a = _0x12c1b0;
                var _0x466fa0 = _0xd5a19f ? _0xd5a19f + _0x39d3e9 : _0x39d3e9;
                if (!this[_0xf4f90a(0x2f8)][_0x466fa0]) return this;
                if (!_0x3f0bc9) return _0x5c3b83(this, _0x466fa0), this;
                var _0xa45a14 = this[_0xf4f90a(0x2f8)][_0x466fa0];
                if (_0xa45a14["fn"])
                  _0xa45a14["fn"] !== _0x3f0bc9 ||
                    (_0x275bc5 && !_0xa45a14[_0xf4f90a(0x23a)]) ||
                    (_0x2c1982 && _0xa45a14[_0xf4f90a(0x708)] !== _0x2c1982) ||
                    _0x5c3b83(this, _0x466fa0);
                else {
                  for (var _0x2cb82f = 0x0, _0x62a2bc = [], _0xc7060e = _0xa45a14[_0xf4f90a(0x5ab)]; _0x2cb82f < _0xc7060e; _0x2cb82f++)
                    (_0xa45a14[_0x2cb82f]["fn"] !== _0x3f0bc9 ||
                      (_0x275bc5 && !_0xa45a14[_0x2cb82f][_0xf4f90a(0x23a)]) ||
                      (_0x2c1982 && _0xa45a14[_0x2cb82f][_0xf4f90a(0x708)] !== _0x2c1982)) &&
                      _0x62a2bc[_0xf4f90a(0x4a7)](_0xa45a14[_0x2cb82f]);
                  _0x62a2bc[_0xf4f90a(0x5ab)]
                    ? (this["_events"][_0x466fa0] = 0x1 === _0x62a2bc[_0xf4f90a(0x5ab)] ? _0x62a2bc[0x0] : _0x62a2bc)
                    : _0x5c3b83(this, _0x466fa0);
                }
                return this;
              }),
              (_0x3bb8d9[_0x12c1b0(0x2a8)]["removeAllListeners"] = function (_0x168d87) {
                const _0x389f20 = _0x12c1b0;
                var _0x5db1ec;
                return (
                  _0x168d87
                    ? ((_0x5db1ec = _0xd5a19f ? _0xd5a19f + _0x168d87 : _0x168d87),
                      this[_0x389f20(0x2f8)][_0x5db1ec] && _0x5c3b83(this, _0x5db1ec))
                    : ((this[_0x389f20(0x2f8)] = new _0x32149e()), (this[_0x389f20(0x62a)] = 0x0)),
                  this
                );
              }),
              (_0x3bb8d9[_0x12c1b0(0x2a8)]["off"] = _0x3bb8d9["prototype"]["removeListener"]),
              (_0x3bb8d9[_0x12c1b0(0x2a8)][_0x12c1b0(0x1fd)] = _0x3bb8d9[_0x12c1b0(0x2a8)]["on"]),
              (_0x3bb8d9["prefixed"] = _0xd5a19f),
              (_0x3bb8d9["EventEmitter"] = _0x3bb8d9),
              (_0x45c035[_0x12c1b0(0x4f7)] = _0x3bb8d9);
          },
          0x177: (_0x5d593a, _0x2a8ff1, _0x28982c) => {
            _0x28982c["d"](_0x2a8ff1, { Z: () => _0x50a6f7 });
            const _0x50a6f7 = class {
              constructor(_0x477185, _0x478a8e, _0x1a054b) {
                const _0x15cbaa = a0_0x1b49;
                (this[_0x15cbaa(0x245)] = _0x477185), (this["actionMode"] = _0x478a8e), (this["deviceType"] = _0x1a054b);
              }
            };
          },
          0x246: (_0x153cb3, _0x30e483, _0x4e8c13) => {
            const _0x21a0cc = a0_0x1b49;
            _0x4e8c13["d"](_0x30e483, { Z: () => _0x5a400b });
            let _0x4decee = _0x21a0cc(0x5f1);
            const _0x18cd64 = { isInternalDebuggerEnabled: !0x1, namespaces: ["*:*:*:*:*"] } || {
              isInternalDebuggerEnabled: !0x1,
              namespaces: [],
            };
            var _0x337ea4 = _0x4e8c13(0x170);
            const _0x3bd437 = Object[_0x21a0cc(0x70e)](
                new (class {
                  constructor() {
                    const _0x515396 = _0x21a0cc;
                    (this["DL_FRONT"] = {
                      MOBILE: {
                        FCT: 0x2ee,
                        LCT: 0x1f4,
                        BBT: 0x258,
                        GT: 0x24e,
                        FT: 0x2ee,
                        ET: 0x190,
                        HFT: 0x226,
                        MPT: 0x19,
                        SAT: 0x32,
                        AR: 1.59,
                        MARV: 0.2,
                        EAT: 0xa,
                      },
                      DESKTOP: {
                        FCT: 0x28a,
                        LCT: 0x1f4,
                        BBT: 0x258,
                        GT: 0x24e,
                        FT: 0x1f4,
                        ET: 0x190,
                        HFT: 0x226,
                        MPT: 0x19,
                        SAT: 0x32,
                        AR: 1.59,
                        MARV: 0.2,
                        EAT: 0xa,
                      },
                    }),
                      (this[_0x515396(0x478)] = {
                        MOBILE: {
                          FCT: 0x12c,
                          LCT: 0x1f4,
                          BBT: 0x258,
                          GT: 0x1f4,
                          FT: 0x2b2,
                          ET: 0x190,
                          mrzThreshold: 0x3b6,
                          HFT: 0x1f4,
                          MPT: 0x19,
                          SAT: 0xe1,
                          AR: 1.42045,
                          MARV: 0.2,
                          EAT: 0xa,
                        },
                        DESKTOP: {
                          FCT: 0xfa,
                          LCT: 0x1f4,
                          BBT: 0x258,
                          GT: 0x1f4,
                          FT: 0x1f4,
                          ET: 0x190,
                          mrzThreshold: 0x3b6,
                          HFT: 0x1f4,
                          MPT: 0x19,
                          SAT: 0xe1,
                          AR: 1.42045,
                          MARV: 0.2,
                          EAT: 0xa,
                        },
                      }),
                      (this[_0x515396(0x717)] = {
                        MOBILE: {
                          FCT: 0x258,
                          LCT: 0x0,
                          BBT: 0x0,
                          GT: 0x0,
                          FT: 0x258,
                          ET: 0x14a,
                          HFT: 0x2a3,
                          MPT: 0x19,
                          SAT: 0x63,
                          AR: 2.7,
                          MARV: 0x1,
                          EAT: 0xa,
                        },
                        DESKTOP: {
                          FCT: 0x1f4,
                          LCT: 0x0,
                          BBT: 0x0,
                          GT: 0x0,
                          FT: 0x190,
                          ET: 0x14a,
                          HFT: 0x2a3,
                          MPT: 0x19,
                          SAT: 0x63,
                          AR: 2.7,
                          MARV: 0x1,
                          EAT: 0xa,
                        },
                      }),
                      (this[_0x515396(0x381)] = {
                        MOBILE: {
                          FCT: 0x258,
                          LCT: 0x0,
                          BBT: 0x0,
                          GT: 0x0,
                          FT: 0x32,
                          ET: 0x14a,
                          HFT: 0x2a3,
                          MPT: 0x19,
                          SAT: 0x63,
                          AR: 2.7,
                          MARV: 0x1,
                          EAT: 0xa,
                        },
                        DESKTOP: {
                          FCT: 0x1f4,
                          LCT: 0x0,
                          BBT: 0x0,
                          GT: 0x0,
                          FT: 0x32,
                          ET: 0x14a,
                          HFT: 0x2a3,
                          MPT: 0x19,
                          SAT: 0x63,
                          AR: 2.7,
                          MARV: 0x1,
                          EAT: 0xa,
                        },
                      }),
                      (this[_0x515396(0x434)] = {
                        MOBILE: {
                          FCT: 0x1f4,
                          LCT: 0x1f4,
                          BBT: 0x258,
                          GT: 0x0,
                          FT: 0x2ee,
                          ET: 0x140,
                          HFT: 0x1fe,
                          MPT: 0x14,
                          SAT: 0x63,
                          AR: 1.294,
                          MARV: 0.2,
                          EAT: 0xa,
                        },
                        DESKTOP: {
                          FCT: 0x1f4,
                          LCT: 0x1f4,
                          BBT: 0x258,
                          GT: 0x0,
                          FT: 0x2ee,
                          ET: 0x140,
                          HFT: 0x1fe,
                          MPT: 0x14,
                          SAT: 0x63,
                          AR: 1.294,
                          MARV: 0.2,
                          EAT: 0xa,
                        },
                      }),
                      (this["SELFIE"] = {
                        MOBILE: {
                          FTFT: 0.12,
                          FTCT: 0.75,
                          BT: 0x5,
                          LT: 0xa,
                          HT: 0.7,
                          NT: 0.7,
                          FIGAX: 0xa0,
                          FIGAY: 0x46,
                          HST: 0x46,
                          AALT: 0x37,
                          AAHT: 0x7d,
                          SBVM: 0x15,
                        },
                        DESKTOP: {
                          FTFT: 0.1,
                          FTCT: 0.6,
                          BT: 0x5,
                          LT: 0xa,
                          HT: 0.7,
                          NT: 0.7,
                          FIGAX: 0xa0,
                          FIGAY: 0x46,
                          HST: 0x46,
                          AALT: 0x37,
                          AAHT: 0x7d,
                          SBVM: 0x11,
                        },
                      }),
                      (this[_0x515396(0x36c)] = {
                        MISL: 0x1c2,
                        MAISL: 0x780,
                        MDISL: 0x1000,
                        MP: 0x64,
                        MST: 0x3e8,
                        MHFMS: 0x1388,
                        ML: 0x3,
                        ALML: 0x2,
                        MIVB: 0x7a120,
                        MAVB: 0x5b8d80,
                        MRSM: 0xafc8,
                        AMRTM: 0x493e0,
                        RCM: 0x3e8,
                      }),
                      this[_0x515396(0x22f)]();
                  }
                  [_0x21a0cc(0x22f)]() {}
                })()
              ),
              _0x38cd8b = new (class {
                constructor() {
                  const _0x11d02b = _0x21a0cc;
                  (this["DL_FRONT"] = {
                    documentType: 0xa,
                    detectFourCorners: !0x0,
                    detectGlare: !0x0,
                    detectFocus: !0x0,
                    detectExposure: !0x0,
                    enableLogging: !0x1,
                    detectMRZ: !0x1,
                  }),
                    (this[_0x11d02b(0x692)] = {
                      documentType: 0x14,
                      detectFourCorners: !0x0,
                      detectGlare: !0x0,
                      detectFocus: !0x0,
                      detectExposure: !0x0,
                      enableLogging: !0x1,
                      detectMRZ: !0x1,
                    }),
                    (this[_0x11d02b(0x717)] = {
                      documentType: 0x32,
                      detectFourCorners: !0x0,
                      detectGlare: !0x1,
                      detectFocus: !0x0,
                      detectExposure: !0x0,
                      enableLogging: !0x1,
                      detectMRZ: !0x1,
                    }),
                    (this["CHECK_BACK"] = {
                      documentType: 0x3c,
                      detectFourCorners: !0x0,
                      detectGlare: !0x1,
                      detectFocus: !0x0,
                      detectExposure: !0x0,
                      enableLogging: !0x1,
                      detectMRZ: !0x1,
                    }),
                    (this[_0x11d02b(0x478)] = {
                      documentType: 0x46,
                      detectFourCorners: !0x0,
                      detectGlare: !0x0,
                      detectFocus: !0x0,
                      detectExposure: !0x0,
                      enableLogging: !0x1,
                      detectMRZ: !0x0,
                    }),
                    (this["DOCUMENT"] = {
                      documentType: 0x64,
                      detectFourCorners: !0x0,
                      detectGlare: !0x1,
                      detectFocus: !0x0,
                      detectExposure: !0x0,
                      enableLogging: !0x1,
                      detectMRZ: !0x1,
                    }),
                    (this[_0x11d02b(0x332)] = { inputSize: 0xa0, scoreThreshold: 0.4 }),
                    (this[_0x11d02b(0x268)] = { detectSNR: !0x1, reduceNoise: !0x1 });
                }
              })();
            class _0x533e2a {}
            (_0x533e2a[_0x21a0cc(0x256)] = 0x0),
              (_0x533e2a["mitekSDKPath"] = _0x4decee),
              (_0x533e2a[_0x21a0cc(0x401)] = 0x5a),
              (_0x533e2a[_0x21a0cc(0x1cd)] = 0x1),
              (_0x533e2a[_0x21a0cc(0x3e2)] = 0x2),
              (_0x533e2a[_0x21a0cc(0x6ae)] = 0x2),
              (_0x533e2a[_0x21a0cc(0x2c8)] = ""),
              (_0x533e2a[_0x21a0cc(0x34d)] = 0x4b0),
              (_0x533e2a[_0x21a0cc(0x690)] = !0x1),
              (_0x533e2a[_0x21a0cc(0x2d0)] = !0x1),
              (_0x533e2a["disableMirroring"] = !0x1),
              (_0x533e2a["faceDetectionLevel"] = 0x1),
              (_0x533e2a[_0x21a0cc(0x550)] = !0x1),
              (_0x533e2a[_0x21a0cc(0x6b6)] = !0x1),
              (_0x533e2a["videoQuality"] = 0x46),
              (_0x533e2a[_0x21a0cc(0x1e7)] = "Recording"),
              (_0x533e2a["directFrameData"] = ""),
              (_0x533e2a["phrase"] = _0x21a0cc(0x1bd)),
              (_0x533e2a[_0x21a0cc(0x653)] = !0x1),
              (_0x533e2a[_0x21a0cc(0x6aa)] = ""),
              (_0x533e2a[_0x21a0cc(0x291)] = !0x1),
              (_0x533e2a[_0x21a0cc(0x2f0)] = !0x1);
            const _0x5a835b = _0x533e2a,
              _0x18b1e3 = Object[_0x21a0cc(0x70e)](
                new (class {
                  constructor() {
                    const _0x4c7088 = _0x21a0cc;
                    (this[_0x4c7088(0x349)] = { 0x1: 0.4, 0x2: 0.6, 0x3: 0.8 }),
                      (this["hintAriaLive"] = { 0x0: "off", 0x1: _0x4c7088(0x4b2), 0x2: _0x4c7088(0x26b) }),
                      (this["hintMessageSize"] = { 0x1: _0x4c7088(0x499), 0x2: _0x4c7088(0x50e), 0x3: _0x4c7088(0x254) });
                  }
                })()
              );
            var _0x3b8467 = _0x4e8c13(0x1b8);
            const _0xb74c84 = new (class {
              constructor() {
                const _0x167757 = _0x21a0cc;
                (this[_0x167757(0x4ea)] = "MobileWeb\x205.4.0"),
                  (this[_0x167757(0x44a)] = "2.2"),
                  (this["thresholds"] = _0x3bd437),
                  (this[_0x167757(0x4aa)] = _0x5a835b),
                  (this[_0x167757(0x698)] = _0x38cd8b),
                  (this[_0x167757(0x3c8)] = _0x4decee),
                  (this["deviceInfo"] = {
                    userAgent: _0x337ea4["Z"][_0x167757(0x2c5)],
                    isAndroid: _0x337ea4["Z"][_0x167757(0x52b)](),
                    isMobile: _0x337ea4["Z"][_0x167757(0x4b1)](),
                    supportsUserMedia: _0x337ea4["Z"][_0x167757(0x2a1)](),
                    supportsWasm: _0x337ea4["Z"][_0x167757(0x418)](),
                    supportsWebGl: _0x337ea4["Z"][_0x167757(0x4a9)](),
                    deviceType: _0x337ea4["Z"]["isMobile"]() ? _0x167757(0x477) : "DESKTOP",
                    isSafari: _0x337ea4["Z"]["isSafari"](),
                    isIE: _0x337ea4["Z"][_0x167757(0x2fa)](),
                  }),
                  (this[_0x167757(0x201)] = [_0x167757(0x480), _0x167757(0x684)]),
                  (this[_0x167757(0x3ac)] = _0x18cd64),
                  (this[_0x167757(0x3b1)] = _0x18b1e3);
              }
              ["getCVThresholds"](_0x3343c8, _0x31e87b) {
                const _0x1b634b = _0x21a0cc;
                try {
                  return this["thresholds"][_0x3343c8][_0x31e87b];
                } catch (_0x4862ec) {
                  throw new _0x3b8467["Z"]("RUNTIME_UNKNOWN_ERROR", new Error(_0x1b634b(0x6d1) + _0x3343c8));
                }
              }
              ["getActionTypeRecognizerSettings"](_0x5b5182) {
                const _0x55da68 = _0x21a0cc;
                try {
                  return this[_0x55da68(0x698)][_0x5b5182];
                } catch (_0x136633) {
                  throw new Error(_0x55da68(0x6d1) + _0x5b5182);
                }
              }
              ["getFaceAPIRecognizerSettings"]() {
                const _0x5e7738 = _0x21a0cc;
                try {
                  return this[_0x5e7738(0x698)][_0x5e7738(0x332)];
                } catch (_0x224873) {
                  throw new Error(
                    "AppConfigObject:\x20unable\x20to\x20read\x20actionTypeRecognizerSettings\x20for\x20action\x20type\x20SELFIE"
                  );
                }
              }
              [_0x21a0cc(0x25a)]() {
                try {
                  return this["actionTypeRecognizerSettings"]["VOICE"];
                } catch (_0x1cac76) {
                  throw new Error(
                    "AppConfigObject:\x20unable\x20to\x20read\x20actionTypeRecognizerSettings\x20for\x20action\x20type\x20VOICE"
                  );
                }
              }
            })();
            var _0x5231f9 = _0x4e8c13(0x177),
              _0x461478 = _0x4e8c13(0x141),
              _0x4766d7 = _0x4e8c13(0x127);
            const _0x12b809 = class {
              constructor(_0x4f5c9c) {
                const _0x3a94e9 = _0x21a0cc;
                var _0x5a2783,
                  _0x413c8d,
                  _0x39f99e,
                  _0x376877,
                  _0x66e174,
                  _0x309e12,
                  _0x3af4b8,
                  _0x3bc955,
                  _0x19245c,
                  _0x3cf8ca,
                  _0x2d9037,
                  _0x283567,
                  _0x12c326,
                  _0x29a8c5,
                  _0x52550c,
                  _0x4b5c65,
                  _0x4ac701,
                  _0x545206,
                  _0x457fb2,
                  _0x4095a4,
                  _0xb958fa,
                  _0x2f9b6a,
                  _0x367214,
                  _0x3f55d9,
                  _0x53f6d0,
                  _0x59980c,
                  _0x16557c,
                  _0x43ea0f,
                  _0x163ffd,
                  _0x38d335,
                  _0x3de4dc,
                  _0x24465f,
                  _0x19bc0a,
                  _0x9dfbab,
                  _0x4400e1,
                  _0x3a1127,
                  _0x5b699a,
                  _0x57d5f4,
                  _0x524f9a,
                  _0x3789f9,
                  _0x1adda3,
                  _0x1f6279,
                  _0x358152,
                  _0x13431e,
                  _0x286cc0,
                  _0x168e9a,
                  _0x3a1232,
                  _0x481b79,
                  _0x1adfde,
                  _0x385dbb,
                  _0x508b38,
                  _0x2a6274;
                (this[_0x3a94e9(0x54f)] = _0x5a835b[_0x3a94e9(0x64d)]),
                  (this["_qualityPercent"] = _0x5a835b[_0x3a94e9(0x401)]),
                  (this[_0x3a94e9(0x66b)] = _0x5a835b[_0x3a94e9(0x256)]),
                  (this["_guidePaddingLevel"] = _0x5a835b[_0x3a94e9(0x1cd)]),
                  (this[_0x3a94e9(0x3e4)] = _0x5a835b["videoContainerId"]),
                  (this[_0x3a94e9(0x582)] = _0x5a835b[_0x3a94e9(0x653)]),
                  (this[_0x3a94e9(0x579)] = _0x5a835b["videoSource"]),
                  (this[_0x3a94e9(0x2f3)] = _0x5a835b[_0x3a94e9(0x29c)]),
                  (this[_0x3a94e9(0x510)] = _0x5a835b[_0x3a94e9(0x2d0)]),
                  (this["_faceDetectionLevel"] = _0x5a835b[_0x3a94e9(0x300)]),
                  (this["_redactMRZOptionalData"] = _0x5a835b[_0x3a94e9(0x291)]),
                  (this[_0x3a94e9(0x49d)] = _0x5a835b[_0x3a94e9(0x6ae)]),
                  (this["_hintFrequencyMS"] = _0x5a835b[_0x3a94e9(0x34d)]),
                  (this[_0x3a94e9(0x49f)] = _0x5a835b["hintForceUpdate"]),
                  (this["_hintAriaLive"] = _0x5a835b["hintAriaLive"]),
                  (this[_0x3a94e9(0x705)] = _0x5a835b[_0x3a94e9(0x550)]),
                  (this[_0x3a94e9(0x36a)] = _0x5a835b[_0x3a94e9(0x6b6)]),
                  (this["_videoQuality"] = _0x5a835b[_0x3a94e9(0x4fb)]),
                  (this[_0x3a94e9(0x364)] = _0x5a835b["videoRecordingMessage"]),
                  (this[_0x3a94e9(0x6ed)] = _0x5a835b[_0x3a94e9(0x63d)]),
                  (this[_0x3a94e9(0x66a)] = _0x5a835b[_0x3a94e9(0x663)]),
                  (this["_useDeviceIdSignal"] = _0x5a835b[_0x3a94e9(0x2f0)]),
                  (this[_0x3a94e9(0x53c)] = _0x4f5c9c["mode"]),
                  (this[_0x3a94e9(0x59a)] = _0x4f5c9c[_0x3a94e9(0x59a)]),
                  _0x461478["Z"][_0x3a94e9(0x711)](_0x4f5c9c["mitekSDKPath"]) && (this[_0x3a94e9(0x64d)] = _0x4f5c9c["mitekSDKPath"]),
                  _0x461478["Z"][_0x3a94e9(0x711)](
                    null === (_0x5a2783 = _0x4f5c9c[_0x3a94e9(0x4aa)]) || void 0x0 === _0x5a2783 ? void 0x0 : _0x5a2783["qualityPercent"]
                  ) &&
                    (this[_0x3a94e9(0x401)] =
                      null === (_0x413c8d = _0x4f5c9c["options"]) || void 0x0 === _0x413c8d ? void 0x0 : _0x413c8d[_0x3a94e9(0x401)]),
                  _0x461478["Z"][_0x3a94e9(0x711)](
                    null === (_0x39f99e = _0x4f5c9c["options"]) || void 0x0 === _0x39f99e ? void 0x0 : _0x39f99e[_0x3a94e9(0x256)]
                  ) &&
                    (this["debugLevel"] =
                      null === (_0x376877 = _0x4f5c9c[_0x3a94e9(0x4aa)]) || void 0x0 === _0x376877
                        ? void 0x0
                        : _0x376877[_0x3a94e9(0x256)]),
                  _0x461478["Z"][_0x3a94e9(0x711)](
                    null === (_0x66e174 = _0x4f5c9c[_0x3a94e9(0x4aa)]) || void 0x0 === _0x66e174 ? void 0x0 : _0x66e174[_0x3a94e9(0x1cd)]
                  ) &&
                    (this[_0x3a94e9(0x1cd)] =
                      null === (_0x309e12 = _0x4f5c9c[_0x3a94e9(0x4aa)]) || void 0x0 === _0x309e12
                        ? void 0x0
                        : _0x309e12[_0x3a94e9(0x1cd)]),
                  _0x461478["Z"]["isDefined"](
                    null === (_0x3af4b8 = _0x4f5c9c[_0x3a94e9(0x4aa)]) || void 0x0 === _0x3af4b8 ? void 0x0 : _0x3af4b8[_0x3a94e9(0x653)]
                  ) &&
                    (this[_0x3a94e9(0x653)] =
                      null === (_0x3bc955 = _0x4f5c9c[_0x3a94e9(0x4aa)]) || void 0x0 === _0x3bc955
                        ? void 0x0
                        : _0x3bc955[_0x3a94e9(0x653)]),
                  _0x461478["Z"][_0x3a94e9(0x711)](
                    null === (_0x19245c = _0x4f5c9c[_0x3a94e9(0x4aa)]) || void 0x0 === _0x19245c ? void 0x0 : _0x19245c[_0x3a94e9(0x291)]
                  ) &&
                    (this[_0x3a94e9(0x291)] =
                      null === (_0x3cf8ca = _0x4f5c9c[_0x3a94e9(0x4aa)]) || void 0x0 === _0x3cf8ca
                        ? void 0x0
                        : _0x3cf8ca[_0x3a94e9(0x291)]),
                  _0x461478["Z"][_0x3a94e9(0x711)](
                    null === (_0x2d9037 = _0x4f5c9c[_0x3a94e9(0x4aa)]) || void 0x0 === _0x2d9037 ? void 0x0 : _0x2d9037["useDeviceIdSignal"]
                  ) &&
                    (this["useDeviceIdSignal"] =
                      null === (_0x283567 = _0x4f5c9c[_0x3a94e9(0x4aa)]) || void 0x0 === _0x283567
                        ? void 0x0
                        : _0x283567[_0x3a94e9(0x2f0)]),
                  _0x3a94e9(0x587) === _0x4f5c9c[_0x3a94e9(0x53c)] &&
                    (_0x461478["Z"]["isDefined"](
                      null === (_0x12c326 = _0x4f5c9c[_0x3a94e9(0x4aa)]) || void 0x0 === _0x12c326 ? void 0x0 : _0x12c326[_0x3a94e9(0x2c8)]
                    ) &&
                      (this[_0x3a94e9(0x2c8)] =
                        null === (_0x29a8c5 = _0x4f5c9c[_0x3a94e9(0x4aa)]) || void 0x0 === _0x29a8c5
                          ? void 0x0
                          : _0x29a8c5["videoContainerId"]),
                    _0x461478["Z"][_0x3a94e9(0x711)](
                      null === (_0x52550c = _0x4f5c9c[_0x3a94e9(0x4aa)]) || void 0x0 === _0x52550c ? void 0x0 : _0x52550c[_0x3a94e9(0x6aa)]
                    ) &&
                      (this[_0x3a94e9(0x6aa)] =
                        null === (_0x4b5c65 = _0x4f5c9c[_0x3a94e9(0x4aa)]) || void 0x0 === _0x4b5c65
                          ? void 0x0
                          : _0x4b5c65[_0x3a94e9(0x6aa)]),
                    _0x461478["Z"][_0x3a94e9(0x711)](
                      null === (_0x4ac701 = _0x4f5c9c["options"]) || void 0x0 === _0x4ac701 ? void 0x0 : _0x4ac701["disableSmileDetection"]
                    ) &&
                      (this["disableSmileDetection"] =
                        null === (_0x545206 = _0x4f5c9c["options"]) || void 0x0 === _0x545206 ? void 0x0 : _0x545206[_0x3a94e9(0x2d0)]),
                    _0x461478["Z"][_0x3a94e9(0x711)](
                      null === (_0x457fb2 = _0x4f5c9c["options"]) || void 0x0 === _0x457fb2 ? void 0x0 : _0x457fb2[_0x3a94e9(0x300)]
                    ) &&
                      (this["faceDetectionLevel"] =
                        null === (_0x4095a4 = _0x4f5c9c["options"]) || void 0x0 === _0x4095a4 ? void 0x0 : _0x4095a4[_0x3a94e9(0x300)]),
                    _0x461478["Z"][_0x3a94e9(0x711)](
                      null === (_0xb958fa = _0x4f5c9c[_0x3a94e9(0x4aa)]) || void 0x0 === _0xb958fa ? void 0x0 : _0xb958fa[_0x3a94e9(0x6ae)]
                    ) &&
                      (this[_0x3a94e9(0x6ae)] =
                        null === (_0x2f9b6a = _0x4f5c9c[_0x3a94e9(0x4aa)]) || void 0x0 === _0x2f9b6a
                          ? void 0x0
                          : _0x2f9b6a[_0x3a94e9(0x6ae)]),
                    _0x461478["Z"][_0x3a94e9(0x711)](
                      null === (_0x367214 = _0x4f5c9c["options"]) || void 0x0 === _0x367214 ? void 0x0 : _0x367214["hintFrequencyMS"]
                    ) &&
                      (this[_0x3a94e9(0x34d)] =
                        null === (_0x3f55d9 = _0x4f5c9c[_0x3a94e9(0x4aa)]) || void 0x0 === _0x3f55d9
                          ? void 0x0
                          : _0x3f55d9[_0x3a94e9(0x34d)]),
                    _0x461478["Z"][_0x3a94e9(0x711)](
                      null === (_0x53f6d0 = _0x4f5c9c["options"]) || void 0x0 === _0x53f6d0 ? void 0x0 : _0x53f6d0[_0x3a94e9(0x690)]
                    ) &&
                      (this[_0x3a94e9(0x690)] =
                        null === (_0x59980c = _0x4f5c9c[_0x3a94e9(0x4aa)]) || void 0x0 === _0x59980c
                          ? void 0x0
                          : _0x59980c[_0x3a94e9(0x690)]),
                    _0x461478["Z"][_0x3a94e9(0x711)](
                      null === (_0x16557c = _0x4f5c9c[_0x3a94e9(0x4aa)]) || void 0x0 === _0x16557c ? void 0x0 : _0x16557c[_0x3a94e9(0x3e2)]
                    ) &&
                      (this[_0x3a94e9(0x3e2)] =
                        null === (_0x43ea0f = _0x4f5c9c["options"]) || void 0x0 === _0x43ea0f ? void 0x0 : _0x43ea0f[_0x3a94e9(0x3e2)]),
                    _0x461478["Z"]["isDefined"](
                      null === (_0x163ffd = _0x4f5c9c[_0x3a94e9(0x4aa)]) || void 0x0 === _0x163ffd ? void 0x0 : _0x163ffd[_0x3a94e9(0x550)]
                    ) &&
                      (this["videoRecordingEnabled"] =
                        null === (_0x38d335 = _0x4f5c9c[_0x3a94e9(0x4aa)]) || void 0x0 === _0x38d335
                          ? void 0x0
                          : _0x38d335["videoRecordingEnabled"]),
                    _0x461478["Z"][_0x3a94e9(0x711)](
                      null === (_0x3de4dc = _0x4f5c9c[_0x3a94e9(0x4aa)]) || void 0x0 === _0x3de4dc ? void 0x0 : _0x3de4dc[_0x3a94e9(0x6b6)]
                    ) &&
                      (this["audioRecordingEnabled"] =
                        null === (_0x24465f = _0x4f5c9c[_0x3a94e9(0x4aa)]) || void 0x0 === _0x24465f
                          ? void 0x0
                          : _0x24465f[_0x3a94e9(0x6b6)]),
                    _0x461478["Z"][_0x3a94e9(0x711)](
                      null === (_0x19bc0a = _0x4f5c9c[_0x3a94e9(0x4aa)]) || void 0x0 === _0x19bc0a ? void 0x0 : _0x19bc0a[_0x3a94e9(0x4fb)]
                    ) &&
                      (this[_0x3a94e9(0x4fb)] =
                        null === (_0x9dfbab = _0x4f5c9c["options"]) || void 0x0 === _0x9dfbab ? void 0x0 : _0x9dfbab[_0x3a94e9(0x4fb)]),
                    _0x461478["Z"]["isDefined"](
                      null === (_0x4400e1 = _0x4f5c9c["options"]) || void 0x0 === _0x4400e1 ? void 0x0 : _0x4400e1["videoRecordingMessage"]
                    ) &&
                      (this[_0x3a94e9(0x1e7)] =
                        null === (_0x3a1127 = _0x4f5c9c[_0x3a94e9(0x4aa)]) || void 0x0 === _0x3a1127
                          ? void 0x0
                          : _0x3a1127[_0x3a94e9(0x1e7)])),
                  _0x3a94e9(0x33b) === _0x4f5c9c["mode"] &&
                    _0x461478["Z"][_0x3a94e9(0x711)](
                      null === (_0x5b699a = _0x4f5c9c[_0x3a94e9(0x4aa)]) || void 0x0 === _0x5b699a ? void 0x0 : _0x5b699a[_0x3a94e9(0x5f3)]
                    ) &&
                    (this[_0x3a94e9(0x5f3)] =
                      null === (_0x57d5f4 = _0x4f5c9c[_0x3a94e9(0x4aa)]) || void 0x0 === _0x57d5f4 ? void 0x0 : _0x57d5f4["frame"]),
                  _0x3a94e9(0x268) === _0x4f5c9c[_0x3a94e9(0x59a)] &&
                    _0x461478["Z"][_0x3a94e9(0x711)](
                      null === (_0x524f9a = _0x4f5c9c[_0x3a94e9(0x4aa)]) || void 0x0 === _0x524f9a ? void 0x0 : _0x524f9a[_0x3a94e9(0x663)]
                    ) &&
                    (this[_0x3a94e9(0x663)] =
                      null === (_0x3789f9 = _0x4f5c9c[_0x3a94e9(0x4aa)]) || void 0x0 === _0x3789f9 ? void 0x0 : _0x3789f9["phrase"]),
                  _0x461478["Z"][_0x3a94e9(0x711)](
                    null === (_0x1adda3 = _0x4f5c9c["options"]) || void 0x0 === _0x1adda3 ? void 0x0 : _0x1adda3[_0x3a94e9(0x1d8)]
                  ) &&
                    (this[_0x3a94e9(0x1d8)] =
                      null === (_0x1f6279 = _0x4f5c9c["options"]) || void 0x0 === _0x1f6279 ? void 0x0 : _0x1f6279[_0x3a94e9(0x1d8)]),
                  _0x461478["Z"][_0x3a94e9(0x711)](
                    null === (_0x358152 = _0x4f5c9c[_0x3a94e9(0x4aa)]) || void 0x0 === _0x358152 ? void 0x0 : _0x358152[_0x3a94e9(0x451)]
                  ) &&
                    (this[_0x3a94e9(0x451)] =
                      null === (_0x13431e = _0x4f5c9c[_0x3a94e9(0x4aa)]) || void 0x0 === _0x13431e
                        ? void 0x0
                        : _0x13431e[_0x3a94e9(0x451)]),
                  _0x461478["Z"][_0x3a94e9(0x711)](
                    null === (_0x286cc0 = _0x4f5c9c[_0x3a94e9(0x4aa)]) || void 0x0 === _0x286cc0 ? void 0x0 : _0x286cc0[_0x3a94e9(0x2cb)]
                  ) &&
                    (this[_0x3a94e9(0x2cb)] =
                      null === (_0x168e9a = _0x4f5c9c[_0x3a94e9(0x4aa)]) || void 0x0 === _0x168e9a
                        ? void 0x0
                        : _0x168e9a[_0x3a94e9(0x2cb)]),
                  _0x461478["Z"][_0x3a94e9(0x711)](
                    null === (_0x3a1232 = _0x4f5c9c["options"]) || void 0x0 === _0x3a1232 ? void 0x0 : _0x3a1232[_0x3a94e9(0x1be)]
                  ) &&
                    (this["exposure"] =
                      null === (_0x481b79 = _0x4f5c9c[_0x3a94e9(0x4aa)]) || void 0x0 === _0x481b79 ? void 0x0 : _0x481b79["exposure"]),
                  _0x461478["Z"][_0x3a94e9(0x711)](
                    null === (_0x1adfde = _0x4f5c9c[_0x3a94e9(0x4aa)]) || void 0x0 === _0x1adfde ? void 0x0 : _0x1adfde[_0x3a94e9(0x6dc)]
                  ) &&
                    (this[_0x3a94e9(0x6dc)] =
                      null === (_0x385dbb = _0x4f5c9c["options"]) || void 0x0 === _0x385dbb ? void 0x0 : _0x385dbb[_0x3a94e9(0x6dc)]),
                  _0x461478["Z"][_0x3a94e9(0x711)](
                    null === (_0x508b38 = _0x4f5c9c[_0x3a94e9(0x4aa)]) || void 0x0 === _0x508b38 ? void 0x0 : _0x508b38[_0x3a94e9(0x3cc)]
                  ) &&
                    (this[_0x3a94e9(0x3cc)] =
                      null === (_0x2a6274 = _0x4f5c9c[_0x3a94e9(0x4aa)]) || void 0x0 === _0x2a6274
                        ? void 0x0
                        : _0x2a6274[_0x3a94e9(0x3cc)]);
              }
              [_0x21a0cc(0x365)](_0x1bc73c) {
                const _0x35eeeb = _0x21a0cc;
                switch (_0x1bc73c) {
                  case "AUTO_CAPTURE":
                    return _0x35eeeb(0x548);
                  case _0x35eeeb(0x609):
                    return _0x35eeeb(0x54b);
                  case _0x35eeeb(0x33b):
                    return _0x35eeeb(0x33b);
                  default:
                    return _0x35eeeb(0x42b);
                }
              }
              get [_0x21a0cc(0x53c)]() {
                const _0x1a6561 = _0x21a0cc;
                return this[_0x1a6561(0x699)];
              }
              get [_0x21a0cc(0x64d)]() {
                const _0x463c37 = _0x21a0cc;
                return this[_0x463c37(0x54f)];
              }
              get [_0x21a0cc(0x59a)]() {
                return this["_documentType"];
              }
              get [_0x21a0cc(0x401)]() {
                const _0x489d4b = _0x21a0cc;
                return this[_0x489d4b(0x51e)];
              }
              get ["debugLevel"]() {
                const _0x430946 = _0x21a0cc;
                return this[_0x430946(0x66b)];
              }
              get ["guidePaddingLevel"]() {
                const _0x46352f = _0x21a0cc;
                return this[_0x46352f(0x664)];
              }
              get [_0x21a0cc(0x2c8)]() {
                const _0x13a6da = _0x21a0cc;
                return this[_0x13a6da(0x3e4)];
              }
              get [_0x21a0cc(0x6aa)]() {
                const _0x101ec9 = _0x21a0cc;
                return this[_0x101ec9(0x579)];
              }
              get [_0x21a0cc(0x2d0)]() {
                return this["_disableSmileDetection"];
              }
              get ["redactMRZOptionalData"]() {
                const _0x2be8ce = _0x21a0cc;
                return this[_0x2be8ce(0x5ce)];
              }
              get [_0x21a0cc(0x29c)]() {
                return this["_disableMirroring"];
              }
              get [_0x21a0cc(0x300)]() {
                const _0x38ac46 = _0x21a0cc;
                return this[_0x38ac46(0x5d2)];
              }
              get [_0x21a0cc(0x6ae)]() {
                const _0x10740f = _0x21a0cc;
                return this[_0x10740f(0x49d)];
              }
              get [_0x21a0cc(0x34d)]() {
                const _0x2f899e = _0x21a0cc;
                return this[_0x2f899e(0x271)];
              }
              get [_0x21a0cc(0x690)]() {
                const _0xd19530 = _0x21a0cc;
                return this[_0xd19530(0x49f)];
              }
              get [_0x21a0cc(0x3e2)]() {
                const _0xa790ff = _0x21a0cc;
                return this[_0xa790ff(0x34c)];
              }
              get [_0x21a0cc(0x550)]() {
                const _0x3c033a = _0x21a0cc;
                return this[_0x3c033a(0x705)];
              }
              get [_0x21a0cc(0x6b6)]() {
                const _0x2e4918 = _0x21a0cc;
                return this[_0x2e4918(0x36a)];
              }
              get ["videoQuality"]() {
                const _0x307555 = _0x21a0cc;
                return this[_0x307555(0x3ba)];
              }
              get [_0x21a0cc(0x1e7)]() {
                const _0x1b1848 = _0x21a0cc;
                return this[_0x1b1848(0x364)];
              }
              get ["disablePerpendicularCapture"]() {
                const _0x507f79 = _0x21a0cc;
                return this[_0x507f79(0x582)];
              }
              get [_0x21a0cc(0x5f3)]() {
                const _0x567b5c = _0x21a0cc;
                return this[_0x567b5c(0x6ed)];
              }
              get [_0x21a0cc(0x663)]() {
                return this["_phrase"];
              }
              get ["fourCorner"]() {
                const _0x1996a5 = _0x21a0cc;
                return this[_0x1996a5(0x299)];
              }
              get [_0x21a0cc(0x451)]() {
                const _0x2e39f7 = _0x21a0cc;
                return this[_0x2e39f7(0x4dd)];
              }
              get ["focus"]() {
                const _0x363e9d = _0x21a0cc;
                return this[_0x363e9d(0x1eb)];
              }
              get [_0x21a0cc(0x1be)]() {
                const _0x23e2ef = _0x21a0cc;
                return this[_0x23e2ef(0x3c0)];
              }
              get [_0x21a0cc(0x6dc)]() {
                const _0x5debba = _0x21a0cc;
                return this[_0x5debba(0x526)];
              }
              get ["horizontalFill"]() {
                const _0x3a8684 = _0x21a0cc;
                return this[_0x3a8684(0x67e)];
              }
              get [_0x21a0cc(0x2f0)]() {
                const _0x377e33 = _0x21a0cc;
                return this[_0x377e33(0x60f)];
              }
              set [_0x21a0cc(0x53c)](_0x298c10) {
                const _0x3f4f12 = _0x21a0cc;
                this[_0x3f4f12(0x699)] = this["convertToInternalActionMode"](_0x298c10);
              }
              set [_0x21a0cc(0x59a)](_0x4bb8d7) {
                const _0x1b37bc = _0x21a0cc;
                this[_0x1b37bc(0x542)] = _0x4bb8d7;
              }
              set [_0x21a0cc(0x64d)](_0x2da870) {
                const _0x2e99dd = _0x21a0cc;
                _0x461478["Z"]["isString"](_0x2da870)
                  ? (this[_0x2e99dd(0x54f)] = _0x2da870)
                  : _0x4766d7["Z"][_0x2e99dd(0x21f)](
                      new _0x3b8467["Z"]("VALIDATOR_BAD_COMMAND_OPTIONS_VALUE_OR_TYPE", new Error()),
                      _0x2e99dd(0x64d)
                    );
              }
              set ["qualityPercent"](_0x5bd536) {
                const _0x41c6dd = _0x21a0cc;
                _0x461478["Z"][_0x41c6dd(0x588)](0x1, _0x3bd437["BASE"]["MP"], _0x5bd536)
                  ? (this[_0x41c6dd(0x51e)] = _0x5bd536)
                  : _0x4766d7["Z"][_0x41c6dd(0x21f)](new _0x3b8467["Z"](_0x41c6dd(0x21c), new Error()), "qualityPercent");
              }
              set [_0x21a0cc(0x256)](_0x1cb4bc) {
                const _0x5bcb1b = _0x21a0cc;
                _0x461478["Z"]["isBetween"](0x0, 0x1, _0x1cb4bc)
                  ? (this[_0x5bcb1b(0x66b)] = _0x1cb4bc)
                  : _0x4766d7["Z"][_0x5bcb1b(0x21f)](new _0x3b8467["Z"](_0x5bcb1b(0x21c), new Error()), _0x5bcb1b(0x256));
              }
              set [_0x21a0cc(0x2c8)](_0x205997) {
                const _0x22ed5c = _0x21a0cc;
                _0x461478["Z"][_0x22ed5c(0x28c)](_0x205997)
                  ? (this[_0x22ed5c(0x3e4)] = _0x205997)
                  : _0x4766d7["Z"][_0x22ed5c(0x21f)](new _0x3b8467["Z"](_0x22ed5c(0x21c), new Error()), _0x22ed5c(0x2c8));
              }
              set [_0x21a0cc(0x6aa)](_0x54a61e) {
                const _0x4ce793 = _0x21a0cc;
                _0x461478["Z"][_0x4ce793(0x28c)](_0x54a61e)
                  ? (this["_videoSource"] = _0x54a61e)
                  : _0x4766d7["Z"][_0x4ce793(0x21f)](
                      new _0x3b8467["Z"]("VALIDATOR_BAD_COMMAND_OPTIONS_VALUE_OR_TYPE", new Error()),
                      _0x4ce793(0x31e)
                    );
              }
              set [_0x21a0cc(0x1cd)](_0x7820c5) {
                const _0x441d25 = _0x21a0cc;
                _0x461478["Z"]["isBetween"](0x1, _0x3bd437[_0x441d25(0x36c)]["ML"], _0x7820c5)
                  ? (this["_guidePaddingLevel"] = _0x7820c5)
                  : _0x4766d7["Z"]["handleValidationErrorMessage"](
                      new _0x3b8467["Z"]("VALIDATOR_BAD_COMMAND_OPTIONS_VALUE_OR_TYPE", new Error()),
                      _0x441d25(0x1cd)
                    );
              }
              set ["hintFrequencyMS"](_0x41767f) {
                const _0x3e47f5 = _0x21a0cc;
                _0x461478["Z"][_0x3e47f5(0x588)](0x1, _0x3bd437["BASE"][_0x3e47f5(0x519)], _0x41767f)
                  ? (this[_0x3e47f5(0x271)] = _0x41767f)
                  : _0x4766d7["Z"][_0x3e47f5(0x21f)](new _0x3b8467["Z"](_0x3e47f5(0x21c), new Error()), _0x3e47f5(0x34d));
              }
              set ["hintForceUpdate"](_0x2a1ba2) {
                const _0x479e69 = _0x21a0cc;
                _0x461478["Z"][_0x479e69(0x279)](_0x2a1ba2)
                  ? (this[_0x479e69(0x49f)] = _0x2a1ba2)
                  : _0x4766d7["Z"][_0x479e69(0x21f)](
                      new _0x3b8467["Z"]("VALIDATOR_BAD_COMMAND_OPTIONS_VALUE_OR_TYPE", new Error()),
                      _0x479e69(0x34d)
                    );
              }
              set [_0x21a0cc(0x3e2)](_0x2c68b8) {
                const _0x213593 = _0x21a0cc;
                _0x461478["Z"]["isBetween"](0x0, _0x3bd437["BASE"][_0x213593(0x260)], _0x2c68b8)
                  ? (this[_0x213593(0x34c)] = _0x2c68b8)
                  : _0x4766d7["Z"]["handleValidationErrorMessage"](new _0x3b8467["Z"](_0x213593(0x21c), new Error()), _0x213593(0x3e2));
              }
              set [_0x21a0cc(0x6ae)](_0x200d92) {
                const _0x495527 = _0x21a0cc;
                _0x461478["Z"][_0x495527(0x588)](0x1, _0x3bd437[_0x495527(0x36c)]["ML"], _0x200d92)
                  ? (this[_0x495527(0x49d)] = _0x200d92)
                  : _0x4766d7["Z"][_0x495527(0x21f)](new _0x3b8467["Z"](_0x495527(0x21c), new Error()), _0x495527(0x6ae));
              }
              set [_0x21a0cc(0x2d0)](_0x3f7739) {
                const _0x4658f3 = _0x21a0cc;
                _0x461478["Z"][_0x4658f3(0x279)](_0x3f7739)
                  ? (this[_0x4658f3(0x510)] = _0x3f7739)
                  : _0x4766d7["Z"]["handleValidationErrorMessage"](new _0x3b8467["Z"](_0x4658f3(0x21c), new Error()), _0x4658f3(0x2d0));
              }
              set [_0x21a0cc(0x291)](_0x1e9ec3) {
                const _0x5bfebf = _0x21a0cc;
                _0x461478["Z"]["isBoolean"](_0x1e9ec3)
                  ? (this["_redactMRZOptionalData"] = _0x1e9ec3)
                  : _0x4766d7["Z"]["handleValidationErrorMessage"](
                      new _0x3b8467["Z"](_0x5bfebf(0x21c), new Error()),
                      "redactMRZOptionalData"
                    );
              }
              set [_0x21a0cc(0x29c)](_0x4099ca) {
                const _0x41d560 = _0x21a0cc;
                _0x461478["Z"][_0x41d560(0x279)](_0x4099ca)
                  ? (this[_0x41d560(0x2f3)] = _0x4099ca)
                  : _0x4766d7["Z"]["handleValidationErrorMessage"](
                      new _0x3b8467["Z"]("VALIDATOR_BAD_COMMAND_OPTIONS_VALUE_OR_TYPE", new Error()),
                      _0x41d560(0x4a4)
                    );
              }
              set [_0x21a0cc(0x300)](_0x23c1a9) {
                const _0x29526d = _0x21a0cc;
                _0x461478["Z"][_0x29526d(0x588)](0x1, _0x3bd437["BASE"]["ML"], _0x23c1a9)
                  ? (this[_0x29526d(0x5d2)] = _0x23c1a9)
                  : _0x4766d7["Z"][_0x29526d(0x21f)](new _0x3b8467["Z"](_0x29526d(0x21c), new Error()), _0x29526d(0x300));
              }
              set [_0x21a0cc(0x550)](_0x4d3a2c) {
                const _0x3c89d0 = _0x21a0cc;
                _0x461478["Z"][_0x3c89d0(0x279)](_0x4d3a2c)
                  ? (this["_videoRecordingEnabled"] = _0x4d3a2c)
                  : _0x4766d7["Z"][_0x3c89d0(0x21f)](
                      new _0x3b8467["Z"]("VALIDATOR_BAD_COMMAND_OPTIONS_VALUE_OR_TYPE", new Error()),
                      _0x3c89d0(0x550)
                    );
              }
              set [_0x21a0cc(0x6b6)](_0x89ffe1) {
                const _0x1462c9 = _0x21a0cc;
                _0x461478["Z"][_0x1462c9(0x279)](_0x89ffe1)
                  ? (this["_audioRecordingEnabled"] = _0x89ffe1)
                  : _0x4766d7["Z"][_0x1462c9(0x21f)](new _0x3b8467["Z"](_0x1462c9(0x21c), new Error()), _0x1462c9(0x6b6));
              }
              set [_0x21a0cc(0x4fb)](_0x4b3b3a) {
                const _0x5e5aa5 = _0x21a0cc;
                _0x461478["Z"][_0x5e5aa5(0x588)](0x1, _0x3bd437[_0x5e5aa5(0x36c)]["MP"], _0x4b3b3a)
                  ? (this["_videoQuality"] = _0x4b3b3a)
                  : _0x4766d7["Z"]["handleValidationErrorMessage"](new _0x3b8467["Z"](_0x5e5aa5(0x21c), new Error()), "videoQuality");
              }
              set [_0x21a0cc(0x1e7)](_0x2f8f63) {
                const _0x59fdec = _0x21a0cc;
                _0x461478["Z"]["isString"](_0x2f8f63)
                  ? (this[_0x59fdec(0x364)] = _0x2f8f63[_0x59fdec(0x5d1)]())
                  : _0x4766d7["Z"]["handleValidationErrorMessage"](new _0x3b8467["Z"](_0x59fdec(0x21c), new Error()), _0x59fdec(0x1e7));
              }
              set [_0x21a0cc(0x1d8)](_0x210743) {
                const _0x1d4b07 = _0x21a0cc;
                _0x461478["Z"][_0x1d4b07(0x588)](0x0, _0x3bd437[_0x1d4b07(0x36c)][_0x1d4b07(0x619)], _0x210743)
                  ? (this["_fourCorner"] = _0x210743)
                  : _0x4766d7["Z"][_0x1d4b07(0x21f)](new _0x3b8467["Z"](_0x1d4b07(0x21c), new Error()), _0x1d4b07(0x1d8));
              }
              set [_0x21a0cc(0x451)](_0x167ba3) {
                const _0x2a4e61 = _0x21a0cc;
                _0x461478["Z"]["isBetween"](0x0, _0x3bd437["BASE"][_0x2a4e61(0x619)], _0x167ba3)
                  ? (this[_0x2a4e61(0x4dd)] = _0x167ba3)
                  : _0x4766d7["Z"]["handleValidationErrorMessage"](new _0x3b8467["Z"](_0x2a4e61(0x21c), new Error()), "glare");
              }
              set [_0x21a0cc(0x2cb)](_0x4f1514) {
                const _0x30e879 = _0x21a0cc;
                _0x461478["Z"][_0x30e879(0x588)](0x0, _0x3bd437[_0x30e879(0x36c)][_0x30e879(0x619)], _0x4f1514)
                  ? (this[_0x30e879(0x1eb)] = _0x4f1514)
                  : _0x4766d7["Z"][_0x30e879(0x21f)](new _0x3b8467["Z"](_0x30e879(0x21c), new Error()), _0x30e879(0x2cb));
              }
              set [_0x21a0cc(0x1be)](_0x58e013) {
                const _0x4fe846 = _0x21a0cc;
                _0x461478["Z"]["isBetween"](0x0, _0x3bd437[_0x4fe846(0x36c)][_0x4fe846(0x619)], _0x58e013)
                  ? (this[_0x4fe846(0x3c0)] = _0x58e013)
                  : _0x4766d7["Z"][_0x4fe846(0x21f)](new _0x3b8467["Z"](_0x4fe846(0x21c), new Error()), _0x4fe846(0x1be));
              }
              set [_0x21a0cc(0x6dc)](_0x2d48dd) {
                const _0x559c95 = _0x21a0cc;
                _0x461478["Z"][_0x559c95(0x588)](0x0, _0x3bd437[_0x559c95(0x36c)][_0x559c95(0x619)], _0x2d48dd)
                  ? (this[_0x559c95(0x526)] = _0x2d48dd)
                  : _0x4766d7["Z"][_0x559c95(0x21f)](new _0x3b8467["Z"]("VALIDATOR_BAD_COMMAND_OPTIONS_VALUE_OR_TYPE", new Error()), "mrz");
              }
              set [_0x21a0cc(0x3cc)](_0x2e095b) {
                const _0x14433e = _0x21a0cc;
                _0x461478["Z"][_0x14433e(0x588)](0x0, _0x3bd437[_0x14433e(0x36c)]["MST"], _0x2e095b)
                  ? (this[_0x14433e(0x67e)] = _0x2e095b)
                  : _0x4766d7["Z"][_0x14433e(0x21f)](new _0x3b8467["Z"](_0x14433e(0x21c), new Error()), _0x14433e(0x3cc));
              }
              set [_0x21a0cc(0x5f3)](_0x10d0d8) {
                const _0x55f4b9 = _0x21a0cc;
                _0x461478["Z"][_0x55f4b9(0x439)](_0x10d0d8)
                  ? (this[_0x55f4b9(0x6ed)] = _0x10d0d8)
                  : _0x4766d7["Z"][_0x55f4b9(0x21f)](new _0x3b8467["Z"](_0x55f4b9(0x1f3), new Error()), "frame");
              }
              set [_0x21a0cc(0x663)](_0x3919d8) {
                const _0x160e5a = _0x21a0cc;
                _0x461478["Z"][_0x160e5a(0x28c)](_0x3919d8)
                  ? (this[_0x160e5a(0x66a)] = _0x3919d8)
                  : _0x4766d7["Z"][_0x160e5a(0x21f)](new _0x3b8467["Z"](_0x160e5a(0x21c), new Error()), _0x160e5a(0x663));
              }
              set ["disablePerpendicularCapture"](_0xc11f74) {
                const _0x3fdac8 = _0x21a0cc;
                _0x461478["Z"][_0x3fdac8(0x279)](_0xc11f74)
                  ? (this[_0x3fdac8(0x582)] = _0xc11f74)
                  : _0x4766d7["Z"][_0x3fdac8(0x21f)](new _0x3b8467["Z"](_0x3fdac8(0x21c), new Error()), _0x3fdac8(0x653));
              }
              set [_0x21a0cc(0x2f0)](_0x143a22) {
                const _0xcabdc8 = _0x21a0cc;
                _0x461478["Z"][_0xcabdc8(0x279)](_0x143a22)
                  ? (this[_0xcabdc8(0x60f)] = _0x143a22)
                  : _0x4766d7["Z"][_0xcabdc8(0x21f)](new _0x3b8467["Z"](_0xcabdc8(0x21c), new Error()), _0xcabdc8(0x2f0));
              }
            };
            var _0x39c85c = _0x4e8c13(0x26);
            const _0xaacb2b = class {
              constructor() {
                const _0x148565 = _0x21a0cc;
                (this[_0x148565(0x3fa)] = !0x1),
                  (this["_hasDetectedNeutralExpression"] = !0x1),
                  (this[_0x148565(0x691)] = {
                    MISNAP_HEAD_TOO_CLOSE: 0x0,
                    MISNAP_HEAD_OUTSIDE: 0x0,
                    MISNAP_STAY_STILL: 0x0,
                    MISNAP_HEAD_SKEWED: 0x0,
                    MISNAP_HEAD_TOO_FAR: 0x0,
                    NO_FACE_FOUND: 0x0,
                  }),
                  this[_0x148565(0x6a6)];
              }
              get [_0x21a0cc(0x6f0)]() {
                const _0x2e18ed = _0x21a0cc;
                return this[_0x2e18ed(0x3fa)];
              }
              get [_0x21a0cc(0x3c5)]() {
                const _0xac6fd3 = _0x21a0cc;
                return this[_0xac6fd3(0x6f5)];
              }
              get [_0x21a0cc(0x236)]() {
                return this["_previousRecognizedData"];
              }
              get ["isValidFaceInGuideOverlay"]() {
                const _0x45bf72 = _0x21a0cc;
                return this[_0x45bf72(0x3f9)];
              }
              get ["uxpFaceFailureCount"]() {
                const _0x22f04b = _0x21a0cc;
                return this[_0x22f04b(0x691)];
              }
              set ["hasFoundNeutralExpressionSnapshot"](_0x2fea28) {
                const _0x351ce0 = _0x21a0cc;
                this[_0x351ce0(0x6f5)] = _0x2fea28;
              }
              set [_0x21a0cc(0x6f0)](_0x3a09dc) {
                const _0x28bf6a = _0x21a0cc;
                this[_0x28bf6a(0x3fa)] = _0x3a09dc;
              }
              set ["previousRecognizedData"](_0x3ac94e) {
                const _0x5e99b3 = _0x21a0cc;
                this[_0x5e99b3(0x64a)] = Object[_0x5e99b3(0x620)]({}, _0x3ac94e);
              }
              set [_0x21a0cc(0x597)](_0x2c24c5) {
                this["_isFaceInGuideOverlay"] = _0x2c24c5;
              }
              [_0x21a0cc(0x3ed)](_0x33bceb) {
                const _0x1fc23a = _0x21a0cc;
                Object[_0x1fc23a(0x426)](this["_faceFailureCountByHintMessageKey"])[_0x1fc23a(0x20d)](_0x33bceb) &&
                  (this[_0x1fc23a(0x691)][_0x33bceb] += 0x1);
              }
            };
            var _0x509552 = _0x4e8c13(0x2e4);
            class _0x116aaf {
              constructor(_0xafdb39, _0x4b6812) {
                const _0x889053 = _0x21a0cc;
                var _0x4f3cf0, _0x1e6a56;
                switch (
                  ((this["Platform"] = _0x889053(0x6ec)),
                  (this["MibiVersion"] = _0xafdb39[_0x889053(0x44a)]),
                  (this[_0x889053(0x485)] = {
                    Type: _0xafdb39[_0x889053(0x218)]["deviceType"],
                    UserAgent: _0xafdb39[_0x889053(0x218)][_0x889053(0x2c5)],
                    ID: "",
                  }),
                  (this[_0x889053(0x32f)] = {
                    Modules: [{ Name: _0x889053(0x2c4), Version: _0xafdb39[_0x889053(0x4ea)] }],
                    License: {
                      GPO:
                        null === (_0x4f3cf0 = _0x509552["Z"][_0x889053(0x5d7)]) || void 0x0 === _0x4f3cf0
                          ? void 0x0
                          : _0x4f3cf0[_0x889053(0x568)],
                      ExpiryDate:
                        null === (_0x1e6a56 = _0x509552["Z"][_0x889053(0x5d7)]) || void 0x0 === _0x1e6a56
                          ? void 0x0
                          : _0x1e6a56[_0x889053(0x2e1)],
                    },
                  }),
                  (this[_0x889053(0x317)] = {
                    UserMediaSupported: _0xafdb39[_0x889053(0x218)][_0x889053(0x2a1)],
                    WASMSupported: _0xafdb39[_0x889053(0x218)][_0x889053(0x418)],
                    WebGLSupported: _0xafdb39[_0x889053(0x218)]["supportsWebGl"],
                    RQGDIM: null,
                    ACQGDIM: null,
                    UXP: [],
                  }),
                  _0x4b6812[_0x889053(0x59a)])
                ) {
                  case _0x889053(0x68c):
                  case "CHECK_FRONT":
                  case "CHECK_BACK":
                  case "DOCUMENT":
                  case _0x889053(0x478):
                    this[_0x889053(0x33d)] = [this["generateSessionInfoItemDocument"](_0x4b6812)];
                    break;
                  case "PDF417_BARCODE":
                  case "QR_BARCODE":
                  case _0x889053(0x692):
                    this[_0x889053(0x33d)] = [this[_0x889053(0x4ec)](_0x4b6812)];
                    break;
                  case _0x889053(0x332):
                    this[_0x889053(0x33d)] = [this[_0x889053(0x695)](_0x4b6812)];
                    break;
                  case "VOICE":
                    this[_0x889053(0x33d)] = [this[_0x889053(0x3f3)]()];
                    break;
                  default:
                    this[_0x889053(0x33d)] = [this[_0x889053(0x457)]()];
                }
              }
              ["generateSessionInfoItemDocument"](_0x3d2db4) {
                const _0x1c20fe = _0x21a0cc;
                var _0x59f348;
                return {
                  Type: _0x1c20fe(0x5ea),
                  Mode:
                    null === (_0x59f348 = _0x116aaf[_0x1c20fe(0x280)]) || void 0x0 === _0x59f348
                      ? void 0x0
                      : _0x59f348[_0x3d2db4[_0x1c20fe(0x53c)]],
                  JpegQuality: _0x3d2db4["qualityPercent"],
                  AutoTries: _0x1c20fe(0x548) === _0x3d2db4[_0x1c20fe(0x53c)] ? 0x1 : 0x0,
                  ManualTries: _0x1c20fe(0x54b) === _0x3d2db4[_0x1c20fe(0x53c)] ? 0x1 : 0x0,
                  DirectTries: _0x1c20fe(0x33b) === _0x3d2db4[_0x1c20fe(0x53c)] ? 0x1 : 0x0,
                  DocType: _0x116aaf["MIBI_DOCUMENT_TYPE_BY_ACTION_TYPE"][_0x3d2db4[_0x1c20fe(0x59a)]],
                  MrzExtracted: "PASSPORT" === _0x3d2db4[_0x1c20fe(0x59a)],
                  TotalDuration: -0x1,
                  DeviceOrientation: _0x1c20fe(0x2b1),
                  DocumentOrientation: _0x1c20fe(0x2b1),
                  Warnings: [],
                  FourCorners: [
                    [0x0, 0x0],
                    [0x0, 0x0],
                    [0x0, 0x0],
                    [0x0, 0x0],
                  ],
                  ClassificationType: "",
                  OptionalDataRedacted: !0x1,
                };
              }
              [_0x21a0cc(0x4ec)](_0x475eb9) {
                const _0xc6c7b9 = _0x21a0cc;
                var _0x2eb4f4;
                return {
                  Type: _0xc6c7b9(0x4e6),
                  Mode:
                    null === (_0x2eb4f4 = _0x116aaf[_0xc6c7b9(0x280)]) || void 0x0 === _0x2eb4f4
                      ? void 0x0
                      : _0x2eb4f4[_0x475eb9[_0xc6c7b9(0x53c)]],
                  JpegQuality: _0x475eb9[_0xc6c7b9(0x401)],
                  AutoTries: _0xc6c7b9(0x548) === _0x475eb9["mode"] ? 0x1 : 0x0,
                  ManualTries: _0xc6c7b9(0x54b) === _0x475eb9[_0xc6c7b9(0x53c)] ? 0x1 : 0x0,
                  DirectTries: _0xc6c7b9(0x33b) === _0x475eb9[_0xc6c7b9(0x53c)] ? 0x1 : 0x0,
                  TotalDuration: -0x1,
                  DeviceOrientation: "Portrait",
                  DocumentOrientation: _0xc6c7b9(0x2b1),
                  BarcodeType: _0xc6c7b9(0x5e0),
                };
              }
              [_0x21a0cc(0x695)](_0x349224) {
                const _0x5d4923 = _0x21a0cc;
                var _0x1b0b32;
                return {
                  Type: "Face",
                  Mode:
                    null === (_0x1b0b32 = _0x116aaf[_0x5d4923(0x280)]) || void 0x0 === _0x1b0b32 ? void 0x0 : _0x1b0b32[_0x349224["mode"]],
                  JpegQuality: _0x349224["qualityPercent"],
                  AutoTries: _0x5d4923(0x548) === _0x349224[_0x5d4923(0x53c)] ? 0x1 : 0x0,
                  ManualTries: _0x5d4923(0x54b) === _0x349224["mode"] ? 0x1 : 0x0,
                  DirectTries: _0x5d4923(0x33b) === _0x349224["mode"] ? 0x1 : 0x0,
                  Smile: !_0x349224["disableSmileDetection"],
                  TotalDuration: -0x1,
                  DeviceOrientation: _0x5d4923(0x2b1),
                  Warnings: [],
                };
              }
              [_0x21a0cc(0x3f3)]() {
                return { Type: "Voice", Tries: 0x1, TotalDuration: -0x1 };
              }
              [_0x21a0cc(0x457)]() {
                const _0x2d7595 = _0x21a0cc;
                return { Type: _0x2d7595(0x710), TotalDuration: -0x1 };
              }
              [_0x21a0cc(0x1f5)](_0x339b6f) {
                const _0x13bd36 = _0x21a0cc,
                  _0x187cd3 = _0x339b6f > 0x0;
                this["SessionInfo"][0x0][_0x13bd36(0x5b1)] && _0x187cd3 && (this[_0x13bd36(0x33d)][0x0][_0x13bd36(0x5b1)] = _0x339b6f);
              }
              ["setSessionInfoDeviceOrientation"](_0x549dd9) {
                const _0x4a1b56 = _0x21a0cc,
                  _0x348f84 = this["SessionInfo"][0x0][_0x4a1b56(0x4e7)],
                  _0x3875a1 = "Document" === _0x348f84 || "Barcode" === _0x348f84 || _0x4a1b56(0x683) === _0x348f84;
                this[_0x4a1b56(0x33d)][0x0][_0x4a1b56(0x5e9)] && _0x3875a1 && (this[_0x4a1b56(0x33d)][0x0][_0x4a1b56(0x5e9)] = _0x549dd9);
              }
              [_0x21a0cc(0x6c9)](_0xf45035) {
                const _0x5b2bde = _0x21a0cc,
                  _0x3b53ab = this["SessionInfo"][0x0]["Type"],
                  _0x17aed1 = _0x5b2bde(0x5ea) === _0x3b53ab || _0x5b2bde(0x4e6) === _0x3b53ab;
                this["SessionInfo"][0x0][_0x5b2bde(0x420)] && _0x17aed1 && (this["SessionInfo"][0x0][_0x5b2bde(0x420)] = _0xf45035);
              }
              [_0x21a0cc(0x694)](_0x2a7429) {
                const _0x8fef7b = _0x21a0cc,
                  _0x32a3af = this[_0x8fef7b(0x33d)][0x0][_0x8fef7b(0x4e7)],
                  _0x5b49b6 = "Document" === _0x32a3af || "Face" === _0x32a3af;
                this["SessionInfo"][0x0][_0x8fef7b(0x329)] && _0x5b49b6 && (this[_0x8fef7b(0x33d)][0x0][_0x8fef7b(0x329)] = _0x2a7429);
              }
              [_0x21a0cc(0x460)](_0x567e36) {
                const _0x2f6907 = _0x21a0cc,
                  _0x30c08c = _0x2f6907(0x5ea) === this[_0x2f6907(0x33d)][0x0][_0x2f6907(0x4e7)];
                this[_0x2f6907(0x33d)][0x0][_0x2f6907(0x375)] && _0x30c08c && (this["SessionInfo"][0x0][_0x2f6907(0x375)] = _0x567e36);
              }
              ["setSessionInfoClassificationType"](_0x137eeb) {
                const _0x3afe7e = _0x21a0cc,
                  _0x1b525d = _0x3afe7e(0x5ea) === this[_0x3afe7e(0x33d)][0x0]["Type"];
                this[_0x3afe7e(0x33d)][0x0]["ClassificationType"] &&
                  _0x1b525d &&
                  (this[_0x3afe7e(0x33d)][0x0]["ClassificationType"] = _0x137eeb);
              }
              [_0x21a0cc(0x48d)](_0xff588c = !0x1) {
                const _0x3687d2 = _0x21a0cc;
                this[_0x3687d2(0x33d)][0x0][_0x3687d2(0x1fb)] = _0xff588c;
              }
              [_0x21a0cc(0x2b6)](_0x1f2e64) {
                const _0x21ae1e = _0x21a0cc,
                  _0x414c90 = _0x21ae1e(0x4e6) === this[_0x21ae1e(0x33d)][0x0]["Type"];
                (this["SessionInfo"][0x0][_0x21ae1e(0x6ac)] || _0x414c90) && (this[_0x21ae1e(0x33d)][0x0][_0x21ae1e(0x6ac)] = _0x1f2e64);
              }
              [_0x21a0cc(0x1dd)](_0x509539) {
                const _0x1e943d = _0x21a0cc;
                this[_0x1e943d(0x317)][_0x1e943d(0x26f)] = _0x509539;
              }
              ["setPlatformPrivateAcquiredGumCanvasDimensions"](_0x455d69) {
                const _0x38f5dc = _0x21a0cc;
                this[_0x38f5dc(0x317)]["ACQGDIM"] = _0x455d69;
              }
              [_0x21a0cc(0x4c4)](_0x5db252) {
                const _0x53a043 = _0x21a0cc;
                Array[_0x53a043(0x357)](this[_0x53a043(0x317)]["UXP"]) && this["PlatformPrivate"]["UXP"]["push"](_0x5db252);
              }
              [_0x21a0cc(0x406)]() {
                const _0x4ab0fd = _0x21a0cc;
                return JSON[_0x4ab0fd(0x502)]({
                  MibiVersion: this[_0x4ab0fd(0x58d)],
                  Platform: this["Platform"],
                  DeviceInfo: this[_0x4ab0fd(0x485)],
                  SdkInfo: this[_0x4ab0fd(0x32f)],
                  PlatformPrivate: this["PlatformPrivate"],
                  SessionInfo: this[_0x4ab0fd(0x33d)],
                });
              }
            }
            (_0x116aaf[_0x21a0cc(0x280)] = { AUTO: _0x21a0cc(0x22a), MANUAL: _0x21a0cc(0x393), DIRECT: _0x21a0cc(0x334) }),
              (_0x116aaf[_0x21a0cc(0x726)] = {
                DL_FRONT: _0x21a0cc(0x4c0),
                DL_BACK: "ID_Back",
                CHECK_FRONT: _0x21a0cc(0x4ed),
                CHECK_BACK: _0x21a0cc(0x69f),
                PASSPORT: _0x21a0cc(0x251),
                DOCUMENT: _0x21a0cc(0x361),
              });
            const _0x18d709 = _0x116aaf;
            var _0x278d64 = _0x4e8c13(0x2b);
            const _0x5c1b0b = class {
              constructor(_0x4877ea, _0x5900a8) {
                const _0x2dc41b = _0x21a0cc;
                try {
                  (this[_0x2dc41b(0x1df)] = Date[_0x2dc41b(0x3f5)]()),
                    (this[_0x2dc41b(0x658)] = []),
                    (this[_0x2dc41b(0x514)] = new _0x39c85c["Z"]()),
                    (this[_0x2dc41b(0x2de)] = !0x1),
                    (this["_isStoppedReason"] = _0x2dc41b(0x69e)),
                    (this[_0x2dc41b(0x6b3)] = !0x1),
                    (this["guideBox"] = { x: 0x0, y: 0x0, height: 0x0, width: 0x0 }),
                    (this["lastSnapshot"] = new _0x278d64["Z"](new ImageData(0x64, 0x64), 0x4)),
                    this[_0x2dc41b(0x362)],
                    (this[_0x2dc41b(0x2c3)] = !0x1),
                    (this[_0x2dc41b(0x3f6)] = !0x0),
                    (this[_0x2dc41b(0x403)] = new _0x12b809(_0x5900a8[_0x2dc41b(0x48a)])),
                    (this["actionIdentifier"] = new _0x5231f9["Z"](
                      _0x5900a8[_0x2dc41b(0x48a)][_0x2dc41b(0x59a)],
                      this["commandOptions"][_0x2dc41b(0x53c)],
                      _0x4877ea[_0x2dc41b(0x218)][_0x2dc41b(0x431)]
                    )),
                    (this["facingDirection"] =
                      _0x2dc41b(0x332) === this[_0x2dc41b(0x452)]["actionType"] ? _0x2dc41b(0x1ee) : _0x2dc41b(0x69d)),
                    (this["requiresMirroring"] = this[_0x2dc41b(0x24d)](_0x5900a8["params"], _0x4877ea)),
                    (this[_0x2dc41b(0x3b8)] = new _0xaacb2b()),
                    (this[_0x2dc41b(0x274)] = new _0x18d709(_0x4877ea, this[_0x2dc41b(0x403)])),
                    (this[_0x2dc41b(0x5ee)] = null);
                } catch (_0x2609ca) {
                  console[_0x2dc41b(0x677)](_0x2609ca),
                    (this["actionIdentifier"] = new _0x5231f9["Z"](
                      _0x5900a8[_0x2dc41b(0x48a)]["documentType"],
                      _0x2dc41b(0x42b),
                      _0x4877ea[_0x2dc41b(0x218)]["deviceType"]
                    )),
                    this[_0x2dc41b(0x47f)](_0x2dc41b(0x1d7));
                }
              }
              [_0x21a0cc(0x24d)](_0x4642af, _0x5cfcde) {
                const _0x12539e = _0x21a0cc;
                var _0x35dff3;
                switch (!0x0) {
                  case null === (_0x35dff3 = _0x4642af["options"]) || void 0x0 === _0x35dff3 ? void 0x0 : _0x35dff3[_0x12539e(0x29c)]:
                    return !0x1;
                  case _0x12539e(0x332) === this[_0x12539e(0x452)]["actionType"]:
                  case !_0x5cfcde[_0x12539e(0x218)]["isMobile"]:
                    return !0x0;
                  case _0x5cfcde["deviceInfo"][_0x12539e(0x4b1)]:
                  default:
                    return !0x1;
                }
              }
              [_0x21a0cc(0x47f)](_0x5691d8) {
                const _0x513312 = _0x21a0cc;
                (this[_0x513312(0x3a9)] = !0x0), (this[_0x513312(0x591)] = _0x5691d8);
              }
              get ["lastSnapshot"]() {
                const _0x5d4bc8 = _0x21a0cc;
                return this[_0x5d4bc8(0x325)];
              }
              set [_0x21a0cc(0x372)](_0x4521a4) {
                const _0xdcfe7a = _0x21a0cc;
                _0x461478["Z"][_0xdcfe7a(0x2f1)](_0x4521a4), (this[_0xdcfe7a(0x325)] = _0x4521a4);
              }
              get [_0x21a0cc(0x3a9)]() {
                const _0x19e6c8 = _0x21a0cc;
                return this[_0x19e6c8(0x2de)];
              }
              set [_0x21a0cc(0x3a9)](_0x498e9d) {
                const _0x77664c = _0x21a0cc;
                this[_0x77664c(0x2de)] = _0x498e9d;
              }
              get [_0x21a0cc(0x591)]() {
                return this["_isStoppedReason"];
              }
              set [_0x21a0cc(0x591)](_0x5dac6d) {
                const _0x2f7384 = _0x21a0cc;
                this[_0x2f7384(0x6c5)] = _0x5dac6d;
              }
              get [_0x21a0cc(0x36d)]() {
                return this["_hasSessionRecordingStopped"];
              }
              set [_0x21a0cc(0x36d)](_0x443a4) {
                const _0x5b7ca1 = _0x21a0cc;
                this[_0x5b7ca1(0x3f6)] = _0x443a4;
              }
            };
            var _0x1c5995 = _0x4e8c13(0x117),
              _0x4b01c8 = function (_0xc520c9, _0x1f6f4d, _0x124a06, _0x190af4) {
                return new (_0x124a06 || (_0x124a06 = Promise))(function (_0x4b4c5f, _0x229b97) {
                  const _0x34b2f6 = a0_0x1b49;
                  function _0x2cb828(_0x33ba18) {
                    try {
                      _0x3907db(_0x190af4["next"](_0x33ba18));
                    } catch (_0xab76ca) {
                      _0x229b97(_0xab76ca);
                    }
                  }
                  function _0x1667d1(_0x1a02ab) {
                    try {
                      _0x3907db(_0x190af4["throw"](_0x1a02ab));
                    } catch (_0x148508) {
                      _0x229b97(_0x148508);
                    }
                  }
                  function _0x3907db(_0x1eaec6) {
                    const _0x30b949 = a0_0x1b49;
                    var _0x350730;
                    _0x1eaec6["done"]
                      ? _0x4b4c5f(_0x1eaec6[_0x30b949(0x331)])
                      : ((_0x350730 = _0x1eaec6["value"]),
                        _0x350730 instanceof _0x124a06
                          ? _0x350730
                          : new _0x124a06(function (_0x2fc3b5) {
                              _0x2fc3b5(_0x350730);
                            }))[_0x30b949(0x429)](_0x2cb828, _0x1667d1);
                  }
                  _0x3907db((_0x190af4 = _0x190af4[_0x34b2f6(0x1d1)](_0xc520c9, _0x1f6f4d || []))["next"]());
                });
              };
            const _0x5a400b = new (class {
              constructor() {
                const _0x4e3834 = _0x21a0cc;
                (this["_appConfig"] = _0xb74c84), (this[_0x4e3834(0x2c9)] = "");
              }
              set [_0x21a0cc(0x5dd)](_0x148259) {
                const _0x3b4ef5 = _0x21a0cc;
                _0x3b4ef5(0x621) == typeof _0x148259 &&
                  (function (_0x44aab5) {
                    _0x44aab5["endsWith"]("/") || (_0x44aab5 += "/"), (_0x4decee = _0x44aab5), (_0x4e8c13["p"] = _0x44aab5);
                  })(_0x148259);
              }
              get ["publicPath"]() {
                const _0x27b3dc = _0x21a0cc;
                var _0x49fcfa, _0x35465f;
                return (
                  this["preloadPath"] ||
                  (null ===
                    (_0x35465f =
                      null === (_0x49fcfa = this[_0x27b3dc(0x3e5)]) || void 0x0 === _0x49fcfa ? void 0x0 : _0x49fcfa[_0x27b3dc(0x403)]) ||
                  void 0x0 === _0x35465f
                    ? void 0x0
                    : _0x35465f[_0x27b3dc(0x64d)]) ||
                  this["_appConfig"]["webpackPublicPath"]
                );
              }
              [_0x21a0cc(0x311)](_0x1f9674) {
                const _0x17993c = _0x21a0cc;
                try {
                  this[_0x17993c(0x3e5)] = Object[_0x17993c(0x6a2)](new _0x5c1b0b(this[_0x17993c(0x2a6)], _0x1f9674));
                } catch (_0x3dc4d0) {
                  throw new _0x3b8467["Z"](_0x17993c(0x277), new Error(_0x17993c(0x277)));
                }
              }
              get [_0x21a0cc(0x63a)]() {
                const _0x4d768e = _0x21a0cc;
                return this[_0x4d768e(0x2a6)];
              }
              get [_0x21a0cc(0x637)]() {
                const _0x23e1e0 = _0x21a0cc;
                return this[_0x23e1e0(0x3e5)];
              }
              get [_0x21a0cc(0x396)]() {
                return this["_currentAction"]["startTime"];
              }
              get ["hasCurrentActionSessionRecordingStopped"]() {
                const _0x6bcbc2 = _0x21a0cc;
                return this[_0x6bcbc2(0x3e5)][_0x6bcbc2(0x36d)];
              }
              ["insertCurrentActionSnapshot"](_0x4366ff) {
                const _0x2a3c8d = _0x21a0cc;
                this[_0x2a3c8d(0x3e5)][_0x2a3c8d(0x658)][_0x2a3c8d(0x462)](_0x4366ff),
                  this[_0x2a3c8d(0x3e5)][_0x2a3c8d(0x658)][_0x2a3c8d(0x5ab)] > 0x5 &&
                    this["_currentAction"][_0x2a3c8d(0x658)][_0x2a3c8d(0x269)]();
              }
              [_0x21a0cc(0x595)]() {
                const _0x1f1ca9 = _0x21a0cc;
                this[_0x1f1ca9(0x3e5)][_0x1f1ca9(0x658)][_0x1f1ca9(0x5ab)] = 0x0;
              }
              [_0x21a0cc(0x504)](_0x2f0658) {
                const _0x25c7b3 = _0x21a0cc;
                (this[_0x25c7b3(0x3e5)][_0x25c7b3(0x3a9)] = !0x0), (this[_0x25c7b3(0x3e5)]["isStoppedReason"] = _0x2f0658);
              }
              [_0x21a0cc(0x5eb)](_0x144d7e) {
                const _0x3e0d46 = _0x21a0cc;
                this[_0x3e0d46(0x3e5)][_0x3e0d46(0x2c3)] = _0x144d7e;
              }
              [_0x21a0cc(0x408)](_0x6b045d) {
                const _0x1848fc = _0x21a0cc;
                this["_currentAction"][_0x1848fc(0x36d)] = _0x6b045d;
              }
              [_0x21a0cc(0x337)](_0x39dbd6) {
                const _0x360911 = _0x21a0cc;
                this[_0x360911(0x3e5)]["RTSTrackSignals"] = _0x39dbd6;
              }
              [_0x21a0cc(0x20b)]() {
                return _0x4b01c8(this, void 0x0, void 0x0, function* () {
                  const _0x2afb25 = a0_0x1b49;
                  try {
                    this["_currentAction"][_0x2afb25(0x403)][_0x2afb25(0x2f0)] &&
                      (this[_0x2afb25(0x2a6)][_0x2afb25(0x339)] = yield _0x1c5995["Z"][_0x2afb25(0x70a)]());
                  } catch (_0x328abb) {}
                });
              }
              get ["deviceIdSignal"]() {
                const _0x1db076 = _0x21a0cc;
                return this[_0x1db076(0x2a6)]["encryptedDevicesSignals"] || null;
              }
              [_0x21a0cc(0x37d)](_0x4eefa1) {
                const _0x4c04c6 = _0x21a0cc;
                var _0x396f28, _0x5dc223;
                null ===
                  (_0x5dc223 =
                    null === (_0x396f28 = this[_0x4c04c6(0x3e5)]) || void 0x0 === _0x396f28 ? void 0x0 : _0x396f28["mibiData"]) ||
                  void 0x0 === _0x5dc223 ||
                  _0x5dc223["insertUXPEvent"](_0x4eefa1);
              }
              [_0x21a0cc(0x22e)](_0x43a687) {
                const _0x25bedd = _0x21a0cc;
                var _0x32f0e7, _0x2ddc94;
                null ===
                  (_0x2ddc94 =
                    null === (_0x32f0e7 = this[_0x25bedd(0x3e5)]) || void 0x0 === _0x32f0e7 ? void 0x0 : _0x32f0e7[_0x25bedd(0x274)]) ||
                  void 0x0 === _0x2ddc94 ||
                  _0x2ddc94[_0x25bedd(0x1f5)](_0x43a687);
              }
              [_0x21a0cc(0x53a)](_0x12530e) {
                var _0x4aa526, _0x30e126;
                null ===
                  (_0x30e126 =
                    null === (_0x4aa526 = this["_currentAction"]) || void 0x0 === _0x4aa526 ? void 0x0 : _0x4aa526["mibiData"]) ||
                  void 0x0 === _0x30e126 ||
                  _0x30e126["setSessionInfoDeviceOrientation"](_0x12530e);
              }
              [_0x21a0cc(0x58a)](_0x51d313) {
                const _0x5ad321 = _0x21a0cc;
                var _0x1bbd4d, _0x48d55a;
                null ===
                  (_0x48d55a =
                    null === (_0x1bbd4d = this[_0x5ad321(0x3e5)]) || void 0x0 === _0x1bbd4d ? void 0x0 : _0x1bbd4d[_0x5ad321(0x274)]) ||
                  void 0x0 === _0x48d55a ||
                  _0x48d55a[_0x5ad321(0x6c9)](_0x51d313);
              }
              [_0x21a0cc(0x6af)](_0x4d2178) {
                const _0x242572 = _0x21a0cc;
                var _0x496aea, _0x52471e;
                null ===
                  (_0x52471e =
                    null === (_0x496aea = this["_currentAction"]) || void 0x0 === _0x496aea ? void 0x0 : _0x496aea[_0x242572(0x274)]) ||
                  void 0x0 === _0x52471e ||
                  _0x52471e["setSessionInfoWarnings"](_0x4d2178);
              }
              ["setCurrentActionMibiDataSessionInfoMRZOptionalDataRedacted"](_0x4ebe0e) {
                const _0x296124 = _0x21a0cc;
                var _0x5ec07e, _0xa756ed;
                null ===
                  (_0xa756ed =
                    null === (_0x5ec07e = this["_currentAction"]) || void 0x0 === _0x5ec07e ? void 0x0 : _0x5ec07e[_0x296124(0x274)]) ||
                  void 0x0 === _0xa756ed ||
                  _0xa756ed[_0x296124(0x48d)](_0x4ebe0e);
              }
              [_0x21a0cc(0x6b2)](_0x283e46) {
                const _0xeb5e5f = _0x21a0cc;
                var _0x586ffd, _0x32296d;
                null ===
                  (_0x32296d =
                    null === (_0x586ffd = this[_0xeb5e5f(0x3e5)]) || void 0x0 === _0x586ffd ? void 0x0 : _0x586ffd[_0xeb5e5f(0x274)]) ||
                  void 0x0 === _0x32296d ||
                  _0x32296d[_0xeb5e5f(0x460)](_0x283e46);
              }
              [_0x21a0cc(0x56e)](_0x3e48f4) {
                const _0x279b4b = _0x21a0cc;
                var _0x5b2629, _0x29066e;
                null ===
                  (_0x29066e =
                    null === (_0x5b2629 = this["_currentAction"]) || void 0x0 === _0x5b2629 ? void 0x0 : _0x5b2629["mibiData"]) ||
                  void 0x0 === _0x29066e ||
                  _0x29066e[_0x279b4b(0x3ce)](_0x3e48f4);
              }
              ["setCurrentActionMibiDataSessionInfoBarcodeType"](_0x4af1cd) {
                const _0x52c62f = _0x21a0cc;
                var _0x2d10f7, _0x185fe3;
                null ===
                  (_0x185fe3 =
                    null === (_0x2d10f7 = this[_0x52c62f(0x3e5)]) || void 0x0 === _0x2d10f7 ? void 0x0 : _0x2d10f7[_0x52c62f(0x274)]) ||
                  void 0x0 === _0x185fe3 ||
                  _0x185fe3[_0x52c62f(0x2b6)](_0x4af1cd);
              }
              [_0x21a0cc(0x66e)](_0x4a3ca9) {
                const _0x3df024 = _0x21a0cc;
                var _0x1b1c0e, _0x192f20;
                null ===
                  (_0x192f20 =
                    null === (_0x1b1c0e = this["_currentAction"]) || void 0x0 === _0x1b1c0e ? void 0x0 : _0x1b1c0e[_0x3df024(0x274)]) ||
                  void 0x0 === _0x192f20 ||
                  _0x192f20[_0x3df024(0x1dd)](_0x4a3ca9);
              }
              ["setCurrentActionMibiDataPlatformPrivateAcquiredGumCanvasDimension"](_0x506297) {
                const _0x24820f = _0x21a0cc;
                var _0x1a718d, _0x38acfd;
                null ===
                  (_0x38acfd =
                    null === (_0x1a718d = this["_currentAction"]) || void 0x0 === _0x1a718d ? void 0x0 : _0x1a718d[_0x24820f(0x274)]) ||
                  void 0x0 === _0x38acfd ||
                  _0x38acfd["setPlatformPrivateAcquiredGumCanvasDimensions"](_0x506297);
              }
              [_0x21a0cc(0x43d)](_0x3bab79) {
                const _0x24e92c = _0x21a0cc;
                var _0x2152ea, _0x35f8ac;
                null ===
                  (_0x35f8ac =
                    null === (_0x2152ea = this[_0x24e92c(0x3e5)]) || void 0x0 === _0x2152ea ? void 0x0 : _0x2152ea[_0x24e92c(0x514)]) ||
                  void 0x0 === _0x35f8ac ||
                  _0x35f8ac[_0x24e92c(0x30e)](_0x3bab79);
              }
              [_0x21a0cc(0x23d)](_0x47058f) {
                const _0x49c910 = _0x21a0cc;
                var _0x4b4cd5, _0x2c7eae;
                null ===
                  (_0x2c7eae =
                    null === (_0x4b4cd5 = this[_0x49c910(0x3e5)]) || void 0x0 === _0x4b4cd5 ? void 0x0 : _0x4b4cd5[_0x49c910(0x514)]) ||
                  void 0x0 === _0x2c7eae ||
                  _0x2c7eae[_0x49c910(0x5c6)](_0x47058f);
              }
              [_0x21a0cc(0x51c)](_0x15dd8c) {
                const _0x1f5f7f = _0x21a0cc;
                var _0x5dc31b, _0x19213a;
                return null ===
                  (_0x19213a =
                    null === (_0x5dc31b = this[_0x1f5f7f(0x3e5)]) || void 0x0 === _0x5dc31b ? void 0x0 : _0x5dc31b[_0x1f5f7f(0x514)]) ||
                  void 0x0 === _0x19213a
                  ? void 0x0
                  : _0x19213a[_0x1f5f7f(0x24f)](_0x15dd8c);
              }
              ["setPreloadPath"](_0x303d5d) {
                const _0x54958b = _0x21a0cc;
                if ("" !== this["_preloadPath"] || !_0x461478["Z"][_0x54958b(0x28c)](_0x303d5d))
                  throw new _0x3b8467["Z"](_0x54958b(0x21c), new Error(_0x54958b(0x3f2)));
                (this[_0x54958b(0x2c9)] = _0x303d5d), (this[_0x54958b(0x221)] = () => {});
              }
              get ["preloadPath"]() {
                const _0x27c611 = _0x21a0cc;
                return this[_0x27c611(0x2c9)];
              }
              set [_0x21a0cc(0x3f4)](_0x247606) {}
            })();
          },
          0x127: (_0x565743, _0x4c2396, _0x33dbda) => {
            const _0x4067e7 = a0_0x1b49;
            _0x33dbda["d"](_0x4c2396, { Z: () => _0x411080 });
            var _0x409f64 = _0x33dbda(0x246);
            const _0x43a8f4 = _0x409f64["Z"]["appConfig"][_0x4067e7(0x3ac)][_0x4067e7(0x1cb)],
              _0x3da364 = _0x43a8f4
                ? class {
                    constructor(_0x4bbad5) {
                      const _0x196763 = _0x4067e7;
                      this[_0x196763(0x2b4)] = _0x4bbad5;
                    }
                    [_0x4067e7(0x3c2)](_0x3398e6, _0x5bdc26, _0x2b6152) {
                      const _0x59650a = _0x4067e7;
                      var _0x507b78, _0x46a61a;
                      (null ===
                        (_0x46a61a =
                          null === (_0x507b78 = _0x409f64["Z"][_0x59650a(0x63a)]) || void 0x0 === _0x507b78
                            ? void 0x0
                            : _0x507b78[_0x59650a(0x3ac)]) || void 0x0 === _0x46a61a
                        ? void 0x0
                        : _0x46a61a[_0x59650a(0x1cb)]) && this[_0x59650a(0x45d)]();
                    }
                    [_0x4067e7(0x6cd)](_0x1cbdb4, _0x53a6d3, _0x2c35b4) {
                      const _0x43a184 = _0x4067e7;
                      var _0x1d58b0, _0x1f3e9a;
                      (null ===
                        (_0x1f3e9a =
                          null === (_0x1d58b0 = _0x409f64["Z"]["appConfig"]) || void 0x0 === _0x1d58b0
                            ? void 0x0
                            : _0x1d58b0[_0x43a184(0x3ac)]) || void 0x0 === _0x1f3e9a
                        ? void 0x0
                        : _0x1f3e9a[_0x43a184(0x1cb)]) &&
                        this["isNamespaceAllowed"]() &&
                        console["error"](_0x1cbdb4);
                    }
                    [_0x4067e7(0x45d)]() {
                      const _0x7c4d20 = _0x4067e7;
                      var _0xe912c7, _0x292a71;
                      if (!_0x43a8f4) return !0x1;
                      let _0x1dca02 = !0x1,
                        _0x723600 = this["_namespace"][_0x7c4d20(0x341)](":");
                      return (
                        (null ===
                          (_0x292a71 =
                            null === (_0xe912c7 = _0x409f64["Z"]["appConfig"]) || void 0x0 === _0xe912c7
                              ? void 0x0
                              : _0xe912c7["InternalDebuggerLogSettings"]) || void 0x0 === _0x292a71
                          ? void 0x0
                          : _0x292a71[_0x7c4d20(0x4bd)])
                          [_0x7c4d20(0x6c0)]((_0x26c3ba) => {
                            const _0x1e032e = _0x7c4d20;
                            let _0xaf5a49 = _0x26c3ba[_0x1e032e(0x341)](":");
                            return _0x723600["map"](
                              (_0x45a423, _0x53a775) => _0x723600[_0x53a775] === _0xaf5a49[_0x53a775] || "*" === _0xaf5a49[_0x53a775]
                            )["every"]((_0x1c34ec) => !0x0 === _0x1c34ec);
                          })
                          [_0x7c4d20(0x20d)](!0x0) && (_0x1dca02 = !0x0),
                        _0x1dca02
                      );
                    }
                  }
                : class {
                    constructor() {}
                    [_0x4067e7(0x3c2)]() {}
                    [_0x4067e7(0x6cd)]() {}
                  };
            var _0x3b1c1e = _0x33dbda(0x1b8);
            const _0x5edb28 = new (_0x33dbda(0x2d9))(),
              _0x1089cc = new (class {
                constructor() {}
                ["on"](_0xb5d566, _0x5e52d1) {
                  let _0x54f429 = this["getErrorManagedCallback"](_0x5e52d1);
                  _0x5edb28["on"](_0xb5d566, _0x54f429);
                }
                ["once"](_0x3a8024, _0x4cc9e1) {
                  const _0x51f571 = _0x4067e7;
                  let _0x15d5d3 = this[_0x51f571(0x1c3)](_0x4cc9e1);
                  _0x5edb28["once"](_0x3a8024, _0x15d5d3);
                }
                [_0x4067e7(0x1c3)](_0x5b3e51) {
                  return (_0x49987d) => {
                    const _0x208ea6 = a0_0x1b49;
                    try {
                      _0x5b3e51[_0x208ea6(0x62d)](void 0x0, _0x49987d);
                    } catch (_0x28a4b9) {
                      throw new _0x3b1c1e["Z"](_0x208ea6(0x6cb), _0x28a4b9);
                    }
                  };
                }
                ["clearListeners"]() {
                  const _0x32c922 = _0x4067e7;
                  _0x5edb28[_0x32c922(0x2e0)]();
                }
                [_0x4067e7(0x306)](_0x226092) {
                  const _0x26a3c5 = _0x4067e7;
                  _0x5edb28[_0x26a3c5(0x3ff)](_0x226092["id"], _0x226092[_0x26a3c5(0x668)]);
                }
                [_0x4067e7(0x422)](_0xf3ca38, _0x3fdcd9) {
                  const _0xa88aa6 = _0x4067e7;
                  _0x5edb28[_0xa88aa6(0x422)](_0xf3ca38, _0x3fdcd9);
                }
              })();
            class _0x3acf3d {
              constructor(_0x38d2e4, _0x4d9e38, _0x5df403, _0x45feba) {
                const _0x2b12b4 = _0x4067e7;
                (this[_0x2b12b4(0x2b5)] = _0x38d2e4),
                  (this["hintMessageKey"] = _0x4d9e38),
                  (this["score"] = _0x5df403),
                  (this[_0x2b12b4(0x4d4)] = _0x45feba);
              }
            }
            class _0x308ca0 extends _0x3acf3d {
              constructor(_0x4f2e0d, _0x57050b, _0x39d290, _0x193a19, _0x27433b) {
                const _0x188531 = _0x4067e7;
                super(_0x4f2e0d, _0x57050b, _0x39d290, _0x193a19), (this[_0x188531(0x6f3)] = !0x1), (this[_0x188531(0x523)] = _0x27433b);
              }
            }
            class _0x579044 extends _0x3acf3d {
              constructor(_0x2f33fd, _0x426799, _0x3de509, _0x45612e) {
                const _0x4167f9 = _0x4067e7;
                super(_0x2f33fd, _0x426799, _0x3de509, _0x45612e), (this[_0x4167f9(0x6f3)] = !0x0), (this[_0x4167f9(0x229)] = _0x426799);
              }
            }
            var _0x13336a = _0x33dbda(0x141);
            const _0x45ff28 = class {
                constructor(_0x39cb58) {
                  const _0x3b44c0 = _0x4067e7;
                  (this["MIN_SIDE_LENGTH"] = _0x409f64["Z"][_0x3b44c0(0x63a)][_0x3b44c0(0x38d)][_0x3b44c0(0x36c)][_0x3b44c0(0x659)]),
                    (this[_0x3b44c0(0x38d)] = _0x409f64["Z"][_0x3b44c0(0x63a)][_0x3b44c0(0x725)](
                      _0x39cb58[_0x3b44c0(0x245)],
                      _0x39cb58[_0x3b44c0(0x431)]
                    )),
                    (this[_0x3b44c0(0x338)] = _0x409f64["Z"][_0x3b44c0(0x637)][_0x3b44c0(0x403)][_0x3b44c0(0x653)]);
                }
                [_0x4067e7(0x1d0)](_0x33a1ac, _0xf1f014, _0x1e9e05) {
                  const _0x345cb2 = _0x4067e7;
                  let _0xdbd01 = !0x1;
                  if (!(null == _0x33a1ac ? void 0x0 : _0x33a1ac["ax"])) return !0x1;
                  let _0x41b18c = _0x33a1ac;
                  const _0xce99e3 = [
                    Math[_0x345cb2(0x522)](
                      Math[_0x345cb2(0x714)](_0x41b18c["bx"] - _0x41b18c["ax"], 0x2) +
                        Math[_0x345cb2(0x714)](_0x41b18c["by"] - _0x41b18c["ay"], 0x2)
                    ),
                    Math[_0x345cb2(0x522)](
                      Math["pow"](_0x41b18c["cx"] - _0x41b18c["bx"], 0x2) + Math[_0x345cb2(0x714)](_0x41b18c["cy"] - _0x41b18c["by"], 0x2)
                    ),
                  ];
                  _0xce99e3["sort"]((_0x4c4a54, _0x36f5c7) => _0x36f5c7 - _0x4c4a54);
                  let _0x34392a = (_0xce99e3[0x0] || 0x0) / (_0xce99e3[0x1] || 0x0);
                  return (
                    !!_0x34392a &&
                    ((_0xdbd01 = _0x13336a["Z"]["isBetween"](_0xf1f014 - _0x1e9e05, _0xf1f014 + _0x1e9e05, _0x34392a)), _0xdbd01)
                  );
                }
                ["getDimensionsFromFourCornerData"](_0x1a4c69) {
                  const _0x4321e7 = _0x4067e7,
                    {
                      ax: _0x4e4f22,
                      ay: _0x3963f6,
                      bx: _0x375937,
                      by: _0x4a085c,
                      cx: _0x1546d7,
                      cy: _0x3a164b,
                      dx: _0xd4542e,
                      dy: _0x408bbb,
                    } = _0x1a4c69;
                  return {
                    width:
                      Math[_0x4321e7(0x47c)](_0x4e4f22, _0x375937, _0x1546d7, _0xd4542e) -
                      Math[_0x4321e7(0x61b)](_0x4e4f22, _0x375937, _0x1546d7, _0xd4542e),
                    height:
                      Math[_0x4321e7(0x47c)](_0x3963f6, _0x4a085c, _0x3a164b, _0x408bbb) -
                      Math[_0x4321e7(0x61b)](_0x3963f6, _0x4a085c, _0x3a164b, _0x408bbb),
                  };
                }
                ["isCaptureParallel"](_0x50dded, _0xb43b0b) {
                  const _0x16389e = _0x4067e7,
                    _0x2b13fc = _0x50dded[_0x16389e(0x39c)] > _0x50dded[_0x16389e(0x657)];
                  return _0xb43b0b["height"] > _0xb43b0b["width"] === _0x2b13fc;
                }
                [_0x4067e7(0x340)](_0x166a57) {
                  const _0x33540c = _0x4067e7,
                    _0x487fc4 = _0x166a57["rawData"];
                  if (
                    _0x166a57[_0x33540c(0x28d)] ||
                    _0x487fc4["fourCornerScore"] < this[_0x33540c(0x38d)]["FCT"] ||
                    !this[_0x33540c(0x1d0)](_0x487fc4, this[_0x33540c(0x38d)]["AR"], this[_0x33540c(0x38d)][_0x33540c(0x479)])
                  )
                    return new _0x308ca0("NF", _0x33540c(0x50a), 0x0, _0x166a57);
                  if (this[_0x33540c(0x338)]) {
                    const _0x47a6bb = this[_0x33540c(0x4f1)](null == _0x166a57 ? void 0x0 : _0x166a57[_0x33540c(0x572)]);
                    if (!this["isCaptureParallel"](_0x166a57[_0x33540c(0x4d8)], _0x47a6bb))
                      return new _0x308ca0("NF", "MITEK_ERROR_PERPENDICULAR_DOCUMENT", 0x0, _0x166a57);
                  }
                  return _0x487fc4["skewAngle"] > this[_0x33540c(0x38d)][_0x33540c(0x565)] ||
                    (_0x33540c(0x68c) === _0x409f64["Z"][_0x33540c(0x637)]["actionIdentifier"]["actionType"] &&
                      Math["abs"]((null == _0x166a57 ? void 0x0 : _0x166a57[_0x33540c(0x43b)]) || 0x0) >
                        this[_0x33540c(0x38d)][_0x33540c(0x4ca)])
                    ? new _0x308ca0("QS", _0x33540c(0x217), 0x0, _0x166a57)
                    : _0x487fc4[_0x33540c(0x3cc)] < this[_0x33540c(0x38d)][_0x33540c(0x5df)]
                    ? new _0x308ca0("HF", _0x33540c(0x1c0), 0x0, _0x166a57)
                    : _0x487fc4[_0x33540c(0x40d)] < this[_0x33540c(0x38d)][_0x33540c(0x282)]
                    ? new _0x308ca0("MP", _0x33540c(0x284), 0x0, _0x166a57)
                    : _0x487fc4["lowContrastConfidence"] < this["thresholds"][_0x33540c(0x3ef)]
                    ? new _0x308ca0("LC", _0x33540c(0x377), 0x0, _0x166a57)
                    : _0x487fc4[_0x33540c(0x5f9)] < this[_0x33540c(0x38d)][_0x33540c(0x30b)]
                    ? new _0x308ca0("BB", "MITEK_ERROR_BUSY_BACKGROUND", 0x0, _0x166a57)
                    : _0x487fc4[_0x33540c(0x488)] < this[_0x33540c(0x38d)]["ET"]
                    ? new _0x308ca0("BF", _0x33540c(0x687), 0x0, _0x166a57)
                    : _0x487fc4[_0x33540c(0x2e3)] < this[_0x33540c(0x38d)]["FT"]
                    ? new _0x308ca0("QF", _0x33540c(0x258), 0x0, _0x166a57)
                    : _0x487fc4[_0x33540c(0x44f)] < this[_0x33540c(0x38d)]["GT"]
                    ? new _0x308ca0("GF", "MITEK_ERROR_GLARE", 0x0, _0x166a57)
                    : new _0x579044("SU", _0x33540c(0x66f), _0x487fc4[_0x33540c(0x564)], _0x166a57);
                }
                [_0x4067e7(0x2f9)](_0x2fb8ba) {
                  const _0x23004d = _0x4067e7;
                  return this[_0x23004d(0x340)](_0x2fb8ba);
                }
              },
              _0x55a1f5 = class extends _0x45ff28 {
                ["evaluateThresholds"](_0x277eaa) {
                  const _0x2eab4d = _0x4067e7,
                    _0x403772 = _0x277eaa[_0x2eab4d(0x572)],
                    _0x393987 = super[_0x2eab4d(0x340)](_0x277eaa);
                  return _0x393987[_0x2eab4d(0x6f3)] && _0x403772["mrzScore"] < this[_0x2eab4d(0x38d)][_0x2eab4d(0x3b0)]
                    ? new _0x308ca0("NF", "MITEK_ERROR_MRZ_MISSING", 0x0, _0x277eaa)
                    : _0x393987;
                }
              };
            var _0x2c3d54 = _0x33dbda(0x2b);
            const _0x5a5eb5 = class {
                constructor(_0x42fbc9) {
                  const _0x57b9ab = _0x4067e7;
                  (this["thresholds"] = _0x409f64["Z"][_0x57b9ab(0x63a)][_0x57b9ab(0x38d)][_0x57b9ab(0x332)][_0x42fbc9["deviceType"]]),
                    (this[_0x57b9ab(0x492)] = this[_0x57b9ab(0x70c)](_0x42fbc9[_0x57b9ab(0x400)])),
                    (this[_0x57b9ab(0x1d2)] =
                      _0x409f64["Z"]["currentAction"][_0x57b9ab(0x403)]["disableSmileDetection"] ||
                      _0x57b9ab(0x548) !== _0x409f64["Z"][_0x57b9ab(0x637)][_0x57b9ab(0x452)][_0x57b9ab(0x400)]),
                    (this[_0x57b9ab(0x727)] = {
                      detectionBoxPercentage: 0x0,
                      faceTooCloseThreshold: this[_0x57b9ab(0x38d)][_0x57b9ab(0x5b3)],
                      faceTooFarThreshold: this[_0x57b9ab(0x38d)][_0x57b9ab(0x4f2)],
                      isFaceTooFar: null,
                      isFaceTooClose: null,
                      sobelBlurValueMinThreshold: this[_0x57b9ab(0x38d)][_0x57b9ab(0x6f7)],
                      sobelBlurValueMin: 0x0,
                    });
                }
                [_0x4067e7(0x3e3)](_0xd18732) {
                  const _0x3b512f = _0x4067e7;
                  var _0xb585ef, _0x3a4c32, _0x4ab873, _0x309a06;
                  const _0x5750dc =
                      (null ===
                        (_0x3a4c32 =
                          null === (_0xb585ef = null == _0xd18732 ? void 0x0 : _0xd18732[_0x3b512f(0x572)]) || void 0x0 === _0xb585ef
                            ? void 0x0
                            : _0xb585ef[_0x3b512f(0x4f8)]) || void 0x0 === _0x3a4c32
                        ? void 0x0
                        : _0x3a4c32["box"]) ||
                      (null === (_0x4ab873 = null == _0xd18732 ? void 0x0 : _0xd18732["rawData"]) || void 0x0 === _0x4ab873
                        ? void 0x0
                        : _0x4ab873[_0x3b512f(0x4b7)]) ||
                      (null === (_0x309a06 = null == _0xd18732 ? void 0x0 : _0xd18732[_0x3b512f(0x572)]) || void 0x0 === _0x309a06
                        ? void 0x0
                        : _0x309a06[_0x3b512f(0x6d6)]),
                    _0x3f03bd = (_0x5750dc[_0x3b512f(0x6ee)] || _0x5750dc["_y"]) - 0.1 * (_0x5750dc[_0x3b512f(0x6ee)] || _0x5750dc["_y"]),
                    _0x374c24 = _0x5750dc["height"] - 0.1 * _0x5750dc[_0x3b512f(0x39c)],
                    _0x260a75 = _0x5750dc[_0x3b512f(0x657)] - 0.1 * _0x5750dc[_0x3b512f(0x657)];
                  return {
                    top: _0x3f03bd,
                    left: _0x5750dc[_0x3b512f(0x371)],
                    x: _0x5750dc["x"],
                    y: _0x5750dc["y"],
                    height: _0x374c24,
                    width: _0x260a75,
                  };
                }
                [_0x4067e7(0x722)](_0xbc4896) {
                  const _0x54e831 = _0x4067e7;
                  return {
                    x: _0xbc4896[_0x54e831(0x4d8)][_0x54e831(0x657)] / 0x2,
                    y: _0xbc4896["imageDimensions"][_0x54e831(0x39c)] / 0x2,
                  };
                }
                [_0x4067e7(0x3cf)](_0x5d139d) {
                  const _0x452897 = _0x4067e7,
                    _0x2db8d3 = this[_0x452897(0x3e3)](_0x5d139d);
                  return (
                    (_0x2db8d3["width"] * _0x2db8d3[_0x452897(0x39c)]) /
                    (_0x5d139d[_0x452897(0x4d8)]["width"] * _0x5d139d[_0x452897(0x4d8)][_0x452897(0x39c)])
                  );
                }
                ["isFaceNotFound"](_0x82ba04) {
                  const _0x3ed7ff = _0x4067e7;
                  var _0x31ee4a;
                  return (
                    _0x82ba04[_0x3ed7ff(0x28d)] ||
                    !(
                      (null === (_0x31ee4a = _0x82ba04[_0x3ed7ff(0x572)][_0x3ed7ff(0x4f8)]) || void 0x0 === _0x31ee4a
                        ? void 0x0
                        : _0x31ee4a[_0x3ed7ff(0x4b7)]) || _0x82ba04[_0x3ed7ff(0x572)][_0x3ed7ff(0x4b7)]
                    )
                  );
                }
                ["isFaceTooClose"](_0x1958ff) {
                  const _0x46c1fa = _0x4067e7;
                  return (
                    (this[_0x46c1fa(0x727)][_0x46c1fa(0x2ca)] = this[_0x46c1fa(0x3cf)](_0x1958ff)),
                    this[_0x46c1fa(0x3cf)](_0x1958ff) > this[_0x46c1fa(0x38d)]["FTCT"]
                  );
                }
                [_0x4067e7(0x363)](_0x15bd10) {
                  const _0x51f38e = _0x4067e7;
                  return (
                    (this[_0x51f38e(0x727)]["isFaceTooFar"] = this[_0x51f38e(0x3cf)](_0x15bd10) < this[_0x51f38e(0x38d)][_0x51f38e(0x4f2)]),
                    this[_0x51f38e(0x3cf)](_0x15bd10) < this[_0x51f38e(0x38d)][_0x51f38e(0x4f2)]
                  );
                }
                ["isFaceSkewed"](_0x2c950b) {
                  const _0x9be922 = _0x4067e7;
                  var _0x2cd01c, _0x33aeb2, _0x43d80a, _0x2ea028;
                  if (
                    !(null ===
                      (_0x33aeb2 =
                        null === (_0x2cd01c = null == _0x2c950b ? void 0x0 : _0x2c950b[_0x9be922(0x572)]) || void 0x0 === _0x2cd01c
                          ? void 0x0
                          : _0x2cd01c[_0x9be922(0x39b)]) || void 0x0 === _0x33aeb2
                      ? void 0x0
                      : _0x33aeb2[_0x9be922(0x516)]) ||
                    !(null ===
                      (_0x2ea028 =
                        null === (_0x43d80a = null == _0x2c950b ? void 0x0 : _0x2c950b["rawData"]) || void 0x0 === _0x43d80a
                          ? void 0x0
                          : _0x43d80a[_0x9be922(0x39b)]) || void 0x0 === _0x2ea028
                      ? void 0x0
                      : _0x2ea028["getRightEye"])
                  )
                    return !0x1;
                  let _0x15036e = this[_0x9be922(0x5b6)](_0x2c950b["rawData"][_0x9be922(0x39b)]);
                  return Math[_0x9be922(0x661)](_0x15036e) > 0x4;
                }
                [_0x4067e7(0x427)](_0x388c83) {
                  return this["getDistanceOfImageAndDetectionBoxCenterPoints"](_0x388c83) > 0x50;
                }
                ["isFaceBlurry"](_0x2e7762) {
                  const _0xf1491a = _0x4067e7;
                  return (
                    !!_0x2e7762[_0xf1491a(0x3c1)] &&
                    ((this[_0xf1491a(0x727)]["sobelBlurValueMin"] = _0x2e7762[_0xf1491a(0x3c1)]),
                    (null == _0x2e7762 ? void 0x0 : _0x2e7762[_0xf1491a(0x3c1)]) < this[_0xf1491a(0x38d)][_0xf1491a(0x6f7)])
                  );
                }
                [_0x4067e7(0x2e8)](_0x13e729, _0xa8ca09) {
                  const _0x19f3ee = _0x4067e7;
                  return Math[_0x19f3ee(0x522)](
                    Math[_0x19f3ee(0x714)](_0x13e729["x"] - _0xa8ca09["x"], 0x2) +
                      Math[_0x19f3ee(0x714)](_0x13e729["y"] - _0xa8ca09["y"], 0x2)
                  );
                }
                ["getEyeCenter"](_0x3fb6ed) {
                  const _0x2f9a6b = _0x4067e7,
                    _0x229cd8 = _0x3fb6ed[_0x2f9a6b(0x208)](
                      (_0x501bec, _0x4e1fd3) => ({ _x: _0x501bec["_x"] + _0x4e1fd3["_x"], _y: _0x501bec["_y"] + _0x4e1fd3["_y"] }),
                      { _x: 0x0, _y: 0x0 }
                    );
                  return { _x: _0x229cd8["_x"] / _0x3fb6ed[_0x2f9a6b(0x5ab)], _y: _0x229cd8["_y"] / _0x3fb6ed[_0x2f9a6b(0x5ab)] };
                }
                [_0x4067e7(0x5b6)](_0x593443) {
                  const _0x5642f6 = _0x4067e7,
                    _0x5eb18d = _0x593443["getLeftEye"](),
                    _0xab5f13 = _0x593443[_0x5642f6(0x47e)](),
                    _0x407831 = this[_0x5642f6(0x2dc)](_0x5eb18d),
                    _0x16e755 = this[_0x5642f6(0x2dc)](_0xab5f13),
                    _0x2b8040 = _0x16e755["_x"] - _0x407831["_x"],
                    _0x382b82 = _0x16e755["_y"] - _0x407831["_y"];
                  return (0xb4 * Math["atan2"](_0x382b82, _0x2b8040)) / Math["PI"];
                }
                ["getDistanceOfImageAndDetectionBoxCenterPoints"](_0x4f1cd0) {
                  const _0x2bec63 = _0x4067e7,
                    _0x2c4464 = this[_0x2bec63(0x4c1)](_0x4f1cd0),
                    _0x4a0f1c = this[_0x2bec63(0x722)](_0x4f1cd0);
                  return this[_0x2bec63(0x2e8)](_0x2c4464, _0x4a0f1c);
                }
                ["getDetectionBoxCenterPoint"](_0x52b842) {
                  const _0x1c12d9 = _0x4067e7,
                    _0xc376ce = this[_0x1c12d9(0x3e3)](_0x52b842);
                  return {
                    x: _0xc376ce[_0x1c12d9(0x371)] + _0xc376ce[_0x1c12d9(0x657)] / 0x2,
                    y: _0xc376ce[_0x1c12d9(0x6ee)] + _0xc376ce[_0x1c12d9(0x39c)] / 0x2,
                  };
                }
                [_0x4067e7(0x415)](_0xd29211) {
                  const _0x3b66a5 = _0x4067e7;
                  var _0x694118;
                  if (
                    !(null === (_0x694118 = _0x409f64["Z"][_0x3b66a5(0x637)][_0x3b66a5(0x3b8)][_0x3b66a5(0x236)]) || void 0x0 === _0x694118
                      ? void 0x0
                      : _0x694118[_0x3b66a5(0x572)])
                  )
                    return !0x1;
                  const _0x134553 = _0xd29211[_0x3b66a5(0x572)]["detection"][_0x3b66a5(0x4b7)],
                    _0x4a4b25 =
                      _0x409f64["Z"][_0x3b66a5(0x637)][_0x3b66a5(0x3b8)][_0x3b66a5(0x236)][_0x3b66a5(0x572)][_0x3b66a5(0x4f8)]["box"],
                    _0x3bd1cd = Math["abs"](_0x134553["x"] - _0x4a4b25["x"]),
                    _0x5c9859 = Math[_0x3b66a5(0x661)](_0x134553["y"] - _0x4a4b25["y"]);
                  return _0x3bd1cd > this[_0x3b66a5(0x38d)][_0x3b66a5(0x36f)] || _0x5c9859 > this["thresholds"][_0x3b66a5(0x36f)];
                }
                ["hasSmile"](_0x14c847) {
                  const _0x29b0ea = _0x4067e7;
                  return (
                    _0x409f64["Z"][_0x29b0ea(0x637)][_0x29b0ea(0x3b8)][_0x29b0ea(0x6f0)] ||
                    _0x14c847[_0x29b0ea(0x572)][_0x29b0ea(0x3cb)][_0x29b0ea(0x2d6)] > this["thresholds"]["HT"]
                  );
                }
                [_0x4067e7(0x270)](_0x3ec398) {
                  const _0x1fa643 = _0x4067e7;
                  let _0x286952 = this[_0x1fa643(0x5f0)](_0x3ec398),
                    _0x43fd01 = _0x3ec398[_0x1fa643(0x572)]["expressions"][_0x1fa643(0x4a5)] > this[_0x1fa643(0x38d)]["NT"];
                  return _0x409f64["Z"][_0x1fa643(0x637)][_0x1fa643(0x3b8)][_0x1fa643(0x3c5)] || (_0x43fd01 && !_0x286952);
                }
                [_0x4067e7(0x70c)](_0x16234c) {
                  const _0x4d6d2b = _0x4067e7,
                    _0x3a33c0 = !_0x409f64["Z"][_0x4d6d2b(0x637)]["commandOptions"][_0x4d6d2b(0x2d0)],
                    _0x310de9 = [
                      { weightId: 0x1, hintMessageKey: _0x4d6d2b(0x559), testFunc: this["isFaceNotFound"] },
                      { weightId: 0x2, hintMessageKey: _0x4d6d2b(0x347), testFunc: this[_0x4d6d2b(0x5cc)] },
                      { weightId: 0x3, hintMessageKey: _0x4d6d2b(0x46f), testFunc: this["isFaceTooFar"] },
                      { weightId: 0x4, hintMessageKey: _0x4d6d2b(0x2da), testFunc: this[_0x4d6d2b(0x5f0)] },
                    ];
                  return (
                    _0x4d6d2b(0x548) === _0x16234c &&
                      (_0x310de9[_0x4d6d2b(0x462)]({ weightId: 1.2, hintMessageKey: _0x4d6d2b(0x23b), testFunc: this[_0x4d6d2b(0x427)] }),
                      _0x310de9["unshift"]({ weightId: 0x4, hintMessageKey: "MISNAP_STAY_STILL", testFunc: this[_0x4d6d2b(0x415)] }),
                      _0x310de9[_0x4d6d2b(0x462)]({ weightId: 0x4, hintMessageKey: _0x4d6d2b(0x258), testFunc: this[_0x4d6d2b(0x549)] }),
                      _0x3a33c0 &&
                        _0x310de9[_0x4d6d2b(0x4a7)]({
                          weightId: 0x5,
                          hintMessageKey: _0x4d6d2b(0x353),
                          testFunc: (_0x35d7c2) => !this[_0x4d6d2b(0x413)](_0x35d7c2),
                        })),
                    _0x310de9[_0x4d6d2b(0x223)]((_0x47051d, _0x34ff64) => _0x47051d[_0x4d6d2b(0x476)] - _0x34ff64[_0x4d6d2b(0x476)]),
                    _0x310de9
                  );
                }
                [_0x4067e7(0x66d)](_0x5dddb8) {
                  const _0x587fa3 = _0x4067e7;
                  var _0x541d0a;
                  return (
                    (null ===
                      (_0x541d0a = this["failureConditions"][_0x587fa3(0x6a3)]((_0x27f9ff) =>
                        _0x27f9ff[_0x587fa3(0x6df)][_0x587fa3(0x23e)](this)(_0x5dddb8)
                      )) || void 0x0 === _0x541d0a
                      ? void 0x0
                      : _0x541d0a[_0x587fa3(0x229)]) || _0x587fa3(0x66f)
                  );
                }
                [_0x4067e7(0x2f9)](_0x5a49c6) {
                  const _0x55fbcd = _0x4067e7;
                  var _0x278880, _0x142f58;
                  let _0x272ce8 = this[_0x55fbcd(0x66d)](_0x5a49c6);
                  if (
                    ((_0x409f64["Z"][_0x55fbcd(0x637)][_0x55fbcd(0x3b8)]["previousRecognizedData"] = _0x5a49c6), this[_0x55fbcd(0x1d2)])
                  ) {
                    if (_0x55fbcd(0x66f) === _0x272ce8)
                      return new _0x579044(
                        "SU",
                        _0x55fbcd(0x66f),
                        0x0,
                        _0x409f64["Z"][_0x55fbcd(0x637)][_0x55fbcd(0x3b8)]["neutralFacialExpressionRecognizedData"]
                      );
                  } else {
                    if (
                      _0x55fbcd(0x66f) === _0x272ce8 &&
                      _0x409f64["Z"][_0x55fbcd(0x637)][_0x55fbcd(0x3b8)][_0x55fbcd(0x6d2)] &&
                      _0x409f64["Z"][_0x55fbcd(0x637)][_0x55fbcd(0x3b8)]["hasFoundSmilingExpressionSnapshot"]
                    )
                      return (
                        (_0x409f64["Z"][_0x55fbcd(0x637)][_0x55fbcd(0x372)] =
                          _0x409f64["Z"][_0x55fbcd(0x637)][_0x55fbcd(0x3b8)][_0x55fbcd(0x6d2)]),
                        new _0x579044(
                          "SU",
                          _0x55fbcd(0x66f),
                          0x0,
                          _0x409f64["Z"][_0x55fbcd(0x637)][_0x55fbcd(0x3b8)]["neutralFacialExpressionRecognizedData"]
                        )
                      );
                  }
                  if (
                    _0x55fbcd(0x66f) === _0x272ce8 &&
                    (this[_0x55fbcd(0x413)](_0x5a49c6) &&
                      (_0x409f64["Z"][_0x55fbcd(0x637)][_0x55fbcd(0x3b8)]["hasFoundSmilingExpressionSnapshot"] = !0x0),
                    this[_0x55fbcd(0x270)](_0x5a49c6) &&
                      !_0x409f64["Z"][_0x55fbcd(0x637)][_0x55fbcd(0x3b8)][_0x55fbcd(0x3c5)] &&
                      !this[_0x55fbcd(0x549)](_0x5a49c6))
                  ) {
                    (_0x409f64["Z"][_0x55fbcd(0x637)][_0x55fbcd(0x3b8)][_0x55fbcd(0x6a6)] = Object[_0x55fbcd(0x620)]({}, _0x5a49c6)),
                      (_0x409f64["Z"][_0x55fbcd(0x637)][_0x55fbcd(0x3b8)][_0x55fbcd(0x3c5)] = !0x0);
                    const _0x2ef791 = _0x409f64["Z"][_0x55fbcd(0x637)][_0x55fbcd(0x372)][_0x55fbcd(0x248)],
                      _0xdc6a5f = Uint8ClampedArray[_0x55fbcd(0x547)](_0x2ef791["data"]);
                    _0x409f64["Z"]["currentAction"]["faceAPIStore"][_0x55fbcd(0x6d2)] = new _0x2c3d54["Z"](
                      new ImageData(_0xdc6a5f, _0x2ef791[_0x55fbcd(0x657)], _0x2ef791[_0x55fbcd(0x39c)]),
                      0x1
                    );
                  }
                  return (
                    _0x409f64["Z"][_0x55fbcd(0x637)][_0x55fbcd(0x3b8)][_0x55fbcd(0x3ed)](_0x272ce8),
                    "NO_ISSUE" === _0x272ce8 &&
                      (_0x409f64["Z"][_0x55fbcd(0x637)][_0x55fbcd(0x3b8)][_0x55fbcd(0x3c5)]
                        ? (null ===
                            (_0x142f58 =
                              null ===
                                (_0x278880 =
                                  null === _0x409f64["Z"] || void 0x0 === _0x409f64["Z"] ? void 0x0 : _0x409f64["Z"]["currentAction"]) ||
                              void 0x0 === _0x278880
                                ? void 0x0
                                : _0x278880["faceAPIStore"]) || void 0x0 === _0x142f58
                            ? void 0x0
                            : _0x142f58[_0x55fbcd(0x6f0)]) || (_0x272ce8 = _0x55fbcd(0x353))
                        : (_0x272ce8 = _0x55fbcd(0x2a0))),
                    new _0x308ca0("NF", _0x272ce8, 0x0, _0x5a49c6)
                  );
                }
              },
              _0x3edde8 = class {
                constructor(_0x36d54f) {
                  const _0x242974 = _0x4067e7;
                  (this[_0x242974(0x295)] = "-1"),
                    (this["ERROR_CODE_2"] = "No\x20barcode\x20found."),
                    (this[_0x242974(0x468)] = _0x242974(0x5ae)),
                    (this["PROP_IMAGE_HEIGHT"] = _0x242974(0x64c));
                }
                [_0x4067e7(0x2f9)](_0x2765ac) {
                  const _0x33fe28 = _0x4067e7;
                  var _0x366d05, _0x2badf5;
                  return (null == _0x2765ac ? void 0x0 : _0x2765ac["isFailure"]) ||
                    !(null == _0x2765ac ? void 0x0 : _0x2765ac[_0x33fe28(0x572)][_0x33fe28(0x5a9)](this[_0x33fe28(0x5ad)])) ||
                    (null == _0x2765ac ? void 0x0 : _0x2765ac[_0x33fe28(0x572)][_0x33fe28(0x4d0)]) === this[_0x33fe28(0x25d)] ||
                    (null == _0x2765ac ? void 0x0 : _0x2765ac[_0x33fe28(0x572)][_0x33fe28(0x4d0)]) === this["ERROR_CODE"] ||
                    (null === (_0x366d05 = null == _0x2765ac ? void 0x0 : _0x2765ac["rawData"]) || void 0x0 === _0x366d05
                      ? void 0x0
                      : _0x366d05[_0x33fe28(0x1f7)]) === this["DATA_TYPE_LABEL"] ||
                    0x0 ===
                      (null === (_0x2badf5 = null == _0x2765ac ? void 0x0 : _0x2765ac[_0x33fe28(0x572)]) || void 0x0 === _0x2badf5
                        ? void 0x0
                        : _0x2badf5[_0x33fe28(0x4d0)][_0x33fe28(0x5ab)])
                    ? new _0x308ca0("NB", _0x33fe28(0x33a), 0x0, _0x2765ac)
                    : new _0x579044("SU", "NO_ISSUE", 0x3e8, _0x2765ac);
                }
              },
              _0x3564cd = class {
                constructor(_0x193f25) {}
                [_0x4067e7(0x2f9)](_0x16502f) {
                  const _0x21185e = _0x4067e7;
                  if (null == _0x16502f ? void 0x0 : _0x16502f["isFailure"])
                    throw new _0x3b1c1e["Z"](_0x21185e(0x2e6), new Error(_0x21185e(0x712)));
                  return new _0x579044("SU", "NO_ISSUE", 0x3e8, _0x16502f);
                }
              },
              _0x2fa509 = new (class {
                [_0x4067e7(0x2f9)](_0x4f9909, _0x3db37e) {
                  const _0xd828d8 = _0x4067e7;
                  switch (_0x4f9909["actionType"]) {
                    case "PDF417_BARCODE":
                    case _0xd828d8(0x533):
                      return _0x411080[_0xd828d8(0x456)](), new _0x3edde8(_0x4f9909)[_0xd828d8(0x2f9)](_0x3db37e);
                    case _0xd828d8(0x332):
                      return _0x411080[_0xd828d8(0x456)](), new _0x5a5eb5(_0x4f9909)[_0xd828d8(0x2f9)](_0x3db37e);
                    case _0xd828d8(0x478):
                      return _0x411080[_0xd828d8(0x456)](), new _0x55a1f5(_0x4f9909)[_0xd828d8(0x2f9)](_0x3db37e);
                    case "CHECK_BACK":
                    case _0xd828d8(0x717):
                    case _0xd828d8(0x68c):
                    case _0xd828d8(0x692):
                    case "DOCUMENT":
                      return _0x411080[_0xd828d8(0x456)](), new _0x45ff28(_0x4f9909)[_0xd828d8(0x2f9)](_0x3db37e);
                    case _0xd828d8(0x268):
                      return new _0x3564cd(_0x4f9909)[_0xd828d8(0x2f9)](_0x3db37e);
                    default:
                      throw _0xd828d8(0x4e9);
                  }
                }
              })();
            var _0x1068d8 = _0x33dbda(0x35e);
            const _0x39d85d = /(?:P[<0A-Z])([0A-Z]{3})/,
              _0x1d2ad9 = /(?:[0-9O]{7}[<FM][0-9O]{7})([<0-9A-Z]{14})([0-9O])/,
              _0x324fc4 = class {
                constructor(_0xb6269) {
                  const _0x391e37 = _0x4067e7;
                  (this[_0x391e37(0x618)] = ""),
                    (this["hasOptionalData"] = !0x1),
                    _0xb6269[_0x391e37(0x5ab)] >= 0x2c &&
                      ((this[_0x391e37(0x618)] = (function (_0x59d382) {
                        const _0x1ed76e = _0x391e37,
                          _0xf76057 = _0x59d382["match"](_0x39d85d),
                          _0x5c59b6 = (null == _0xf76057 ? void 0x0 : _0xf76057[0x1]) || _0x1ed76e(0x4b0);
                        return _0x1ed76e(0x4b0) === _0x5c59b6 ? "" : _0x5c59b6[_0x1ed76e(0x6a5)](/0/g, "O");
                      })(_0xb6269)),
                      (this[_0x391e37(0x335)] = (function (_0x2c8027) {
                        const _0x2b1845 = _0x391e37,
                          _0x3e2804 = _0x2c8027["match"](_0x1d2ad9),
                          _0x5bcd30 = null == _0x3e2804 ? void 0x0 : _0x3e2804[0x1],
                          _0x1e24cc = null == _0x3e2804 ? void 0x0 : _0x3e2804[0x2];
                        return (
                          (_0x5bcd30 && _0x1e24cc && _0x2b1845(0x3a0) !== _0x5bcd30 && "<" !== _0x1e24cc) ||
                          ("<<<<<<<<<<<<<<" === _0x5bcd30 && "<" === _0x1e24cc)
                        );
                      })(_0xb6269)));
                }
              };
            var _0x5492f1 = function (_0x37d5f6, _0x5a6dc2, _0x56f31e, _0x373c3c) {
              return new (_0x56f31e || (_0x56f31e = Promise))(function (_0x510345, _0x463cfc) {
                const _0x59c8ff = a0_0x1b49;
                function _0x207b77(_0x418b70) {
                  const _0x2dc462 = a0_0x1b49;
                  try {
                    _0x4cfdee(_0x373c3c[_0x2dc462(0x3e1)](_0x418b70));
                  } catch (_0x584631) {
                    _0x463cfc(_0x584631);
                  }
                }
                function _0x2045ab(_0x24e6a9) {
                  try {
                    _0x4cfdee(_0x373c3c["throw"](_0x24e6a9));
                  } catch (_0x4b2a6c) {
                    _0x463cfc(_0x4b2a6c);
                  }
                }
                function _0x4cfdee(_0x3dfb72) {
                  const _0x1ad0b2 = a0_0x1b49;
                  var _0x560701;
                  _0x3dfb72[_0x1ad0b2(0x4f5)]
                    ? _0x510345(_0x3dfb72[_0x1ad0b2(0x331)])
                    : ((_0x560701 = _0x3dfb72[_0x1ad0b2(0x331)]),
                      _0x560701 instanceof _0x56f31e
                        ? _0x560701
                        : new _0x56f31e(function (_0x48d6da) {
                            _0x48d6da(_0x560701);
                          }))["then"](_0x207b77, _0x2045ab);
                }
                _0x4cfdee((_0x373c3c = _0x373c3c[_0x59c8ff(0x1d1)](_0x37d5f6, _0x5a6dc2 || []))[_0x59c8ff(0x3e1)]());
              });
            };
            new _0x3da364(_0x4067e7(0x2a2));
            const _0x527ec2 = new (class {
              constructor() {
                const _0x24bebf = _0x4067e7;
                (this[_0x24bebf(0x316)] = [_0x24bebf(0x39a), _0x24bebf(0x5f6)]),
                  (this[_0x24bebf(0x71a)] = _0x24bebf(0x24c)),
                  (this["recordedBlobs"] = []),
                  (this[_0x24bebf(0x6aa)] = null);
              }
              [_0x4067e7(0x47b)]() {
                const _0x104557 = _0x4067e7;
                return (
                  this[_0x104557(0x316)][_0x104557(0x6a3)]((_0x329a14) => _0x33dbda["g"]["MediaRecorder"][_0x104557(0x518)](_0x329a14)) ||
                  "video/mp4"
                );
              }
              [_0x4067e7(0x21e)]() {
                const _0x6e4861 = _0x4067e7;
                return Math[_0x6e4861(0x6b9)](
                  ((_0x409f64["Z"][_0x6e4861(0x63a)][_0x6e4861(0x38d)][_0x6e4861(0x36c)][_0x6e4861(0x2fb)] -
                    _0x409f64["Z"][_0x6e4861(0x63a)][_0x6e4861(0x38d)]["BASE"][_0x6e4861(0x253)]) *
                    (_0x409f64["Z"]["currentAction"][_0x6e4861(0x403)]["videoQuality"] - 0x1)) /
                    0x63 +
                    _0x409f64["Z"][_0x6e4861(0x63a)][_0x6e4861(0x38d)][_0x6e4861(0x36c)][_0x6e4861(0x253)]
                );
              }
              [_0x4067e7(0x2b9)](_0x3a5003) {
                const _0x31b69b = _0x4067e7;
                var _0x1a4da5;
                (null === (_0x1a4da5 = _0x3a5003[_0x31b69b(0x589)]) || void 0x0 === _0x1a4da5 ? void 0x0 : _0x1a4da5[_0x31b69b(0x4bc)]) >
                  0x0 && this[_0x31b69b(0x314)][_0x31b69b(0x4a7)](_0x3a5003[_0x31b69b(0x589)]);
              }
              ["handleStop"]() {
                const _0x3ab55c = _0x4067e7;
                this[_0x3ab55c(0x314)] = [];
              }
              ["loadRecordingDomElements"]() {
                const _0x1919f4 = _0x4067e7,
                  _0x40fa23 = document["getElementById"]("mitekDisplayContainer");
                if (_0x40fa23 && "" !== _0x409f64["Z"]["currentAction"][_0x1919f4(0x403)]["videoRecordingMessage"]) {
                  const _0x2acbf5 = document[_0x1919f4(0x506)](_0x1919f4(0x6dd));
                  _0x2acbf5[_0x1919f4(0x584)]("id", _0x1919f4(0x425)),
                    _0x2acbf5[_0x1919f4(0x584)](
                      _0x1919f4(0x1c7),
                      _0x409f64["Z"][_0x1919f4(0x63a)]["CommandOptionsDictionary"][_0x1919f4(0x3e2)][
                        _0x409f64["Z"][_0x1919f4(0x637)][_0x1919f4(0x403)][_0x1919f4(0x3e2)]
                      ]
                    );
                  const _0x254f09 = document[_0x1919f4(0x506)](_0x1919f4(0x6dd));
                  _0x254f09[_0x1919f4(0x584)]("id", "mitekVideoRecordingIcon");
                  const _0x400ec7 = document[_0x1919f4(0x506)](_0x1919f4(0x4ac));
                  _0x400ec7[_0x1919f4(0x584)]("id", _0x1919f4(0x24e)),
                    (_0x400ec7[_0x1919f4(0x69a)] = _0x409f64["Z"][_0x1919f4(0x637)][_0x1919f4(0x403)][_0x1919f4(0x1e7)]),
                    _0x2acbf5[_0x1919f4(0x625)](_0x254f09),
                    _0x2acbf5[_0x1919f4(0x625)](_0x400ec7),
                    _0x40fa23[_0x1919f4(0x625)](_0x2acbf5);
                }
              }
              [_0x4067e7(0x674)](_0x219ee2) {
                const _0x8348d1 = _0x4067e7;
                try {
                  _0x409f64["Z"]["setCurrentActionHasSessionRecordingStopped"](!0x1),
                    (this[_0x8348d1(0x624)] = this[_0x8348d1(0x47b)]()),
                    (this["bitRate"] = this[_0x8348d1(0x21e)]());
                  const _0x30e8f = { videoBitsPerSecond: this[_0x8348d1(0x210)], mimeType: this[_0x8348d1(0x624)] };
                  return (
                    (this["mediaRecorder"] = new _0x33dbda["g"][_0x8348d1(0x44e)](_0x219ee2, _0x30e8f)),
                    (this["mediaRecorder"][_0x8348d1(0x25e)] = (_0x21e514) => {
                      const _0x570c2e = _0x8348d1;
                      this[_0x570c2e(0x2b9)](_0x21e514);
                    }),
                    (this[_0x8348d1(0x3cd)][_0x8348d1(0x5cd)] = () => this[_0x8348d1(0x204)]()),
                    (this[_0x8348d1(0x3cd)][_0x8348d1(0x4be)] = function (_0x5dbe12) {
                      const _0x1a9631 = _0x8348d1;
                      throw (console[_0x1a9631(0x677)](_0x1a9631(0x5c7)), new Error(_0x1a9631(0x22c)));
                    }),
                    this[_0x8348d1(0x3cd)][_0x8348d1(0x4b4)](
                      _0x409f64["Z"]["appConfig"][_0x8348d1(0x38d)][_0x8348d1(0x36c)][_0x8348d1(0x382)]
                    ),
                    this[_0x8348d1(0x358)](),
                    this[_0x8348d1(0x424)] && clearTimeout(this[_0x8348d1(0x424)]),
                    (this["recordingTimeout"] = setTimeout(() => {
                      const _0x5de6e6 = _0x8348d1;
                      _0x409f64["Z"][_0x5de6e6(0x408)](!0x0);
                    }, _0x409f64["Z"][_0x8348d1(0x63a)][_0x8348d1(0x38d)]["BASE"][_0x8348d1(0x459)])),
                    !0x0
                  );
                } catch (_0x43eaba) {
                  throw new _0x3b1c1e["Z"](_0x8348d1(0x6bd), new Error());
                }
              }
              [_0x4067e7(0x225)]() {
                var _0x2acaf3;
                return _0x5492f1(this, void 0x0, void 0x0, function* () {
                  const _0x8ebf86 = a0_0x1b49;
                  if (
                    (_0x409f64["Z"]["setCurrentActionHasSessionRecordingStopped"](!0x0),
                    (null === (_0x2acaf3 = this[_0x8ebf86(0x3cd)]) || void 0x0 === _0x2acaf3 ? void 0x0 : _0x2acaf3[_0x8ebf86(0x6d9)]) ===
                      this["STATE_RECORDING"])
                  )
                    return (
                      this[_0x8ebf86(0x3cd)]["stop"](),
                      new Promise((_0x16dfaf, _0x104eb6) => {
                        const _0x55d7ee = _0x8ebf86,
                          _0x539c99 = new Blob(this[_0x55d7ee(0x314)], { type: this[_0x55d7ee(0x624)] }),
                          _0x56eca0 = new FileReader();
                        (_0x56eca0[_0x55d7ee(0x3fb)] = function () {
                          const _0x439029 = _0x55d7ee;
                          _0x16dfaf(_0x56eca0[_0x439029(0x28b)]);
                        }),
                          (_0x56eca0[_0x55d7ee(0x4be)] = function (_0x5863a4) {
                            _0x104eb6(_0x5863a4);
                          }),
                          _0x56eca0[_0x55d7ee(0x2a4)](_0x539c99);
                      })
                    );
                  throw new _0x3b1c1e["Z"]("RUNTIME_SESSION_RECORDING_ERROR", new Error());
                });
              }
              [_0x4067e7(0x250)]() {
                const _0x649c57 = _0x4067e7;
                return {
                  VIDEO_RECORDING_ENABLED: _0x409f64["Z"][_0x649c57(0x637)][_0x649c57(0x403)][_0x649c57(0x550)],
                  AUDIO_RECORDING_ENABLED: _0x409f64["Z"][_0x649c57(0x637)][_0x649c57(0x403)][_0x649c57(0x6b6)],
                  VIDEO_QUALITY: _0x409f64["Z"][_0x649c57(0x637)]["commandOptions"][_0x649c57(0x4fb)],
                  RECORDING_MESSAGE: _0x409f64["Z"]["currentAction"][_0x649c57(0x403)][_0x649c57(0x1e7)],
                };
              }
            })();
            var _0x368a06 = function (_0x241636, _0x2836f2, _0x3f5b5e, _0x377562) {
              return new (_0x3f5b5e || (_0x3f5b5e = Promise))(function (_0x5c4d1c, _0x49e625) {
                const _0xbc2949 = a0_0x1b49;
                function _0x1cdadc(_0x373ffa) {
                  const _0x522404 = a0_0x1b49;
                  try {
                    _0x52f841(_0x377562[_0x522404(0x3e1)](_0x373ffa));
                  } catch (_0x534b53) {
                    _0x49e625(_0x534b53);
                  }
                }
                function _0x2b131e(_0x12e3a2) {
                  const _0x43318b = a0_0x1b49;
                  try {
                    _0x52f841(_0x377562[_0x43318b(0x3b2)](_0x12e3a2));
                  } catch (_0x550027) {
                    _0x49e625(_0x550027);
                  }
                }
                function _0x52f841(_0x22e83f) {
                  const _0x284316 = a0_0x1b49;
                  var _0x52a649;
                  _0x22e83f[_0x284316(0x4f5)]
                    ? _0x5c4d1c(_0x22e83f[_0x284316(0x331)])
                    : ((_0x52a649 = _0x22e83f[_0x284316(0x331)]),
                      _0x52a649 instanceof _0x3f5b5e
                        ? _0x52a649
                        : new _0x3f5b5e(function (_0x3d59ba) {
                            _0x3d59ba(_0x52a649);
                          }))[_0x284316(0x429)](_0x1cdadc, _0x2b131e);
                }
                _0x52f841((_0x377562 = _0x377562[_0xbc2949(0x1d1)](_0x241636, _0x2836f2 || []))["next"]());
              });
            };
            new _0x3da364("app:ImageUtil");
            let _0x3ff507 = document[_0x4067e7(0x506)](_0x4067e7(0x5ca));
            _0x3ff507[_0x4067e7(0x584)]("id", "utilCanvas_" + Date[_0x4067e7(0x3f5)]());
            const _0x11c06d = new (class {
                constructor() {
                  const _0x40f93f = _0x4067e7;
                  (this[_0x40f93f(0x3ea)] = _0x409f64["Z"][_0x40f93f(0x63a)][_0x40f93f(0x38d)][_0x40f93f(0x36c)][_0x40f93f(0x659)]),
                    (this[_0x40f93f(0x67d)] = _0x409f64["Z"][_0x40f93f(0x63a)]["thresholds"][_0x40f93f(0x36c)][_0x40f93f(0x2af)]);
                }
                [_0x4067e7(0x566)](_0x2ca4ab, _0x29867c, _0x2b1ed3) {
                  const _0x4bc249 = _0x4067e7;
                  var _0x3ef690, _0x475414;
                  try {
                    const _0xb1fc91 = Date["now"](),
                      _0x194483 = this["convertImageDataToDataURL"](_0x2ca4ab),
                      _0xe3ee1a = Date[_0x4bc249(0x3f5)]() - _0xb1fc91;
                    return (
                      _0x1068d8["Z"][_0x4bc249(0x344)][_0x4bc249(0x3c2)](
                        null ===
                          (_0x475414 =
                            null ===
                              (_0x3ef690 =
                                null === _0x409f64["Z"] || void 0x0 === _0x409f64["Z"] ? void 0x0 : _0x409f64["Z"]["currentAction"]) ||
                            void 0x0 === _0x3ef690
                              ? void 0x0
                              : _0x3ef690[_0x4bc249(0x403)]) || void 0x0 === _0x475414
                          ? void 0x0
                          : _0x475414["qualityPercent"]
                      ),
                      _0x1068d8["Z"][_0x4bc249(0x304)]["log"](_0xe3ee1a),
                      _0x4bc249(0x548) === _0x409f64["Z"][_0x4bc249(0x637)][_0x4bc249(0x452)][_0x4bc249(0x400)] &&
                        _0x1068d8["Z"]["VIDEO_RECORDING_DATA"][_0x4bc249(0x3c2)](_0x527ec2["getSessionRecorderMibiData"]()),
                      _0x2b1ed3["setSessionInfoTotalDuration"](Date[_0x4bc249(0x3f5)]() - _0x409f64["Z"]["currentActionStartTime"]),
                      _0x29867c[_0x4bc249(0x5c6)](_0x2b1ed3),
                      _0x29867c[_0x4bc249(0x24f)](_0x194483)
                    );
                  } catch (_0x5a4ba9) {
                    throw new _0x3b1c1e["Z"](_0x4bc249(0x4a8), _0x5a4ba9, _0x4bc249(0x6b4));
                  }
                }
                [_0x4067e7(0x590)](_0x2f06d8, _0x5edb98) {
                  return _0x368a06(this, void 0x0, void 0x0, function* () {
                    const _0xac1f76 = a0_0x1b49;
                    let _0x3ca514, _0x281d1e;
                    try {
                      const _0x1f889c = Date["now"]();
                      (_0x3ca514 = yield this[_0xac1f76(0x627)](_0x2f06d8)), (_0x281d1e = Date[_0xac1f76(0x3f5)]() - _0x1f889c);
                    } catch (_0x13ffe3) {
                      throw new _0x3b1c1e["Z"](_0xac1f76(0x6cc), new Error());
                    }
                    try {
                      return (
                        _0x1068d8["Z"][_0xac1f76(0x304)]["log"](_0x281d1e),
                        _0xac1f76(0x548) === _0x409f64["Z"][_0xac1f76(0x637)][_0xac1f76(0x452)][_0xac1f76(0x400)] &&
                          _0x1068d8["Z"][_0xac1f76(0x2e7)][_0xac1f76(0x3c2)](_0x527ec2[_0xac1f76(0x250)]()),
                        _0x5edb98[_0xac1f76(0x1f5)](Date[_0xac1f76(0x3f5)]() - _0x409f64["Z"][_0xac1f76(0x396)]),
                        _0x3ca514
                      );
                    } catch (_0x2ed7ba) {
                      return _0x3ca514;
                    }
                  });
                }
                [_0x4067e7(0x4ba)](_0x405e8f, _0x155826) {
                  const _0x10c142 = _0x4067e7;
                  try {
                    if (
                      (_0x155826 || (_0x155826 = { width: _0x405e8f["width"], height: _0x405e8f["height"] }),
                      !(_0x405e8f instanceof ImageData || _0x405e8f instanceof HTMLImageElement || _0x405e8f instanceof HTMLCanvasElement))
                    )
                      throw new _0x3b1c1e["Z"](_0x10c142(0x376), new Error(), "IU.RCWNI");
                    let _0x3d92cc;
                    _0x3d92cc = _0x405e8f instanceof HTMLCanvasElement ? _0x405e8f : _0x3ff507;
                    const _0x3fd2b6 = _0x3d92cc[_0x10c142(0x5c4)]("2d", { willReadFrequently: !0x0 });
                    return (
                      (_0x3d92cc[_0x10c142(0x657)] = _0x405e8f[_0x10c142(0x657)]),
                      (_0x3d92cc[_0x10c142(0x39c)] = _0x405e8f["height"]),
                      _0x405e8f instanceof ImageData
                        ? (null == _0x3fd2b6 ||
                            _0x3fd2b6[_0x10c142(0x1c9)](0x0, 0x0, _0x155826[_0x10c142(0x657)], _0x155826[_0x10c142(0x39c)]),
                          null == _0x3fd2b6 || _0x3fd2b6[_0x10c142(0x632)](_0x405e8f, 0x0, 0x0),
                          null == _0x3fd2b6 ||
                            _0x3fd2b6[_0x10c142(0x65a)](
                              _0x3d92cc,
                              0x0,
                              0x0,
                              _0x405e8f[_0x10c142(0x657)],
                              _0x405e8f["height"],
                              0x0,
                              0x0,
                              _0x155826[_0x10c142(0x657)],
                              _0x155826[_0x10c142(0x39c)]
                            ))
                        : (null == _0x3fd2b6 || _0x3fd2b6[_0x10c142(0x1c9)](0x0, 0x0, _0x155826["width"], _0x155826[_0x10c142(0x39c)]),
                          null == _0x3fd2b6 ||
                            _0x3fd2b6["drawImage"](_0x405e8f, 0x0, 0x0, _0x155826[_0x10c142(0x657)], _0x155826[_0x10c142(0x39c)])),
                      _0x3d92cc
                    );
                  } catch (_0x2b3b5c) {
                    throw new _0x3b1c1e["Z"](_0x10c142(0x376), _0x2b3b5c, _0x10c142(0x3af));
                  }
                }
                [_0x4067e7(0x537)](_0x21856c) {
                  const _0x3442b7 = _0x4067e7;
                  return new Promise((_0x21a975, _0xd52ecb) => {
                    const _0x5207eb = a0_0x1b49;
                    let _0x381de5 = this[_0x5207eb(0x230)](_0x21856c);
                    if (!_0x381de5) throw new _0x3b1c1e["Z"]("RUNTIME_INVALID_DIRECT_IMAGE_DATA_FORMAT", new Error(), _0x5207eb(0x281));
                    const _0x3096dd = new Image();
                    (_0x3096dd[_0x5207eb(0x4be)] = (_0x4080c) => {
                      const _0x4b8c01 = _0x5207eb;
                      _0xd52ecb(_0x4b8c01(0x673));
                    }),
                      (_0x3096dd[_0x5207eb(0x507)] = () => {
                        const _0x2240a2 = _0x5207eb;
                        URL[_0x2240a2(0x2d5)](_0x21856c), _0x21a975(_0x3096dd);
                      }),
                      (_0x3096dd[_0x5207eb(0x27c)] = _0x381de5);
                  })["catch"]((_0x2870d9) => Promise[_0x3442b7(0x34e)](_0x2870d9));
                }
                [_0x4067e7(0x230)](_0x45a696) {
                  const _0x1612a0 = _0x4067e7,
                    _0x259183 =
                      /^(data:image\/[a-zA-Z+.-]+;base64,([a-zA-Z0-9+/=]+))|(blob:https?:\/\/[a-zA-Z0-9-_.~:/?#[\]@!$&'()*+,;=]+)/;
                  try {
                    if (_0x259183[_0x1612a0(0x3b4)](_0x45a696)) return _0x45a696;
                    throw new _0x3b1c1e["Z"](_0x1612a0(0x1f3), new Error(), _0x1612a0(0x631));
                  } catch (_0x5f5678) {
                    throw new _0x3b1c1e["Z"](_0x1612a0(0x1f3), _0x5f5678, _0x1612a0(0x704));
                  }
                }
                ["createElementFromImageURL"](_0x1db0c2) {
                  const _0x26fa34 = _0x4067e7;
                  return this[_0x26fa34(0x537)](_0x1db0c2);
                }
                [_0x4067e7(0x239)](_0x1df35a) {
                  const _0x5ab908 = _0x4067e7;
                  _0x13336a["Z"][_0x5ab908(0x6f6)](_0x1df35a) || Promise[_0x5ab908(0x34e)](_0x5ab908(0x3c3));
                  const _0x2258f6 = URL["createObjectURL"](_0x1df35a);
                  return this["createElementFromDataURL"](_0x2258f6);
                }
                [_0x4067e7(0x2fe)](_0x2c0207) {
                  const _0x395016 = _0x4067e7;
                  var _0x183028, _0x9abc2c;
                  const _0x5e7fe4 =
                    0.01 *
                    (null ===
                      (_0x9abc2c =
                        null === (_0x183028 = _0x409f64["Z"][_0x395016(0x637)]) || void 0x0 === _0x183028
                          ? void 0x0
                          : _0x183028["commandOptions"]) || void 0x0 === _0x9abc2c
                      ? void 0x0
                      : _0x9abc2c[_0x395016(0x401)]);
                  return this[_0x395016(0x4ba)](_0x2c0207)[_0x395016(0x41a)]("image/jpeg", _0x5e7fe4);
                }
                [_0x4067e7(0x627)](_0x12e675) {
                  const _0x57dff7 = _0x4067e7;
                  return new Promise((_0x72f067, _0x56bbf4) => {
                    const _0x5a9bee = a0_0x1b49,
                      _0x3fd2e = new FileReader();
                    (_0x3fd2e[_0x5a9bee(0x4be)] = (_0x55074f) => {
                      const _0x57606a = _0x5a9bee;
                      _0x56bbf4(_0x57606a(0x5e8));
                    }),
                      (_0x3fd2e[_0x5a9bee(0x3fb)] = () => {
                        const _0x2262b5 = _0x5a9bee;
                        _0x72f067("" + _0x3fd2e[_0x2262b5(0x28b)]);
                      }),
                      _0x3fd2e[_0x5a9bee(0x2a4)](_0x12e675);
                  })[_0x57dff7(0x38b)]((_0x24df8b) => Promise[_0x57dff7(0x34e)](_0x24df8b));
                }
                [_0x4067e7(0x43c)](_0x15028c) {
                  const _0x5699da = _0x4067e7;
                  var _0x433557;
                  const _0x35a4e9 =
                    null === (_0x433557 = this[_0x5699da(0x4ba)](_0x15028c)[_0x5699da(0x5c4)]("2d", { willReadFrequently: !0x0 })) ||
                    void 0x0 === _0x433557
                      ? void 0x0
                      : _0x433557[_0x5699da(0x231)](0x0, 0x0, _0x15028c[_0x5699da(0x657)], _0x15028c[_0x5699da(0x39c)]);
                  if (!_0x35a4e9) throw new _0x3b1c1e["Z"](_0x5699da(0x376), new Error());
                  return _0x35a4e9;
                }
                [_0x4067e7(0x227)](_0x23e879) {
                  const _0x4958ac = _0x4067e7;
                  return this[_0x4958ac(0x239)](_0x23e879)
                    ["then"]((_0x31cfc3) => this[_0x4958ac(0x43c)](_0x31cfc3))
                    ["catch"]((_0x3831d4) => Promise["reject"](_0x3831d4));
                }
                [_0x4067e7(0x2cf)](_0x122718) {
                  const _0xc6e37a = _0x4067e7;
                  return this["createElementFromImageURL"](_0x122718)
                    ["then"]((_0x1218ca) => this["convertElementToImageData"](_0x1218ca))
                    [_0xc6e37a(0x38b)]((_0x29cd8b) => Promise[_0xc6e37a(0x34e)](_0x29cd8b));
                }
                [_0x4067e7(0x3da)](_0xe1538a) {
                  const _0x46cb7d = _0x4067e7;
                  return this["createElementFromFile"](_0xe1538a)
                    [_0x46cb7d(0x429)]((_0x5a9426) => this[_0x46cb7d(0x4ba)](_0x5a9426))
                    [_0x46cb7d(0x38b)]((_0x148a5e) => Promise[_0x46cb7d(0x34e)](_0x148a5e));
                }
                [_0x4067e7(0x203)](_0x3e8ad3) {
                  const _0x596d2d = _0x4067e7;
                  return { width: _0x3e8ad3[_0x596d2d(0x657)], height: _0x3e8ad3["height"] };
                }
                [_0x4067e7(0x64f)](_0x25acff, _0x5b869f, _0xe3606c) {
                  const _0x3bf191 = _0x4067e7,
                    _0x569160 = { width: _0x25acff, height: _0x5b869f },
                    _0x1cd615 = Math[_0x3bf191(0x47c)](_0x25acff, _0x5b869f),
                    _0x5b875d = Math[_0x3bf191(0x61b)](_0x25acff, _0x5b869f);
                  if (
                    (_0xe3606c < this[_0x3bf191(0x3ea)] && (_0xe3606c = this[_0x3bf191(0x67d)]),
                    _0x1cd615 <= _0xe3606c &&
                      _0x5b875d <= _0xe3606c &&
                      _0x1cd615 >= this[_0x3bf191(0x3ea)] &&
                      _0x5b875d >= this["MIN_SIDE_LENGTH"])
                  )
                    return _0x569160;
                  const _0x382ca2 = _0x25acff > _0x5b869f ? "width" : _0x3bf191(0x39c),
                    _0x162368 = _0x3bf191(0x657) === _0x382ca2 ? _0x3bf191(0x39c) : "width";
                  return (
                    (_0x569160[_0x382ca2] = _0xe3606c),
                    (_0x569160[_0x162368] = Math[_0x3bf191(0x6a1)](_0xe3606c * (_0x5b875d / _0x1cd615))),
                    _0x569160[_0x162368] < this[_0x3bf191(0x3ea)] &&
                      ((_0x569160[_0x162368] = this["MIN_SIDE_LENGTH"]),
                      (_0x569160[_0x382ca2] = Math[_0x3bf191(0x6a1)](this[_0x3bf191(0x3ea)] * (_0x1cd615 / _0x5b875d)))),
                    _0x569160
                  );
                }
                [_0x4067e7(0x68e)](_0x579ad0, _0x4c5c00 = this[_0x4067e7(0x67d)]) {
                  const _0xc336ff = _0x4067e7;
                  var _0x14f154;
                  const _0x2f92b2 = this[_0xc336ff(0x64f)](_0x579ad0[_0xc336ff(0x657)], _0x579ad0[_0xc336ff(0x39c)], _0x4c5c00),
                    _0x1360a2 =
                      null ===
                        (_0x14f154 = this[_0xc336ff(0x4ba)](_0x579ad0, _0x2f92b2)[_0xc336ff(0x5c4)]("2d", { willReadFrequently: !0x0 })) ||
                      void 0x0 === _0x14f154
                        ? void 0x0
                        : _0x14f154[_0xc336ff(0x231)](0x0, 0x0, _0x2f92b2[_0xc336ff(0x657)], _0x2f92b2[_0xc336ff(0x39c)]);
                  if (!_0x1360a2) throw new _0x3b1c1e["Z"](_0xc336ff(0x641), new Error());
                  return _0x1360a2;
                }
                ["normalizeCanvasAspectRatio"](_0x14e758, _0x1f1973 = this[_0x4067e7(0x67d)]) {
                  const _0x4112f6 = _0x4067e7,
                    _0x1216b6 = this[_0x4112f6(0x64f)](_0x14e758[_0x4112f6(0x657)], _0x14e758[_0x4112f6(0x39c)], _0x1f1973);
                  return this[_0x4112f6(0x4ba)](_0x14e758, _0x1216b6);
                }
                [_0x4067e7(0x513)](_0x2c5c63, _0x40c011) {
                  const _0x4df846 = _0x4067e7,
                    _0x594bd5 = document[_0x4df846(0x506)](_0x4df846(0x5ca))[_0x4df846(0x5c4)]("2d", { willReadFrequently: !0x0 });
                  return (
                    (_0x594bd5[_0x4df846(0x3bc)] = "white"),
                    (_0x594bd5["font"] = _0x4df846(0x68a)),
                    _0x594bd5[_0x4df846(0x257)](_0x4df846(0x5ba), 0xa, 0x32),
                    (_0x594bd5[_0x4df846(0x222)] = _0x4df846(0x43a)),
                    _0x594bd5[_0x4df846(0x257)](_0x2c5c63, 0xa, 0x46),
                    _0x594bd5["getImageData"](0x0, 0x0, _0x40c011["width"], _0x40c011["height"])
                  );
                }
              })(),
              _0x4a37ec = {},
              _0x536635 = {},
              _0x3e064d = class {
                constructor() {
                  const _0x44bf6e = _0x4067e7;
                  (this[_0x44bf6e(0x485)] = Object[_0x44bf6e(0x620)](
                    Object[_0x44bf6e(0x620)]({}, _0x409f64["Z"][_0x44bf6e(0x637)][_0x44bf6e(0x274)][_0x44bf6e(0x485)]),
                    _0x4a37ec
                  )),
                    (this["SessionInfo"] = Object["assign"](
                      Object[_0x44bf6e(0x620)]({}, _0x409f64["Z"][_0x44bf6e(0x637)]["mibiData"][_0x44bf6e(0x33d)]),
                      _0x536635
                    ));
                }
              };
            var _0x3aeeb1 = _0x33dbda(0x117),
              _0x34fe32 = function (_0x510449, _0x3a69ec, _0x118eec, _0x54f1e5) {
                return new (_0x118eec || (_0x118eec = Promise))(function (_0x1f80b2, _0x2949e2) {
                  const _0x3b4724 = a0_0x1b49;
                  function _0x3d75d7(_0x3667d0) {
                    const _0x855d4a = a0_0x1b49;
                    try {
                      _0x349197(_0x54f1e5[_0x855d4a(0x3e1)](_0x3667d0));
                    } catch (_0x43f44c) {
                      _0x2949e2(_0x43f44c);
                    }
                  }
                  function _0x348bfd(_0x5afa07) {
                    const _0x59c6ac = a0_0x1b49;
                    try {
                      _0x349197(_0x54f1e5[_0x59c6ac(0x3b2)](_0x5afa07));
                    } catch (_0x45af6a) {
                      _0x2949e2(_0x45af6a);
                    }
                  }
                  function _0x349197(_0x476207) {
                    const _0x4d10cf = a0_0x1b49;
                    var _0x3e874a;
                    _0x476207["done"]
                      ? _0x1f80b2(_0x476207[_0x4d10cf(0x331)])
                      : ((_0x3e874a = _0x476207[_0x4d10cf(0x331)]),
                        _0x3e874a instanceof _0x118eec
                          ? _0x3e874a
                          : new _0x118eec(function (_0x2d3121) {
                              _0x2d3121(_0x3e874a);
                            }))[_0x4d10cf(0x429)](_0x3d75d7, _0x348bfd);
                  }
                  _0x349197((_0x54f1e5 = _0x54f1e5["apply"](_0x510449, _0x3a69ec || []))[_0x3b4724(0x3e1)]());
                });
              };
            new _0x3da364("app:integratorResponses");
            class _0x3fba5e {
              constructor(_0x1e1f8c, _0x4d13d2, _0xb7dd9, _0x2a3df3, _0x4a025b) {
                const _0x3a0ecd = _0x4067e7;
                switch (
                  ((this["status"] = "success"),
                  (this[_0x3a0ecd(0x53c)] = _0x1e1f8c[_0x3a0ecd(0x400)]),
                  (this[_0x3a0ecd(0x46c)] = _0x1e1f8c[_0x3a0ecd(0x245)]),
                  (this[_0x3a0ecd(0x274)] = _0x2a3df3),
                  (this[_0x3a0ecd(0x49e)] = new _0x3e064d()),
                  (this[_0x3a0ecd(0x1e3)] = _0x3aeeb1["Z"][_0x3a0ecd(0x463)](
                    _0x409f64["Z"][_0x3a0ecd(0x637)]["RTSTrackSignals"],
                    _0x3aeeb1["Z"][_0x3a0ecd(0x23c)]()
                  )),
                  _0x4a025b && (this[_0x3a0ecd(0x305)] = _0x4a025b),
                  _0x1e1f8c["actionType"])
                ) {
                  case "DL_BACK":
                  case _0x3a0ecd(0x381):
                  case _0x3a0ecd(0x717):
                  case "DOCUMENT":
                  case _0x3a0ecd(0x68c):
                    this[_0x3a0ecd(0x5c1)](_0x4d13d2);
                    break;
                  case _0x3a0ecd(0x478):
                    this[_0x3a0ecd(0x5c1)](_0x4d13d2), this[_0x3a0ecd(0x40b)](_0x4d13d2);
                    break;
                  case _0x3a0ecd(0x2d4):
                  case _0x3a0ecd(0x533):
                    this["setManateeWorksBarcodeAdditionalValues"](_0x4d13d2);
                    break;
                  case _0x3a0ecd(0x332):
                  case _0x3a0ecd(0x268):
                    this[_0x3a0ecd(0x5bf)]();
                }
                this[_0x3a0ecd(0x639)](_0x1e1f8c[_0x3a0ecd(0x245)], null == _0x4d13d2 ? void 0x0 : _0x4d13d2[_0x3a0ecd(0x4d4)]);
              }
              [_0x4067e7(0x5bf)]() {
                return _0x34fe32(this, void 0x0, void 0x0, function* () {
                  const _0x1b410f = a0_0x1b49;
                  _0x409f64["Z"][_0x1b410f(0x370)] && (this["deviceIdSignal"] = _0x409f64["Z"][_0x1b410f(0x370)]);
                });
              }
              [_0x4067e7(0x369)](_0x191c94) {
                const _0x565c81 = _0x4067e7;
                var _0x3df7e5;
                let _0x151142 =
                  null === (_0x3df7e5 = _0x191c94["recognizedData"]) || void 0x0 === _0x3df7e5 ? void 0x0 : _0x3df7e5[_0x565c81(0x572)];
                _0x191c94[_0x565c81(0x6f3)] &&
                  (null == _0x151142 ? void 0x0 : _0x151142[_0x565c81(0x4d0)]) &&
                  ((this["fourCornerA"] = _0x151142[_0x565c81(0x346)]["p1"]),
                  (this[_0x565c81(0x6a0)] = _0x151142[_0x565c81(0x346)]["p2"]),
                  (this[_0x565c81(0x4c5)] = _0x151142[_0x565c81(0x346)]["p3"]),
                  (this[_0x565c81(0x1ff)] = _0x151142["locationPoints"]["p4"]),
                  (this["locationPoints"] = _0x151142[_0x565c81(0x346)]),
                  (this[_0x565c81(0x1f7)] = _0x151142[_0x565c81(0x1f7)]),
                  (this[_0x565c81(0x4d0)] = _0x151142[_0x565c81(0x4d0)]),
                  (this[_0x565c81(0x6a4)] = _0x151142["bytes"]),
                  (this[_0x565c81(0x613)] = _0x151142[_0x565c81(0x613)]),
                  (this[_0x565c81(0x64c)] = _0x151142[_0x565c81(0x64c)]));
              }
              [_0x4067e7(0x5c1)](_0x37d264) {
                const _0x19c83b = _0x4067e7;
                var _0x257c98;
                let _0x2b956f =
                  null === (_0x257c98 = _0x37d264[_0x19c83b(0x4d4)]) || void 0x0 === _0x257c98 ? void 0x0 : _0x257c98[_0x19c83b(0x572)];
                _0x2b956f &&
                  ((this[_0x19c83b(0x60d)] = { x: _0x2b956f["ax"], y: _0x2b956f["ay"] }),
                  (this[_0x19c83b(0x6a0)] = { x: _0x2b956f["bx"], y: _0x2b956f["by"] }),
                  (this["fourCornerC"] = { x: _0x2b956f["cx"], y: _0x2b956f["cy"] }),
                  (this["fourCornerD"] = { x: _0x2b956f["dx"], y: _0x2b956f["dy"] }),
                  (this["glareTop"] = _0x2b956f[_0x19c83b(0x1e5)]),
                  (this["glareBottom"] = _0x2b956f[_0x19c83b(0x2ee)]),
                  (this[_0x19c83b(0x1b6)] = _0x2b956f[_0x19c83b(0x1b6)]),
                  (this[_0x19c83b(0x20c)] = _0x2b956f[_0x19c83b(0x20c)]));
              }
              ["setCoreVisionPassportAdditionalValues"](_0x1787fd) {
                const _0x355bcf = _0x4067e7;
                var _0x87cd4a;
                let _0x34858f =
                  null === (_0x87cd4a = _0x1787fd[_0x355bcf(0x4d4)]) || void 0x0 === _0x87cd4a ? void 0x0 : _0x87cd4a[_0x355bcf(0x572)];
                _0x1787fd[_0x355bcf(0x6f3)] && _0x34858f && (this[_0x355bcf(0x6dc)] = new _0x324fc4(_0x34858f[_0x355bcf(0x6dc)]));
              }
              [_0x4067e7(0x697)]({
                ax: _0x22086a,
                ay: _0x28380c,
                bx: _0x5b14a9,
                by: _0x4a9cde,
                cx: _0x4b8dc8,
                cy: _0x5c01ff,
                dx: _0x2d1faa,
                dy: _0xa70b6b,
              }) {
                const _0x4b23f1 = _0x4067e7;
                return {
                  width: Math["max"](_0x22086a, _0x5b14a9, _0x4b8dc8, _0x2d1faa) - Math["min"](_0x22086a, _0x5b14a9, _0x4b8dc8, _0x2d1faa),
                  height:
                    Math[_0x4b23f1(0x47c)](_0x28380c, _0x4a9cde, _0x5c01ff, _0xa70b6b) -
                    Math[_0x4b23f1(0x61b)](_0x28380c, _0x4a9cde, _0x5c01ff, _0xa70b6b),
                };
              }
              ["updateMibiSessionInfo"](_0x5bc27b, _0x2e7951) {
                const _0x13ea79 = _0x4067e7;
                var _0x3cc309,
                  _0x4e2334,
                  _0x537dc4,
                  _0x573c7f,
                  _0x37a646,
                  _0xdf04ad,
                  _0x3916b3,
                  _0xd31c3a,
                  _0x308d91,
                  _0x4c7aee,
                  _0x85889a,
                  _0xf43dc4,
                  _0x4f1bce,
                  _0xafd2dd,
                  _0x19372f,
                  _0x187e6a,
                  _0x4ed337,
                  _0x6380e,
                  _0x3be564,
                  _0x5987e9,
                  _0x31cc20,
                  _0x34a71f,
                  _0x48b2cf,
                  _0x289fef,
                  _0x2e05fc,
                  _0x388217,
                  _0x2a5b56,
                  _0x1646a1,
                  _0x421011,
                  _0x84a350,
                  _0x4c808e,
                  _0x23a10d,
                  _0x42f410,
                  _0x176b7e,
                  _0x2ffc8f,
                  _0x540b7a,
                  _0x922b8d,
                  _0x15b108,
                  _0x898140,
                  _0x19ebd8,
                  _0x4d743c,
                  _0x56eeed,
                  _0x473fed,
                  _0x200108,
                  _0x550fcc,
                  _0x4fd8d5,
                  _0x1de8b3,
                  _0xd3cd5d,
                  _0x2e89f0,
                  _0x2562b9,
                  _0x30c159;
                const _0x18ea78 = null == _0x2e7951 ? void 0x0 : _0x2e7951["imageDimensions"];
                let _0x373314, _0x125d82;
                switch (_0x5bc27b) {
                  case _0x13ea79(0x68c):
                  case _0x13ea79(0x717):
                  case _0x13ea79(0x381):
                  case "DOCUMENT":
                  case _0x13ea79(0x478):
                    if (
                      ((_0x373314 =
                        (null === (_0x3cc309 = null == _0x2e7951 ? void 0x0 : _0x2e7951[_0x13ea79(0x572)]) || void 0x0 === _0x3cc309
                          ? void 0x0
                          : _0x3cc309[_0x13ea79(0x5a9)]("ax")) &&
                        (null === (_0x4e2334 = null == _0x2e7951 ? void 0x0 : _0x2e7951[_0x13ea79(0x572)]) || void 0x0 === _0x4e2334
                          ? void 0x0
                          : _0x4e2334["hasOwnProperty"]("bx")) &&
                        (null === (_0x537dc4 = null == _0x2e7951 ? void 0x0 : _0x2e7951[_0x13ea79(0x572)]) || void 0x0 === _0x537dc4
                          ? void 0x0
                          : _0x537dc4[_0x13ea79(0x5a9)]("cx")) &&
                        (null === (_0x573c7f = null == _0x2e7951 ? void 0x0 : _0x2e7951[_0x13ea79(0x572)]) || void 0x0 === _0x573c7f
                          ? void 0x0
                          : _0x573c7f[_0x13ea79(0x5a9)]("dx"))),
                      (_0x125d82 =
                        (null == _0x18ea78 ? void 0x0 : _0x18ea78[_0x13ea79(0x5a9)](_0x13ea79(0x657))) &&
                        (null == _0x18ea78 ? void 0x0 : _0x18ea78["hasOwnProperty"](_0x13ea79(0x39c)))),
                      _0x125d82 && _0x373314)
                    ) {
                      const _0x27c2c6 = _0x18ea78[_0x13ea79(0x39c)] > _0x18ea78[_0x13ea79(0x657)] ? "Portrait" : _0x13ea79(0x373),
                        _0xb035a3 = [
                          [
                            null === (_0x37a646 = null == _0x2e7951 ? void 0x0 : _0x2e7951[_0x13ea79(0x572)]) || void 0x0 === _0x37a646
                              ? void 0x0
                              : _0x37a646["ax"],
                            null === (_0xdf04ad = null == _0x2e7951 ? void 0x0 : _0x2e7951[_0x13ea79(0x572)]) || void 0x0 === _0xdf04ad
                              ? void 0x0
                              : _0xdf04ad["ay"],
                          ],
                          [
                            null === (_0x3916b3 = null == _0x2e7951 ? void 0x0 : _0x2e7951[_0x13ea79(0x572)]) || void 0x0 === _0x3916b3
                              ? void 0x0
                              : _0x3916b3["bx"],
                            null === (_0xd31c3a = null == _0x2e7951 ? void 0x0 : _0x2e7951[_0x13ea79(0x572)]) || void 0x0 === _0xd31c3a
                              ? void 0x0
                              : _0xd31c3a["by"],
                          ],
                          [
                            null === (_0x308d91 = null == _0x2e7951 ? void 0x0 : _0x2e7951["rawData"]) || void 0x0 === _0x308d91
                              ? void 0x0
                              : _0x308d91["cx"],
                            null === (_0x4c7aee = null == _0x2e7951 ? void 0x0 : _0x2e7951[_0x13ea79(0x572)]) || void 0x0 === _0x4c7aee
                              ? void 0x0
                              : _0x4c7aee["cy"],
                          ],
                          [
                            null === (_0x85889a = null == _0x2e7951 ? void 0x0 : _0x2e7951["rawData"]) || void 0x0 === _0x85889a
                              ? void 0x0
                              : _0x85889a["dx"],
                            null === (_0xf43dc4 = null == _0x2e7951 ? void 0x0 : _0x2e7951[_0x13ea79(0x572)]) || void 0x0 === _0xf43dc4
                              ? void 0x0
                              : _0xf43dc4["dy"],
                          ],
                        ],
                        _0x6ca07e = {
                          ax:
                            null === (_0x4f1bce = null == _0x2e7951 ? void 0x0 : _0x2e7951["rawData"]) || void 0x0 === _0x4f1bce
                              ? void 0x0
                              : _0x4f1bce["ax"],
                          ay:
                            null === (_0xafd2dd = null == _0x2e7951 ? void 0x0 : _0x2e7951[_0x13ea79(0x572)]) || void 0x0 === _0xafd2dd
                              ? void 0x0
                              : _0xafd2dd["ay"],
                          bx:
                            null === (_0x19372f = null == _0x2e7951 ? void 0x0 : _0x2e7951[_0x13ea79(0x572)]) || void 0x0 === _0x19372f
                              ? void 0x0
                              : _0x19372f["bx"],
                          by:
                            null === (_0x187e6a = null == _0x2e7951 ? void 0x0 : _0x2e7951[_0x13ea79(0x572)]) || void 0x0 === _0x187e6a
                              ? void 0x0
                              : _0x187e6a["by"],
                          cx:
                            null === (_0x4ed337 = null == _0x2e7951 ? void 0x0 : _0x2e7951[_0x13ea79(0x572)]) || void 0x0 === _0x4ed337
                              ? void 0x0
                              : _0x4ed337["cx"],
                          cy:
                            null === (_0x6380e = null == _0x2e7951 ? void 0x0 : _0x2e7951["rawData"]) || void 0x0 === _0x6380e
                              ? void 0x0
                              : _0x6380e["cy"],
                          dx:
                            null === (_0x3be564 = null == _0x2e7951 ? void 0x0 : _0x2e7951["rawData"]) || void 0x0 === _0x3be564
                              ? void 0x0
                              : _0x3be564["dx"],
                          dy:
                            null === (_0x5987e9 = null == _0x2e7951 ? void 0x0 : _0x2e7951["rawData"]) || void 0x0 === _0x5987e9
                              ? void 0x0
                              : _0x5987e9["dy"],
                        },
                        _0x296f65 = this[_0x13ea79(0x697)](_0x6ca07e),
                        _0x219518 = _0x296f65[_0x13ea79(0x39c)] > _0x296f65[_0x13ea79(0x657)] ? "Portrait" : "Landscape";
                      this[_0x13ea79(0x274)]["setSessionInfoDeviceOrientation"](_0x27c2c6),
                        this[_0x13ea79(0x274)][_0x13ea79(0x6c9)](_0x219518),
                        this[_0x13ea79(0x274)][_0x13ea79(0x460)](_0xb035a3);
                    }
                    break;
                  case _0x13ea79(0x2d4):
                  case "QR_BARCODE":
                  case _0x13ea79(0x692):
                    if (
                      ((_0x373314 =
                        (null === (_0x31cc20 = null == _0x2e7951 ? void 0x0 : _0x2e7951[_0x13ea79(0x572)]) || void 0x0 === _0x31cc20
                          ? void 0x0
                          : _0x31cc20[_0x13ea79(0x5a9)](_0x13ea79(0x346))) &&
                        (null ===
                          (_0x48b2cf =
                            null === (_0x34a71f = null == _0x2e7951 ? void 0x0 : _0x2e7951["rawData"]) || void 0x0 === _0x34a71f
                              ? void 0x0
                              : _0x34a71f[_0x13ea79(0x346)]) || void 0x0 === _0x48b2cf
                          ? void 0x0
                          : _0x48b2cf[_0x13ea79(0x5a9)]("p1")) &&
                        (null === (_0x289fef = _0x2e7951[_0x13ea79(0x572)]) || void 0x0 === _0x289fef
                          ? void 0x0
                          : _0x289fef["locationPoints"]["hasOwnProperty"]("p2")) &&
                        (null === (_0x2e05fc = _0x2e7951["rawData"]) || void 0x0 === _0x2e05fc
                          ? void 0x0
                          : _0x2e05fc[_0x13ea79(0x346)][_0x13ea79(0x5a9)]("p3")) &&
                        _0x2e7951["rawData"][_0x13ea79(0x346)]["hasOwnProperty"]("p4")),
                      (_0x125d82 =
                        (null == _0x18ea78 ? void 0x0 : _0x18ea78[_0x13ea79(0x5a9)]("width")) &&
                        (null == _0x18ea78 ? void 0x0 : _0x18ea78["hasOwnProperty"](_0x13ea79(0x39c)))),
                      _0x125d82 && _0x373314)
                    ) {
                      const _0x15c0c3 = _0x18ea78["height"] > _0x18ea78[_0x13ea79(0x657)] ? _0x13ea79(0x2b1) : _0x13ea79(0x373),
                        _0x5f618 = {
                          ax:
                            null ===
                              (_0x1646a1 =
                                null ===
                                  (_0x2a5b56 =
                                    null === (_0x388217 = null == _0x2e7951 ? void 0x0 : _0x2e7951["rawData"]) || void 0x0 === _0x388217
                                      ? void 0x0
                                      : _0x388217["locationPoints"]) || void 0x0 === _0x2a5b56
                                  ? void 0x0
                                  : _0x2a5b56["p1"]) || void 0x0 === _0x1646a1
                              ? void 0x0
                              : _0x1646a1["x"],
                          ay:
                            null ===
                              (_0x4c808e =
                                null ===
                                  (_0x84a350 =
                                    null === (_0x421011 = null == _0x2e7951 ? void 0x0 : _0x2e7951[_0x13ea79(0x572)]) ||
                                    void 0x0 === _0x421011
                                      ? void 0x0
                                      : _0x421011["locationPoints"]) || void 0x0 === _0x84a350
                                  ? void 0x0
                                  : _0x84a350["p1"]) || void 0x0 === _0x4c808e
                              ? void 0x0
                              : _0x4c808e["y"],
                          bx:
                            null ===
                              (_0x176b7e =
                                null ===
                                  (_0x42f410 =
                                    null === (_0x23a10d = null == _0x2e7951 ? void 0x0 : _0x2e7951[_0x13ea79(0x572)]) ||
                                    void 0x0 === _0x23a10d
                                      ? void 0x0
                                      : _0x23a10d[_0x13ea79(0x346)]) || void 0x0 === _0x42f410
                                  ? void 0x0
                                  : _0x42f410["p2"]) || void 0x0 === _0x176b7e
                              ? void 0x0
                              : _0x176b7e["x"],
                          by:
                            null ===
                              (_0x922b8d =
                                null ===
                                  (_0x540b7a =
                                    null === (_0x2ffc8f = null == _0x2e7951 ? void 0x0 : _0x2e7951[_0x13ea79(0x572)]) ||
                                    void 0x0 === _0x2ffc8f
                                      ? void 0x0
                                      : _0x2ffc8f[_0x13ea79(0x346)]) || void 0x0 === _0x540b7a
                                  ? void 0x0
                                  : _0x540b7a["p2"]) || void 0x0 === _0x922b8d
                              ? void 0x0
                              : _0x922b8d["y"],
                          cx:
                            null ===
                              (_0x19ebd8 =
                                null ===
                                  (_0x898140 =
                                    null === (_0x15b108 = null == _0x2e7951 ? void 0x0 : _0x2e7951[_0x13ea79(0x572)]) ||
                                    void 0x0 === _0x15b108
                                      ? void 0x0
                                      : _0x15b108[_0x13ea79(0x346)]) || void 0x0 === _0x898140
                                  ? void 0x0
                                  : _0x898140["p3"]) || void 0x0 === _0x19ebd8
                              ? void 0x0
                              : _0x19ebd8["x"],
                          cy:
                            null ===
                              (_0x473fed =
                                null ===
                                  (_0x56eeed =
                                    null === (_0x4d743c = null == _0x2e7951 ? void 0x0 : _0x2e7951[_0x13ea79(0x572)]) ||
                                    void 0x0 === _0x4d743c
                                      ? void 0x0
                                      : _0x4d743c[_0x13ea79(0x346)]) || void 0x0 === _0x56eeed
                                  ? void 0x0
                                  : _0x56eeed["p3"]) || void 0x0 === _0x473fed
                              ? void 0x0
                              : _0x473fed["y"],
                          dx:
                            null ===
                              (_0x4fd8d5 =
                                null ===
                                  (_0x550fcc =
                                    null === (_0x200108 = null == _0x2e7951 ? void 0x0 : _0x2e7951[_0x13ea79(0x572)]) ||
                                    void 0x0 === _0x200108
                                      ? void 0x0
                                      : _0x200108[_0x13ea79(0x346)]) || void 0x0 === _0x550fcc
                                  ? void 0x0
                                  : _0x550fcc["p4"]) || void 0x0 === _0x4fd8d5
                              ? void 0x0
                              : _0x4fd8d5["x"],
                          dy:
                            null ===
                              (_0x2e89f0 =
                                null ===
                                  (_0xd3cd5d =
                                    null === (_0x1de8b3 = null == _0x2e7951 ? void 0x0 : _0x2e7951["rawData"]) || void 0x0 === _0x1de8b3
                                      ? void 0x0
                                      : _0x1de8b3["locationPoints"]) || void 0x0 === _0xd3cd5d
                                  ? void 0x0
                                  : _0xd3cd5d["p4"]) || void 0x0 === _0x2e89f0
                              ? void 0x0
                              : _0x2e89f0["y"],
                        },
                        _0x1abcea = this[_0x13ea79(0x697)](_0x5f618),
                        _0x5ade5c =
                          "QR" ===
                          (null === (_0x2562b9 = null == _0x2e7951 ? void 0x0 : _0x2e7951[_0x13ea79(0x572)]) || void 0x0 === _0x2562b9
                            ? void 0x0
                            : _0x2562b9[_0x13ea79(0x1f7)])
                            ? _0x15c0c3
                            : _0x1abcea[_0x13ea79(0x39c)] > _0x1abcea[_0x13ea79(0x657)]
                            ? "Portrait"
                            : _0x13ea79(0x373);
                      this[_0x13ea79(0x274)]["setSessionInfoDeviceOrientation"](_0x15c0c3),
                        this[_0x13ea79(0x274)][_0x13ea79(0x6c9)](_0x5ade5c),
                        this[_0x13ea79(0x274)][_0x13ea79(0x2b6)](
                          null === (_0x30c159 = null == _0x2e7951 ? void 0x0 : _0x2e7951[_0x13ea79(0x572)]) || void 0x0 === _0x30c159
                            ? void 0x0
                            : _0x30c159[_0x13ea79(0x1f7)]
                        );
                    }
                    break;
                  case _0x13ea79(0x332):
                    if (
                      ((_0x125d82 =
                        (null == _0x18ea78 ? void 0x0 : _0x18ea78[_0x13ea79(0x5a9)](_0x13ea79(0x657))) &&
                        (null == _0x18ea78 ? void 0x0 : _0x18ea78[_0x13ea79(0x5a9)](_0x13ea79(0x39c)))),
                      _0x125d82)
                    ) {
                      const _0x337276 = _0x18ea78[_0x13ea79(0x39c)] > _0x18ea78[_0x13ea79(0x657)] ? _0x13ea79(0x2b1) : _0x13ea79(0x373);
                      this["mibiData"][_0x13ea79(0x405)](_0x337276);
                    }
                }
              }
              ["toggleDebuggingData"](_0x5429d7) {
                const _0x274b3e = _0x4067e7;
                var _0x2501be;
                (null === (_0x2501be = _0x5429d7[_0x274b3e(0x4d4)]) || void 0x0 === _0x2501be ? void 0x0 : _0x2501be[_0x274b3e(0x572)]) &&
                  (delete _0x5429d7[_0x274b3e(0x4d4)][_0x274b3e(0x572)][_0x274b3e(0x5a6)],
                  delete _0x5429d7["recognizedData"][_0x274b3e(0x572)][_0x274b3e(0x248)],
                  (this[_0x274b3e(0x643)] = _0x5429d7));
              }
            }
            class _0x2a36e9 extends _0x3fba5e {
              constructor(_0x52bd1b, _0x22647c, _0x352dbd, _0x1493f4, _0x29ddb4) {
                const _0x193203 = _0x4067e7;
                var _0x2097c5;
                super(_0x52bd1b, _0x352dbd, _0x1493f4, _0x29ddb4),
                  (this[_0x193203(0x6ef)] = _0x193203(0x1c1)),
                  (this[_0x193203(0x43f)] = {
                    status: _0x193203(0x1c1),
                    code: _0x352dbd[_0x193203(0x2b5)],
                    key: _0x352dbd[_0x193203(0x229)],
                  }),
                  (null === (_0x2097c5 = _0x352dbd[_0x193203(0x523)]) || void 0x0 === _0x2097c5 ? void 0x0 : _0x2097c5[_0x193203(0x4d0)]) &&
                    (this[_0x193203(0x6cd)] = _0x352dbd["outboundError"]),
                  this["mibiData"][_0x193203(0x694)]([this[_0x193203(0x43f)][_0x193203(0x713)]]),
                  _0x578818(_0x52bd1b[_0x193203(0x245)], _0x352dbd),
                  (this[_0x193203(0x1fc)] = _0x11c06d["generateFinalImageURLWithExifAndMibi"](
                    _0x22647c[_0x193203(0x248)],
                    _0x1493f4,
                    _0x29ddb4
                  ));
              }
            }
            class _0x5d5489 extends _0x3fba5e {
              constructor(_0x12b208, _0x1eaa2c, _0x58ffed, _0x4be9b2, _0x1a7d10, _0x337f85) {
                const _0x1d1657 = _0x4067e7;
                super(_0x12b208, _0x58ffed, _0x4be9b2, _0x1a7d10, _0x337f85),
                  (this["status"] = _0x1d1657(0x3bf)),
                  this[_0x1d1657(0x264)](_0x12b208[_0x1d1657(0x245)], _0x58ffed),
                  _0x2d4d58(_0x12b208[_0x1d1657(0x245)], this),
                  (this[_0x1d1657(0x248)] = _0x11c06d[_0x1d1657(0x566)](_0x1eaa2c[_0x1d1657(0x248)], _0x4be9b2, _0x1a7d10));
              }
              [_0x4067e7(0x264)](_0x167329, _0x27a5f3) {
                const _0x428ec1 = _0x4067e7;
                (this[_0x428ec1(0x43f)] = { status: _0x428ec1(0x3bf) }),
                  (_0x428ec1(0x2d4) !== _0x167329 && _0x428ec1(0x533) !== _0x167329) ||
                    ((this["warnings"][_0x428ec1(0x4d0)] = "MC"), (this["warnings"]["score"] = _0x27a5f3[_0x428ec1(0x3f0)]));
              }
            }
            class _0x47a6a7 extends _0x3fba5e {
              constructor(_0x9aa7c5, _0x56d0cf, _0x23c81e, _0x199474, _0x1e05c0, _0x497744) {
                const _0x591e2c = _0x4067e7;
                super(_0x9aa7c5, _0x23c81e, _0x199474, _0x1e05c0, _0x497744),
                  (this[_0x591e2c(0x6ef)] = _0x591e2c(0x3bf)),
                  _0x2d4d58(_0x9aa7c5[_0x591e2c(0x245)], this),
                  this[_0x591e2c(0x274)][_0x591e2c(0x1f5)](Date[_0x591e2c(0x3f5)]() - _0x409f64["Z"][_0x591e2c(0x396)]),
                  _0x2d4d58(_0x9aa7c5[_0x591e2c(0x245)], this),
                  (this[_0x591e2c(0x5e2)] = null == _0x56d0cf ? void 0x0 : _0x56d0cf[_0x591e2c(0x37f)]);
              }
            }
            class _0x11e705 extends _0x3fba5e {
              constructor(_0x406638, _0x35c740, _0x475305, _0x45cd3a, _0x31fd71) {
                const _0x18ca00 = _0x4067e7;
                var _0x3d26f3;
                super(_0x406638, _0x475305, _0x45cd3a, _0x31fd71),
                  (this[_0x18ca00(0x6ef)] = "failure"),
                  (this[_0x18ca00(0x43f)] = {
                    status: _0x18ca00(0x1c1),
                    code: _0x475305[_0x18ca00(0x2b5)],
                    key: _0x475305[_0x18ca00(0x229)],
                  }),
                  (null === (_0x3d26f3 = _0x475305[_0x18ca00(0x523)]) || void 0x0 === _0x3d26f3 ? void 0x0 : _0x3d26f3["code"]) &&
                    (this[_0x18ca00(0x6cd)] = _0x475305[_0x18ca00(0x523)]),
                  this[_0x18ca00(0x274)][_0x18ca00(0x694)]([this["warnings"][_0x18ca00(0x713)]]),
                  this[_0x18ca00(0x274)][_0x18ca00(0x1f5)](Date[_0x18ca00(0x3f5)]() - _0x409f64["Z"][_0x18ca00(0x396)]),
                  _0x578818(_0x406638[_0x18ca00(0x245)], _0x475305),
                  (this["failedAudio"] = null == _0x35c740 ? void 0x0 : _0x35c740[_0x18ca00(0x37f)]);
              }
            }
            function _0x2d4d58(_0x3af80f, _0x206ffb) {
              const _0x1fa727 = _0x4067e7;
              var _0x514fa1, _0x3b4bbe, _0xfbf053, _0x6b8cac, _0x44135d, _0x1bab00, _0x56d7b1, _0x1e62bf;
              try {
                const _0x25e02e = [_0x1fa727(0x68c), _0x1fa727(0x717), "CHECK_BACK", _0x1fa727(0x434), _0x1fa727(0x478)];
                _0x1fa727(0x268) === _0x3af80f
                  ? _0x1068d8["Z"][_0x1fa727(0x308)]["log"](_0x3af80f)
                  : [..._0x25e02e, _0x1fa727(0x332)]["includes"](_0x3af80f) &&
                    _0x1068d8["Z"][_0x1fa727(0x6f2)][_0x1fa727(0x3c2)](_0x3af80f),
                  _0x1068d8["Z"][_0x1fa727(0x70b)][_0x1fa727(0x3c2)](0x0),
                  _0x25e02e[_0x1fa727(0x20d)](_0x3af80f)
                    ? _0x1068d8["Z"][_0x1fa727(0x395)]["log"]([
                        [
                          null === (_0x514fa1 = _0x206ffb[_0x1fa727(0x60d)]) || void 0x0 === _0x514fa1 ? void 0x0 : _0x514fa1["x"],
                          null === (_0x3b4bbe = _0x206ffb[_0x1fa727(0x60d)]) || void 0x0 === _0x3b4bbe ? void 0x0 : _0x3b4bbe["y"],
                        ],
                        [
                          null === (_0xfbf053 = _0x206ffb[_0x1fa727(0x6a0)]) || void 0x0 === _0xfbf053 ? void 0x0 : _0xfbf053["x"],
                          null === (_0x6b8cac = _0x206ffb[_0x1fa727(0x6a0)]) || void 0x0 === _0x6b8cac ? void 0x0 : _0x6b8cac["y"],
                        ],
                        [
                          null === (_0x44135d = _0x206ffb[_0x1fa727(0x4c5)]) || void 0x0 === _0x44135d ? void 0x0 : _0x44135d["x"],
                          null === (_0x1bab00 = _0x206ffb["fourCornerC"]) || void 0x0 === _0x1bab00 ? void 0x0 : _0x1bab00["y"],
                        ],
                        [
                          null === (_0x56d7b1 = _0x206ffb["fourCornerD"]) || void 0x0 === _0x56d7b1 ? void 0x0 : _0x56d7b1["x"],
                          null === (_0x1e62bf = _0x206ffb[_0x1fa727(0x1ff)]) || void 0x0 === _0x1e62bf ? void 0x0 : _0x1e62bf["y"],
                        ],
                      ])
                    : [_0x1fa727(0x332)]["includes"](_0x3af80f) &&
                      _0x1068d8["Z"][_0x1fa727(0x5bd)]["log"](_0x409f64["Z"]["currentAction"][_0x1fa727(0x3b8)]["uxpFaceFailureCount"]);
              } catch (_0x399825) {}
            }
            function _0x578818(_0x3b911f, _0x5bdd8f) {
              const _0x3d18c4 = _0x4067e7;
              try {
                const _0x39b74f = [_0x3d18c4(0x2d4), _0x3d18c4(0x533)],
                  _0x59da3f = ["DL_FRONT", "CHECK_FRONT", _0x3d18c4(0x381), _0x3d18c4(0x434), _0x3d18c4(0x478)];
                "VOICE" === _0x3b911f
                  ? _0x1068d8["Z"][_0x3d18c4(0x308)][_0x3d18c4(0x3c2)](_0x3b911f)
                  : [..._0x59da3f, _0x3d18c4(0x332)]["includes"](_0x3b911f) &&
                    _0x1068d8["Z"][_0x3d18c4(0x6f2)][_0x3d18c4(0x3c2)](_0x3b911f),
                  _0x39b74f[_0x3d18c4(0x20d)](_0x3b911f)
                    ? _0x1068d8["Z"][_0x3d18c4(0x4c6)][_0x3d18c4(0x3c2)](0x0)
                    : _0x1068d8["Z"][_0x3d18c4(0x5e7)][_0x3d18c4(0x3c2)](0x0),
                  _0x1068d8["Z"][_0x3d18c4(0x573)]["log"](_0x5bdd8f[_0x3d18c4(0x2b5)]);
              } catch (_0x33702c) {}
            }
            const _0x3289d5 = class {
              constructor(_0x3aa70, _0x4b1f58, _0x16cc7f, _0x3da6e6, _0x4b38e9, _0x479c8c) {
                const _0x379093 = _0x4067e7;
                (this["request"] = _0x3aa70[_0x379093(0x245)]),
                  "VOICE" === _0x3aa70[_0x379093(0x245)]
                    ? _0x16cc7f[_0x379093(0x6f3)]
                      ? (this[_0x379093(0x6e5)] = new _0x47a6a7(_0x3aa70, _0x4b1f58, _0x16cc7f, _0x3da6e6, _0x4b38e9, _0x479c8c))
                      : (this[_0x379093(0x6e5)] = new _0x11e705(_0x3aa70, _0x4b1f58, _0x16cc7f, _0x3da6e6, _0x4b38e9))
                    : _0x16cc7f[_0x379093(0x6f3)]
                    ? (this[_0x379093(0x6e5)] = new _0x5d5489(_0x3aa70, _0x4b1f58, _0x16cc7f, _0x3da6e6, _0x4b38e9, _0x479c8c))
                    : (this[_0x379093(0x6e5)] = new _0x2a36e9(_0x3aa70, _0x4b1f58, _0x16cc7f, _0x3da6e6, _0x4b38e9));
              }
            };
            var _0x3c9edc = _0x33dbda(0x170),
              _0x406cbd = function (_0x5af0c6, _0x306e07, _0x12cde6, _0x43f42e) {
                return new (_0x12cde6 || (_0x12cde6 = Promise))(function (_0x48f92f, _0x871fce) {
                  const _0x4d3e60 = a0_0x1b49;
                  function _0x37d09e(_0x4f7726) {
                    const _0x7eca82 = a0_0x1b49;
                    try {
                      _0x47c7a5(_0x43f42e[_0x7eca82(0x3e1)](_0x4f7726));
                    } catch (_0x1d62bb) {
                      _0x871fce(_0x1d62bb);
                    }
                  }
                  function _0x58425c(_0xac8061) {
                    const _0x1ef91f = a0_0x1b49;
                    try {
                      _0x47c7a5(_0x43f42e[_0x1ef91f(0x3b2)](_0xac8061));
                    } catch (_0x13c2f6) {
                      _0x871fce(_0x13c2f6);
                    }
                  }
                  function _0x47c7a5(_0x3fbf9b) {
                    const _0x57352c = a0_0x1b49;
                    var _0x1fa547;
                    _0x3fbf9b[_0x57352c(0x4f5)]
                      ? _0x48f92f(_0x3fbf9b[_0x57352c(0x331)])
                      : ((_0x1fa547 = _0x3fbf9b[_0x57352c(0x331)]),
                        _0x1fa547 instanceof _0x12cde6
                          ? _0x1fa547
                          : new _0x12cde6(function (_0x3ad2d4) {
                              _0x3ad2d4(_0x1fa547);
                            }))["then"](_0x37d09e, _0x58425c);
                  }
                  _0x47c7a5((_0x43f42e = _0x43f42e["apply"](_0x5af0c6, _0x306e07 || []))[_0x4d3e60(0x3e1)]());
                });
              };
            new _0x3da364(_0x4067e7(0x60a));
            const _0x4dd2dc = { width: 0x500, height: 0x2d0 },
              _0x15d2e6 = { width: 0x780, height: 0x438 },
              _0x26660a = class {
                constructor(_0x564217) {
                  const _0x5183f5 = _0x4067e7;
                  this["videoSourceElement"],
                    this[_0x5183f5(0x430)],
                    this[_0x5183f5(0x57b)],
                    this[_0x5183f5(0x2db)],
                    this["canvas2dContext"],
                    (this[_0x5183f5(0x234)] = !0x1),
                    (this[_0x5183f5(0x25b)] = 0x0),
                    (this["throttleSpeed"] = 0xfa),
                    (this["imageGumExtractorGlobalMaxTimeAllowed"] = _0x409f64["Z"]["appConfig"]["thresholds"][_0x5183f5(0x36c)]["AMRTM"]),
                    this["startTime"],
                    this[_0x5183f5(0x1bf)],
                    (this[_0x5183f5(0x29d)] = !0x1),
                    (this[_0x5183f5(0x54e)] = this[_0x5183f5(0x555)](_0x409f64["Z"][_0x5183f5(0x637)][_0x5183f5(0x452)][_0x5183f5(0x245)])),
                    (this[_0x5183f5(0x56d)] = { onWindowResizeOrOrientationChange: null }),
                    (this[_0x5183f5(0x2f5)] =
                      _0x409f64["Z"]["appConfig"][_0x5183f5(0x3b1)][_0x5183f5(0x3e2)][
                        _0x409f64["Z"]["currentAction"][_0x5183f5(0x403)][_0x5183f5(0x3e2)]
                      ]),
                    (this[_0x5183f5(0x4cb)] =
                      _0x409f64["Z"][_0x5183f5(0x63a)][_0x5183f5(0x3b1)]["hintMessageSize"][
                        _0x409f64["Z"]["currentAction"][_0x5183f5(0x403)][_0x5183f5(0x6ae)]
                      ]),
                    (this[_0x5183f5(0x71b)] = _0x409f64["Z"]["currentAction"][_0x5183f5(0x403)][_0x5183f5(0x2c8)]),
                    (this[_0x5183f5(0x650)] = document["getElementById"](this["customVideoSourceContainerElementId"])),
                    this[_0x5183f5(0x650)]
                      ? ((this[_0x5183f5(0x569)] = this[_0x5183f5(0x437)]),
                        (this["classNameForVideoSourceElement"] = _0x5183f5(0x3b7)),
                        (this[_0x5183f5(0x263)] = "mitekMediaStreamSourceCustom"))
                      : ((this[_0x5183f5(0x569)] = this[_0x5183f5(0x552)]),
                        (this[_0x5183f5(0x1c6)] = _0x5183f5(0x4bb)),
                        (this[_0x5183f5(0x263)] = _0x5183f5(0x4bb))),
                    (this[_0x5183f5(0x2c0)] = _0x5183f5(0x51d)),
                    (this[_0x5183f5(0x20f)] = this[_0x5183f5(0x47d)](
                      _0x409f64["Z"][_0x5183f5(0x637)]["actionIdentifier"][_0x5183f5(0x245)]
                    )),
                    _0x409f64["Z"][_0x5183f5(0x66e)](this[_0x5183f5(0x20f)]),
                    (this[_0x5183f5(0x461)] = {
                      video: {
                        width: { ideal: this["canvasDimensions"][_0x5183f5(0x657)] },
                        height: { ideal: this["canvasDimensions"][_0x5183f5(0x39c)] },
                        facingMode: _0x564217,
                        frameRate: { ideal: 0x19 },
                      },
                    }),
                    _0x409f64["Z"][_0x5183f5(0x637)][_0x5183f5(0x403)][_0x5183f5(0x6b6)] &&
                      (this[_0x5183f5(0x461)][_0x5183f5(0x348)] = { echoCancellation: { ideal: !0x0 } });
                }
                ["getCameraPreferredLabelsByActionType"](_0x376dca) {
                  const _0xdcd22f = _0x4067e7;
                  switch (_0x376dca) {
                    case _0xdcd22f(0x332):
                      return [..._0x3c9edc["Z"]["getDeviceFrontCameraLabels"]()];
                    default:
                      return [
                        ..._0x3c9edc["Z"]["getIphonePreferredBackCameraLabels"](_0x33dbda["g"][_0xdcd22f(0x52d)][_0xdcd22f(0x657)]),
                        ..._0x409f64["Z"]["appConfig"][_0xdcd22f(0x201)],
                      ];
                  }
                }
                [_0x4067e7(0x47d)](_0x371deb) {
                  const _0x51900d = _0x4067e7;
                  switch (_0x371deb) {
                    case _0x51900d(0x332):
                      return (this[_0x51900d(0x20f)] = _0x4dd2dc);
                    default:
                      return _0x15d2e6;
                  }
                }
                [_0x4067e7(0x68d)]() {
                  return _0x406cbd(this, void 0x0, void 0x0, function* () {
                    const _0xf1645d = a0_0x1b49;
                    yield this[_0xf1645d(0x69c)](), yield this[_0xf1645d(0x27a)]();
                    const _0x28aabd = new Promise((_0x311eeb) => {
                      const _0x5a4cfa = _0xf1645d;
                      setTimeout(() => {
                        const _0x5f57a8 = a0_0x1b49;
                        this[_0x5f57a8(0x1bf)]
                          ? _0x311eeb(this[_0x5f57a8(0x1bf)])
                          : _0x311eeb(new _0x2c3d54["Z"](new ImageData(0x184, 0x184), 0x4));
                      }, this[_0x5a4cfa(0x4e2)]);
                    });
                    return yield _0x28aabd;
                  });
                }
                [_0x4067e7(0x69c)]() {
                  var _0x5e850b;
                  return _0x406cbd(this, void 0x0, void 0x0, function* () {
                    const _0x3a89c5 = a0_0x1b49;
                    if (null === (_0x5e850b = this[_0x3a89c5(0x318)]) || void 0x0 === _0x5e850b ? void 0x0 : _0x5e850b[_0x3a89c5(0x296)])
                      return !0x0;
                    try {
                      this[_0x3a89c5(0x387)](), this["setMirroring"](), this["createHintMessageElement"]();
                      let _0x81d033 = yield this[_0x3a89c5(0x5a5)](),
                        _0xcdc7c7 = yield this[_0x3a89c5(0x21d)](this[_0x3a89c5(0x318)], _0x81d033);
                      return (
                        this["registerEventListeners"](),
                        this[_0x3a89c5(0x599)](),
                        this[_0x3a89c5(0x6da)](),
                        _0x411080[_0x3a89c5(0x4c8)](),
                        this["startSessionRecorder"](_0x81d033),
                        _0xcdc7c7
                      );
                    } catch (_0x438cef) {
                      throw _0x438cef;
                    }
                  });
                }
                [_0x4067e7(0x5a5)]() {
                  return _0x406cbd(this, void 0x0, void 0x0, function* () {
                    const _0x12f3c0 = a0_0x1b49;
                    let _0x370aa0;
                    if ("" !== _0x409f64["Z"]["currentAction"]["commandOptions"][_0x12f3c0(0x6aa)])
                      _0x370aa0 = yield this[_0x12f3c0(0x2ad)]();
                    else {
                      (this["mediaStreamConstraints"][_0x12f3c0(0x617)][_0x12f3c0(0x385)] = yield this[_0x12f3c0(0x42c)]()),
                        _0x33dbda["g"]["globalVideoSelectedId"] &&
                          (this[_0x12f3c0(0x461)]["video"]["deviceId"] = _0x33dbda["g"]["globalVideoSelectedId"]),
                        (_0x370aa0 = yield this[_0x12f3c0(0x644)](this[_0x12f3c0(0x461)])),
                        _0x409f64["Z"]["setCurrentActionMibiDataPlatformPrivateAcquiredGumCanvasDimension"](this["getTrackDimensions"]());
                      let _0x594db8 = yield _0x3aeeb1["Z"][_0x12f3c0(0x3d0)](_0x370aa0);
                      _0x409f64["Z"][_0x12f3c0(0x337)](_0x594db8);
                    }
                    return _0x370aa0;
                  });
                }
                [_0x4067e7(0x21d)](_0x4ae3a3, _0x2bfd64) {
                  return _0x406cbd(this, void 0x0, void 0x0, function* () {
                    return new Promise((_0x172ee4, _0x3920f1) => {
                      const _0x58c341 = a0_0x1b49;
                      this[_0x58c341(0x318)][_0x58c341(0x307)](_0x58c341(0x5a7), () =>
                        _0x406cbd(this, void 0x0, void 0x0, function* () {
                          const _0x344cf5 = _0x58c341,
                            _0x2d14df = () => {
                              const _0x7199f2 = a0_0x1b49;
                              0x4 === this[_0x7199f2(0x318)][_0x7199f2(0x25f)] &&
                                ((this[_0x7199f2(0x234)] = !0x0),
                                (this[_0x7199f2(0x1df)] = new Date()[_0x7199f2(0x214)]()),
                                _0x172ee4(!0x0));
                            };
                          for (; !this[_0x344cf5(0x234)]; )
                            yield new Promise((_0x295424) => setTimeout(_0x295424, 0x12c)),
                              _0x2d14df(),
                              this[_0x344cf5(0x25b)]++,
                              0x5 === this[_0x344cf5(0x25b)] && _0x3920f1(!0x1);
                        })
                      ),
                        (_0x4ae3a3[_0x58c341(0x296)] = _0x2bfd64);
                    });
                  });
                }
                ["getCurrentOrientationWidthAndHeight"]() {
                  const _0x2ae70d = _0x4067e7;
                  return _0x2ae70d(0x6c6) === (window[_0x2ae70d(0x4d9)] / window[_0x2ae70d(0x219)] > 0x1 ? "landscape" : "portrait")
                    ? { width: window[_0x2ae70d(0x4d9)], height: window[_0x2ae70d(0x219)] }
                    : { width: window[_0x2ae70d(0x219)], height: window["outerWidth"] };
                }
                [_0x4067e7(0x599)]() {
                  return _0x406cbd(this, void 0x0, void 0x0, function* () {
                    const _0x42b118 = a0_0x1b49;
                    this[_0x42b118(0x318)][_0x42b118(0x660)](),
                      this[_0x42b118(0x430)][_0x42b118(0x625)](this[_0x42b118(0x318)]),
                      this[_0x42b118(0x650)]
                        ? (this[_0x42b118(0x650)][_0x42b118(0x625)](this["videoSourceContainerElement"]),
                          this[_0x42b118(0x430)][_0x42b118(0x255)]["add"](_0x42b118(0x443)))
                        : (_0x33dbda["g"]["document"][_0x42b118(0x30f)][_0x42b118(0x625)](this[_0x42b118(0x430)]),
                          this["videoSourceContainerElement"][_0x42b118(0x255)]["add"](_0x42b118(0x235)));
                  });
                }
                ["createGuideOverlay"]() {
                  const _0x6e30e2 = _0x4067e7,
                    _0x2c1966 = 0.8 * this["canvasDimensions"][_0x6e30e2(0x657)],
                    _0x3ed706 = 0.8 * this[_0x6e30e2(0x20f)]["height"];
                  return {
                    x: this[_0x6e30e2(0x20f)][_0x6e30e2(0x657)] - _0x2c1966 / 0x2,
                    y: this[_0x6e30e2(0x20f)][_0x6e30e2(0x39c)] - _0x2c1966 / 0x2,
                    width: _0x2c1966,
                    height: _0x3ed706,
                  };
                }
                [_0x4067e7(0x36b)]() {
                  const _0x144de4 = _0x4067e7;
                  switch (
                    ((_0x409f64["Z"][_0x144de4(0x637)][_0x144de4(0x2ef)] = this[_0x144de4(0x1e0)]()),
                    (this[_0x144de4(0x678)] = document[_0x144de4(0x506)](_0x144de4(0x6dd))),
                    this[_0x144de4(0x678)][_0x144de4(0x584)]("id", _0x144de4(0x671)),
                    this[_0x144de4(0x678)]["classList"][_0x144de4(0x5de)](_0x144de4(0x2c1)),
                    this[_0x144de4(0x678)][_0x144de4(0x255)][_0x144de4(0x5de)](
                      _0x409f64["Z"]["currentAction"]["actionIdentifier"][_0x144de4(0x245)]
                    ),
                    this["guideElement"][_0x144de4(0x255)][_0x144de4(0x5de)](_0x144de4(0x3a1)),
                    this[_0x144de4(0x678)]["classList"]["add"](_0x144de4(0x1c5)),
                    _0x409f64["Z"][_0x144de4(0x637)][_0x144de4(0x452)][_0x144de4(0x245)])
                  ) {
                    case _0x144de4(0x332):
                      this[_0x144de4(0x678)]["classList"]["add"]("mitek-selfie-guide");
                      break;
                    default:
                      this[_0x144de4(0x678)][_0x144de4(0x255)]["add"](_0x144de4(0x709));
                  }
                  this["videoSourceContainerElement"][_0x144de4(0x625)](this[_0x144de4(0x678)]);
                }
                [_0x4067e7(0x387)]() {
                  return _0x406cbd(this, void 0x0, void 0x0, function* () {
                    const _0x1e6baf = a0_0x1b49;
                    (this[_0x1e6baf(0x318)] = _0x33dbda["g"][_0x1e6baf(0x2c6)][_0x1e6baf(0x506)](_0x1e6baf(0x617))),
                      this["videoSourceElement"][_0x1e6baf(0x584)]("id", _0x1e6baf(0x51d)),
                      this[_0x1e6baf(0x318)]["setAttribute"]("autoplay", _0x1e6baf(0x1f4)),
                      this[_0x1e6baf(0x318)][_0x1e6baf(0x584)](_0x1e6baf(0x2d2), _0x1e6baf(0x1f4)),
                      this[_0x1e6baf(0x318)]["setAttribute"](_0x1e6baf(0x556), _0x1e6baf(0x2e5)),
                      (this[_0x1e6baf(0x318)]["muted"] = !0x0),
                      this[_0x1e6baf(0x318)][_0x1e6baf(0x255)][_0x1e6baf(0x5de)](_0x1e6baf(0x1e1)),
                      this[_0x1e6baf(0x318)]["classList"]["add"](this["classNameForVideoSourceContainerElement"]),
                      (this[_0x1e6baf(0x430)] = _0x33dbda["g"][_0x1e6baf(0x2c6)][_0x1e6baf(0x506)](_0x1e6baf(0x6dd))),
                      this[_0x1e6baf(0x430)]["setAttribute"]("id", _0x1e6baf(0x3eb)),
                      this[_0x1e6baf(0x36b)](),
                      (this["canvasElement"] = _0x33dbda["g"][_0x1e6baf(0x2c6)]["createElement"](_0x1e6baf(0x5ca))),
                      this[_0x1e6baf(0x2db)][_0x1e6baf(0x584)](_0x1e6baf(0x657), this[_0x1e6baf(0x20f)][_0x1e6baf(0x657)]["toString"]()),
                      this["canvasElement"]["setAttribute"](_0x1e6baf(0x39c), this[_0x1e6baf(0x20f)][_0x1e6baf(0x39c)][_0x1e6baf(0x406)]());
                  });
                }
                ["setMirroring"]() {
                  const _0x32f8e0 = _0x4067e7;
                  _0x409f64["Z"][_0x32f8e0(0x637)][_0x32f8e0(0x530)] &&
                    (this[_0x32f8e0(0x318)][_0x32f8e0(0x3b9)][_0x32f8e0(0x541)] = "scaleX(-1)");
                }
                [_0x4067e7(0x4ae)]() {
                  const _0x35ada0 = _0x4067e7,
                    _0x45e4c5 = document[_0x35ada0(0x506)]("div");
                  _0x45e4c5["setAttribute"]("id", _0x35ada0(0x44d)),
                    _0x45e4c5[_0x35ada0(0x255)][_0x35ada0(0x5de)](_0x35ada0(0x1c5)),
                    this[_0x35ada0(0x678)]["append"](_0x45e4c5),
                    (this["hintMessageElement"] = _0x45e4c5),
                    this[_0x35ada0(0x3d1)][_0x35ada0(0x584)]("aria-live", this[_0x35ada0(0x2f5)]),
                    this[_0x35ada0(0x3d1)]["setAttribute"](_0x35ada0(0x61f), "alert"),
                    this[_0x35ada0(0x3d1)][_0x35ada0(0x255)][_0x35ada0(0x5de)](this[_0x35ada0(0x4cb)]);
                }
                ["takeSnapshotSaveToState"]() {
                  const _0xb8a99d = _0x4067e7;
                  this["isVideoStreamReady"] && this[_0xb8a99d(0x3a4)]();
                }
                ["removeDomElementSafely"](_0x557610) {
                  const _0x43523f = _0x4067e7;
                  _0x557610 && _0x557610[_0x43523f(0x44c)]();
                }
                [_0x4067e7(0x2d8)]() {
                  const _0x446d2e = _0x4067e7;
                  this["removeDomElementSafely"](this[_0x446d2e(0x430)]),
                    this[_0x446d2e(0x5ac)](this[_0x446d2e(0x318)]),
                    this["removeDomElementSafely"](this[_0x446d2e(0x3d1)]);
                }
                [_0x4067e7(0x3a4)]() {
                  const _0x547408 = _0x4067e7;
                  try {
                    let _0x450e94 = document[_0x547408(0x1da)]("mitekMediaStreamSource"),
                      _0x18c7aa = this[_0x547408(0x2db)][_0x547408(0x5c4)]("2d", { willReadFrequently: !0x0 });
                    _0x18c7aa[_0x547408(0x65a)](_0x450e94, 0x0, 0x0);
                    let _0x48c527 = _0x18c7aa[_0x547408(0x231)](
                      0x0,
                      0x0,
                      this["canvasElement"][_0x547408(0x657)],
                      this[_0x547408(0x2db)]["height"]
                    );
                    (this[_0x547408(0x1bf)] = void 0x0), (this["snapshot"] = new _0x2c3d54["Z"](_0x48c527, 0x2));
                  } catch (_0xd7d141) {
                    throw _0x547408(0x61e);
                  }
                }
                ["getSpecificDeviceByLabel"]() {
                  var _0x2af5d4;
                  return _0x406cbd(this, void 0x0, void 0x0, function* () {
                    const _0x6f40ad = a0_0x1b49;
                    let _0x425ba2 = [],
                      _0x27a52a = "";
                    (this["acquireGumPermissionStream"] = yield navigator[_0x6f40ad(0x1e2)][_0x6f40ad(0x324)]({ video: !0x0 })),
                      this["acquireGumPermissionStream"][_0x6f40ad(0x440)]()[_0x6f40ad(0x672)](function (_0x464d09) {
                        const _0x5c2fa2 = _0x6f40ad;
                        _0x464d09[_0x5c2fa2(0x52e)]();
                      });
                    let _0x4bcb6c = yield navigator["mediaDevices"][_0x6f40ad(0x4a3)]();
                    return (
                      _0x3c9edc["Z"][_0x6f40ad(0x656)]() && (_0x4bcb6c = _0x4bcb6c["reverse"]()),
                      _0x4bcb6c[_0x6f40ad(0x25c)]((_0x5354f0) => this[_0x6f40ad(0x54e)]["includes"](_0x5354f0[_0x6f40ad(0x444)]))[
                        _0x6f40ad(0x672)
                      ]((_0x4f2a3a) => {
                        _0x425ba2["push"](_0x4f2a3a);
                      }),
                      _0x425ba2["length"] &&
                        (_0x27a52a = null === (_0x2af5d4 = _0x425ba2[0x0]) || void 0x0 === _0x2af5d4 ? void 0x0 : _0x2af5d4["deviceId"]),
                      _0x27a52a
                    );
                  });
                }
                [_0x4067e7(0x644)](_0x71e6b) {
                  return _0x406cbd(this, void 0x0, void 0x0, function* () {
                    const _0x263295 = a0_0x1b49;
                    try {
                      return (
                        (this[_0x263295(0x57b)] = yield navigator[_0x263295(0x1e2)][_0x263295(0x324)](_0x71e6b)), this["userMediaStream"]
                      );
                    } catch (_0x1b8c40) {
                      throw new _0x3b1c1e["Z"](_0x263295(0x436), _0x1b8c40);
                    }
                  });
                }
                [_0x4067e7(0x2ad)]() {
                  return _0x406cbd(this, void 0x0, void 0x0, function* () {
                    return new Promise((_0x3f5a25, _0x262339) => {
                      const _0x2b96b9 = a0_0x1b49;
                      try {
                        const _0x21fb3c = document[_0x2b96b9(0x506)]("video");
                        (_0x21fb3c[_0x2b96b9(0x4c7)] = !0x0),
                          (_0x21fb3c[_0x2b96b9(0x3ae)] = !0x0),
                          _0x21fb3c["addEventListener"](_0x2b96b9(0x5a7), () => {
                            const _0x259185 = _0x2b96b9;
                            _0x21fb3c[_0x259185(0x505)]
                              ? (this[_0x259185(0x57b)] = _0x21fb3c[_0x259185(0x505)](0x0))
                              : _0x21fb3c[_0x259185(0x65f)]
                              ? (this[_0x259185(0x57b)] = _0x21fb3c[_0x259185(0x65f)](0x0))
                              : (this[_0x259185(0x57b)] = new MediaStream()),
                              _0x3f5a25(this["userMediaStream"]);
                          }),
                          (_0x21fb3c[_0x2b96b9(0x27c)] = _0x409f64["Z"][_0x2b96b9(0x637)]["commandOptions"][_0x2b96b9(0x6aa)]);
                      } catch (_0x3f28e0) {
                        _0x262339(_0x3f28e0);
                      }
                    });
                  });
                }
                [_0x4067e7(0x6da)]() {
                  const _0x45745e = _0x4067e7;
                  this[_0x45745e(0x4b3)](this[_0x45745e(0x29b)]()),
                    this[_0x45745e(0x569)](),
                    this[_0x45745e(0x430)][_0x45745e(0x255)]["add"](_0x45745e(0x28e));
                }
                [_0x4067e7(0x4b3)](_0x3f3a93) {
                  const _0x2bbed4 = _0x4067e7;
                  _0x3f3a93 &&
                    _0x3f3a93[_0x2bbed4(0x657)] &&
                    ((this[_0x2bbed4(0x20f)] = _0x3f3a93),
                    this[_0x2bbed4(0x2db)]["setAttribute"](_0x2bbed4(0x657), _0x3f3a93["width"][_0x2bbed4(0x406)]()),
                    this[_0x2bbed4(0x2db)][_0x2bbed4(0x584)](_0x2bbed4(0x39c), _0x3f3a93["height"][_0x2bbed4(0x406)]()));
                }
                ["getDivElementDimensions"](_0x5b5543) {
                  const _0x353659 = _0x4067e7;
                  return { width: _0x5b5543[_0x353659(0x359)], height: _0x5b5543[_0x353659(0x345)] };
                }
                [_0x4067e7(0x486)]() {
                  const _0x176e4f = _0x4067e7;
                  var _0x3f75de;
                  let _0x454230 = this[_0x176e4f(0x57b)][_0x176e4f(0x508)]();
                  if (_0x454230[0x0] instanceof MediaStreamTrack)
                    return null === (_0x3f75de = _0x454230[0x0]) || void 0x0 === _0x3f75de ? void 0x0 : _0x3f75de[_0x176e4f(0x642)]();
                  throw new _0x3b1c1e["Z"]("INVALID_STREAM_TRACK", new Error());
                }
                ["getTrackDimensions"]() {
                  const _0x3e86c9 = _0x4067e7;
                  let _0x2bed5c = this["getTrackSettings"]();
                  return { width: _0x2bed5c[_0x3e86c9(0x657)], height: _0x2bed5c[_0x3e86c9(0x39c)] };
                }
                [_0x4067e7(0x636)]() {
                  const _0x1c1bbf = _0x4067e7;
                  return { width: window[_0x1c1bbf(0x4d9)], height: window[_0x1c1bbf(0x219)] };
                }
                [_0x4067e7(0x552)]() {
                  const _0x5cc82c = _0x4067e7,
                    _0x1f33b4 = this["getWindowDimensions"]();
                  (this[_0x5cc82c(0x318)][_0x5cc82c(0x657)] = _0x1f33b4["width"]),
                    (this[_0x5cc82c(0x318)]["height"] = _0x1f33b4[_0x5cc82c(0x39c)]),
                    this[_0x5cc82c(0x435)](_0x1f33b4),
                    _0x5cc82c(0x332) === _0x409f64["Z"][_0x5cc82c(0x637)][_0x5cc82c(0x452)][_0x5cc82c(0x245)] && this[_0x5cc82c(0x445)]();
                }
                [_0x4067e7(0x437)]() {
                  const _0x22bc98 = _0x4067e7,
                    _0x2024a5 = this[_0x22bc98(0x40c)](this[_0x22bc98(0x650)]);
                  (this["videoSourceElement"]["width"] = _0x2024a5["width"]),
                    (this[_0x22bc98(0x318)][_0x22bc98(0x39c)] = _0x2024a5[_0x22bc98(0x39c)]),
                    this[_0x22bc98(0x435)](_0x2024a5),
                    _0x22bc98(0x332) === _0x409f64["Z"][_0x22bc98(0x637)][_0x22bc98(0x452)]["actionType"] && this[_0x22bc98(0x445)]();
                }
                ["updateSelfieGuide"]() {
                  const _0x4675d3 = _0x4067e7;
                  let _0x13929b = getComputedStyle(this[_0x4675d3(0x430)]),
                    _0x205bfa = parseInt(_0x13929b[_0x4675d3(0x39c)]),
                    _0x5235ed = Math["floor"]((0.8 * _0x205bfa) / 1.56);
                  this["guideElement"]["style"][_0x4675d3(0x657)] = _0x5235ed + "px";
                }
                [_0x4067e7(0x435)](_0x202de) {
                  const _0x1bfc2c = _0x4067e7;
                  (this[_0x1bfc2c(0x430)][_0x1bfc2c(0x3b9)][_0x1bfc2c(0x657)] = "\x27" + _0x202de["width"] + _0x1bfc2c(0x432)),
                    (this[_0x1bfc2c(0x430)][_0x1bfc2c(0x3b9)][_0x1bfc2c(0x39c)] = "\x27" + _0x202de[_0x1bfc2c(0x39c)] + _0x1bfc2c(0x432));
                }
                [_0x4067e7(0x278)]() {
                  const _0x986f1d = _0x4067e7;
                  clearTimeout(this[_0x986f1d(0x45a)]),
                    (this[_0x986f1d(0x45a)] = setTimeout(() => {
                      const _0x51d3d7 = _0x986f1d;
                      try {
                        this["updateCanvasSize"](this[_0x51d3d7(0x29b)]()), this[_0x51d3d7(0x569)]();
                      } catch (_0x5d9640) {
                        console[_0x51d3d7(0x677)](_0x51d3d7(0x640) + JSON[_0x51d3d7(0x502)](_0x5d9640));
                      }
                    }, 0x12c));
                }
                [_0x4067e7(0x5a8)]() {
                  const _0x55dbe6 = _0x4067e7;
                  (this["boundEventListenerCallbacks"]["onWindowResizeOrOrientationChange"] =
                    this[_0x55dbe6(0x278)][_0x55dbe6(0x23e)](this)),
                    window[_0x55dbe6(0x307)](_0x55dbe6(0x6bc), this[_0x55dbe6(0x56d)][_0x55dbe6(0x278)]);
                }
                [_0x4067e7(0x4a6)]() {
                  const _0x38ef6b = _0x4067e7;
                  window[_0x38ef6b(0x614)](_0x38ef6b(0x6bc), this[_0x38ef6b(0x56d)][_0x38ef6b(0x278)]);
                }
                [_0x4067e7(0x570)](_0x41126e, _0x4ec24f) {
                  const _0x2cb020 = _0x4067e7;
                  this[_0x2cb020(0x430)][_0x2cb020(0x584)](
                    "style",
                    _0x2cb020(0x5e6) + _0x41126e + "px;\x20height:\x20" + _0x4ec24f + _0x2cb020(0x58e)
                  ),
                    this["videoSourceElement"]["setAttribute"](_0x2cb020(0x657), _0x41126e),
                    this[_0x2cb020(0x318)][_0x2cb020(0x584)](_0x2cb020(0x39c), _0x4ec24f),
                    this[_0x2cb020(0x318)][_0x2cb020(0x584)](
                      "style",
                      "margin:\x200;\x20padding:\x200;\x20width:\x20" + _0x41126e + _0x2cb020(0x58c) + _0x4ec24f + "px;"
                    ),
                    this[_0x2cb020(0x2db)][_0x2cb020(0x584)](_0x2cb020(0x657), _0x41126e),
                    this["canvasElement"][_0x2cb020(0x584)](_0x2cb020(0x39c), _0x4ec24f),
                    this[_0x2cb020(0x2db)][_0x2cb020(0x584)]("style", _0x2cb020(0x4f3) + _0x41126e + _0x2cb020(0x58c) + _0x4ec24f + "px;");
                }
                [_0x4067e7(0x464)]() {
                  const _0xa90797 = _0x4067e7;
                  return new Date()[_0xa90797(0x214)]() - this["startTime"] > this[_0xa90797(0x419)];
                }
                [_0x4067e7(0x265)]() {
                  const _0x270459 = _0x4067e7;
                  var _0xe78104;
                  try {
                    const _0x54371d =
                      null === (_0xe78104 = this["userMediaStream"]) || void 0x0 === _0xe78104 ? void 0x0 : _0xe78104[_0x270459(0x440)]();
                    if (_0x54371d)
                      for (let _0x4aebc3 = 0x0; _0x4aebc3 < _0x54371d[_0x270459(0x5ab)]; _0x4aebc3++) {
                        _0x54371d[_0x4aebc3][_0x270459(0x52e)]();
                      }
                    (this["videoSourceElement"] && (this["videoSourceElement"][_0x270459(0x296)] = null), this[_0x270459(0x2db)]) &&
                      (this[_0x270459(0x2db)]
                        [_0x270459(0x5c4)]("2d", { willReadFrequently: !0x0 })
                        [_0x270459(0x1c9)](0x0, 0x0, this[_0x270459(0x20f)]["width"], this[_0x270459(0x20f)][_0x270459(0x39c)]),
                      this["canvasElement"][_0x270459(0x44c)]()),
                      (this["snapshot"] = void 0x0),
                      this["removeEventListeners"](),
                      this[_0x270459(0x2d8)]();
                  } catch (_0x2f61eb) {
                    throw _0x2f61eb;
                  }
                }
                [_0x4067e7(0x41b)](_0x4b0c0f) {
                  const _0x3a16a9 = _0x4067e7;
                  _0x409f64["Z"][_0x3a16a9(0x637)]["commandOptions"]["videoRecordingEnabled"] && _0x527ec2["startRecording"](_0x4b0c0f);
                }
              };
            var _0x1a1831 = function (_0x4715fa, _0x19994d, _0x4a0254, _0x11501b) {
              return new (_0x4a0254 || (_0x4a0254 = Promise))(function (_0x40a77d, _0x34b71d) {
                const _0xc4d9fd = a0_0x1b49;
                function _0xd8bc7a(_0x2b85c0) {
                  const _0x3eece4 = a0_0x1b49;
                  try {
                    _0x55acd6(_0x11501b[_0x3eece4(0x3e1)](_0x2b85c0));
                  } catch (_0xaf46b0) {
                    _0x34b71d(_0xaf46b0);
                  }
                }
                function _0x18420f(_0x24d84e) {
                  const _0x452cea = a0_0x1b49;
                  try {
                    _0x55acd6(_0x11501b[_0x452cea(0x3b2)](_0x24d84e));
                  } catch (_0x5d2662) {
                    _0x34b71d(_0x5d2662);
                  }
                }
                function _0x55acd6(_0x2248d0) {
                  const _0x272c62 = a0_0x1b49;
                  var _0x217429;
                  _0x2248d0[_0x272c62(0x4f5)]
                    ? _0x40a77d(_0x2248d0[_0x272c62(0x331)])
                    : ((_0x217429 = _0x2248d0[_0x272c62(0x331)]),
                      _0x217429 instanceof _0x4a0254
                        ? _0x217429
                        : new _0x4a0254(function (_0xec563b) {
                            _0xec563b(_0x217429);
                          }))["then"](_0xd8bc7a, _0x18420f);
                }
                _0x55acd6((_0x11501b = _0x11501b[_0xc4d9fd(0x1d1)](_0x4715fa, _0x19994d || []))["next"]());
              });
            };
            const _0x30bd95 = class {
              constructor(_0x2c252e) {
                const _0x54f0fb = _0x4067e7;
                this[_0x54f0fb(0x26e)] = _0x2c252e;
              }
              ["preserveExifInCurrentAction"](_0x2af2f1) {
                return _0x1a1831(this, void 0x0, void 0x0, function* () {
                  const _0x5de71b = a0_0x1b49;
                  try {
                    if (_0x13336a["Z"][_0x5de71b(0x610)](_0x2af2f1)) {
                      const _0x40041e = yield _0x11c06d[_0x5de71b(0x627)](_0x2af2f1);
                      _0x409f64["Z"]["extractCurrentActionExifFromDataURL"](_0x40041e);
                    }
                  } catch (_0x1ff56b) {
                    throw new _0x3b1c1e["Z"](_0x5de71b(0x4a8), new Error());
                  }
                });
              }
              [_0x4067e7(0x53e)]() {
                const _0x1319e7 = _0x4067e7,
                  _0x7726bd = document["createElement"](_0x1319e7(0x6dd));
                _0x7726bd[_0x1319e7(0x69a)] = _0x1319e7(0x391) + this[_0x1319e7(0x26e)] + _0x1319e7(0x1ea);
                const _0x5b941b = _0x7726bd[_0x1319e7(0x5bb)](_0x1319e7(0x26d));
                return { inputContainerElement: _0x7726bd, inputElement: _0x5b941b };
              }
              [_0x4067e7(0x68d)]() {
                return _0x1a1831(this, void 0x0, void 0x0, function* () {
                  const _0x279819 = a0_0x1b49,
                    { inputContainerElement: _0x46a750, inputElement: _0x58e58d } = this[_0x279819(0x53e)]();
                  return (
                    document["body"]["appendChild"](_0x46a750),
                    new Promise((_0x1d6462, _0x5ddba0) => {
                      (_0x58e58d["onchange"] = (_0x1577a2) => {
                        const _0x842a4c = a0_0x1b49;
                        _0x411080[_0x842a4c(0x352)]();
                        const _0x59b0a2 = _0x1577a2[_0x842a4c(0x288)][_0x842a4c(0x397)][0x0];
                        return Promise[_0x842a4c(0x4f0)]([
                          _0x11c06d["convertFileToImageData"](_0x59b0a2),
                          this[_0x842a4c(0x32c)](_0x59b0a2),
                        ])
                          ["then"](([_0x5014a8]) => {
                            const _0x50001c = _0x842a4c;
                            _0x46a750[_0x50001c(0x44c)]();
                            let _0x52dc62 = { width: _0x5014a8[_0x50001c(0x657)], height: _0x5014a8["height"] };
                            _0x13336a["Z"][_0x50001c(0x3d7)](
                              _0x52dc62,
                              _0x409f64["Z"][_0x50001c(0x63a)][_0x50001c(0x38d)]["BASE"][_0x50001c(0x659)]
                            )
                              ? _0x1d6462(new _0x2c3d54["Z"](_0x5014a8, 0x2))
                              : _0x5ddba0(new _0x3b1c1e["Z"](_0x50001c(0x1ca), new Error()));
                          })
                          [_0x842a4c(0x38b)]((_0x12dfe4) => _0x5ddba0(_0x12dfe4));
                      }),
                        _0x58e58d["click"]();
                    })["catch"]((_0x40b014) => Promise["reject"](_0x40b014))
                  );
                });
              }
            };
            var _0x1d0ba = function (_0xe6c97e, _0x24a6d4, _0x2a965a, _0xcc3805) {
              return new (_0x2a965a || (_0x2a965a = Promise))(function (_0x2871c4, _0x12569e) {
                const _0x4f4cf4 = a0_0x1b49;
                function _0x3f1145(_0x1b5b58) {
                  const _0x980245 = a0_0x1b49;
                  try {
                    _0x50e9a2(_0xcc3805[_0x980245(0x3e1)](_0x1b5b58));
                  } catch (_0x2f7d0a) {
                    _0x12569e(_0x2f7d0a);
                  }
                }
                function _0x35ed5d(_0x478870) {
                  const _0x2e9161 = a0_0x1b49;
                  try {
                    _0x50e9a2(_0xcc3805[_0x2e9161(0x3b2)](_0x478870));
                  } catch (_0x338933) {
                    _0x12569e(_0x338933);
                  }
                }
                function _0x50e9a2(_0x44763b) {
                  const _0x2434fe = a0_0x1b49;
                  var _0x2d4a76;
                  _0x44763b[_0x2434fe(0x4f5)]
                    ? _0x2871c4(_0x44763b[_0x2434fe(0x331)])
                    : ((_0x2d4a76 = _0x44763b[_0x2434fe(0x331)]),
                      _0x2d4a76 instanceof _0x2a965a
                        ? _0x2d4a76
                        : new _0x2a965a(function (_0x2a7b23) {
                            _0x2a7b23(_0x2d4a76);
                          }))[_0x2434fe(0x429)](_0x3f1145, _0x35ed5d);
                }
                _0x50e9a2((_0xcc3805 = _0xcc3805[_0x4f4cf4(0x1d1)](_0xe6c97e, _0x24a6d4 || []))[_0x4f4cf4(0x3e1)]());
              });
            };
            const _0x4de1f7 = class {
              constructor(_0x3d036d) {
                const _0x4858ab = _0x4067e7;
                this[_0x4858ab(0x26e)] = _0x3d036d;
              }
              [_0x4067e7(0x623)](_0xdad946) {
                const _0x9b040c = _0x4067e7;
                return _0x9b040c(0x621) == typeof _0xdad946 && _0x9b040c(0x589) === _0xdad946[_0x9b040c(0x467)](0x0, 0x4);
              }
              [_0x4067e7(0x5ff)](_0x3802bf) {
                const _0x410373 = _0x4067e7;
                switch (!0x0) {
                  case _0x3802bf instanceof _0x33dbda["g"][_0x410373(0x61c)]:
                    return "File";
                  case _0x3802bf instanceof ImageData:
                    return _0x410373(0x1b5);
                  case this["isImageDataUrl"](_0x3802bf):
                    return _0x410373(0x70d);
                  default:
                    throw new _0x3b1c1e["Z"](_0x410373(0x1f3), new Error("RUNTIME_INVALID_DIRECT_IMAGE_DATA_FORMAT"));
                }
              }
              ["extract"]() {
                return _0x1d0ba(this, void 0x0, void 0x0, function* () {
                  const _0x4ada35 = a0_0x1b49;
                  try {
                    const _0xc385b3 = _0x409f64["Z"]["currentAction"][_0x4ada35(0x403)][_0x4ada35(0x5f3)],
                      _0x18612f = this["determineFormat"](_0xc385b3);
                    let _0x2e99e2 = new _0x2c3d54["Z"](new ImageData(0x6f, 0x6f), 0x4);
                    switch (_0x18612f) {
                      case _0x4ada35(0x70d):
                        _0x2e99e2 = yield this[_0x4ada35(0x630)](_0xc385b3);
                        break;
                      case _0x4ada35(0x61c):
                        _0x2e99e2 = yield this[_0x4ada35(0x2fd)](_0xc385b3);
                        break;
                      case _0x4ada35(0x1b5):
                        _0x2e99e2 = this[_0x4ada35(0x2c7)](_0xc385b3);
                    }
                    return _0x2e99e2;
                  } catch (_0x2469b6) {
                    if (_0x2469b6 instanceof _0x3b1c1e["Z"]) throw _0x2469b6;
                    throw new _0x3b1c1e["Z"](_0x4ada35(0x1f3), new Error(), _0x4ada35(0x40f));
                  }
                });
              }
              ["extractFromDataUrl"](_0x4f0823) {
                return _0x1d0ba(this, void 0x0, void 0x0, function* () {
                  const _0x21824a = a0_0x1b49,
                    _0x44d5fe = yield _0x11c06d[_0x21824a(0x2cf)](_0x4f0823),
                    _0x41c7be = { width: _0x44d5fe[_0x21824a(0x657)], height: _0x44d5fe["height"] };
                  if (
                    _0x13336a["Z"][_0x21824a(0x3d7)](
                      _0x41c7be,
                      _0x409f64["Z"]["appConfig"][_0x21824a(0x38d)][_0x21824a(0x36c)][_0x21824a(0x659)]
                    )
                  )
                    return Promise[_0x21824a(0x57a)](new _0x2c3d54["Z"](_0x44d5fe, 0x2));
                  throw new _0x3b1c1e["Z"]("VALIDATOR_MIN_IMAGE_SIZE", new Error());
                });
              }
              [_0x4067e7(0x2c7)](_0x1437e7) {
                const _0x5543b8 = _0x4067e7,
                  _0x3c1fe7 = { width: _0x1437e7[_0x5543b8(0x657)], height: _0x1437e7[_0x5543b8(0x39c)] };
                if (
                  _0x13336a["Z"][_0x5543b8(0x3d7)](
                    _0x3c1fe7,
                    _0x409f64["Z"][_0x5543b8(0x63a)][_0x5543b8(0x38d)][_0x5543b8(0x36c)][_0x5543b8(0x659)]
                  )
                )
                  return new _0x2c3d54["Z"](_0x1437e7, 0x2);
                throw new _0x3b1c1e["Z"](_0x5543b8(0x1ca), new Error());
              }
              [_0x4067e7(0x2fd)](_0x1fda5d) {
                return _0x1d0ba(this, void 0x0, void 0x0, function* () {
                  const _0xae6d97 = a0_0x1b49,
                    _0x2e4818 = yield _0x11c06d["convertFileToImageData"](_0x1fda5d),
                    _0x7f4fc3 = { width: _0x2e4818[_0xae6d97(0x657)], height: _0x2e4818[_0xae6d97(0x39c)] };
                  if (
                    _0x13336a["Z"][_0xae6d97(0x3d7)](
                      _0x7f4fc3,
                      _0x409f64["Z"][_0xae6d97(0x63a)][_0xae6d97(0x38d)][_0xae6d97(0x36c)][_0xae6d97(0x659)]
                    )
                  )
                    return Promise["resolve"](new _0x2c3d54["Z"](_0x2e4818, 0x2));
                  throw new _0x3b1c1e["Z"](_0xae6d97(0x1ca), new Error());
                });
              }
            };
            var _0x37c156 = function (_0x4fd93f, _0x45222d, _0x21c9be, _0xa8d6c2) {
              return new (_0x21c9be || (_0x21c9be = Promise))(function (_0x2f7c67, _0x5efe44) {
                const _0x33dfd3 = a0_0x1b49;
                function _0x4a555c(_0x51fea3) {
                  const _0x66f56e = a0_0x1b49;
                  try {
                    _0x27a051(_0xa8d6c2[_0x66f56e(0x3e1)](_0x51fea3));
                  } catch (_0x19e017) {
                    _0x5efe44(_0x19e017);
                  }
                }
                function _0x10459c(_0x26e855) {
                  const _0x318b11 = a0_0x1b49;
                  try {
                    _0x27a051(_0xa8d6c2[_0x318b11(0x3b2)](_0x26e855));
                  } catch (_0x3286c8) {
                    _0x5efe44(_0x3286c8);
                  }
                }
                function _0x27a051(_0x232210) {
                  const _0x51fdf9 = a0_0x1b49;
                  var _0x22fc1d;
                  _0x232210[_0x51fdf9(0x4f5)]
                    ? _0x2f7c67(_0x232210[_0x51fdf9(0x331)])
                    : ((_0x22fc1d = _0x232210[_0x51fdf9(0x331)]),
                      _0x22fc1d instanceof _0x21c9be
                        ? _0x22fc1d
                        : new _0x21c9be(function (_0x33653b) {
                            _0x33653b(_0x22fc1d);
                          }))[_0x51fdf9(0x429)](_0x4a555c, _0x10459c);
                }
                _0x27a051((_0xa8d6c2 = _0xa8d6c2[_0x33dfd3(0x1d1)](_0x4fd93f, _0x45222d || []))[_0x33dfd3(0x3e1)]());
              });
            };
            const _0x44b347 = class {
                constructor(_0x5e3021) {
                  const _0x16e360 = _0x4067e7;
                  switch (_0x5e3021) {
                    case _0x16e360(0x54b):
                      this[_0x16e360(0x60c)] = new _0x30bd95(_0x409f64["Z"]["currentAction"][_0x16e360(0x26e)]);
                      break;
                    case _0x16e360(0x548):
                      this[_0x16e360(0x60c)] = new _0x26660a(_0x409f64["Z"][_0x16e360(0x637)][_0x16e360(0x26e)]);
                      break;
                    case "DIRECT":
                      this[_0x16e360(0x60c)] = new _0x4de1f7(_0x409f64["Z"]["currentAction"][_0x16e360(0x26e)]);
                      break;
                    default:
                      throw new _0x3b1c1e["Z"](_0x16e360(0x724), new Error());
                  }
                }
                [_0x4067e7(0x68d)]() {
                  return _0x37c156(this, void 0x0, void 0x0, function* () {
                    const _0x12ad20 = a0_0x1b49;
                    return yield this[_0x12ad20(0x60c)][_0x12ad20(0x68d)]();
                  });
                }
              },
              _0x4f51e3 = new (class {
                constructor() {}
                [_0x4067e7(0x541)](_0x21df15) {
                  const _0x15c0f2 = _0x4067e7;
                  return (_0x21df15[_0x15c0f2(0x248)] = _0x11c06d[_0x15c0f2(0x68e)](_0x21df15[_0x15c0f2(0x248)])), _0x21df15;
                }
              })();
            var _0x6a66db = function (_0xa7df81, _0x4bcfcc, _0x8dd5a4, _0x3e8cf5) {
              return new (_0x8dd5a4 || (_0x8dd5a4 = Promise))(function (_0x71f291, _0x52d68b) {
                function _0x4b8e26(_0x1728dc) {
                  try {
                    _0x21f783(_0x3e8cf5["next"](_0x1728dc));
                  } catch (_0x4db8a7) {
                    _0x52d68b(_0x4db8a7);
                  }
                }
                function _0x299eb8(_0x296406) {
                  try {
                    _0x21f783(_0x3e8cf5["throw"](_0x296406));
                  } catch (_0x190205) {
                    _0x52d68b(_0x190205);
                  }
                }
                function _0x21f783(_0x293ce0) {
                  const _0x3d0eb4 = a0_0x1b49;
                  var _0x359725;
                  _0x293ce0[_0x3d0eb4(0x4f5)]
                    ? _0x71f291(_0x293ce0[_0x3d0eb4(0x331)])
                    : ((_0x359725 = _0x293ce0["value"]),
                      _0x359725 instanceof _0x8dd5a4
                        ? _0x359725
                        : new _0x8dd5a4(function (_0x56719b) {
                            _0x56719b(_0x359725);
                          }))[_0x3d0eb4(0x429)](_0x4b8e26, _0x299eb8);
                }
                _0x21f783((_0x3e8cf5 = _0x3e8cf5["apply"](_0xa7df81, _0x4bcfcc || []))["next"]());
              });
            };
            const _0x471ae1 = new (class {
              constructor() {}
              ["transform"](_0x3b0e03) {
                return _0x6a66db(this, void 0x0, void 0x0, function* () {
                  const _0x5e999d = a0_0x1b49;
                  return yield this[_0x5e999d(0x5f7)](_0x3b0e03);
                });
              }
              [_0x4067e7(0x5f7)](_0x437694) {
                return new Promise((_0x158073, _0x274350) => {
                  const _0x293ae1 = a0_0x1b49,
                    _0x31a2c6 = new FileReader();
                  (_0x31a2c6[_0x293ae1(0x3fb)] = () => {
                    const _0x3271fb = _0x293ae1;
                    (_0x437694[_0x3271fb(0x37f)] = _0x31a2c6["result"]), _0x158073(_0x437694);
                  }),
                    _0x31a2c6[_0x293ae1(0x2a4)](_0x437694[_0x293ae1(0x539)]);
                });
              }
            })();
            var _0x35c142 = function (_0x151243, _0x188033, _0x423675, _0x239b0b) {
              return new (_0x423675 || (_0x423675 = Promise))(function (_0x52e7e0, _0x4254a1) {
                function _0x14c72d(_0x490ba6) {
                  const _0xe03b1b = a0_0x1b49;
                  try {
                    _0x53a86e(_0x239b0b[_0xe03b1b(0x3e1)](_0x490ba6));
                  } catch (_0xc4bc13) {
                    _0x4254a1(_0xc4bc13);
                  }
                }
                function _0x4d4b86(_0x3d0e7a) {
                  const _0x3f04dd = a0_0x1b49;
                  try {
                    _0x53a86e(_0x239b0b[_0x3f04dd(0x3b2)](_0x3d0e7a));
                  } catch (_0x250a62) {
                    _0x4254a1(_0x250a62);
                  }
                }
                function _0x53a86e(_0x49474f) {
                  const _0x360ab6 = a0_0x1b49;
                  var _0x52642b;
                  _0x49474f["done"]
                    ? _0x52e7e0(_0x49474f[_0x360ab6(0x331)])
                    : ((_0x52642b = _0x49474f["value"]),
                      _0x52642b instanceof _0x423675
                        ? _0x52642b
                        : new _0x423675(function (_0x5de5df) {
                            _0x5de5df(_0x52642b);
                          }))["then"](_0x14c72d, _0x4d4b86);
                }
                _0x53a86e((_0x239b0b = _0x239b0b["apply"](_0x151243, _0x188033 || []))["next"]());
              });
            };
            const _0x15a5df = class {
              constructor(_0x4c03f4) {
                const _0x23aecd = _0x4067e7;
                switch (_0x4c03f4) {
                  case "SELFIE":
                    this[_0x23aecd(0x29a)] = _0x4f51e3;
                    break;
                  case "CHECK_BACK":
                  case _0x23aecd(0x717):
                  case _0x23aecd(0x692):
                  case "DL_FRONT":
                  case _0x23aecd(0x434):
                  case _0x23aecd(0x478):
                  case _0x23aecd(0x2d4):
                  case "QR_BARCODE":
                    this[_0x23aecd(0x29a)] = _0x4f51e3;
                    break;
                  case _0x23aecd(0x268):
                    this["transformer"] = _0x471ae1;
                    break;
                  default:
                    throw _0x23aecd(0x69b);
                }
              }
              [_0x4067e7(0x541)](_0x317541) {
                return _0x35c142(this, void 0x0, void 0x0, function* () {
                  const _0x560ad8 = a0_0x1b49;
                  return yield this[_0x560ad8(0x29a)][_0x560ad8(0x541)](_0x317541);
                });
              }
            };
            var _0x501c78 = function (_0x38c214, _0x4ca660, _0x3b8e75, _0x274ca8) {
              return new (_0x3b8e75 || (_0x3b8e75 = Promise))(function (_0x5d74b7, _0x5609a6) {
                function _0x2a6d57(_0x5bcb9f) {
                  const _0x34e764 = a0_0x1b49;
                  try {
                    _0x158923(_0x274ca8[_0x34e764(0x3e1)](_0x5bcb9f));
                  } catch (_0x3b592b) {
                    _0x5609a6(_0x3b592b);
                  }
                }
                function _0x2c0378(_0x26655d) {
                  const _0x36c1e4 = a0_0x1b49;
                  try {
                    _0x158923(_0x274ca8[_0x36c1e4(0x3b2)](_0x26655d));
                  } catch (_0x5b4128) {
                    _0x5609a6(_0x5b4128);
                  }
                }
                function _0x158923(_0x175767) {
                  const _0x5cbe2d = a0_0x1b49;
                  var _0x190aca;
                  _0x175767[_0x5cbe2d(0x4f5)]
                    ? _0x5d74b7(_0x175767[_0x5cbe2d(0x331)])
                    : ((_0x190aca = _0x175767[_0x5cbe2d(0x331)]),
                      _0x190aca instanceof _0x3b8e75
                        ? _0x190aca
                        : new _0x3b8e75(function (_0x4be29b) {
                            _0x4be29b(_0x190aca);
                          }))[_0x5cbe2d(0x429)](_0x2a6d57, _0x2c0378);
                }
                _0x158923((_0x274ca8 = _0x274ca8["apply"](_0x38c214, _0x4ca660 || []))["next"]());
              });
            };
            new _0x3da364("app:recognizer:corevision");
            const _0x436b1c = new (class {
              constructor() {
                const _0x1e0e2e = _0x4067e7;
                (this["iterations"] = 0x0), (this[_0x1e0e2e(0x4f6)] = 0x64), this[_0x1e0e2e(0x47a)], (this["isLoaded"] = !0x1);
              }
              [_0x4067e7(0x4ab)]() {
                return _0x501c78(this, void 0x0, void 0x0, function* () {
                  const _0x236cf8 = a0_0x1b49;
                  try {
                    return (
                      this["isLoaded"] &&
                        ((this[_0x236cf8(0x62e)]["onerror"] = null),
                        (this["coreVisionWorkerInstance"][_0x236cf8(0x681)] = null),
                        this[_0x236cf8(0x62e)][_0x236cf8(0x4c3)](),
                        (this["isLoaded"] = !0x1)),
                      !0x0
                    );
                  } catch (_0x45befa) {
                    throw new _0x3b1c1e["Z"](_0x236cf8(0x6ff), _0x45befa);
                  }
                });
              }
              [_0x4067e7(0x1ef)]() {
                return _0x501c78(this, void 0x0, void 0x0, function* () {
                  const _0x28b20d = a0_0x1b49;
                  if ((this[_0x28b20d(0x315)]++, this[_0x28b20d(0x315)] % this["maxCallsBeforeReset"] == 0x0))
                    try {
                      yield this["reset"]();
                    } catch (_0x109f7f) {
                      throw _0x109f7f;
                    }
                });
              }
              ["onWorkerError"](_0x2b3561) {
                const _0x23727b = _0x4067e7;
                throw _0x411080["getRuntimeOutboundError"](new _0x3b1c1e["Z"](_0x23727b(0x37a), new Error(_0x2b3561[_0x23727b(0x22b)])));
              }
              [_0x4067e7(0x660)]() {
                return _0x501c78(this, void 0x0, void 0x0, function* () {
                  const _0x5147f7 = a0_0x1b49;
                  if (this["isLoading"]) return !0x1;
                  try {
                    if (!this[_0x5147f7(0x47a)]) {
                      this[_0x5147f7(0x3db)] = !0x0;
                      const _0x456478 = yield _0x33dbda["e"](0x123)[_0x5147f7(0x429)](_0x33dbda["bind"](_0x33dbda, 0x2e1));
                      this[_0x5147f7(0x47a)] = _0x456478["default"];
                    }
                    return (
                      (this[_0x5147f7(0x62e)] = new this["CoreVisionWorkerModule"]()),
                      (this["coreVisionWorkerInstance"]["onerror"] = this[_0x5147f7(0x594)]),
                      yield this["getCVResults"]({ data: null }),
                      (this[_0x5147f7(0x3db)] = !0x1),
                      !0x0
                    );
                  } catch (_0x19aab0) {
                    throw _0x19aab0;
                  }
                });
              }
              ["getCVResults"](_0x1cc607) {
                return _0x501c78(this, void 0x0, void 0x0, function* () {
                  return yield new Promise((_0x39ba76, _0x32345e) => {
                    const _0x2b688c = a0_0x1b49;
                    try {
                      (this[_0x2b688c(0x62e)]["onmessage"] = ({ data: _0x8d47a2 }) => {
                        _0x39ba76(_0x8d47a2);
                      }),
                        this[_0x2b688c(0x62e)][_0x2b688c(0x38f)](_0x1cc607);
                    } catch (_0x423a14) {
                      _0x32345e(_0x423a14);
                    }
                  });
                });
              }
              [_0x4067e7(0x388)](_0x2900a0, _0x55e077) {
                return _0x501c78(this, void 0x0, void 0x0, function* () {
                  const _0x2e4e8e = a0_0x1b49;
                  try {
                    yield this["performMemorySafetyCheck"](), this["isLoaded"] || (this[_0x2e4e8e(0x323)] = yield this["load"]());
                    const _0x45bbe5 = yield this[_0x2e4e8e(0x65e)](_0x2900a0),
                      _0x402193 = {
                        isFailure: !_0x45bbe5 || _0x2e4e8e(0x621) == typeof _0x45bbe5,
                        imageWidth: _0x2900a0[_0x2e4e8e(0x248)]["width"],
                        imageHeight: _0x2900a0[_0x2e4e8e(0x248)][_0x2e4e8e(0x39c)],
                        imageDimensions: _0x11c06d[_0x2e4e8e(0x203)](_0x2900a0[_0x2e4e8e(0x248)]),
                        rawData: _0x45bbe5,
                        snapShotId: _0x55e077,
                        averageAngleRotation: this[_0x2e4e8e(0x4e8)](_0x45bbe5),
                      };
                    return this[_0x2e4e8e(0x5fd)](_0x402193), _0x402193;
                  } catch (_0x409237) {
                    if (_0x409237 instanceof _0x3b1c1e["Z"]) throw _0x409237;
                    return {
                      isFailure: !0x0,
                      imageWidth: _0x2900a0[_0x2e4e8e(0x248)][_0x2e4e8e(0x657)],
                      imageHeight: _0x2900a0["imageData"][_0x2e4e8e(0x39c)],
                      rawData: void 0x0,
                      imageDimensions: _0x11c06d["getDimensionsFromImage"](_0x2900a0[_0x2e4e8e(0x248)]),
                      snapShotId: _0x55e077,
                      caughtError: new Error(_0x409237),
                      averageAngleRotation: NaN,
                    };
                  }
                });
              }
              [_0x4067e7(0x5fd)](_0x364395) {
                const _0x37b438 = _0x4067e7;
                var _0x3f0d01,
                  _0x4d8251,
                  _0x3f371e,
                  _0x22b286,
                  _0x2f3d4e,
                  _0x43a12a,
                  _0x5b1001,
                  _0x14de15,
                  _0x49a84c,
                  _0x314f18,
                  _0x1f9484,
                  _0x2c3ec2,
                  _0x45c7d4,
                  _0x53df9c;
                switch (!0x0) {
                  case !(null === _0x409f64["Z"] || void 0x0 === _0x409f64["Z"] ? void 0x0 : _0x409f64["Z"][_0x37b438(0x637)]):
                    break;
                  case _0x37b438(0x478) ===
                    (null ===
                      (_0x4d8251 =
                        null ===
                          (_0x3f0d01 =
                            null === _0x409f64["Z"] || void 0x0 === _0x409f64["Z"] ? void 0x0 : _0x409f64["Z"][_0x37b438(0x637)]) ||
                        void 0x0 === _0x3f0d01
                          ? void 0x0
                          : _0x3f0d01[_0x37b438(0x452)]) || void 0x0 === _0x4d8251
                      ? void 0x0
                      : _0x4d8251[_0x37b438(0x245)]):
                    (null ===
                      (_0x22b286 =
                        null === (_0x3f371e = _0x409f64["Z"][_0x37b438(0x637)]) || void 0x0 === _0x3f371e
                          ? void 0x0
                          : _0x3f371e[_0x37b438(0x403)]) || void 0x0 === _0x22b286
                      ? void 0x0
                      : _0x22b286["redactMRZOptionalData"]) &&
                      (null ===
                        (_0x43a12a =
                          null === (_0x2f3d4e = null == _0x364395 ? void 0x0 : _0x364395[_0x37b438(0x572)]) || void 0x0 === _0x2f3d4e
                            ? void 0x0
                            : _0x2f3d4e[_0x37b438(0x6dc)]) || void 0x0 === _0x43a12a
                        ? void 0x0
                        : _0x43a12a[_0x37b438(0x297)](0x0, 0x5)[_0x37b438(0x240)](/P.NLD/g)) &&
                      !(null ===
                        (_0x14de15 =
                          null === (_0x5b1001 = null == _0x364395 ? void 0x0 : _0x364395[_0x37b438(0x572)]) || void 0x0 === _0x5b1001
                            ? void 0x0
                            : _0x5b1001[_0x37b438(0x6dc)]) || void 0x0 === _0x14de15
                        ? void 0x0
                        : _0x14de15["slice"](0x48, 0x51)[_0x37b438(0x20d)](_0x37b438(0x356))) &&
                      this[_0x37b438(0x1e4)](_0x364395, 0x0);
                    break;
                  case _0x37b438(0x68c) ===
                    (null ===
                      (_0x314f18 =
                        null ===
                          (_0x49a84c =
                            null === _0x409f64["Z"] || void 0x0 === _0x409f64["Z"] ? void 0x0 : _0x409f64["Z"][_0x37b438(0x637)]) ||
                        void 0x0 === _0x49a84c
                          ? void 0x0
                          : _0x49a84c["actionIdentifier"]) || void 0x0 === _0x314f18
                      ? void 0x0
                      : _0x314f18[_0x37b438(0x245)]):
                    if (
                      null ===
                        (_0x2c3ec2 =
                          null === (_0x1f9484 = _0x409f64["Z"][_0x37b438(0x637)]) || void 0x0 === _0x1f9484
                            ? void 0x0
                            : _0x1f9484[_0x37b438(0x403)]) || void 0x0 === _0x2c3ec2
                        ? void 0x0
                        : _0x2c3ec2[_0x37b438(0x291)]
                    ) {
                      const _0x308be9 =
                        null ===
                          (_0x53df9c =
                            null === (_0x45c7d4 = null == _0x364395 ? void 0x0 : _0x364395[_0x37b438(0x572)]) || void 0x0 === _0x45c7d4
                              ? void 0x0
                              : _0x45c7d4[_0x37b438(0x6dc)]) || void 0x0 === _0x53df9c
                          ? void 0x0
                          : _0x53df9c[_0x37b438(0x297)](0x0, 0x5);
                      (null == _0x308be9 ? void 0x0 : _0x308be9[_0x37b438(0x240)](/(?:[1I]|^)<[HYN][LCI]D/g)) &&
                        this[_0x37b438(0x1e4)](_0x364395, 0x1);
                    }
                }
                return _0x364395;
              }
              ["redactMRZOptionalDataFromImage"](_0x2fe99c, _0x174570) {
                const _0x34e7d3 = _0x4067e7;
                var _0x256730,
                  _0x41b6fd,
                  _0x578ca5,
                  _0x5186fe,
                  _0x43f04b,
                  _0x299efc,
                  _0x1c8dcb,
                  _0x2b3563,
                  _0xdbb958,
                  _0x1aca46,
                  _0x4a4eda,
                  _0x32caf2,
                  _0x389e06,
                  _0x124591,
                  _0x272c4b,
                  _0x59b296;
                const _0x278c05 =
                    null === (_0x256730 = null == _0x2fe99c ? void 0x0 : _0x2fe99c[_0x34e7d3(0x572)]) || void 0x0 === _0x256730
                      ? void 0x0
                      : _0x256730[_0x34e7d3(0x45b)],
                  _0xfb76fc = {
                    x:
                      null === (_0x41b6fd = null == _0x2fe99c ? void 0x0 : _0x2fe99c[_0x34e7d3(0x572)]) || void 0x0 === _0x41b6fd
                        ? void 0x0
                        : _0x41b6fd["ax"],
                    y:
                      null === (_0x578ca5 = null == _0x2fe99c ? void 0x0 : _0x2fe99c[_0x34e7d3(0x572)]) || void 0x0 === _0x578ca5
                        ? void 0x0
                        : _0x578ca5["ay"],
                  },
                  _0x523c66 = {
                    x:
                      null === (_0x5186fe = null == _0x2fe99c ? void 0x0 : _0x2fe99c["rawData"]) || void 0x0 === _0x5186fe
                        ? void 0x0
                        : _0x5186fe["bx"],
                    y:
                      null === (_0x43f04b = null == _0x2fe99c ? void 0x0 : _0x2fe99c["rawData"]) || void 0x0 === _0x43f04b
                        ? void 0x0
                        : _0x43f04b["by"],
                  },
                  _0x473d28 = {
                    x:
                      null === (_0x299efc = null == _0x2fe99c ? void 0x0 : _0x2fe99c[_0x34e7d3(0x572)]) || void 0x0 === _0x299efc
                        ? void 0x0
                        : _0x299efc["cx"],
                    y:
                      null === (_0x1c8dcb = null == _0x2fe99c ? void 0x0 : _0x2fe99c[_0x34e7d3(0x572)]) || void 0x0 === _0x1c8dcb
                        ? void 0x0
                        : _0x1c8dcb["cy"],
                  },
                  _0x362372 = {
                    x:
                      null === (_0x2b3563 = null == _0x2fe99c ? void 0x0 : _0x2fe99c[_0x34e7d3(0x572)]) || void 0x0 === _0x2b3563
                        ? void 0x0
                        : _0x2b3563["dx"],
                    y:
                      null === (_0xdbb958 = null == _0x2fe99c ? void 0x0 : _0x2fe99c["rawData"]) || void 0x0 === _0xdbb958
                        ? void 0x0
                        : _0xdbb958["dy"],
                  };
                if (
                  (null ===
                    (_0x32caf2 =
                      null ===
                        (_0x4a4eda =
                          null ===
                            (_0x1aca46 =
                              null === _0x409f64["Z"] || void 0x0 === _0x409f64["Z"] ? void 0x0 : _0x409f64["Z"][_0x34e7d3(0x637)]) ||
                          void 0x0 === _0x1aca46
                            ? void 0x0
                            : _0x1aca46["lastSnapshot"]) || void 0x0 === _0x4a4eda
                        ? void 0x0
                        : _0x4a4eda[_0x34e7d3(0x248)]) || void 0x0 === _0x32caf2
                    ? void 0x0
                    : _0x32caf2[_0x34e7d3(0x589)]) &&
                  _0x278c05[_0x34e7d3(0x5ab)] > 0x64
                ) {
                  let _0x2a837f = "black",
                    _0x4f694b =
                      null ===
                        (_0x124591 =
                          null ===
                            (_0x389e06 =
                              null === _0x409f64["Z"] || void 0x0 === _0x409f64["Z"] ? void 0x0 : _0x409f64["Z"][_0x34e7d3(0x637)]) ||
                          void 0x0 === _0x389e06
                            ? void 0x0
                            : _0x389e06["lastSnapshot"]) || void 0x0 === _0x124591
                        ? void 0x0
                        : _0x124591[_0x34e7d3(0x248)],
                    _0x13242c = document[_0x34e7d3(0x506)](_0x34e7d3(0x5ca));
                  (_0x13242c[_0x34e7d3(0x657)] = _0x4f694b[_0x34e7d3(0x657)]), (_0x13242c[_0x34e7d3(0x39c)] = _0x4f694b[_0x34e7d3(0x39c)]);
                  let _0x1b86d9 = _0x13242c[_0x34e7d3(0x5c4)]("2d");
                  function _0x24a998(_0x4d121a, _0x57efac, _0x25ec0a, _0x5d5fda) {
                    return { x: _0x57efac, y: _0x4d121a, bh: _0x5d5fda - _0x4d121a, bw: _0x25ec0a - _0x57efac };
                  }
                  if (((_0x1b86d9[_0x34e7d3(0x3bc)] = _0x2a837f), _0x1b86d9[_0x34e7d3(0x632)](_0x4f694b, 0x0, 0x0), 0x0 === _0x174570)) {
                    (_0x1b86d9["lineWidth"] = 0x2), (_0x1b86d9[_0x34e7d3(0x54c)] = _0x2a837f), (_0x1b86d9[_0x34e7d3(0x3bc)] = _0x2a837f);
                    for (let _0xb1717a = 0x0; _0xb1717a < 0x190; _0xb1717a += 0x4)
                      if (_0xb1717a > 0x11c && _0xb1717a < 0x142) {
                        let _0x324537 = _0x24a998(
                          _0x278c05[_0xb1717a],
                          _0x278c05[_0xb1717a + 0x1],
                          _0x278c05[_0xb1717a + 0x2],
                          _0x278c05[_0xb1717a + 0x3]
                        );
                        _0x1b86d9[_0x34e7d3(0x61a)](_0x324537["x"], _0x324537["y"], _0x324537["bw"] + 0x2, _0x324537["bh"]);
                      }
                  }
                  if (0x1 === _0x174570) {
                    let _0xc6fb61 = 0x0,
                      _0x31085c = 0x0,
                      _0x1f4752 = { x: NaN, y: NaN },
                      _0x3d7d21 = _0x24a998(_0x278c05[0x0], _0x278c05[0x1], _0x278c05[0x2], _0x278c05[0x3]);
                    for (let _0x205b5e = 0x0; _0x205b5e < 0x190; _0x205b5e += 0x4)
                      if (_0x205b5e >= 0x3c && _0x205b5e < 0x60) {
                        let _0x7328ab = _0x24a998(
                          _0x278c05[_0x205b5e],
                          _0x278c05[_0x205b5e + 0x1],
                          _0x278c05[_0x205b5e + 0x2],
                          _0x278c05[_0x205b5e + 0x3]
                        );
                        _0x1b86d9[_0x34e7d3(0x61a)](_0x7328ab["x"], _0x7328ab["y"], _0x7328ab["bw"], _0x7328ab["bh"]),
                          (_0xc6fb61 += _0x7328ab["bh"]),
                          (_0x31085c += _0x7328ab["bw"]),
                          (_0x1f4752 = _0x7328ab);
                      }
                    let _0x1987e1 = _0xc6fb61 / 0x9,
                      _0xbca2aa = _0x31085c / 0x9,
                      _0x49f2a2 = _0x1987e1 > _0xbca2aa ? _0x34e7d3(0x2b1) : _0x34e7d3(0x373),
                      _0x324d1e = this[_0x34e7d3(0x28f)](_0xfb76fc, _0x1f4752),
                      _0x4485d0 = this[_0x34e7d3(0x28f)](_0x523c66, _0x1f4752);
                    if (((_0x1b86d9[_0x34e7d3(0x3bc)] = _0x2a837f), _0x34e7d3(0x2b1) == _0x49f2a2)) {
                      if (_0x324d1e > _0x4485d0) {
                        const _0x12d964 = {
                          ctx: _0x1b86d9,
                          x: _0x1f4752["x"] - 0x3 * _0xbca2aa,
                          y: _0x1f4752["y"] - 0xc * _0x1987e1,
                          width: 0xd * _0xbca2aa,
                          height: 3.4 * _0x1987e1,
                          angleInDegrees: _0x2fe99c[_0x34e7d3(0x43b)],
                          color: _0x2a837f,
                        };
                        -0x1 == Math["sign"](_0x2fe99c[_0x34e7d3(0x43b)]) && (_0x12d964["x"] = _0x12d964["x"] - 1.4 * _0xbca2aa),
                          this["drawRotatedRect"](_0x12d964);
                        const _0x1e7d03 = {
                          ctx: _0x1b86d9,
                          x: _0x3d7d21["x"] + 0x1 * _0xbca2aa,
                          y: _0x1f4752["y"] - 0x7 * _0x1987e1,
                          width: 0x7 * _0xbca2aa,
                          height: 0x7 * _0xbca2aa,
                          angleInDegrees: _0x2fe99c[_0x34e7d3(0x43b)],
                          color: _0x2a837f,
                        };
                        let _0x284987 = this[_0x34e7d3(0x39f)](
                          _0x1e7d03,
                          _0x2fe99c[_0x34e7d3(0x43b)],
                          _0xfb76fc["x"],
                          _0xfb76fc["y"],
                          _0x523c66["x"],
                          _0x523c66["y"],
                          _0x473d28["x"],
                          _0x473d28["y"],
                          _0x362372["x"],
                          _0x362372["y"]
                        );
                        (_0x1e7d03["x"] = _0x284987["x"]), (_0x1e7d03["y"] = _0x284987["y"]), this[_0x34e7d3(0x45f)](_0x1e7d03);
                      } else {
                        const _0x40b273 = {
                          ctx: _0x1b86d9,
                          x: _0x1f4752["x"] - 0x8 * _0xbca2aa,
                          y: _0x1f4752["y"] + 0xa * _0x1987e1,
                          width: 0xd * _0xbca2aa,
                          height: 0x4 * _0x1987e1,
                          angleInDegrees: _0x2fe99c["averageAngleRotation"],
                          color: _0x2a837f,
                        };
                        this[_0x34e7d3(0x45f)](_0x40b273);
                        const _0x2f79ce = {
                          ctx: _0x1b86d9,
                          x: _0x3d7d21["x"] - 0x7 * _0xbca2aa,
                          y: _0x3d7d21["y"] - -0x4 * _0x1987e1,
                          width: 0x7 * _0xbca2aa,
                          height: 0x7 * _0xbca2aa,
                          angleInDegrees: _0x2fe99c["averageAngleRotation"],
                          color: _0x2a837f,
                        };
                        let _0x13ad99 = this["rotatePoint"](
                          _0x2f79ce,
                          _0x2fe99c[_0x34e7d3(0x43b)],
                          _0xfb76fc["x"],
                          _0xfb76fc["y"],
                          _0x523c66["x"],
                          _0x523c66["y"],
                          _0x473d28["x"],
                          _0x473d28["y"],
                          _0x362372["x"],
                          _0x362372["y"],
                          0x2,
                          !0x0
                        );
                        (_0x2f79ce["x"] = _0x13ad99["x"]), (_0x2f79ce["y"] = _0x13ad99["y"]), this["drawRotatedRect"](_0x2f79ce);
                      }
                    } else {
                      if (_0x324d1e < _0x4485d0) {
                        let _0x5bdcb9 = 1.5 * _0xbca2aa;
                        -0x1 == Math[_0x34e7d3(0x592)](_0x2fe99c[_0x34e7d3(0x43b)]) && (_0x5bdcb9 = 0x3 * _0xbca2aa);
                        const _0x5328d9 = {
                          ctx: _0x1b86d9,
                          x: _0x1f4752["x"] + 0x9 * _0xbca2aa,
                          y: _0x1f4752["y"] - _0x5bdcb9,
                          width: 0x3 * _0xbca2aa,
                          height: 0xc * _0x1987e1,
                          angleInDegrees: _0x2fe99c[_0x34e7d3(0x43b)],
                          color: _0x2a837f,
                        };
                        this[_0x34e7d3(0x45f)](_0x5328d9);
                        const _0x17e3b7 = {
                          ctx: _0x1b86d9,
                          x: _0x3d7d21["x"] - -2.5 * _0xbca2aa,
                          y: _0x3d7d21["y"] - 0x0 * _0x1987e1,
                          width: 0x6 * _0xbca2aa,
                          height: 0x6 * _0xbca2aa,
                          angleInDegrees: _0x2fe99c[_0x34e7d3(0x43b)],
                          color: _0x2a837f,
                        };
                        let _0x556920 = this[_0x34e7d3(0x39f)](
                          _0x17e3b7,
                          _0x2fe99c[_0x34e7d3(0x43b)],
                          _0xfb76fc["x"],
                          _0xfb76fc["y"],
                          _0x523c66["x"],
                          _0x523c66["y"],
                          _0x473d28["x"],
                          _0x473d28["y"],
                          _0x362372["x"],
                          _0x362372["y"],
                          -0x3,
                          !0x1
                        );
                        (_0x17e3b7["x"] = _0x556920["x"]), (_0x17e3b7["y"] = _0x556920["y"]), this["drawRotatedRect"](_0x17e3b7);
                      } else {
                        const _0x37e3a3 = {
                          ctx: _0x1b86d9,
                          x: _0x1f4752["x"] - 0xb * _0xbca2aa,
                          y: _0x1f4752["y"] - 0x5 * _0xbca2aa,
                          width: 0x3 * _0xbca2aa,
                          height: 0xc * _0x1987e1,
                          angleInDegrees: _0x2fe99c[_0x34e7d3(0x43b)],
                          color: _0x2a837f,
                        };
                        this[_0x34e7d3(0x226)](_0x2fe99c[_0x34e7d3(0x43b)]) || (_0x37e3a3["y"] = _0x37e3a3["y"] = 4.2 * _0xbca2aa),
                          this[_0x34e7d3(0x45f)](_0x37e3a3);
                        const _0x1d5978 = {
                          ctx: _0x1b86d9,
                          x: _0x3d7d21["x"] - 7.5 * _0xbca2aa,
                          y: _0x3d7d21["y"] - 7.5 * _0x1987e1,
                          width: 0x6 * _0xbca2aa,
                          height: 0x6 * _0xbca2aa,
                          angleInDegrees: _0x2fe99c[_0x34e7d3(0x43b)],
                          color: _0x2a837f,
                        };
                        let _0x41c7d6 = this["rotatePoint"](
                          _0x1d5978,
                          _0x2fe99c[_0x34e7d3(0x43b)],
                          _0xfb76fc["x"],
                          _0xfb76fc["y"],
                          _0x523c66["x"],
                          _0x523c66["y"],
                          _0x473d28["x"],
                          _0x473d28["y"],
                          _0x362372["x"],
                          _0x362372["y"],
                          -0x2,
                          !0x1
                        );
                        (_0x1d5978["x"] = _0x41c7d6["x"]), (_0x1d5978["y"] = _0x41c7d6["y"]), this["drawRotatedRect"](_0x1d5978);
                      }
                    }
                  }
                  if (
                    null ===
                      (_0x59b296 =
                        null ===
                          (_0x272c4b =
                            null === _0x409f64["Z"] || void 0x0 === _0x409f64["Z"] ? void 0x0 : _0x409f64["Z"]["currentAction"]) ||
                        void 0x0 === _0x272c4b
                          ? void 0x0
                          : _0x272c4b[_0x34e7d3(0x372)]) || void 0x0 === _0x59b296
                      ? void 0x0
                      : _0x59b296[_0x34e7d3(0x248)]
                  ) {
                    let _0x22819b = _0x1b86d9[_0x34e7d3(0x231)](0x0, 0x0, _0x4f694b["width"], _0x4f694b[_0x34e7d3(0x39c)]);
                    (_0x409f64["Z"]["currentAction"]["lastSnapshot"][_0x34e7d3(0x248)] = _0x22819b), _0x409f64["Z"][_0x34e7d3(0x200)](!0x0);
                  }
                }
              }
              [_0x4067e7(0x226)](_0x1fce58) {
                return _0x1fce58 < 0x0 ? -0x1 : 0x1;
              }
              [_0x4067e7(0x39f)](
                _0x3349b8,
                _0x17e083,
                _0x3a1332,
                _0x1f26fa,
                _0x5025f8,
                _0x239bb4,
                _0x2c38a8,
                _0x19dcb5,
                _0x5c0c12,
                _0x36836d,
                _0x42a95d = 0x3,
                _0x201dd6 = !0x1
              ) {
                const _0x148c50 = _0x4067e7,
                  { x: _0x4b3a60, y: _0x3737b9 } = _0x3349b8;
                let _0x186ab1 = _0x17e083 * (Math["PI"] / 0xb4),
                  _0x500830 =
                    this[_0x148c50(0x226)](_0x186ab1) *
                    (Math[_0x148c50(0x661)](_0x186ab1) + _0x42a95d * Math[_0x148c50(0x714)](_0x186ab1, 0x2));
                _0x201dd6 && (_0x500830 *= -0x1);
                const _0x5850d6 = (_0x3a1332 + _0x5025f8 + _0x2c38a8 + _0x5c0c12) / 0x4,
                  _0x361d33 = (_0x1f26fa + _0x239bb4 + _0x19dcb5 + _0x36836d) / 0x4;
                return {
                  x:
                    _0x5850d6 +
                    (_0x4b3a60 - _0x5850d6) * Math[_0x148c50(0x50b)](_0x500830) -
                    (_0x3737b9 - _0x361d33) * Math["sin"](_0x500830),
                  y:
                    _0x361d33 +
                    (_0x4b3a60 - _0x5850d6) * Math[_0x148c50(0x458)](_0x500830) +
                    (_0x3737b9 - _0x361d33) * Math["cos"](_0x500830),
                };
              }
              ["drawRotatedRect"](_0x3611dd) {
                const _0x427cdb = _0x4067e7,
                  {
                    ctx: _0x44e2ef,
                    x: _0x2f7f31,
                    y: _0x2fed62,
                    width: _0x132c4c,
                    height: _0x3038b1,
                    color: _0x550200,
                    angleInDegrees: _0x1d0c60,
                  } = _0x3611dd;
                (_0x44e2ef["fillStyle"] = _0x550200),
                  _0x44e2ef[_0x427cdb(0x2ce)](),
                  _0x44e2ef[_0x427cdb(0x4e0)](_0x2f7f31 + _0x132c4c / 0x2, _0x2fed62 + _0x3038b1 / 0x2),
                  _0x44e2ef["rotate"]((_0x1d0c60 * Math["PI"]) / 0xb4),
                  _0x44e2ef[_0x427cdb(0x61a)](-_0x132c4c / 0x2, -_0x3038b1 / 0x2, _0x132c4c, _0x3038b1),
                  (_0x44e2ef[_0x427cdb(0x500)] = 0x1),
                  _0x44e2ef[_0x427cdb(0x5b4)]();
              }
              [_0x4067e7(0x28f)](_0x490b63, _0x95d2e5) {
                const _0x3565d5 = _0x4067e7;
                return Math[_0x3565d5(0x522)](
                  Math[_0x3565d5(0x714)](_0x95d2e5["x"] - _0x490b63["x"], 0x2) + Math["pow"](_0x95d2e5["y"] - _0x490b63["y"], 0x2)
                );
              }
              [_0x4067e7(0x4e8)](_0x51ca73) {
                const _0x319bf9 = _0x4067e7,
                  {
                    ax: _0x4e0075,
                    ay: _0x1f0a9d,
                    bx: _0x44af11,
                    by: _0x5cfd63,
                    cx: _0x29f528,
                    cy: _0x485187,
                    dx: _0x107c26,
                    dy: _0x2601de,
                  } = _0x51ca73;
                function _0x5914c7(_0x2bb90c, _0xc73b82, _0x250437, _0x5ae518) {
                  const _0x3f1c7c = a0_0x1b49;
                  let _0x3a5f18 = _0x250437 - _0x2bb90c,
                    _0x4d05ef = _0x5ae518 - _0xc73b82,
                    _0x433c66 = Math[_0x3f1c7c(0x522)](_0x3a5f18 * _0x3a5f18 + _0x4d05ef * _0x4d05ef);
                  (_0x3a5f18 /= _0x433c66), (_0x4d05ef /= _0x433c66);
                  let _0x5ed571 = Math[_0x3f1c7c(0x538)](_0x3a5f18) * (0xb4 / Math["PI"]);
                  return _0x4d05ef < 0x0 && (_0x5ed571 = 0x168 - _0x5ed571), _0x5ed571 > 0xb4 && (_0x5ed571 -= 0x168), _0x5ed571;
                }
                let _0x39fa23 = _0x5914c7(_0x4e0075, _0x1f0a9d, _0x44af11, _0x5cfd63),
                  _0x5d8cf9 = _0x5914c7(_0x44af11, _0x5cfd63, _0x29f528, _0x485187) - 0x5a,
                  _0x3dcf7d = _0x5914c7(_0x29f528, _0x485187, _0x107c26, _0x2601de) - 0xb4,
                  _0x341cd1 = _0x5914c7(_0x107c26, _0x2601de, _0x4e0075, _0x1f0a9d) - 0x10e,
                  _0xe5a4ea = (_0x39fa23 + _0x5d8cf9) / 0x2;
                return (
                  _0xe5a4ea &&
                    (_0x51ca73[_0x319bf9(0x34a)] = {
                      angleAB: _0x39fa23,
                      angleBC: _0x5d8cf9,
                      angleCD: _0x3dcf7d,
                      angleDA: _0x341cd1,
                      ofssetAngleAverage: _0xe5a4ea,
                    }),
                  _0xe5a4ea
                );
              }
            })();
            var _0x2f9c0f = _0x33dbda(0x2e4),
              _0x12ae57 = function (_0x12b824, _0x1b6449, _0x4e15b1, _0x144023) {
                return new (_0x4e15b1 || (_0x4e15b1 = Promise))(function (_0x28d781, _0x5440e) {
                  const _0x3278db = a0_0x1b49;
                  function _0x911bf4(_0x3f92f4) {
                    try {
                      _0x447b0f(_0x144023["next"](_0x3f92f4));
                    } catch (_0x4eed2f) {
                      _0x5440e(_0x4eed2f);
                    }
                  }
                  function _0x2916e9(_0xaa8f39) {
                    const _0x36e497 = a0_0x1b49;
                    try {
                      _0x447b0f(_0x144023[_0x36e497(0x3b2)](_0xaa8f39));
                    } catch (_0x59ef80) {
                      _0x5440e(_0x59ef80);
                    }
                  }
                  function _0x447b0f(_0x215986) {
                    const _0x1ffd1f = a0_0x1b49;
                    var _0x2574b6;
                    _0x215986[_0x1ffd1f(0x4f5)]
                      ? _0x28d781(_0x215986[_0x1ffd1f(0x331)])
                      : ((_0x2574b6 = _0x215986[_0x1ffd1f(0x331)]),
                        _0x2574b6 instanceof _0x4e15b1
                          ? _0x2574b6
                          : new _0x4e15b1(function (_0x3bd462) {
                              _0x3bd462(_0x2574b6);
                            }))[_0x1ffd1f(0x429)](_0x911bf4, _0x2916e9);
                  }
                  _0x447b0f((_0x144023 = _0x144023[_0x3278db(0x1d1)](_0x12b824, _0x1b6449 || []))[_0x3278db(0x3e1)]());
                });
              };
            new _0x3da364("app:recognizer:barcode");
            const _0x2feff0 = new (class {
              constructor() {
                const _0x3a508a = _0x4067e7;
                this[_0x3a508a(0x323)] = !0x1;
              }
              ["getBarcodeLicenseTypeAndPath"]() {
                return _0x12ae57(this, void 0x0, void 0x0, function* () {
                  const _0x1919bd = a0_0x1b49,
                    _0x31e930 = _0x2f9c0f["Z"][_0x1919bd(0x497)]();
                  let _0x1510dc;
                  return _0x31e930
                    ? { licenseType: 0x0, value: _0x31e930 }
                    : (_0x1510dc = yield _0x2f9c0f["Z"][_0x1919bd(0x484)]())
                    ? { licenseType: 0x1, value: yield _0x1510dc }
                    : Promise["resolve"]({ licenseType: 0x2, value: "" });
                });
              }
              [_0x4067e7(0x660)]() {
                return _0x12ae57(this, void 0x0, void 0x0, function* () {
                  const _0x2e9f7c = a0_0x1b49;
                  return (
                    !this[_0x2e9f7c(0x3db)] &&
                    ((this[_0x2e9f7c(0x3db)] = !0x0),
                    Promise["all"]([
                      _0x33dbda["e"](0x279)[_0x2e9f7c(0x429)](_0x33dbda[_0x2e9f7c(0x23e)](_0x33dbda, 0x303)),
                      _0x33dbda["e"](0x196)["then"](_0x33dbda["t"]["bind"](_0x33dbda, 0x294, 0x17)),
                    ])
                      [_0x2e9f7c(0x429)](
                        ([{ default: _0x20f394 }, { default: _0x1c2472 }]) => (
                          (this[_0x2e9f7c(0x5cb)] = _0x20f394),
                          (_0x33dbda["g"]["Module"] = _0x20f394[_0x2e9f7c(0x5b5)]),
                          new Promise((_0x500b90, _0x198362) => {
                            try {
                              setTimeout(() => {
                                const _0xd4e475 = a0_0x1b49;
                                _0x1c2472[_0xd4e475(0x551)](_0x20f394[_0xd4e475(0x662)]),
                                  _0x20f394[_0xd4e475(0x272)](_0x1c2472[_0xd4e475(0x1f0)]),
                                  _0x1c2472[_0xd4e475(0x1f0)]()[_0xd4e475(0x429)]((_0x16c482) => {
                                    const _0x1a574e = _0xd4e475;
                                    this[_0x1a574e(0x544)]()[_0x1a574e(0x429)]((_0x336d40) => {
                                      const _0x353636 = _0x1a574e;
                                      0x0 === (null == _0x336d40 ? void 0x0 : _0x336d40[_0x353636(0x6db)])
                                        ? _0x20f394[_0x353636(0x662)][_0x353636(0x574)](
                                            null == _0x336d40 ? void 0x0 : _0x336d40[_0x353636(0x331)]
                                          )
                                        : 0x1 === _0x336d40[_0x353636(0x6db)]
                                        ? _0x20f394[_0x353636(0x662)][_0x353636(0x667)](
                                            null == _0x336d40 ? void 0x0 : _0x336d40[_0x353636(0x331)]
                                          )
                                        : _0x198362(new _0x3b1c1e["Z"](_0x353636(0x581), new Error())),
                                        setTimeout(() => {
                                          _0x500b90(!0x0);
                                        }, 0x3e8);
                                    });
                                  });
                              }, 0x320);
                            } catch (_0x140432) {
                              _0x198362(_0x140432);
                            }
                          })["catch"]((_0x54e73e) => Promise[_0x2e9f7c(0x34e)](_0x54e73e))
                        )
                      )
                      [_0x2e9f7c(0x429)]((_0x3746e2) => !0x0)
                      [_0x2e9f7c(0x38b)]((_0x1d77ff) => Promise[_0x2e9f7c(0x34e)](_0x1d77ff)))
                  );
                });
              }
              [_0x4067e7(0x388)](_0x9d615f, _0x569e1a) {
                return _0x12ae57(this, void 0x0, void 0x0, function* () {
                  const _0x2a65db = a0_0x1b49;
                  try {
                    this[_0x2a65db(0x323)] || (this[_0x2a65db(0x323)] = yield this[_0x2a65db(0x660)]());
                    const _0xa8a75f = yield new Promise((_0x3c85ac, _0x4af082) => {
                      const _0x2e50ea = _0x2a65db;
                      let _0x9e8aa0 = function (_0x3986ed) {
                        _0x3c85ac(_0x3986ed);
                      };
                      try {
                        this[_0x2e50ea(0x5cb)][_0x2e50ea(0x662)][_0x2e50ea(0x58b)](_0x9d615f[_0x2e50ea(0x1bf)]["imageData"], _0x9e8aa0);
                      } catch (_0x42c06e) {
                        _0x4af082(_0x42c06e);
                      }
                    })[_0x2a65db(0x38b)]((_0x4ec35c) => {
                      const _0x503d71 = _0x2a65db;
                      throw new _0x3b1c1e["Z"](_0x503d71(0x302), _0x4ec35c);
                    });
                    return {
                      isFailure: !_0xa8a75f,
                      imageWidth: _0x9d615f["snapshot"][_0x2a65db(0x248)][_0x2a65db(0x657)],
                      imageHeight: _0x9d615f[_0x2a65db(0x1bf)]["imageData"][_0x2a65db(0x39c)],
                      imageDimensions: _0x11c06d[_0x2a65db(0x203)](_0x9d615f[_0x2a65db(0x1bf)]["imageData"]),
                      rawData: _0xa8a75f,
                      snapShotId: _0x569e1a,
                    };
                  } catch (_0x45eeeb) {
                    if (_0x45eeeb instanceof _0x3b1c1e["Z"]) throw _0x45eeeb;
                    return {
                      isFailure: !0x0,
                      imageWidth: 0x0,
                      imageHeight: 0x0,
                      imageDimensions: _0x11c06d[_0x2a65db(0x203)](_0x9d615f[_0x2a65db(0x1bf)][_0x2a65db(0x248)]),
                      rawData: void 0x0,
                      snapShotId: _0x569e1a,
                      caughtError: new Error(_0x45eeeb),
                    };
                  }
                });
              }
              ["reset"]() {
                return _0x12ae57(this, void 0x0, void 0x0, function* () {
                  return !0x0;
                });
              }
            })();
            var _0x4b0c1d = function (_0x3480b6, _0x580022, _0x30a54e, _0x3da438) {
              return new (_0x30a54e || (_0x30a54e = Promise))(function (_0x23f744, _0xd4262c) {
                const _0x4c0112 = a0_0x1b49;
                function _0x5e51b5(_0x1ceaff) {
                  try {
                    _0x30b969(_0x3da438["next"](_0x1ceaff));
                  } catch (_0x207048) {
                    _0xd4262c(_0x207048);
                  }
                }
                function _0x1e7d84(_0xfa6679) {
                  const _0xc410e6 = a0_0x1b49;
                  try {
                    _0x30b969(_0x3da438[_0xc410e6(0x3b2)](_0xfa6679));
                  } catch (_0x31ae6d) {
                    _0xd4262c(_0x31ae6d);
                  }
                }
                function _0x30b969(_0x2c7fd3) {
                  const _0x28eba9 = a0_0x1b49;
                  var _0x52108b;
                  _0x2c7fd3[_0x28eba9(0x4f5)]
                    ? _0x23f744(_0x2c7fd3["value"])
                    : ((_0x52108b = _0x2c7fd3[_0x28eba9(0x331)]),
                      _0x52108b instanceof _0x30a54e
                        ? _0x52108b
                        : new _0x30a54e(function (_0x369431) {
                            _0x369431(_0x52108b);
                          }))["then"](_0x5e51b5, _0x1e7d84);
                }
                _0x30b969((_0x3da438 = _0x3da438[_0x4c0112(0x1d1)](_0x3480b6, _0x580022 || []))[_0x4c0112(0x3e1)]());
              });
            };
            new _0x3da364(_0x4067e7(0x5bc));
            const _0x3de0ad = new (class {
              constructor() {
                const _0x3ed7d6 = _0x4067e7;
                (this[_0x3ed7d6(0x67f)] = !0x1),
                  (this["isLoaded"] = !0x1),
                  (this[_0x3ed7d6(0x378)] = !0x1),
                  (this[_0x3ed7d6(0x58f)] = !0x1);
              }
              ["getPathForSelfieFiles"]() {
                const _0x5e8089 = _0x4067e7;
                var _0x3c94a9, _0x5289b1;
                return (
                  (null ===
                    (_0x5289b1 =
                      null ===
                        (_0x3c94a9 =
                          null === _0x409f64["Z"] || void 0x0 === _0x409f64["Z"] ? void 0x0 : _0x409f64["Z"][_0x5e8089(0x637)]) ||
                      void 0x0 === _0x3c94a9
                        ? void 0x0
                        : _0x3c94a9[_0x5e8089(0x403)]) || void 0x0 === _0x5289b1
                    ? void 0x0
                    : _0x5289b1[_0x5e8089(0x64d)]) ||
                  (null === _0x409f64["Z"] || void 0x0 === _0x409f64["Z"] ? void 0x0 : _0x409f64["Z"][_0x5e8089(0x3f4)]) ||
                  (null === _0x409f64["Z"] || void 0x0 === _0x409f64["Z"] ? void 0x0 : _0x409f64["Z"][_0x5e8089(0x5dd)])
                );
              }
              [_0x4067e7(0x660)]() {
                return _0x4b0c1d(this, void 0x0, void 0x0, function* () {
                  const _0x273664 = a0_0x1b49;
                  try {
                    return (
                      this["setWebGLCompileErrorListener"](),
                      (this[_0x273664(0x2ec)] = yield Promise[_0x273664(0x4f0)]([_0x33dbda["e"](0x172), _0x33dbda["e"](0xc0)])[
                        _0x273664(0x429)
                      ](_0x33dbda[_0x273664(0x23e)](_0x33dbda, 0x172))),
                      !0x0
                    );
                  } catch (_0x2d2d6e) {
                    return Promise[_0x273664(0x34e)](_0x2d2d6e);
                  }
                });
              }
              [_0x4067e7(0x409)]() {
                return _0x4b0c1d(this, void 0x0, void 0x0, function* () {
                  const _0x4d76cc = a0_0x1b49;
                  try {
                    return !!(yield Promise["all"]([
                      this[_0x4d76cc(0x2ec)][_0x4d76cc(0x6d0)][_0x4d76cc(0x31c)][_0x4d76cc(0x571)](this["getPathForSelfieFiles"]()),
                      this["faceapi"][_0x4d76cc(0x6d0)][_0x4d76cc(0x628)]["loadFromUri"](this[_0x4d76cc(0x322)]()),
                    ]));
                  } catch (_0x113ad8) {
                    return Promise["reject"](_0x113ad8);
                  }
                });
              }
              [_0x4067e7(0x33f)]() {
                return _0x4b0c1d(this, void 0x0, void 0x0, function* () {
                  const _0x1b1cf3 = a0_0x1b49;
                  try {
                    return (
                      yield this[_0x1b1cf3(0x2ec)][_0x1b1cf3(0x6d0)][_0x1b1cf3(0x1ed)][_0x1b1cf3(0x571)](this[_0x1b1cf3(0x322)]()), !0x0
                    );
                  } catch (_0x1a4359) {
                    return Promise[_0x1b1cf3(0x34e)](_0x1a4359);
                  }
                });
              }
              ["getSobelBlurDetection"](_0x20ca3a) {
                const _0xbdce90 = _0x4067e7;
                let _0x26a8ec = _0x20ca3a[_0xbdce90(0x657)] || 0x0,
                  _0xf1876e = _0x20ca3a[_0xbdce90(0x39c)] || 0x0,
                  _0x192506 = new Uint8Array(_0x26a8ec * _0xf1876e),
                  _0x67aa08 = 0x0;
                for (let _0x1e0934 = 0x0; _0x1e0934 < _0x20ca3a[_0xbdce90(0x589)][_0xbdce90(0x5ab)]; _0x1e0934 += 0x4) {
                  let _0x180d3f =
                    (_0x20ca3a[_0xbdce90(0x589)][_0x1e0934] +
                      _0x20ca3a[_0xbdce90(0x589)][_0x1e0934 + 0x1] +
                      _0x20ca3a["data"][_0x1e0934 + 0x2]) /
                    0x3;
                  _0x192506[_0x1e0934 / 0x4] = _0x180d3f;
                }
                for (let _0x2101cc = 0x1; _0x2101cc < _0xf1876e - 0x1; _0x2101cc++)
                  for (let _0x5628c0 = 0x1; _0x5628c0 < _0x26a8ec - 0x1; _0x5628c0++) {
                    let _0xb1a3fd = _0x2101cc * _0x26a8ec + _0x5628c0,
                      _0x4b97a6 =
                        -0x1 * _0x192506[_0xb1a3fd - _0x26a8ec - 0x1] +
                        0x1 * _0x192506[_0xb1a3fd - _0x26a8ec + 0x1] +
                        -0x2 * _0x192506[_0xb1a3fd - 0x1] +
                        0x2 * _0x192506[_0xb1a3fd + 0x1] +
                        -0x1 * _0x192506[_0xb1a3fd + _0x26a8ec - 0x1] +
                        0x1 * _0x192506[_0xb1a3fd + _0x26a8ec + 0x1],
                      _0x5d48f4 =
                        -0x1 * _0x192506[_0xb1a3fd - _0x26a8ec - 0x1] -
                        0x2 * _0x192506[_0xb1a3fd - _0x26a8ec] -
                        0x1 * _0x192506[_0xb1a3fd - _0x26a8ec + 0x1] +
                        0x1 * _0x192506[_0xb1a3fd + _0x26a8ec - 0x1] +
                        0x2 * _0x192506[_0xb1a3fd + _0x26a8ec] +
                        0x1 * _0x192506[_0xb1a3fd + _0x26a8ec + 0x1];
                    _0x67aa08 += Math[_0xbdce90(0x522)](_0x4b97a6 * _0x4b97a6 + _0x5d48f4 * _0x5d48f4);
                  }
                return _0x67aa08 / ((_0x26a8ec - 0x2) * (_0xf1876e - 0x2));
              }
              ["recognize"](_0x532669, _0x3844b5) {
                var _0x157c48, _0x361004, _0x56d521, _0x5b48a8, _0x599c78, _0xd67a28;
                return _0x4b0c1d(this, void 0x0, void 0x0, function* () {
                  const _0x377d73 = a0_0x1b49;
                  this[_0x377d73(0x67f)] =
                    _0x377d73(0x548) ===
                      (null ===
                        (_0x361004 =
                          null === (_0x157c48 = _0x409f64["Z"][_0x377d73(0x637)]) || void 0x0 === _0x157c48
                            ? void 0x0
                            : _0x157c48[_0x377d73(0x452)]) || void 0x0 === _0x361004
                        ? void 0x0
                        : _0x361004[_0x377d73(0x400)]) &&
                    !(null ===
                      (_0x5b48a8 =
                        null === (_0x56d521 = _0x409f64["Z"][_0x377d73(0x637)]) || void 0x0 === _0x56d521
                          ? void 0x0
                          : _0x56d521[_0x377d73(0x403)]) || void 0x0 === _0x5b48a8
                      ? void 0x0
                      : _0x5b48a8[_0x377d73(0x2d0)]);
                  try {
                    this[_0x377d73(0x323)] || (this[_0x377d73(0x323)] = yield this[_0x377d73(0x660)]()),
                      this[_0x377d73(0x378)] || (this["areDefaultModelsLoaded"] = yield this[_0x377d73(0x409)]()),
                      this["isSmileDetectionEnabled"] &&
                        !this["areFacialExpressionModelsLoaded"] &&
                        (this["areFacialExpressionModelsLoaded"] = yield this[_0x377d73(0x33f)]());
                    const _0x3ccd0f = _0x11c06d["reuseCanvasWithNewImage"](_0x532669["snapshot"]["imageData"]),
                      _0x4a4be1 = new this[_0x377d73(0x2ec)]["TinyFaceDetectorOptions"]({
                        inputSize: _0x532669["tinyFaceDetectorSettings"][_0x377d73(0x3dd)],
                        scoreThreshold: _0x532669[_0x377d73(0x5a1)][_0x377d73(0x474)],
                      });
                    switch (
                      null ===
                        (_0xd67a28 =
                          null ===
                            (_0x599c78 =
                              null === _0x409f64["Z"] || void 0x0 === _0x409f64["Z"] ? void 0x0 : _0x409f64["Z"][_0x377d73(0x637)]) ||
                          void 0x0 === _0x599c78
                            ? void 0x0
                            : _0x599c78[_0x377d73(0x452)]) || void 0x0 === _0xd67a28
                        ? void 0x0
                        : _0xd67a28["actionMode"]
                    ) {
                      case _0x377d73(0x548):
                        this[_0x377d73(0x2ec)]["tf"][_0x377d73(0x1b7)](_0x377d73(0x6fe));
                        break;
                      case _0x377d73(0x54b):
                        this["faceapi"]["tf"][_0x377d73(0x1b7)](_0x377d73(0x471));
                        break;
                      default:
                        this[_0x377d73(0x2ec)]["tf"][_0x377d73(0x1b7)](_0x377d73(0x471));
                    }
                    let _0x1bb305;
                    return (
                      _0x409f64["Z"]["appConfig"][_0x377d73(0x218)][_0x377d73(0x2fa)] &&
                        this[_0x377d73(0x2ec)]["tf"]["ENV"][_0x377d73(0x2f4)](_0x377d73(0x4cc), !0x1),
                      (_0x1bb305 = this[_0x377d73(0x67f)]
                        ? yield this[_0x377d73(0x2ec)][_0x377d73(0x4de)](_0x3ccd0f, _0x4a4be1)[_0x377d73(0x367)](!0x0)[_0x377d73(0x524)]()
                        : yield this[_0x377d73(0x2ec)]["detectSingleFace"](_0x3ccd0f, _0x4a4be1)[_0x377d73(0x367)](!0x0)),
                      {
                        isFailure: !_0x1bb305,
                        imageWidth: _0x3ccd0f[_0x377d73(0x657)],
                        imageHeight: _0x3ccd0f[_0x377d73(0x39c)],
                        rawData: _0x1bb305,
                        snapShotId: _0x3844b5,
                        imageDimensions: _0x11c06d["getDimensionsFromImage"](_0x532669[_0x377d73(0x1bf)][_0x377d73(0x248)]),
                        sobelBlurLevel: this["getSobelBlurDetection"](this[_0x377d73(0x1e8)](_0x3ccd0f, _0x1bb305)),
                      }
                    );
                  } catch (_0x3eabc6) {
                    return {
                      isFailure: !0x0,
                      imageWidth: 0x0,
                      imageHeight: 0x0,
                      rawData: void 0x0,
                      snapShotId: _0x3844b5,
                      imageDimensions: _0x11c06d[_0x377d73(0x203)](_0x532669[_0x377d73(0x1bf)]["imageData"]),
                      sobelBlurLevel: void 0x0,
                      caughtError: new Error(_0x3eabc6),
                    };
                  }
                });
              }
              ["reset"]() {
                return _0x4b0c1d(this, void 0x0, void 0x0, function* () {
                  const _0x21776d = a0_0x1b49;
                  return this[_0x21776d(0x5d6)](), !0x0;
                });
              }
              [_0x4067e7(0x1e8)](_0x22200f, _0x1cb4de) {
                const _0x210993 = _0x4067e7;
                var _0x5d2970;
                let _0x4c3fbd = new ImageData(0x1, 0x1);
                if (
                  null === (_0x5d2970 = null == _0x1cb4de ? void 0x0 : _0x1cb4de[_0x210993(0x4f8)]) || void 0x0 === _0x5d2970
                    ? void 0x0
                    : _0x5d2970[_0x210993(0x4b7)]
                ) {
                  const _0x5474d2 = _0x1cb4de[_0x210993(0x4f8)]["box"][_0x210993(0x4da)]();
                  _0x4c3fbd = _0x22200f[_0x210993(0x5c4)]("2d", { willReadFrequently: !0x0 })[_0x210993(0x231)](
                    _0x5474d2["x"],
                    _0x5474d2["y"],
                    _0x5474d2[_0x210993(0x657)],
                    _0x5474d2["height"]
                  );
                }
                return _0x4c3fbd;
              }
              [_0x4067e7(0x557)](_0x5f20cc) {
                const _0x5ac1c7 = _0x4067e7;
                try {
                  (null == _0x5f20cc ? void 0x0 : _0x5f20cc["reason"]) &&
                    new String(_0x5f20cc[_0x5ac1c7(0x51a)])["includes"](_0x5ac1c7(0x2bd)) &&
                    (_0x5f20cc[_0x5ac1c7(0x5a3)](),
                    _0x411080["forceAutocaptureToStopWithError"](_0x5ac1c7(0x491)),
                    _0x411080[_0x5ac1c7(0x29e)](_0x5ac1c7(0x491)),
                    _0x411080[_0x5ac1c7(0x57e)]());
                } catch (_0x13ae0e) {
                  console[_0x5ac1c7(0x677)]("RUNTIME_WEBGL_NOT_SUPPORTED");
                }
              }
              [_0x4067e7(0x65b)]() {
                const _0x18bd9c = _0x4067e7;
                window[_0x18bd9c(0x307)](_0x18bd9c(0x28a), this["unhandledPromiseRejectionCallback"], { once: !0x0 });
              }
              [_0x4067e7(0x5d6)]() {
                const _0x36c2d2 = _0x4067e7;
                window[_0x36c2d2(0x614)](_0x36c2d2(0x28a), this[_0x36c2d2(0x557)]);
              }
            })();
            var _0x556f5c = function (_0x5033d8, _0x2fd049, _0x3cd5c6, _0x3fa3df) {
              return new (_0x3cd5c6 || (_0x3cd5c6 = Promise))(function (_0x168acc, _0x17ea4a) {
                const _0x48403a = a0_0x1b49;
                function _0x40b156(_0x4430c7) {
                  try {
                    _0x3aff4c(_0x3fa3df["next"](_0x4430c7));
                  } catch (_0x392eff) {
                    _0x17ea4a(_0x392eff);
                  }
                }
                function _0x5c47ac(_0x35e98f) {
                  const _0x3d29b5 = a0_0x1b49;
                  try {
                    _0x3aff4c(_0x3fa3df[_0x3d29b5(0x3b2)](_0x35e98f));
                  } catch (_0x91fcf3) {
                    _0x17ea4a(_0x91fcf3);
                  }
                }
                function _0x3aff4c(_0x163476) {
                  const _0x2948a7 = a0_0x1b49;
                  var _0x48e9ce;
                  _0x163476[_0x2948a7(0x4f5)]
                    ? _0x168acc(_0x163476[_0x2948a7(0x331)])
                    : ((_0x48e9ce = _0x163476[_0x2948a7(0x331)]),
                      _0x48e9ce instanceof _0x3cd5c6
                        ? _0x48e9ce
                        : new _0x3cd5c6(function (_0x595a2b) {
                            _0x595a2b(_0x48e9ce);
                          }))[_0x2948a7(0x429)](_0x40b156, _0x5c47ac);
                }
                _0x3aff4c((_0x3fa3df = _0x3fa3df[_0x48403a(0x1d1)](_0x5033d8, _0x2fd049 || []))[_0x48403a(0x3e1)]());
              });
            };
            const _0x3ca153 = new (class {
              constructor() {
                const _0x24ccf0 = _0x4067e7;
                this[_0x24ccf0(0x685)], (this[_0x24ccf0(0x323)] = !0x1);
              }
              [_0x4067e7(0x4ab)]() {
                return _0x556f5c(this, void 0x0, void 0x0, function* () {
                  const _0x24d768 = a0_0x1b49;
                  try {
                    return this[_0x24d768(0x323)] && (this[_0x24d768(0x323)] = !0x1), !0x0;
                  } catch (_0x5375f3) {
                    throw new _0x3b1c1e["Z"](_0x24d768(0x6ff), _0x5375f3);
                  }
                });
              }
              [_0x4067e7(0x660)]() {
                return _0x556f5c(this, void 0x0, void 0x0, function* () {
                  const _0x1b63ba = a0_0x1b49;
                  try {
                    return (
                      this[_0x1b63ba(0x685)] ||
                        (this[_0x1b63ba(0x685)] = yield _0x33dbda["e"](0xce)["then"](_0x33dbda["bind"](_0x33dbda, 0x1ca))),
                      (this[_0x1b63ba(0x5fa)] = new this["voiceRecognizerModule"][_0x1b63ba(0x715)]()),
                      yield this[_0x1b63ba(0x5fa)][_0x1b63ba(0x6e2)](),
                      !0x0
                    );
                  } catch (_0x10a12f) {
                    throw _0x10a12f;
                  }
                });
              }
              [_0x4067e7(0x5c8)](_0x47630a) {
                return _0x556f5c(this, void 0x0, void 0x0, function* () {
                  return yield new Promise((_0x50f1b8, _0x3ce590) => {
                    const _0x1e3a2d = a0_0x1b49;
                    try {
                      _0x50f1b8(this["voiceRecognizerInstance"][_0x1e3a2d(0x388)](_0x47630a));
                    } catch (_0x1bb570) {
                      _0x3ce590(_0x1bb570);
                    }
                  });
                });
              }
              [_0x4067e7(0x388)](_0x598bf5, _0x12eeb9) {
                return _0x556f5c(this, void 0x0, void 0x0, function* () {
                  const _0x4bd2c0 = a0_0x1b49;
                  try {
                    this["isLoaded"] || (this[_0x4bd2c0(0x323)] = yield this[_0x4bd2c0(0x660)]());
                    const _0x282c7c = yield this[_0x4bd2c0(0x5c8)](_0x598bf5);
                    return { isFailure: !_0x282c7c, rawData: _0x282c7c, snapShotId: _0x12eeb9 };
                  } catch (_0x16d291) {
                    if (_0x16d291 instanceof _0x3b1c1e["Z"]) throw _0x16d291;
                    return { isFailure: !0x0, rawData: void 0x0, snapShotId: _0x12eeb9, caughtError: new Error(_0x16d291) };
                  }
                });
              }
            })();
            var _0x113b0a = function (_0x3fcc14, _0x42a0ba, _0x4ce645, _0x3700b5) {
              return new (_0x4ce645 || (_0x4ce645 = Promise))(function (_0x3f246a, _0x2ec6c1) {
                const _0x49f72e = a0_0x1b49;
                function _0x538f94(_0x3f2397) {
                  const _0xe61d39 = a0_0x1b49;
                  try {
                    _0x488958(_0x3700b5[_0xe61d39(0x3e1)](_0x3f2397));
                  } catch (_0x2a9db9) {
                    _0x2ec6c1(_0x2a9db9);
                  }
                }
                function _0x34170f(_0x50acb8) {
                  const _0x59a8e2 = a0_0x1b49;
                  try {
                    _0x488958(_0x3700b5[_0x59a8e2(0x3b2)](_0x50acb8));
                  } catch (_0x1aef2f) {
                    _0x2ec6c1(_0x1aef2f);
                  }
                }
                function _0x488958(_0x2f1458) {
                  const _0x2d4ab2 = a0_0x1b49;
                  var _0x3a5972;
                  _0x2f1458[_0x2d4ab2(0x4f5)]
                    ? _0x3f246a(_0x2f1458["value"])
                    : ((_0x3a5972 = _0x2f1458["value"]),
                      _0x3a5972 instanceof _0x4ce645
                        ? _0x3a5972
                        : new _0x4ce645(function (_0x3873f2) {
                            _0x3873f2(_0x3a5972);
                          }))[_0x2d4ab2(0x429)](_0x538f94, _0x34170f);
                }
                _0x488958((_0x3700b5 = _0x3700b5["apply"](_0x3fcc14, _0x42a0ba || []))[_0x49f72e(0x3e1)]());
              });
            };
            const _0x35eb91 = class {
                constructor(_0xa111ce) {
                  const _0x331a4c = _0x4067e7;
                  switch (_0xa111ce) {
                    case "SELFIE":
                      this[_0x331a4c(0x320)] = _0x3de0ad;
                      break;
                    case _0x331a4c(0x2d4):
                    case _0x331a4c(0x533):
                      this[_0x331a4c(0x320)] = _0x2feff0;
                      break;
                    case _0x331a4c(0x381):
                    case _0x331a4c(0x717):
                    case "DL_FRONT":
                    case _0x331a4c(0x692):
                    case _0x331a4c(0x434):
                    case _0x331a4c(0x478):
                      this[_0x331a4c(0x320)] = _0x436b1c;
                      break;
                    case "VOICE":
                      this[_0x331a4c(0x320)] = _0x3ca153;
                      break;
                    default:
                      throw new Error(_0x331a4c(0x4af));
                  }
                }
                [_0x4067e7(0x388)](_0x2b7922, _0x2ef09c) {
                  return _0x113b0a(this, void 0x0, void 0x0, function* () {
                    try {
                      return yield this["Recognizer"]["recognize"](_0x2b7922, _0x2ef09c);
                    } catch (_0x1426f4) {
                      throw new _0x3b1c1e["Z"]("RUNTIME_RECOGNIZER_FAILED", _0x1426f4);
                    }
                  });
                }
                ["resetRecognizer"]() {
                  return _0x113b0a(this, void 0x0, void 0x0, function* () {
                    const _0xad25b5 = a0_0x1b49;
                    try {
                      return yield this[_0xad25b5(0x320)]["reset"]();
                    } catch (_0x55026a) {
                      console[_0xad25b5(0x677)](_0xad25b5(0x6ff));
                    }
                  });
                }
              },
              _0x2e992f = class {
                constructor(_0x45e7cf, _0x454fdd) {
                  const _0x330050 = _0x4067e7;
                  var _0x4ffd27, _0x14f02f, _0x1f1784, _0x5c5df2, _0x27a4a3, _0x44e09d, _0x51a544, _0x26c2e6, _0x2ed915, _0x1500b0;
                  const _0x2688ee = _0x409f64["Z"][_0x330050(0x63a)][_0x330050(0x725)](_0x45e7cf["actionType"], _0x45e7cf["deviceType"]);
                  if (!_0x2688ee) throw _0x330050(0x243) + _0x45e7cf[_0x330050(0x245)] + "\x20device:\x20" + _0x45e7cf[_0x330050(0x431)];
                  const _0x38c4d2 = _0x409f64["Z"]["appConfig"][_0x330050(0x64e)](_0x45e7cf["actionType"]);
                  (this[_0x330050(0x301)] = _0x38c4d2["detectExposure"]),
                    (this["detectFocus"] = _0x38c4d2[_0x330050(0x41e)]),
                    (this[_0x330050(0x411)] = _0x38c4d2[_0x330050(0x411)]),
                    (this[_0x330050(0x693)] = _0x38c4d2[_0x330050(0x693)]),
                    (this[_0x330050(0x6b0)] = _0x38c4d2[_0x330050(0x6b0)]),
                    (this[_0x330050(0x59a)] = _0x38c4d2[_0x330050(0x59a)]),
                    (this[_0x330050(0x465)] = _0x38c4d2[_0x330050(0x465)]),
                    (this[_0x330050(0x4d1)] = _0x13336a["Z"][_0x330050(0x711)](
                      null ===
                        (_0x14f02f =
                          null === (_0x4ffd27 = _0x409f64["Z"][_0x330050(0x637)]) || void 0x0 === _0x4ffd27
                            ? void 0x0
                            : _0x4ffd27[_0x330050(0x403)]) || void 0x0 === _0x14f02f
                        ? void 0x0
                        : _0x14f02f[_0x330050(0x1be)]
                    )
                      ? _0x409f64["Z"][_0x330050(0x637)][_0x330050(0x403)][_0x330050(0x1be)]
                      : _0x2688ee["ET"]),
                    (this["focusThreshold"] = _0x13336a["Z"][_0x330050(0x711)](
                      null ===
                        (_0x5c5df2 =
                          null === (_0x1f1784 = _0x409f64["Z"][_0x330050(0x637)]) || void 0x0 === _0x1f1784
                            ? void 0x0
                            : _0x1f1784[_0x330050(0x403)]) || void 0x0 === _0x5c5df2
                        ? void 0x0
                        : _0x5c5df2[_0x330050(0x2cb)]
                    )
                      ? _0x409f64["Z"]["currentAction"]["commandOptions"]["focus"]
                      : _0x2688ee["FT"]),
                    (this[_0x330050(0x6cf)] = _0x13336a["Z"][_0x330050(0x711)](
                      null ===
                        (_0x44e09d =
                          null === (_0x27a4a3 = _0x409f64["Z"][_0x330050(0x637)]) || void 0x0 === _0x27a4a3
                            ? void 0x0
                            : _0x27a4a3[_0x330050(0x403)]) || void 0x0 === _0x44e09d
                        ? void 0x0
                        : _0x44e09d["fourCorner"]
                    )
                      ? _0x409f64["Z"]["currentAction"]["commandOptions"][_0x330050(0x1d8)]
                      : _0x2688ee["FCT"]),
                    (this[_0x330050(0x328)] = _0x13336a["Z"][_0x330050(0x711)](
                      null ===
                        (_0x26c2e6 =
                          null === (_0x51a544 = _0x409f64["Z"][_0x330050(0x637)]) || void 0x0 === _0x51a544
                            ? void 0x0
                            : _0x51a544[_0x330050(0x403)]) || void 0x0 === _0x26c2e6
                        ? void 0x0
                        : _0x26c2e6["glare"]
                    )
                      ? _0x409f64["Z"]["currentAction"][_0x330050(0x403)][_0x330050(0x451)]
                      : _0x2688ee["GT"]),
                    (this[_0x330050(0x5db)] = _0x13336a["Z"][_0x330050(0x711)](
                      null ===
                        (_0x1500b0 =
                          null === (_0x2ed915 = _0x409f64["Z"]["currentAction"]) || void 0x0 === _0x2ed915
                            ? void 0x0
                            : _0x2ed915[_0x330050(0x403)]) || void 0x0 === _0x1500b0
                        ? void 0x0
                        : _0x1500b0[_0x330050(0x3cc)]
                    )
                      ? _0x409f64["Z"][_0x330050(0x637)][_0x330050(0x403)][_0x330050(0x3cc)]
                      : _0x2688ee[_0x330050(0x5df)]),
                    (this[_0x330050(0x293)] = _0x2688ee[_0x330050(0x30b)]),
                    (this["lowContrastThreshold"] = _0x2688ee[_0x330050(0x3ef)]),
                    (this["minPaddingThreshold"] = _0x2688ee[_0x330050(0x282)]),
                    (this[_0x330050(0x5f5)] = _0x2688ee[_0x330050(0x565)]),
                    (this[_0x330050(0x248)] = _0x454fdd[_0x330050(0x248)]);
                }
              },
              _0x79a66e = class {
                constructor(_0x42bf63, _0x170032) {
                  const _0x40e12b = _0x4067e7;
                  var _0x2d149b, _0x1c58c2;
                  (this[_0x40e12b(0x245)] = _0x40e12b(0x332)),
                    (this["tinyFaceDetectorSettings"] = _0x409f64["Z"][_0x40e12b(0x63a)]["getFaceAPIRecognizerSettings"]()),
                    (this[_0x40e12b(0x5a1)][_0x40e12b(0x474)] =
                      _0x409f64["Z"][_0x40e12b(0x63a)]["CommandOptionsDictionary"]["faceApiDetectionLevel"][
                        null ===
                          (_0x1c58c2 =
                            null ===
                              (_0x2d149b =
                                null === _0x409f64["Z"] || void 0x0 === _0x409f64["Z"] ? void 0x0 : _0x409f64["Z"]["currentAction"]) ||
                            void 0x0 === _0x2d149b
                              ? void 0x0
                              : _0x2d149b["commandOptions"]) || void 0x0 === _0x1c58c2
                          ? void 0x0
                          : _0x1c58c2[_0x40e12b(0x300)]
                      ]),
                    (this[_0x40e12b(0x1bf)] = _0x170032);
                }
              },
              _0x164cb1 = class {
                constructor(_0x192215, _0x675503) {
                  const _0x70eac9 = _0x4067e7;
                  (this[_0x70eac9(0x452)] = _0x192215), (this[_0x70eac9(0x1bf)] = _0x675503);
                }
              },
              _0x485ec8 = class {
                constructor(_0x5ed8ea, _0x40b9f9) {
                  const _0x593aa8 = _0x4067e7;
                  (this["actionType"] = _0x593aa8(0x268)),
                    (this[_0x593aa8(0x52f)] = _0x409f64["Z"][_0x593aa8(0x63a)]["getVoiceRecognizerSettings"]()),
                    (this["audioSnapshot"] = _0x40b9f9);
                }
              },
              _0x1bf369 = class {
                constructor(_0x4a95d7, _0xed4ab3) {
                  const _0x4a9536 = _0x4067e7;
                  switch (_0x4a95d7[_0x4a9536(0x245)]) {
                    case _0x4a9536(0x332):
                      this[_0x4a9536(0x5fb)] = new _0x79a66e(_0x4a95d7[_0x4a9536(0x431)], _0xed4ab3);
                      break;
                    case _0x4a9536(0x2d4):
                    case _0x4a9536(0x533):
                      this[_0x4a9536(0x5fb)] = new _0x164cb1(_0x4a95d7, _0xed4ab3);
                      break;
                    case "CHECK_BACK":
                    case "CHECK_FRONT":
                    case _0x4a9536(0x68c):
                    case _0x4a9536(0x692):
                    case _0x4a9536(0x434):
                    case _0x4a9536(0x478):
                      this["recognizableData"] = new _0x2e992f(_0x4a95d7, _0xed4ab3);
                      break;
                    case _0x4a9536(0x268):
                      this[_0x4a9536(0x5fb)] = new _0x485ec8(_0x4a95d7, _0xed4ab3);
                      break;
                    default:
                      throw _0x4a9536(0x343);
                  }
                }
              },
              _0x2a0747 = class {
                constructor() {
                  const _0x19c704 = _0x4067e7;
                  this[_0x19c704(0x42f)];
                }
                [_0x4067e7(0x473)](_0x2fbbb6) {
                  const _0x1fc5d6 = _0x4067e7;
                  this[_0x1fc5d6(0x42f)] = _0x2fbbb6;
                }
                [_0x4067e7(0x44b)](_0x2fd085, _0x1b1038) {
                  const _0x2321e6 = _0x4067e7;
                  var _0xc1d85b, _0x194582, _0x3273f0;
                  const _0x46ef17 = { width: 0x14d, height: 0xde };
                  try {
                    (null === _0x409f64["Z"] || void 0x0 === _0x409f64["Z"] ? void 0x0 : _0x409f64["Z"][_0x2321e6(0x637)]) &&
                      !(null === (_0xc1d85b = _0x409f64["Z"][_0x2321e6(0x637)]) || void 0x0 === _0xc1d85b
                        ? void 0x0
                        : _0xc1d85b[_0x2321e6(0x372)]) &&
                      (_0x409f64["Z"][_0x2321e6(0x637)][_0x2321e6(0x372)] = new _0x2c3d54["Z"](
                        _0x11c06d[_0x2321e6(0x513)](_0x2fd085["code"]["toString"](), _0x46ef17),
                        0x4
                      ));
                    const _0xb61246 = {
                      isFailure: !0x0,
                      imageWidth: _0x46ef17[_0x2321e6(0x657)],
                      imageHeight: _0x46ef17["height"],
                      rawData: {},
                      imageDimensions: _0x46ef17,
                      caughtError: _0x1b1038,
                      snapShotId:
                        null ===
                          (_0x3273f0 =
                            null ===
                              (_0x194582 =
                                null === _0x409f64["Z"] || void 0x0 === _0x409f64["Z"] ? void 0x0 : _0x409f64["Z"]["currentAction"]) ||
                            void 0x0 === _0x194582
                              ? void 0x0
                              : _0x194582[_0x2321e6(0x372)]) || void 0x0 === _0x3273f0
                          ? void 0x0
                          : _0x3273f0["UID"],
                    };
                    this[_0x2321e6(0x42f)] = new _0x308ca0("QQ", _0x2fd085[_0x2321e6(0x1f7)], 0x0, _0xb61246, _0x2fd085);
                  } catch (_0x1c8e4f) {
                    _0x411080[_0x2321e6(0x29e)](_0x2321e6(0x654));
                  }
                }
              };
            class _0x58a46f {
              constructor(_0x1ef55b) {
                const _0x570862 = _0x4067e7;
                this[_0x570862(0x31a)] = _0x570862(0x548) === _0x1ef55b[_0x570862(0x400)];
              }
              [_0x4067e7(0x561)]() {
                const _0x9e1178 = _0x4067e7;
                if (this[_0x9e1178(0x31a)] && !_0x409f64["Z"][_0x9e1178(0x63a)][_0x9e1178(0x218)][_0x9e1178(0x2a1)])
                  throw new _0x3b1c1e["Z"](_0x9e1178(0x6c7), new Error("RUNTIME_GUM_ERROR_USER_MEDIA_NOT_SUPPORTED"));
              }
            }
            class _0x15e500 extends _0x58a46f {
              ["validate"]() {
                const _0xb65cee = _0x4067e7;
                if ((super[_0xb65cee(0x561)](), !_0x409f64["Z"][_0xb65cee(0x63a)][_0xb65cee(0x218)]["supportsWasm"]))
                  throw new _0x3b1c1e["Z"]("RUNTIME_WEBASSEMBLY_NOT_SUPPORTED", new Error(_0xb65cee(0x543)));
              }
            }
            class _0x3e64a4 extends _0x58a46f {
              [_0x4067e7(0x561)]() {
                const _0x9f9b0d = _0x4067e7;
                if ((super[_0x9f9b0d(0x561)](), !_0x409f64["Z"][_0x9f9b0d(0x63a)][_0x9f9b0d(0x218)][_0x9f9b0d(0x418)]))
                  throw new _0x3b1c1e["Z"](_0x9f9b0d(0x543), new Error(_0x9f9b0d(0x543)));
              }
            }
            class _0x46cdc6 extends _0x58a46f {
              ["validate"]() {
                const _0x41e5ea = _0x4067e7;
                if ((super[_0x41e5ea(0x561)](), this["isAutoMode"] && !_0x409f64["Z"][_0x41e5ea(0x63a)]["deviceInfo"][_0x41e5ea(0x206)]))
                  throw new _0x3b1c1e["Z"](_0x41e5ea(0x491), new Error(_0x41e5ea(0x491)));
              }
            }
            class _0x261819 {
              static [_0x4067e7(0x421)](_0x4a5277) {
                const _0x1c49a9 = _0x4067e7;
                switch (_0x4a5277["actionType"]) {
                  case _0x1c49a9(0x68c):
                  case _0x1c49a9(0x68c):
                  case _0x1c49a9(0x717):
                  case _0x1c49a9(0x381):
                  case _0x1c49a9(0x434):
                  case "PASSPORT":
                    return new _0x15e500(_0x4a5277);
                  case _0x1c49a9(0x332):
                    return new _0x46cdc6(_0x4a5277);
                  case _0x1c49a9(0x2d4):
                  case _0x1c49a9(0x533):
                    return new _0x3e64a4(_0x4a5277);
                  case _0x1c49a9(0x268):
                    return new _0x58a46f(_0x4a5277);
                  default:
                    throw new _0x3b1c1e["Z"](_0x1c49a9(0x6d3), new Error(_0x1c49a9(0x6d3)));
                }
              }
            }
            var _0x7a80f0 = function (_0x5ce2b3, _0x392400, _0x5cd5bc, _0x139503) {
              return new (_0x5cd5bc || (_0x5cd5bc = Promise))(function (_0x3a02b5, _0x20b439) {
                const _0x316d11 = a0_0x1b49;
                function _0x4671bf(_0x37a8fe) {
                  const _0x3760e8 = a0_0x1b49;
                  try {
                    _0x40adc9(_0x139503[_0x3760e8(0x3e1)](_0x37a8fe));
                  } catch (_0x25f3fe) {
                    _0x20b439(_0x25f3fe);
                  }
                }
                function _0x37d5b9(_0x2c1792) {
                  const _0x41faa7 = a0_0x1b49;
                  try {
                    _0x40adc9(_0x139503[_0x41faa7(0x3b2)](_0x2c1792));
                  } catch (_0x2c458e) {
                    _0x20b439(_0x2c458e);
                  }
                }
                function _0x40adc9(_0x3c1b82) {
                  const _0xa0ff25 = a0_0x1b49;
                  var _0x505fed;
                  _0x3c1b82[_0xa0ff25(0x4f5)]
                    ? _0x3a02b5(_0x3c1b82[_0xa0ff25(0x331)])
                    : ((_0x505fed = _0x3c1b82[_0xa0ff25(0x331)]),
                      _0x505fed instanceof _0x5cd5bc
                        ? _0x505fed
                        : new _0x5cd5bc(function (_0x528137) {
                            _0x528137(_0x505fed);
                          }))[_0xa0ff25(0x429)](_0x4671bf, _0x37d5b9);
                }
                _0x40adc9((_0x139503 = _0x139503[_0x316d11(0x1d1)](_0x5ce2b3, _0x392400 || []))["next"]());
              });
            };
            new _0x3da364(_0x4067e7(0x38c));
            const _0x4d470d = class extends _0x2a0747 {
                constructor() {
                  const _0x5b307b = _0x4067e7;
                  super();
                  try {
                    (this[_0x5b307b(0x558)] = _0x261819[_0x5b307b(0x421)](_0x409f64["Z"]["currentAction"][_0x5b307b(0x452)])),
                      (this[_0x5b307b(0x3a2)] = new _0x44b347(_0x409f64["Z"][_0x5b307b(0x637)][_0x5b307b(0x452)][_0x5b307b(0x400)])),
                      (this["Transformer"] = new _0x15a5df(_0x409f64["Z"]["currentAction"]["actionIdentifier"][_0x5b307b(0x245)])),
                      (this["Recognizer"] = new _0x35eb91(_0x409f64["Z"][_0x5b307b(0x637)]["actionIdentifier"]["actionType"]));
                  } catch (_0x7cd2bd) {
                    throw new _0x3b1c1e["Z"](_0x5b307b(0x1d7), new Error(_0x5b307b(0x1d7)));
                  }
                }
                ["startContextExecution"]() {
                  return _0x7a80f0(this, void 0x0, void 0x0, function* () {
                    const _0x462959 = a0_0x1b49;
                    try {
                      this[_0x462959(0x558)][_0x462959(0x561)]();
                      const _0x533a73 = yield this[_0x462959(0x3a2)]["extract"](),
                        _0x45d200 = yield this[_0x462959(0x351)][_0x462959(0x541)](_0x533a73);
                      _0x409f64["Z"]["currentAction"][_0x462959(0x372)] = _0x45d200;
                      const _0x13f524 = new _0x1bf369(
                          _0x409f64["Z"][_0x462959(0x637)][_0x462959(0x452)],
                          _0x409f64["Z"]["currentAction"][_0x462959(0x372)]
                        )[_0x462959(0x5fb)],
                        _0x2c90ae = yield this[_0x462959(0x320)][_0x462959(0x388)](_0x13f524, _0x45d200[_0x462959(0x27f)]),
                        _0x41803a = _0x2fa509[_0x462959(0x2f9)](_0x409f64["Z"]["currentAction"][_0x462959(0x452)], _0x2c90ae);
                      yield _0x409f64["Z"][_0x462959(0x20b)]();
                      let _0x83b6ec = new _0x3289d5(
                        _0x409f64["Z"]["currentAction"][_0x462959(0x452)],
                        _0x409f64["Z"]["currentAction"][_0x462959(0x372)],
                        _0x41803a,
                        _0x409f64["Z"]["currentAction"]["exif"],
                        _0x409f64["Z"]["currentAction"][_0x462959(0x274)]
                      );
                      return (_0x83b6ec = yield _0x3aeeb1["Z"][_0x462959(0x487)](_0x83b6ec)), _0x83b6ec;
                    } catch (_0x1b03c7) {
                      let _0x2749b9 = _0x1b03c7 instanceof _0x3b1c1e["Z"] ? _0x1b03c7 : new _0x3b1c1e["Z"](_0x462959(0x1d7), _0x1b03c7),
                        _0x223eb1 = _0x411080[_0x462959(0x2e4)](_0x2749b9);
                      return (
                        this[_0x462959(0x44b)](_0x223eb1, _0x1b03c7),
                        new _0x3289d5(
                          _0x409f64["Z"]["currentAction"]["actionIdentifier"],
                          _0x409f64["Z"][_0x462959(0x637)][_0x462959(0x372)],
                          this[_0x462959(0x42f)],
                          _0x409f64["Z"][_0x462959(0x637)]["exif"],
                          _0x409f64["Z"][_0x462959(0x637)][_0x462959(0x274)]
                        )
                      );
                    } finally {
                      _0x411080[_0x462959(0x63f)]();
                    }
                  });
                }
              },
              _0x279850 = class {
                constructor(_0x29c907, _0x56989d) {
                  const _0x2fb0cb = _0x4067e7;
                  (this[_0x2fb0cb(0x713)] = _0x56989d),
                    (this[_0x2fb0cb(0x245)] = _0x29c907["actionType"]),
                    (this[_0x2fb0cb(0x400)] = _0x29c907[_0x2fb0cb(0x400)]);
                }
              };
            var _0x4f3d6f = function (_0x77591, _0x1d6ece, _0x2041ce, _0x3100bb) {
              return new (_0x2041ce || (_0x2041ce = Promise))(function (_0x110097, _0x43889a) {
                const _0x8bd96d = a0_0x1b49;
                function _0x254ad6(_0x1c79ee) {
                  const _0x1b29a0 = a0_0x1b49;
                  try {
                    _0x4aa3d9(_0x3100bb[_0x1b29a0(0x3e1)](_0x1c79ee));
                  } catch (_0x3fa092) {
                    _0x43889a(_0x3fa092);
                  }
                }
                function _0x3da6fb(_0x34a597) {
                  const _0x2ce0b4 = a0_0x1b49;
                  try {
                    _0x4aa3d9(_0x3100bb[_0x2ce0b4(0x3b2)](_0x34a597));
                  } catch (_0x575e78) {
                    _0x43889a(_0x575e78);
                  }
                }
                function _0x4aa3d9(_0x49a952) {
                  const _0x4e1c36 = a0_0x1b49;
                  var _0x144ab2;
                  _0x49a952[_0x4e1c36(0x4f5)]
                    ? _0x110097(_0x49a952[_0x4e1c36(0x331)])
                    : ((_0x144ab2 = _0x49a952["value"]),
                      _0x144ab2 instanceof _0x2041ce
                        ? _0x144ab2
                        : new _0x2041ce(function (_0xdc40c7) {
                            _0xdc40c7(_0x144ab2);
                          }))["then"](_0x254ad6, _0x3da6fb);
                }
                _0x4aa3d9((_0x3100bb = _0x3100bb["apply"](_0x77591, _0x1d6ece || []))[_0x8bd96d(0x3e1)]());
              });
            };
            new _0x3da364("app:context");
            const _0x1ab059 = class extends _0x2a0747 {
              constructor() {
                const _0x54d0a9 = _0x4067e7;
                super();
                try {
                  (this[_0x54d0a9(0x558)] = _0x261819[_0x54d0a9(0x421)](_0x409f64["Z"][_0x54d0a9(0x637)]["actionIdentifier"])),
                    (this[_0x54d0a9(0x3a2)] = new _0x26660a(_0x409f64["Z"][_0x54d0a9(0x637)]["facingDirection"])),
                    (this[_0x54d0a9(0x351)] = new _0x15a5df(_0x409f64["Z"][_0x54d0a9(0x637)][_0x54d0a9(0x452)]["actionType"])),
                    (this[_0x54d0a9(0x320)] = new _0x35eb91(_0x409f64["Z"]["currentAction"][_0x54d0a9(0x452)][_0x54d0a9(0x245)]));
                } catch (_0x184583) {
                  throw new _0x3b1c1e["Z"](_0x54d0a9(0x1d6), new Error(_0x54d0a9(0x1d6)));
                }
              }
              [_0x4067e7(0x33c)]() {
                return _0x4f3d6f(this, void 0x0, void 0x0, function* () {
                  const _0x4857a2 = a0_0x1b49;
                  let _0x3c2f4b = !0x1;
                  try {
                    this[_0x4857a2(0x558)][_0x4857a2(0x561)]();
                    if (!(yield _0x3c9edc["Z"]["hasVideoCamera"]())) throw new _0x3b1c1e["Z"](_0x4857a2(0x55e), new Error());
                    for (; !_0x3c2f4b; ) {
                      const _0x738273 = yield this["Extractor"][_0x4857a2(0x68d)]();
                      (this[_0x4857a2(0x360)] = yield this[_0x4857a2(0x351)][_0x4857a2(0x541)](_0x738273)),
                        (_0x409f64["Z"][_0x4857a2(0x637)][_0x4857a2(0x372)] = this[_0x4857a2(0x360)]);
                      const _0x1413cf = new _0x1bf369(_0x409f64["Z"][_0x4857a2(0x637)]["actionIdentifier"], this[_0x4857a2(0x360)])[
                          _0x4857a2(0x5fb)
                        ],
                        _0x592e51 = yield this[_0x4857a2(0x320)][_0x4857a2(0x388)](
                          _0x1413cf,
                          this["transformedImageDataSnapshot"][_0x4857a2(0x27f)]
                        ),
                        _0x1b27ce = _0x2fa509[_0x4857a2(0x2f9)](_0x409f64["Z"][_0x4857a2(0x637)]["actionIdentifier"], _0x592e51);
                      switch ((this[_0x4857a2(0x473)](_0x1b27ce), !0x0)) {
                        case _0x1b27ce instanceof _0x579044:
                        case _0x409f64["Z"]["currentAction"]["isForceNextEvaluationReturn"]:
                          _0x3c2f4b = !0x0;
                          break;
                        case this[_0x4857a2(0x3a2)][_0x4857a2(0x464)]():
                          console[_0x4857a2(0x677)](_0x4857a2(0x20e) + this[_0x4857a2(0x3a2)][_0x4857a2(0x419)]), (_0x3c2f4b = !0x0);
                          break;
                        case _0x409f64["Z"][_0x4857a2(0x637)][_0x4857a2(0x3a9)]:
                          if (((_0x3c2f4b = !0x0), "NORMAL_EXECUTION_ENDED" !== _0x409f64["Z"][_0x4857a2(0x637)][_0x4857a2(0x591)]))
                            throw new _0x3b1c1e["Z"](
                              _0x409f64["Z"][_0x4857a2(0x637)][_0x4857a2(0x591)],
                              new Error(_0x409f64["Z"][_0x4857a2(0x637)]["isStoppedReason"])
                            );
                          break;
                        case _0x409f64["Z"][_0x4857a2(0x637)][_0x4857a2(0x403)]["videoRecordingEnabled"] &&
                          _0x409f64["Z"][_0x4857a2(0x5d8)]:
                          throw (
                            (console[_0x4857a2(0x677)](
                              "Video\x20has\x20exceeded\x20maximum\x20recording\x20time\x20of:\x20" +
                                _0x409f64["Z"][_0x4857a2(0x63a)]["thresholds"][_0x4857a2(0x36c)][_0x4857a2(0x459)] +
                                "\x20MS"
                            ),
                            new _0x3b1c1e["Z"]("RUNTIME_SESSION_RECORDING_EXCEEDED_MAX_TIME", new Error()))
                          );
                        default:
                          _0x411080[_0x4857a2(0x398)](
                            new _0x279850(_0x409f64["Z"][_0x4857a2(0x637)]["actionIdentifier"], _0x1b27ce[_0x4857a2(0x229)])
                          );
                      }
                    }
                    yield _0x409f64["Z"][_0x4857a2(0x20b)](), (this["sessionRecordingData"] = yield this[_0x4857a2(0x57d)]());
                    let _0x2cac67 = new _0x3289d5(
                      _0x409f64["Z"][_0x4857a2(0x637)][_0x4857a2(0x452)],
                      _0x409f64["Z"][_0x4857a2(0x637)][_0x4857a2(0x372)],
                      this[_0x4857a2(0x42f)],
                      _0x409f64["Z"][_0x4857a2(0x637)]["exif"],
                      _0x409f64["Z"]["currentAction"][_0x4857a2(0x274)],
                      this[_0x4857a2(0x4f4)]
                    );
                    return (_0x2cac67 = yield _0x3aeeb1["Z"]["getSDKresultWithRTS"](_0x2cac67)), _0x2cac67;
                  } catch (_0x907cb5) {
                    let _0x2e086f =
                      _0x907cb5 instanceof _0x3b1c1e["Z"] ? _0x907cb5 : new _0x3b1c1e["Z"]("RUNTIME_ACTION_CONTEXT_AUTO", _0x907cb5);
                    return (
                      this[_0x4857a2(0x44b)](_0x411080[_0x4857a2(0x2e4)](_0x2e086f), _0x907cb5),
                      Object["freeze"](
                        new _0x3289d5(
                          _0x409f64["Z"]["currentAction"]["actionIdentifier"],
                          _0x409f64["Z"][_0x4857a2(0x637)]["lastSnapshot"],
                          this[_0x4857a2(0x42f)],
                          _0x409f64["Z"]["currentAction"][_0x4857a2(0x514)],
                          _0x409f64["Z"][_0x4857a2(0x637)][_0x4857a2(0x274)]
                        )
                      )
                    );
                  } finally {
                    this[_0x4857a2(0x560)]();
                  }
                });
              }
              [_0x4067e7(0x57d)]() {
                return _0x4f3d6f(this, void 0x0, void 0x0, function* () {
                  const _0x3932ca = a0_0x1b49;
                  if (!_0x409f64["Z"][_0x3932ca(0x637)][_0x3932ca(0x403)][_0x3932ca(0x550)]) return "";
                  try {
                    return yield _0x527ec2[_0x3932ca(0x225)]();
                  } catch (_0x4450fb) {
                    return "";
                  }
                });
              }
              [_0x4067e7(0x560)]() {
                const _0x29e2a6 = _0x4067e7;
                try {
                  this[_0x29e2a6(0x3a2)][_0x29e2a6(0x265)](),
                    this[_0x29e2a6(0x320)]["resetRecognizer"](),
                    _0x411080[_0x29e2a6(0x63f)](),
                    _0x527ec2[_0x29e2a6(0x424)] && clearTimeout(_0x527ec2[_0x29e2a6(0x424)]);
                } catch (_0x1e2c74) {
                  console[_0x29e2a6(0x677)](_0x29e2a6(0x383) + _0x1e2c74);
                }
              }
            };
            let _0x33f661 = 0x0;
            const _0x44d76e = class {
              constructor(_0x30581a, _0x76fe98) {
                const _0x2e93e2 = _0x4067e7;
                (this["audioBlob"] = _0x30581a),
                  (this["snapshotLabel"] = _0x76fe98),
                  this[_0x2e93e2(0x37f)],
                  (this[_0x2e93e2(0x27f)] = (_0x33f661++)[_0x2e93e2(0x406)]() + "_" + new Date()[_0x2e93e2(0x214)]());
              }
            };
            var _0x8644ac = function (_0x446588, _0x58e6b7, _0x36afdd, _0x13088a) {
              return new (_0x36afdd || (_0x36afdd = Promise))(function (_0x2df0fe, _0x3641e0) {
                const _0x8a30d2 = a0_0x1b49;
                function _0x4410af(_0x4b9e71) {
                  try {
                    _0xc26b54(_0x13088a["next"](_0x4b9e71));
                  } catch (_0x196e77) {
                    _0x3641e0(_0x196e77);
                  }
                }
                function _0x260142(_0x4cf6b7) {
                  try {
                    _0xc26b54(_0x13088a["throw"](_0x4cf6b7));
                  } catch (_0x5d5eb8) {
                    _0x3641e0(_0x5d5eb8);
                  }
                }
                function _0xc26b54(_0x34d261) {
                  const _0x6a6cba = a0_0x1b49;
                  var _0x57321f;
                  _0x34d261["done"]
                    ? _0x2df0fe(_0x34d261[_0x6a6cba(0x331)])
                    : ((_0x57321f = _0x34d261[_0x6a6cba(0x331)]),
                      _0x57321f instanceof _0x36afdd
                        ? _0x57321f
                        : new _0x36afdd(function (_0x564393) {
                            _0x564393(_0x57321f);
                          }))[_0x6a6cba(0x429)](_0x4410af, _0x260142);
                }
                _0xc26b54((_0x13088a = _0x13088a[_0x8a30d2(0x1d1)](_0x446588, _0x58e6b7 || []))[_0x8a30d2(0x3e1)]());
              });
            };
            new _0x3da364(_0x4067e7(0x721));
            function _0x2388e9(_0x1f169a, _0x597500, _0x3a8fd3) {
              const _0x2087ec = _0x4067e7;
              for (let _0x42e8c9 = 0x0; _0x42e8c9 < _0x1f169a["length"]; ++_0x42e8c9)
                _0x597500[_0x3a8fd3 + _0x42e8c9] = _0x1f169a[_0x2087ec(0x2ed)](_0x42e8c9);
            }
            function _0x13ed9d(_0x16f5d6, _0x465dd4, _0x1f4e66) {
              const _0x202f02 = _0x4067e7;
              (_0x16f5d6 = Math[_0x202f02(0x6b9)](_0x16f5d6)),
                (_0x465dd4[_0x1f4e66 + 0x0] = 0xff & _0x16f5d6),
                (_0x465dd4[_0x1f4e66 + 0x1] = (_0x16f5d6 >> 0x8) & 0xff);
            }
            function _0x3fd861(_0x53d721, _0x2a17fd, _0x4075f6) {
              const _0x221606 = _0x4067e7;
              (_0x53d721 = Math[_0x221606(0x6b9)](_0x53d721)),
                (_0x2a17fd[_0x4075f6 + 0x0] = 0xff & _0x53d721),
                (_0x2a17fd[_0x4075f6 + 0x1] = (_0x53d721 >> 0x8) & 0xff),
                (_0x2a17fd[_0x4075f6 + 0x2] = (_0x53d721 >> 0x10) & 0xff),
                (_0x2a17fd[_0x4075f6 + 0x3] = (_0x53d721 >> 0x18) & 0xff);
            }
            function _0x67b95a(_0x4a6bb5) {
              const _0x3d2278 = new ArrayBuffer(0x4);
              new Float32Array(_0x3d2278)[0x0] = _0x4a6bb5;
              const _0x5d1867 = new Uint32Array(_0x3d2278)[0x0];
              return _0x5d1867 || 0x0;
            }
            const _0x413370 = class {
              constructor(_0x30f422, _0x517cd6) {
                const _0x4a5680 = _0x4067e7;
                (this["timeSlice"] = 0x64),
                  (this[_0x4a5680(0x2ae)] = new _0x33dbda["g"]["MediaRecorder"](_0x30f422, _0x517cd6)),
                  (this[_0x4a5680(0x604)] = _0x30f422),
                  (this[_0x4a5680(0x366)] = []),
                  (this[_0x4a5680(0x42d)] = null == _0x517cd6 ? void 0x0 : _0x517cd6[_0x4a5680(0x624)]),
                  (this["recorder"][_0x4a5680(0x25e)] = (_0x3d0a62) => {
                    const _0x5585c = _0x4a5680;
                    var _0x12df43;
                    (null === (_0x12df43 = _0x3d0a62[_0x5585c(0x589)]) || void 0x0 === _0x12df43 ? void 0x0 : _0x12df43[_0x5585c(0x4bc)]) >
                      0x0 && this[_0x5585c(0x366)][_0x5585c(0x4a7)](_0x3d0a62[_0x5585c(0x589)]);
                  }),
                  (this[_0x4a5680(0x2ae)][_0x4a5680(0x1f9)] = (_0x422d85) => {
                    _0x422d85["target"];
                  }),
                  this["recorder"][_0x4a5680(0x307)](_0x4a5680(0x6cd), (_0x48c2b6) => {
                    const _0x598398 = _0x4a5680;
                    console[_0x598398(0x677)](_0x598398(0x454) + _0x48c2b6);
                  });
              }
              ["startRecording"]() {
                return _0x8644ac(this, void 0x0, void 0x0, function* () {
                  const _0xf0b42b = a0_0x1b49;
                  return this[_0xf0b42b(0x2ae)]["start"](this[_0xf0b42b(0x24b)]), !0x0;
                });
              }
              [_0x4067e7(0x652)]() {
                return _0x8644ac(this, void 0x0, void 0x0, function* () {
                  const _0x2007d9 = a0_0x1b49;
                  this[_0x2007d9(0x2ae)][_0x2007d9(0x5be)]();
                });
              }
              [_0x4067e7(0x2f2)]() {
                return _0x8644ac(this, void 0x0, void 0x0, function* () {
                  const _0x2c5df1 = a0_0x1b49;
                  this[_0x2c5df1(0x2ae)][_0x2c5df1(0x3f8)]();
                });
              }
              [_0x4067e7(0x3ee)]() {
                return _0x8644ac(this, void 0x0, void 0x0, function* () {
                  const _0x815015 = a0_0x1b49;
                  try {
                    "inactive" !== this["recorder"][_0x815015(0x6d9)] && this["recorder"][_0x815015(0x52e)]();
                  } catch (_0x1ac39e) {
                    console["warn"](_0x815015(0x6c2), _0x1ac39e);
                  }
                  (this[_0x815015(0x5e1)] = new Blob(this["chunks"], { type: this[_0x815015(0x42d)] })), (this[_0x815015(0x366)] = []);
                });
              }
              ["getBlob"]() {
                return _0x8644ac(this, void 0x0, void 0x0, function* () {
                  const _0x156308 = a0_0x1b49;
                  if (_0x156308(0x563) != this[_0x156308(0x2ae)]["state"])
                    throw "recorder\x20is\x20doing\x20something\x20stop\x20recorder\x20firest";
                  return this["masterBlob"];
                });
              }
              [_0x4067e7(0x22d)]() {
                return _0x8644ac(this, void 0x0, void 0x0, function* () {
                  const _0x281cf0 = a0_0x1b49;
                  if (0x0 === this[_0x281cf0(0x5e1)][_0x281cf0(0x4bc)])
                    throw new _0x3b1c1e["Z"]("RUNTIME_VOICE_CONTEXT_UNKNOWN_ERROR", new Error(_0x281cf0(0x37c)));
                  return (function (_0x227f4b, _0x5af696, _0x3d9487) {
                    return _0x8644ac(this, void 0x0, void 0x0, function* () {
                      const _0x58bb2f = a0_0x1b49,
                        _0x39b7c7 = yield (function (_0x17dbc3, _0x47df0b) {
                          return _0x8644ac(this, void 0x0, void 0x0, function* () {
                            const _0x182ff4 = a0_0x1b49;
                            let _0xfeff60 = _0x17dbc3;
                            _0xfeff60 instanceof Blob || (_0xfeff60 = new Blob([_0x17dbc3]));
                            const _0x3e951e = URL[_0x182ff4(0x528)](_0xfeff60),
                              _0x492172 = yield fetch(_0x3e951e),
                              _0x4a043e = yield _0x492172[_0x182ff4(0x202)](),
                              _0x4986a2 = new AudioContext(_0x47df0b);
                            return yield _0x4986a2["decodeAudioData"](_0x4a043e);
                          });
                        })(_0x227f4b, _0x3d9487),
                        _0x28f788 = _0x39b7c7[_0x58bb2f(0x5ab)],
                        _0x315cfa = _0x39b7c7[_0x58bb2f(0x2a3)],
                        _0x325f28 = _0x39b7c7[_0x58bb2f(0x1e6)],
                        _0x4c0768 = _0x5af696 ? 0x20 : 0x10,
                        _0x2adad8 = (_0x325f28 * _0x315cfa * _0x4c0768) / 0x8,
                        _0xe12063 = (_0x315cfa * _0x4c0768) / 0x8,
                        _0x3633ed = _0x28f788 * _0x315cfa * (_0x4c0768 / 0x8),
                        _0xbb5e57 = new Uint8Array(0x2c + _0x3633ed),
                        _0x281225 = _0x3633ed,
                        _0x5cffec = 0x1c + (0x8 + _0x281225);
                      return (
                        _0x2388e9(_0x58bb2f(0x5d3), _0xbb5e57, 0x0),
                        _0x3fd861(_0x5cffec, _0xbb5e57, 0x4),
                        _0x2388e9(_0x58bb2f(0x27d), _0xbb5e57, 0x8),
                        _0x2388e9(_0x58bb2f(0x3e0), _0xbb5e57, 0xc),
                        _0x3fd861(0x10, _0xbb5e57, 0x10),
                        _0x13ed9d(_0x5af696 ? 0x3 : 0x1, _0xbb5e57, 0x14),
                        _0x13ed9d(_0x315cfa, _0xbb5e57, 0x16),
                        _0x3fd861(_0x325f28, _0xbb5e57, 0x18),
                        _0x3fd861(_0x2adad8, _0xbb5e57, 0x1c),
                        _0x13ed9d(_0xe12063, _0xbb5e57, 0x20),
                        _0x3fd861(_0x4c0768, _0xbb5e57, 0x22),
                        _0x2388e9(_0x58bb2f(0x589), _0xbb5e57, 0x24),
                        _0x3fd861(_0x281225, _0xbb5e57, 0x28),
                        (function (_0x2c5c82, _0x35affc, _0x32d438, _0x364b32) {
                          const _0x1608bf = _0x58bb2f;
                          let _0x4bd232 = 0x0,
                            _0x4d9278 = 0x0;
                          const _0x5a0bc0 = _0x2c5c82["length"],
                            _0x2e10d6 = _0x2c5c82["numberOfChannels"];
                          let _0xf63899, _0x2898b2;
                          for (_0x4bd232 = 0x0; _0x4bd232 < _0x5a0bc0; ++_0x4bd232)
                            for (_0x4d9278 = 0x0; _0x4d9278 < _0x2e10d6; ++_0x4d9278)
                              if (((_0xf63899 = _0x2c5c82[_0x1608bf(0x4db)](_0x4d9278)), 0x10 === _0x364b32))
                                (_0x2898b2 = 0x8000 * _0xf63899[_0x4bd232]),
                                  _0x2898b2 < -0x8000 ? (_0x2898b2 = -0x8000) : _0x2898b2 > 0x7fff && (_0x2898b2 = 0x7fff),
                                  _0x13ed9d(_0x2898b2, _0x35affc, _0x32d438),
                                  (_0x32d438 += 0x2);
                              else {
                                if (0x20 !== _0x364b32) return;
                                (_0x2898b2 = _0x67b95a(_0xf63899[_0x4bd232])),
                                  _0x3fd861(_0x2898b2, _0x35affc, _0x32d438),
                                  (_0x32d438 += 0x4);
                              }
                        })(_0x39b7c7, _0xbb5e57, 0x2c, _0x4c0768),
                        new Blob([_0xbb5e57], { type: _0x58bb2f(0x1ce) })
                      );
                    });
                  })(this["masterBlob"], !0x1);
                });
              }
              get [_0x4067e7(0x6d9)]() {
                const _0x4693c5 = _0x4067e7;
                return this[_0x4693c5(0x2ae)][_0x4693c5(0x6d9)];
              }
              [_0x4067e7(0x586)]() {}
            };
            var _0x5dd429 = function (_0x490cbc, _0x42c093, _0x59bfef, _0x371d7) {
              return new (_0x59bfef || (_0x59bfef = Promise))(function (_0x321118, _0x1f543a) {
                const _0x283ace = a0_0x1b49;
                function _0x316b44(_0x377768) {
                  const _0x131568 = a0_0x1b49;
                  try {
                    _0x4a98ab(_0x371d7[_0x131568(0x3e1)](_0x377768));
                  } catch (_0x4a1c97) {
                    _0x1f543a(_0x4a1c97);
                  }
                }
                function _0x2d6008(_0x1fcde5) {
                  try {
                    _0x4a98ab(_0x371d7["throw"](_0x1fcde5));
                  } catch (_0x5de562) {
                    _0x1f543a(_0x5de562);
                  }
                }
                function _0x4a98ab(_0x37f963) {
                  const _0x1b7ea7 = a0_0x1b49;
                  var _0x378cd2;
                  _0x37f963[_0x1b7ea7(0x4f5)]
                    ? _0x321118(_0x37f963[_0x1b7ea7(0x331)])
                    : ((_0x378cd2 = _0x37f963["value"]),
                      _0x378cd2 instanceof _0x59bfef
                        ? _0x378cd2
                        : new _0x59bfef(function (_0x3f971a) {
                            _0x3f971a(_0x378cd2);
                          }))[_0x1b7ea7(0x429)](_0x316b44, _0x2d6008);
                }
                _0x4a98ab((_0x371d7 = _0x371d7["apply"](_0x490cbc, _0x42c093 || []))[_0x283ace(0x3e1)]());
              });
            };
            new _0x3da364(_0x4067e7(0x60a));
            const _0xed0ed0 = class {
              constructor(_0x5375b3) {
                const _0x3421ed = _0x4067e7;
                (this[_0x3421ed(0x212)] = 0xac44),
                  (this[_0x3421ed(0x399)] = !0x1),
                  (this[_0x3421ed(0x580)] = 0x0),
                  (this["maxRecordingVoiceTimeoutAllowed"] = 0x1d4c0),
                  (this[_0x3421ed(0x35c)] = 0x5),
                  (this[_0x3421ed(0x3bd)] = 0x32),
                  (this["maxGlobalExtractorTimeAllowed"] =
                    _0x409f64["Z"][_0x3421ed(0x63a)][_0x3421ed(0x38d)][_0x3421ed(0x36c)][_0x3421ed(0x442)]),
                  (this["maxSoundFeedbackRipples"] = 0x3),
                  this[_0x3421ed(0x1df)],
                  (this["stopped"] = !0x1),
                  (this[_0x3421ed(0x719)] = !0x0),
                  (this[_0x3421ed(0x4cb)] =
                    _0x409f64["Z"][_0x3421ed(0x63a)][_0x3421ed(0x3b1)][_0x3421ed(0x6ae)][
                      _0x409f64["Z"][_0x3421ed(0x637)][_0x3421ed(0x403)][_0x3421ed(0x6ae)]
                    ]),
                  (this[_0x3421ed(0x461)] = { audio: { echoCancellation: { ideal: !0x0 } } }),
                  (this[_0x3421ed(0x665)] = 0x12c),
                  (this[_0x3421ed(0x6ea)] = 0x3e8),
                  this["analyzer"],
                  this[_0x3421ed(0x238)],
                  this[_0x3421ed(0x447)],
                  (this[_0x3421ed(0x2ff)] = 0x0),
                  (this[_0x3421ed(0x1fe)] = 0x82),
                  (this["currentRipples"] = 0x0),
                  (this[_0x3421ed(0x31f)] = 0x0),
                  (this[_0x3421ed(0x5fe)] = 0x100),
                  (this[_0x3421ed(0x354)] = 0x0),
                  (this[_0x3421ed(0x634)] = 0x0),
                  (this[_0x3421ed(0x1c8)] = 0x0),
                  (this[_0x3421ed(0x5e5)] = 0x17c),
                  (this["totalAnimateCalls"] = 0x0),
                  (this["logCalls"] = 0x0),
                  (this[_0x3421ed(0x6d5)] = 0x64),
                  (this[_0x3421ed(0x2ac)] = 0xbb80),
                  (this[_0x3421ed(0x60b)] = []),
                  (this["allAmplLog"] = []),
                  (this[_0x3421ed(0x675)] = 0x0),
                  (this[_0x3421ed(0x51f)] = !0x1),
                  (this["minimumRecordingTimeMs"] = 0x7d0),
                  (this[_0x3421ed(0x6e9)] = 0x800),
                  (this[_0x3421ed(0x252)] = _0x409f64["Z"][_0x3421ed(0x637)][_0x3421ed(0x403)]["phrase"]),
                  (this[_0x3421ed(0x453)] = _0x3421ed(0x511)),
                  (this["pauseCounter"] = 0x0),
                  (this[_0x3421ed(0x616)] = "MediaRecorder"),
                  (this[_0x3421ed(0x42d)] = _0x409f64["Z"][_0x3421ed(0x63a)][_0x3421ed(0x218)][_0x3421ed(0x32b)]
                    ? _0x3421ed(0x309)
                    : "audio/webm"),
                  (this[_0x3421ed(0x321)] = new _0x44d76e(new Blob([]), 0x5));
              }
              [_0x4067e7(0x68d)]() {
                return _0x5dd429(this, void 0x0, void 0x0, function* () {
                  const _0x16bae7 = a0_0x1b49;
                  return (
                    yield this[_0x16bae7(0x69c)](),
                    yield new Promise((_0x53af2c, _0xc4d3e4) =>
                      _0x5dd429(this, void 0x0, void 0x0, function* () {
                        const _0x59981e = _0x16bae7;
                        for (; this[_0x59981e(0x719)]; )
                          yield new Promise((_0x5e750a) => setTimeout(_0x5e750a, 0x14d)),
                            (this[_0x59981e(0x6e0)]() || this[_0x59981e(0x59c)]()) && (this[_0x59981e(0x719)] = !0x1);
                        (this["isExtractionCompletedIntervalObject"] = setInterval(
                          () =>
                            _0x5dd429(this, void 0x0, void 0x0, function* () {
                              const _0x4e2c76 = _0x59981e;
                              switch (!0x0) {
                                case this["isGlobalExtractionTimeExpired"]() || this["isMaxExtractionTimerExpired"]():
                                  this[_0x4e2c76(0x48e)](), _0xc4d3e4(new _0x3b1c1e["Z"](_0x4e2c76(0x2d7), new Error()));
                                  break;
                                case this[_0x4e2c76(0x51f)] && this[_0x4e2c76(0x675)] > this["minimumRecordingTimeMs"]:
                                  this[_0x4e2c76(0x3ab)](), this["clearRecordingIntervals"]();
                                  try {
                                    yield this[_0x4e2c76(0x276)](), _0x53af2c(this[_0x4e2c76(0x321)]);
                                  } catch (_0x3fd5b6) {
                                    _0xc4d3e4(_0x3fd5b6);
                                  }
                                  break;
                                case _0x409f64["Z"][_0x4e2c76(0x637)][_0x4e2c76(0x3a9)]:
                                  this[_0x4e2c76(0x48e)](), _0x53af2c(this[_0x4e2c76(0x321)]);
                              }
                            }),
                          this[_0x59981e(0x665)]
                        )),
                          (this[_0x59981e(0x292)] = setInterval(() => {
                            const _0x33d0aa = _0x59981e;
                            this[_0x33d0aa(0x399)] && this[_0x33d0aa(0x600)]();
                          }, this[_0x59981e(0x6d5)]));
                      })
                    ),
                    new Promise((_0x165240, _0x428bbe) => {
                      const _0x74eee1 = _0x16bae7;
                      this[_0x74eee1(0x6bb)] = setInterval(() => {
                        const _0x20d4e2 = _0x74eee1;
                        ((this[_0x20d4e2(0x51f)] && 0x2 === this["audioSnapshot"][_0x20d4e2(0x5b9)] && this[_0x20d4e2(0x62c)]()) ||
                          this["hasUserCanceledAction"]()) &&
                          (_0x165240(this[_0x20d4e2(0x321)]), this[_0x20d4e2(0x48e)]());
                      }, this[_0x74eee1(0x6ea)]);
                    })
                  );
                });
              }
              [_0x4067e7(0x48e)]() {
                const _0x5617dc = _0x4067e7;
                clearInterval(this[_0x5617dc(0x292)]), clearInterval(this[_0x5617dc(0x55f)]), clearInterval(this[_0x5617dc(0x6bb)]);
              }
              [_0x4067e7(0x62c)]() {
                const _0x26b7c1 = _0x4067e7;
                return new Date()["getTime"]() - this[_0x26b7c1(0x1df)] > this["minimumRecordingTimeMs"];
              }
              [_0x4067e7(0x6e0)]() {
                const _0x5b878b = _0x4067e7;
                return new Date()[_0x5b878b(0x214)]() - this["startTime"] > this[_0x5b878b(0x43e)];
              }
              [_0x4067e7(0x59c)]() {
                const _0x170f15 = _0x4067e7;
                return _0x409f64["Z"][_0x170f15(0x637)][_0x170f15(0x3a9)];
              }
              [_0x4067e7(0x496)](_0x3ebb21) {
                return _0x5dd429(this, void 0x0, void 0x0, function* () {
                  const _0x46afe2 = a0_0x1b49;
                  _0x3ebb21 && _0x46afe2(0x511) === this[_0x46afe2(0x453)]
                    ? (yield this["selectedRecorder"][_0x46afe2(0x652)](), (this[_0x46afe2(0x453)] = "PAUSED"))
                    : _0x3ebb21 ||
                      _0x46afe2(0x578) !== this["internalRecorderState"] ||
                      (yield this[_0x46afe2(0x525)][_0x46afe2(0x2f2)](), (this[_0x46afe2(0x453)] = _0x46afe2(0x511)));
                });
              }
              ["getFullBlob"]() {
                return _0x5dd429(this, void 0x0, void 0x0, function* () {
                  const _0x2cf28d = a0_0x1b49;
                  try {
                    if (!this[_0x2cf28d(0x525)]) throw new _0x3b1c1e["Z"](_0x2cf28d(0x2e6), new Error());
                    try {
                      return yield this[_0x2cf28d(0x525)][_0x2cf28d(0x3ee)](), yield this[_0x2cf28d(0x525)][_0x2cf28d(0x3d4)]();
                    } catch (_0x3cac78) {
                      throw _0x3cac78;
                    }
                  } catch (_0x418d69) {
                    throw new _0x3b1c1e["Z"]("RUNTIME_VOICE_CONTEXT_UNKNOWN_ERROR", _0x418d69);
                  }
                });
              }
              [_0x4067e7(0x69c)]() {
                var _0x343e04;
                return _0x5dd429(this, void 0x0, void 0x0, function* () {
                  const _0x37be16 = a0_0x1b49;
                  let _0x8f8340;
                  if (
                    this[_0x37be16(0x495)] ||
                    (null === (_0x343e04 = this[_0x37be16(0x1fa)]) || void 0x0 === _0x343e04 ? void 0x0 : _0x343e04["active"])
                  )
                    return !0x0;
                  try {
                    const _0x4bfeaf = yield navigator[_0x37be16(0x1e2)]["getUserMedia"](this[_0x37be16(0x461)]);
                    (this["readyStream"] = yield this[_0x37be16(0x1db)](_0x4bfeaf)),
                      (_0x8f8340 = new _0x413370(_0x4bfeaf, { mimeType: this[_0x37be16(0x42d)] }));
                    const _0x4d05d3 = { audio: !0x0 };
                    return (
                      (this["analyzerStream"] = yield navigator["mediaDevices"][_0x37be16(0x324)](_0x4d05d3)),
                      yield this[_0x37be16(0x6b5)](),
                      this["createHintMessageElement"](),
                      this[_0x37be16(0x5a8)](),
                      _0x411080[_0x37be16(0x6c3)](),
                      (this[_0x37be16(0x525)] = _0x8f8340),
                      (this[_0x37be16(0x1df)] = new Date()[_0x37be16(0x214)]()),
                      this["attachAnalyzer"](this["analyzerStream"]),
                      this["readyStream"][_0x37be16(0x6fa)]
                    );
                  } catch (_0x1b1510) {
                    throw _0x1b1510;
                  }
                });
              }
              ["startRecording"]() {
                const _0x9738b3 = _0x4067e7;
                (this[_0x9738b3(0x719)] = !0x1), this[_0x9738b3(0x525)][_0x9738b3(0x674)](), this[_0x9738b3(0x42a)]();
              }
              ["waitUntilStreamReady"](_0x5530b1) {
                return _0x5dd429(this, void 0x0, void 0x0, function* () {
                  const _0x46dce6 = a0_0x1b49;
                  let _0x3a0424 = 0x0;
                  const _0x21e4ae = _0x5530b1[_0x46dce6(0x3a6)]();
                  return new Promise((_0x1b0403, _0x6c5c0d) =>
                    _0x5dd429(this, void 0x0, void 0x0, function* () {
                      const _0x44c0ad = _0x46dce6;
                      for (var _0x23e2ae; !this[_0x44c0ad(0x399)]; )
                        yield new Promise((_0x6d27be) => setTimeout(_0x6d27be, 0x12c)),
                          _0x44c0ad(0x46b) ===
                            (null === (_0x23e2ae = _0x21e4ae[0x0]) || void 0x0 === _0x23e2ae ? void 0x0 : _0x23e2ae[_0x44c0ad(0x25f)]) &&
                            ((this[_0x44c0ad(0x399)] = !0x0), _0x1b0403(_0x5530b1)),
                          _0x3a0424++,
                          0x5 === _0x3a0424 && _0x6c5c0d(_0x44c0ad(0x35a));
                    })
                  );
                });
              }
              [_0x4067e7(0x6b5)]() {
                return _0x5dd429(this, void 0x0, void 0x0, function* () {
                  const _0x110214 = a0_0x1b49,
                    _0x133f41 = _0x110214(0x244),
                    _0x506933 = _0x33dbda["g"][_0x110214(0x2c6)][_0x110214(0x506)](_0x110214(0x6dd));
                  _0x506933[_0x110214(0x69a)] = _0x133f41[_0x110214(0x5d1)]();
                  const _0x57e255 = _0x33dbda["g"]["document"]["body"][_0x110214(0x625)](_0x506933);
                  return (this["voiceScreenElement"] = _0x506933), _0x57e255;
                });
              }
              [_0x4067e7(0x42a)]() {
                const _0x5595aa = _0x4067e7,
                  _0x29de66 = document[_0x5595aa(0x1da)](_0x5595aa(0x5c5)),
                  _0xdc066f = document["querySelector"](_0x5595aa(0x68b));
                null == _0x29de66 || _0x29de66[_0x5595aa(0x255)]["add"](_0x5595aa(0x303)),
                  null == _0xdc066f || _0xdc066f["setAttribute"](_0x5595aa(0x3b9), "display:none");
              }
              ["updateRecordingUIMicToDone"]() {
                const _0x5e7067 = _0x4067e7,
                  _0x140f98 = document[_0x5e7067(0x1da)](_0x5e7067(0x5c5));
                null == _0x140f98 || _0x140f98[_0x5e7067(0x255)]["remove"](_0x5e7067(0x303)),
                  null == _0x140f98 || _0x140f98["classList"][_0x5e7067(0x5de)](_0x5e7067(0x412));
              }
              [_0x4067e7(0x21a)](_0x50a61f) {
                const _0xd0f984 = _0x4067e7,
                  _0x5b14a7 = new ((null === _0x33dbda["g"] || void 0x0 === _0x33dbda["g"] ? void 0x0 : _0x33dbda["g"][_0xd0f984(0x312)]) ||
                    (null === _0x33dbda["g"] || void 0x0 === _0x33dbda["g"] ? void 0x0 : _0x33dbda["g"][_0xd0f984(0x448)]))();
                let _0x2a4cbb = _0x5b14a7[_0xd0f984(0x407)](_0x50a61f);
                (this["analyzer"] = _0x5b14a7[_0xd0f984(0x501)]()),
                  (this[_0xd0f984(0x532)][_0xd0f984(0x6a7)] = this[_0xd0f984(0x6e9)]),
                  (this[_0xd0f984(0x447)] = this[_0xd0f984(0x532)]["frequencyBinCount"]),
                  (this[_0xd0f984(0x238)] = new Uint8Array(this[_0xd0f984(0x447)])),
                  _0x2a4cbb[_0xd0f984(0x622)](this["analyzer"]),
                  this[_0xd0f984(0x532)]["getByteTimeDomainData"](this[_0xd0f984(0x238)]);
              }
              [_0x4067e7(0x515)](_0x59b70c) {
                const _0x22f5a7 = _0x4067e7;
                return _0x59b70c[_0x22f5a7(0x208)]((_0x3f2f12, _0x30a6b0) => _0x3f2f12 + _0x30a6b0) / _0x59b70c[_0x22f5a7(0x5ab)] <= 0x80
                  ? (this[_0x22f5a7(0x32e)]++,
                    this[_0x22f5a7(0x32e)] > this[_0x22f5a7(0x35c)] && this[_0x22f5a7(0x1c8)] < this[_0x22f5a7(0x5e5)] / 0x3
                      ? (_0x1068d8["Z"][_0x22f5a7(0x520)][_0x22f5a7(0x3c2)](_0x22f5a7(0x1f4)), !0x0)
                      : this[_0x22f5a7(0x32e)] > this[_0x22f5a7(0x3bd)] &&
                        (_0x1068d8["Z"]["VOICE_PAUSED_LONG"][_0x22f5a7(0x3c2)]("true"), !0x0))
                  : ((this["pauseCounter"] = 0x0), !0x1);
              }
              ["processAnalysisEffects"]() {
                return _0x5dd429(this, void 0x0, void 0x0, function* () {
                  const _0x352e4 = a0_0x1b49;
                  this[_0x352e4(0x532)]["getByteTimeDomainData"](this["dataArray"]),
                    this[_0x352e4(0x515)](this[_0x352e4(0x238)])
                      ? this["togglePauseRecording"](!0x0)
                      : ((this["activeRecordingDuration"] += this[_0x352e4(0x6d5)]), this[_0x352e4(0x496)](!0x1));
                  for (let _0xdb5868 = 0x0; _0xdb5868 < this["bufferLength"]; _0xdb5868 += 0x2) {
                    const _0x3a5cd3 = this[_0x352e4(0x238)][_0xdb5868] || 0x0;
                    this[_0x352e4(0x482)](_0x3a5cd3);
                  }
                });
              }
              ["doAnalysisUpdates"](_0x5f952) {
                const _0x18a92d = _0x4067e7;
                this["logCalls"]++,
                  (this[_0x18a92d(0x2ff)] = _0x5f952),
                  this[_0x18a92d(0x1c8)] >= this[_0x18a92d(0x5e5)] && (this[_0x18a92d(0x51f)] = !0x0),
                  _0x5f952 > this[_0x18a92d(0x1fe)]
                    ? (this[_0x18a92d(0x60b)]["push"](_0x5f952),
                      this[_0x18a92d(0x1c8)]++,
                      this["currentRipples"] < this[_0x18a92d(0x394)] &&
                        (this[_0x18a92d(0x6e8)]++, this[_0x18a92d(0x4fe)](), (this["lowAmpleCount"] = 0x0)))
                    : this["lowAmpleCount"]++,
                  _0x5f952 > this[_0x18a92d(0x31f)] && (this[_0x18a92d(0x31f)] = _0x5f952),
                  _0x5f952 < this[_0x18a92d(0x1fe)] &&
                    _0x5f952 > 0x0 &&
                    _0x5f952 > this[_0x18a92d(0x354)] &&
                    (this[_0x18a92d(0x354)] = _0x5f952),
                  _0x5f952 < this[_0x18a92d(0x5fe)] && (this[_0x18a92d(0x5fe)] = _0x5f952);
              }
              [_0x4067e7(0x4fe)]() {
                const _0x6f7a64 = _0x4067e7;
                var _0x48c9d5;
                this[_0x6f7a64(0x54a)]++;
                let _0x238aa0 = document["querySelector"](".mitek-voice-container-ui"),
                  _0xa430d = document[_0x6f7a64(0x506)](_0x6f7a64(0x6dd)),
                  _0x2b4971 = document[_0x6f7a64(0x506)](_0x6f7a64(0x6dd));
                _0xa430d["classList"][_0x6f7a64(0x5de)]("ripple-circle"),
                  _0x2b4971[_0x6f7a64(0x255)]["add"](_0x6f7a64(0x2df)),
                  null == _0x238aa0 || _0x238aa0[_0x6f7a64(0x625)](_0xa430d),
                  null === (_0x48c9d5 = document[_0x6f7a64(0x5bb)](_0x6f7a64(0x531))) ||
                    void 0x0 === _0x48c9d5 ||
                    _0x48c9d5["classList"][_0x6f7a64(0x5de)](_0x6f7a64(0x534)),
                  setTimeout(() => {
                    null == _0x238aa0 || _0x238aa0["appendChild"](_0x2b4971);
                  }, 0x3e8),
                  setTimeout(() => {
                    const _0x350d27 = _0x6f7a64;
                    var _0x406263;
                    _0xa430d[_0x350d27(0x44c)](),
                      this["currentRipples"] >= this[_0x350d27(0x394)] && (this[_0x350d27(0x6e8)] = 0x0),
                      null === (_0x406263 = document[_0x350d27(0x5bb)](_0x350d27(0x531))) ||
                        void 0x0 === _0x406263 ||
                        _0x406263[_0x350d27(0x255)][_0x350d27(0x5de)]("mic-vol-high");
                  }, 0x7d0),
                  setTimeout(() => {
                    const _0x3088ca = _0x6f7a64;
                    var _0x4dd182;
                    _0x2b4971[_0x3088ca(0x44c)](),
                      null === (_0x4dd182 = document["querySelector"](_0x3088ca(0x531))) ||
                        void 0x0 === _0x4dd182 ||
                        _0x4dd182[_0x3088ca(0x255)]["remove"](_0x3088ca(0x534));
                  }, 0x7d0);
              }
              ["createHintMessageElement"]() {
                const _0x32804e = _0x4067e7;
                var _0x557d99;
                this[_0x32804e(0x57c)] = document[_0x32804e(0x5bb)](".mitek-voice-container-ui");
                const _0x33e5b4 = document[_0x32804e(0x506)](_0x32804e(0x6dd));
                _0x33e5b4[_0x32804e(0x584)]("id", _0x32804e(0x44d)),
                  _0x33e5b4[_0x32804e(0x255)]["add"]("mitek-center-offset"),
                  (this["hintMessageElement"] = _0x33e5b4),
                  this["hintMessageElement"][_0x32804e(0x255)][_0x32804e(0x5de)](this[_0x32804e(0x4cb)]),
                  null === (_0x557d99 = this[_0x32804e(0x57c)]) || void 0x0 === _0x557d99 || _0x557d99[_0x32804e(0x625)](_0x33e5b4);
              }
              ["createPhrseElement"]() {
                const _0x13f698 = _0x4067e7,
                  _0x41bad9 = document[_0x13f698(0x506)](_0x13f698(0x6dd));
                _0x41bad9[_0x13f698(0x584)]("id", _0x13f698(0x42e)),
                  _0x41bad9[_0x13f698(0x255)][_0x13f698(0x5de)](_0x13f698(0x1c5)),
                  (_0x41bad9["innerText"] = this[_0x13f698(0x252)]),
                  this[_0x13f698(0x57c)][_0x13f698(0x625)](_0x41bad9);
              }
              [_0x4067e7(0x276)]() {
                return _0x5dd429(this, void 0x0, void 0x0, function* () {
                  const _0x368fe0 = a0_0x1b49;
                  if (!this[_0x368fe0(0x399)]) throw _0x368fe0(0x319);
                  try {
                    return (this[_0x368fe0(0x321)] = yield this["takeAudioSnapshotData"]()), !0x0;
                  } catch (_0x2051bd) {
                    throw _0x2051bd;
                  }
                });
              }
              [_0x4067e7(0x5ac)](_0x3b0bd2) {
                _0x3b0bd2 && _0x3b0bd2["remove"]();
              }
              ["removeAllExtractorDOMElements"]() {
                const _0x1638d3 = _0x4067e7;
                this["removeDomElementSafely"](this[_0x1638d3(0x495)]), this["removeDomElementSafely"](this[_0x1638d3(0x3d1)]);
              }
              [_0x4067e7(0x40c)](_0x231621) {
                const _0x175264 = _0x4067e7;
                return { width: _0x231621[_0x175264(0x359)], height: _0x231621[_0x175264(0x345)] };
              }
              ["registerEventListeners"]() {
                var _0x1df772;
                return _0x5dd429(this, void 0x0, void 0x0, function* () {
                  const _0x1bf558 = a0_0x1b49;
                  try {
                    if (!_0x33dbda["g"][_0x1bf558(0x2c6)]["getElementById"](_0x1bf558(0x2f6))) throw new Error(_0x1bf558(0x567));
                    null === (_0x1df772 = _0x33dbda["g"][_0x1bf558(0x2c6)][_0x1bf558(0x1da)](_0x1bf558(0x2f6))) ||
                      void 0x0 === _0x1df772 ||
                      _0x1df772[_0x1bf558(0x307)](
                        _0x1bf558(0x2b7),
                        (_0x42cbef) => {
                          const _0x28dec9 = _0x1bf558;
                          this[_0x28dec9(0x67c)](),
                            this[_0x28dec9(0x674)](),
                            this[_0x28dec9(0x4fe)](),
                            _0x411080["sendVoiceRecordingStartedToIntegrator"](),
                            _0x1068d8["Z"][_0x28dec9(0x46e)][_0x28dec9(0x3c2)](_0x28dec9(0x1f4));
                        },
                        { once: !0x0 }
                      );
                  } catch (_0x58b492) {
                    throw _0x58b492;
                  }
                });
              }
              [_0x4067e7(0x220)]() {
                return _0x5dd429(this, void 0x0, void 0x0, function* () {
                  const _0x3005a8 = a0_0x1b49;
                  try {
                    let _0x4d561f = yield this[_0x3005a8(0x633)]();
                    return new _0x44d76e(_0x4d561f, 0x2);
                  } catch (_0x51c390) {
                    throw new _0x3b1c1e["Z"](_0x3005a8(0x6f9), _0x51c390);
                  }
                });
              }
              [_0x4067e7(0x4a6)]() {}
              [_0x4067e7(0x384)]() {
                const _0xd99a3d = _0x4067e7;
                return new Date()[_0xd99a3d(0x214)]() - this[_0xd99a3d(0x1df)] > this[_0xd99a3d(0x207)];
              }
              [_0x4067e7(0x3e9)](_0x1171c3) {
                const _0x2de6bf = _0x4067e7;
                if (_0x1171c3["active"]) {
                  const _0x5a1ebf = _0x1171c3[_0x2de6bf(0x440)]();
                  if (_0x5a1ebf)
                    for (let _0x1c783f = 0x0; _0x1c783f < _0x5a1ebf["length"]; _0x1c783f++) {
                      _0x5a1ebf[_0x1c783f][_0x2de6bf(0x52e)]();
                    }
                }
              }
              [_0x4067e7(0x265)]() {
                const _0x13a774 = _0x4067e7;
                try {
                  this["stopStream"](this[_0x13a774(0x1fa)]),
                    this[_0x13a774(0x3e9)](this["analyzerStream"]),
                    this[_0x13a774(0x4a6)](),
                    this[_0x13a774(0x2d8)](),
                    this[_0x13a774(0x525)][_0x13a774(0x586)](),
                    this["clearRecordingIntervals"]();
                } catch (_0x486983) {}
              }
              [_0x4067e7(0x6e1)](_0x408a4d) {
                return new Promise((_0x8be997, _0x3569e5) => {
                  const _0x21137d = a0_0x1b49,
                    _0x1cb119 = new FileReader();
                  (_0x1cb119["onerror"] = (_0x300b87) => {
                    _0x3569e5(_0x300b87);
                  }),
                    (_0x1cb119["onloadend"] = () => {
                      const _0x40085f = a0_0x1b49;
                      _0x8be997(_0x1cb119[_0x40085f(0x28b)]);
                    }),
                    _0x1cb119[_0x21137d(0x2a4)](_0x408a4d);
                });
              }
            };
            var _0x4ffb6a = function (_0x7b352e, _0x220cdc, _0x565f2b, _0x17aa42) {
              return new (_0x565f2b || (_0x565f2b = Promise))(function (_0x474aa0, _0x56b73c) {
                const _0x4de86c = a0_0x1b49;
                function _0x3782eb(_0x3bf6d1) {
                  try {
                    _0x2c425b(_0x17aa42["next"](_0x3bf6d1));
                  } catch (_0x4267b2) {
                    _0x56b73c(_0x4267b2);
                  }
                }
                function _0xeeb70e(_0x3e2a87) {
                  const _0x48c430 = a0_0x1b49;
                  try {
                    _0x2c425b(_0x17aa42[_0x48c430(0x3b2)](_0x3e2a87));
                  } catch (_0x181157) {
                    _0x56b73c(_0x181157);
                  }
                }
                function _0x2c425b(_0x3cf7c1) {
                  const _0x4f8ed0 = a0_0x1b49;
                  var _0x1c46d8;
                  _0x3cf7c1["done"]
                    ? _0x474aa0(_0x3cf7c1[_0x4f8ed0(0x331)])
                    : ((_0x1c46d8 = _0x3cf7c1[_0x4f8ed0(0x331)]),
                      _0x1c46d8 instanceof _0x565f2b
                        ? _0x1c46d8
                        : new _0x565f2b(function (_0x4726ca) {
                            _0x4726ca(_0x1c46d8);
                          }))["then"](_0x3782eb, _0xeeb70e);
                }
                _0x2c425b((_0x17aa42 = _0x17aa42[_0x4de86c(0x1d1)](_0x7b352e, _0x220cdc || []))["next"]());
              });
            };
            new _0x3da364(_0x4067e7(0x38c));
            const _0x15df86 = class extends _0x2a0747 {
                constructor() {
                  const _0x14a7ca = _0x4067e7;
                  super();
                  try {
                    (this[_0x14a7ca(0x558)] = _0x261819["getValidator"](_0x409f64["Z"][_0x14a7ca(0x637)][_0x14a7ca(0x452)])),
                      (this[_0x14a7ca(0x3a2)] = new _0xed0ed0(_0x409f64["Z"][_0x14a7ca(0x637)]["facingDirection"])),
                      (this[_0x14a7ca(0x351)] = new _0x15a5df(_0x409f64["Z"][_0x14a7ca(0x637)][_0x14a7ca(0x452)][_0x14a7ca(0x245)])),
                      (this[_0x14a7ca(0x320)] = new _0x35eb91(_0x409f64["Z"]["currentAction"][_0x14a7ca(0x452)][_0x14a7ca(0x245)]));
                  } catch (_0x5248e9) {
                    throw new _0x3b1c1e["Z"](_0x14a7ca(0x2e6), _0x5248e9);
                  }
                }
                ["startContextExecution"]() {
                  return _0x4ffb6a(this, void 0x0, void 0x0, function* () {
                    const _0x5dce2e = a0_0x1b49;
                    let _0x496d41 = !0x1;
                    try {
                      this[_0x5dce2e(0x558)][_0x5dce2e(0x561)]();
                      if (!(yield _0x3c9edc["Z"][_0x5dce2e(0x647)]())) throw new _0x3b1c1e["Z"](_0x5dce2e(0x59d), new Error());
                      for (; !_0x496d41; ) {
                        const _0x3f5145 = yield this[_0x5dce2e(0x3a2)]["extract"]();
                        this[_0x5dce2e(0x50f)] = yield this[_0x5dce2e(0x351)][_0x5dce2e(0x541)](_0x3f5145);
                        const _0xa732d4 = new _0x1bf369(_0x409f64["Z"][_0x5dce2e(0x637)]["actionIdentifier"], this[_0x5dce2e(0x50f)])[
                            _0x5dce2e(0x5fb)
                          ],
                          _0x26c92a = yield this["Recognizer"][_0x5dce2e(0x388)](_0xa732d4, this[_0x5dce2e(0x50f)][_0x5dce2e(0x27f)]),
                          _0x2c261f = _0x2fa509[_0x5dce2e(0x2f9)](_0x409f64["Z"][_0x5dce2e(0x637)][_0x5dce2e(0x452)], _0x26c92a);
                        switch ((this[_0x5dce2e(0x473)](_0x2c261f), !0x0)) {
                          case _0x2c261f instanceof _0x579044:
                          case _0x409f64["Z"]["currentAction"][_0x5dce2e(0x6b3)]:
                            _0x496d41 = !0x0;
                            break;
                          case _0x2c261f instanceof _0x308ca0:
                            throw (
                              ((_0x496d41 = !0x0),
                              new _0x3b1c1e["Z"](
                                "RUNTIME_VOICE_CONTEXT_UNKNOWN_ERROR",
                                new Error("failed\x20single\x20recognized\x20evaluation")
                              ))
                            );
                          case this[_0x5dce2e(0x3a2)][_0x5dce2e(0x384)]():
                            throw (
                              (console["warn"]("internal\x20timeout\x20" + this[_0x5dce2e(0x3a2)]["maxRecordingVoiceTimeoutAllowed"]),
                              new _0x3b1c1e["Z"](_0x5dce2e(0x2d7), new Error()))
                            );
                          case _0x409f64["Z"][_0x5dce2e(0x637)]["isStopped"]:
                            if (((_0x496d41 = !0x0), _0x5dce2e(0x69e) !== _0x409f64["Z"][_0x5dce2e(0x637)][_0x5dce2e(0x591)]))
                              throw new _0x3b1c1e["Z"](
                                _0x409f64["Z"][_0x5dce2e(0x637)][_0x5dce2e(0x591)],
                                new Error(_0x409f64["Z"]["currentAction"][_0x5dce2e(0x591)])
                              );
                        }
                      }
                      return (
                        yield _0x409f64["Z"][_0x5dce2e(0x20b)](),
                        Object[_0x5dce2e(0x70e)](
                          new _0x3289d5(
                            _0x409f64["Z"][_0x5dce2e(0x637)]["actionIdentifier"],
                            this["transformedAudioDataSnapshot"],
                            this[_0x5dce2e(0x42f)],
                            _0x409f64["Z"][_0x5dce2e(0x637)]["exif"],
                            _0x409f64["Z"][_0x5dce2e(0x637)][_0x5dce2e(0x274)],
                            this[_0x5dce2e(0x4f4)]
                          )
                        )
                      );
                    } catch (_0xb255) {
                      let _0xc69471 = _0xb255 instanceof _0x3b1c1e["Z"] ? _0xb255 : new _0x3b1c1e["Z"](_0x5dce2e(0x2e6), _0xb255);
                      return (
                        this[_0x5dce2e(0x44b)](_0x411080["getRuntimeOutboundError"](_0xc69471), _0xb255),
                        Object[_0x5dce2e(0x70e)](
                          new _0x3289d5(
                            _0x409f64["Z"][_0x5dce2e(0x637)][_0x5dce2e(0x452)],
                            this[_0x5dce2e(0x50f)],
                            this["lastRecognizedEvaluation"],
                            _0x409f64["Z"][_0x5dce2e(0x637)][_0x5dce2e(0x514)],
                            _0x409f64["Z"]["currentAction"][_0x5dce2e(0x274)]
                          )
                        )
                      );
                    } finally {
                      this[_0x5dce2e(0x560)]();
                    }
                  });
                }
                [_0x4067e7(0x560)]() {
                  const _0x106204 = _0x4067e7;
                  try {
                    this["Extractor"][_0x106204(0x265)](), this[_0x106204(0x320)][_0x106204(0x4f9)](), _0x411080[_0x106204(0x63f)]();
                  } catch (_0x4ce48b) {
                    console[_0x106204(0x677)](_0x106204(0x383) + _0x4ce48b);
                  }
                }
              },
              _0xd0ca4e = new (class {
                constructor() {
                  const _0x2c3d30 = _0x4067e7;
                  this[_0x2c3d30(0x327)] = this["convertStringToStylesheetWithId"](
                    "/*css*/\x0a\x0a\x20\x20.mitekDisplayContainerFull\x20{\x0a\x20\x20\x20\x20max-width:\x20100vw;\x0a\x20\x20\x20\x20max-height:\x20100vh;\x0a\x20\x20\x20\x20visibility:\x20hidden;\x0a\x20\x20\x20\x20position:\x20fixed;\x0a\x20\x20\x20\x20top:\x200;\x0a\x20\x20\x20\x20left:\x200;\x0a\x20\x20\x20\x20bottom:\x200;\x0a\x20\x20\x20\x20right:\x200;\x0a\x20\x20\x20\x20background-color:\x20black;\x0a\x20\x20}\x0a\x0a\x20\x20.mitekDisplayContainerCustom\x20{\x0a\x20\x20\x20\x20max-width:\x20100vw;\x0a\x20\x20\x20\x20max-height:\x20100vh;\x0a\x20\x20\x20\x20visibility:\x20hidden;\x0a\x20\x20\x20\x20position:\x20absolute;\x0a\x20\x20\x20\x20top:\x200;\x0a\x20\x20\x20\x20left:\x200;\x0a\x20\x20\x20\x20bottom:\x200;\x0a\x20\x20\x20\x20right:\x200;\x0a\x20\x20\x20\x20background-color:\x20pink;\x0a\x20\x20\x20\x20overflow:\x20hidden;\x0a\x20\x20\x20\x20position:\x20relative;\x0a\x20\x20}\x0a\x0a\x20\x20.mitekMediaStreamSourceFull\x20{\x0a\x20\x20\x20\x20width:\x20100vw;\x0a\x20\x20\x20\x20height:\x20100vh;\x0a\x20\x20\x20\x20position:\x20relative;\x0a\x20\x20\x20\x20top:\x200;\x0a\x20\x20\x20\x20right:\x200;\x0a\x20\x20\x20\x20bottom:\x200;\x0a\x20\x20\x20\x20left:\x200;\x0a\x20\x20\x20\x20object-fit:\x20cover;\x0a\x20\x20}\x0a\x0a\x20\x20.mitekTransformVideoHZ\x20{\x0a\x20\x20\x20\x20transform:\x20scale(1.5)\x0a\x20\x20\x20\x20border:\x203px\x20solid\x20red;\x0a\x20\x20}\x0a\x0a\x20\x20#mitekMediaStreamSource\x20{\x0a\x20\x20\x20\x20transition:\x20transform\x20.2s;\x0a\x20\x20}\x0a\x0a\x20\x20.mitekMediaStreamSourceCustom\x20{\x0a\x20\x20\x20\x20position:\x20relative;\x0a\x20\x20\x20\x20top:\x200;\x0a\x20\x20\x20\x20right:\x200;\x0a\x20\x20\x20\x20bottom:\x200;\x0a\x20\x20\x20\x20left:\x200;\x0a\x20\x20\x20\x20object-fit:\x20cover;\x0a\x20\x20}\x0a\x20\x20#mitekHintMessage\x20{\x0a\x20\x20\x20\x20width:\x2090%;\x0a\x20\x20\x20\x20padding:\x2015px\x2010px;\x0a\x20\x20\x20\x20position:\x20absolute;\x0a\x20\x20\x20\x20top:\x2050%;\x0a\x20\x20\x20\x20left:\x2050%;\x0a\x20\x20\x20\x20z-index:\x203;\x0a\x20\x20\x20\x20border:\x201px\x20solid\x20#58CE54;\x0a\x20\x20\x20\x20border-radius:\x2010px;\x0a\x20\x20\x20\x20-webkit-border-radius:\x2010px;\x0a\x20\x20\x20\x20text-align:\x20center;\x0a\x20\x20\x20\x20font-family:\x20arial;\x0a\x20\x20\x20\x20font-weight:\x20bold;\x0a\x20\x20\x20\x20color:\x20black;\x0a\x20\x20\x20\x20background-color:\x20rgba(255,\x20255,\x20255,\x200.8);\x0a\x20\x20}\x0a\x20\x20#mitekVoicePhrase\x20{\x0a\x20\x20\x20\x20width:\x2090%;\x0a\x20\x20\x20\x20padding:\x2015px\x2010px;\x0a\x20\x20\x20\x20position:\x20absolute;\x0a\x20\x20\x20\x20top:\x2020%;\x0a\x20\x20\x20\x20left:\x2050%;\x0a\x20\x20\x20\x20min-height:\x2010%;\x0a\x20\x20\x20\x20font-size:\x202em;\x0a\x20\x20\x20\x20z-index:\x203;\x0a\x20\x20\x20\x20border:\x201px\x20solid\x20#fff;\x0a\x20\x20\x20\x20text-align:\x20center;\x0a\x20\x20\x20\x20font-family:\x20arial;\x0a\x20\x20\x20\x20font-weight:\x20bold;\x0a\x20\x20\x20\x20color:\x20#fdfdfd;\x0a\x20\x20\x20\x20background-color:\x20rgba(87,\x2087,\x2087,0.5);\x0a\x20\x20}\x0a\x20\x20\x0a\x0a\x20\x20.mitek-video-container\x20{\x0a\x20\x20\x20\x20margin:\x200;\x0a\x20\x20\x20\x20padding:\x200;\x0a\x20\x20\x20\x20position:\x20absolute;\x0a\x20\x20\x20\x20top:\x200;\x0a\x20\x20\x20\x20left:\x200;\x0a\x20\x20\x20\x20bottom:\x200;\x0a\x20\x20\x20\x20right:\x200;\x0a\x20\x20}\x0a\x20\x20.mitek-voice-container\x20{\x0a\x20\x20\x20\x20\x20\x20position:\x20fixed;\x0a\x20\x20\x20\x20\x20\x20top:\x200;\x0a\x20\x20\x20\x20\x20\x20left:\x200;\x0a\x20\x20\x20\x20\x20\x20background:\x20rgba(0,\x200,\x200,\x20100);\x0a\x20\x20\x20\x20\x20\x20z-index:\x205;\x0a\x20\x20\x20\x20\x20\x20width:\x20100%;\x0a\x20\x20\x20\x20\x20\x20height:\x20100%;\x0a\x20\x20\x20\x20}\x0a\x0a\x20\x20\x20\x20.mitek-voice-container-ui\x20{\x0a\x20\x20\x20\x20\x20\x20min-width:\x2080%;\x0a\x20\x20\x20\x20\x20\x20min-height:\x2090%;\x0a\x20\x20\x20\x20\x20\x20border:\x201px\x20solid\x20gray;\x0a\x20\x20\x20\x20\x20\x20border-radius:\x2020px;\x0a\x20\x20\x20\x20\x20\x20/*\x20Center\x20vertically\x20and\x20horizontally\x20*/\x0a\x20\x20\x20\x20\x20\x20position:\x20absolute;\x0a\x20\x20\x20\x20\x20\x20top:\x2050%;\x0a\x20\x20\x20\x20\x20\x20left:\x2050%;\x0a\x20\x20\x20\x20\x20\x20transform:\x20translate(-50%,\x20-50%);\x0a\x0a\x20\x20\x20\x20}\x0a\x0a\x20\x20\x20\x20.mitek-voice-container-ui\x20#mitekVoiceRecordButton\x20{\x0a\x20\x20\x20\x20\x20\x20top:\x2080%;\x0a\x20\x20\x20\x20\x20\x20left:\x2050%;\x0a\x20\x20\x20\x20\x20\x20position:\x20absolute;\x0a\x20\x20\x20\x20\x20\x20transform:\x20translate(-50%,\x20-50%);\x0a\x20\x20\x20\x20\x20\x20display:\x20block;\x0a\x20\x20\x20\x20\x20\x20color:\x20white;\x0a\x20\x20\x20\x20\x20\x20height:\x20100px;\x0a\x20\x20\x20\x20\x20\x20width:\x20100px;\x0a\x20\x20\x20\x20\x20\x20border-radius:\x2050%;\x0a\x20\x20\x20\x20\x20\x20background-color:\x20transparent;\x0a\x20\x20\x20\x20\x20\x20border:\x202px\x20solid\x20white;\x0a\x20\x20\x20\x20}\x0a\x0a\x0a\x20\x20\x20\x20#mitek-voice-mic\x20{\x0a\x20\x20\x20\x20\x20\x20width:\x2050%;\x0a\x20\x20\x20\x20\x20\x20height:\x2050%;\x0a\x20\x20\x20\x20\x20\x20margin-left:\x2020%;\x0a\x20\x20\x20\x20\x20\x20top:\x2025%;\x0a\x20\x20\x20\x20\x20\x20float:\x20left;\x0a\x20\x20\x20\x20\x20\x20position:\x20absolute;\x0a\x20\x20\x20\x20\x20\x20background-size:\x20cover;\x0a\x20\x20\x20\x20\x20\x20background-image:\x20url(\x22data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pg0KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDE5LjAuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPg0KPHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJDYXBhXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4Ig0KCSB2aWV3Qm94PSIwIDAgNDkwLjkgNDkwLjkiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDQ5MC45IDQ5MC45OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8Zz4NCgk8Zz4NCgkJPHBhdGggZD0iTTI0NS41LDMyMi45YzUzLDAsOTYuMi00My4yLDk2LjItOTYuMlY5Ni4yYzAtNTMtNDMuMi05Ni4yLTk2LjItOTYuMnMtOTYuMiw0My4yLTk2LjIsOTYuMnYxMzAuNQ0KCQkJQzE0OS4zLDI3OS44LDE5Mi41LDMyMi45LDI0NS41LDMyMi45eiBNMTczLjgsOTYuMmMwLTM5LjUsMzIuMi03MS43LDcxLjctNzEuN3M3MS43LDMyLjIsNzEuNyw3MS43djEzMC41DQoJCQljMCwzOS41LTMyLjIsNzEuNy03MS43LDcxLjdzLTcxLjctMzIuMi03MS43LTcxLjdWOTYuMnoiLz4NCgkJPHBhdGggZD0iTTk0LjQsMjE0LjVjLTYuOCwwLTEyLjMsNS41LTEyLjMsMTIuM2MwLDg1LjksNjYuNywxNTYuNiwxNTEuMSwxNjIuOHY3Ni43aC02My45Yy02LjgsMC0xMi4zLDUuNS0xMi4zLDEyLjMNCgkJCXM1LjUsMTIuMywxMi4zLDEyLjNoMTUyLjNjNi44LDAsMTIuMy01LjUsMTIuMy0xMi4zcy01LjUtMTIuMy0xMi4zLTEyLjNoLTYzLjl2LTc2LjdjODQuNC02LjMsMTUxLjEtNzYuOSwxNTEuMS0xNjIuOA0KCQkJYzAtNi44LTUuNS0xMi4zLTEyLjMtMTIuM3MtMTIuMyw1LjUtMTIuMywxMi4zYzAsNzYuNi02Mi4zLDEzOC45LTEzOC45LDEzOC45cy0xMzguOS02Mi4zLTEzOC45LTEzOC45DQoJCQlDMTA2LjYsMjIwLDEwMS4yLDIxNC41LDk0LjQsMjE0LjV6Ii8+DQoJPC9nPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPC9zdmc+DQo=\x22)\x0a\x20\x20\x20\x20}\x0a\x20\x20\x20\x20\x0a\x20\x20\x20\x20#mitek-voice-mic.mic-muted\x20{\x0a\x20\x20\x20\x20\x20\x20filter:\x20invert(48%)\x20saturate(0)\x20brightness(118%)\x20contrast(119%);\x0a\x0a\x20\x20\x20\x20}\x0a\x20\x20\x20\x20\x0a\x20\x20\x20\x20#mitek-voice-mic.mic-active\x20{\x0a\x20\x20\x20\x20\x20\x20filter:\x20invert(48%)\x20sepia(79%)\x20saturate(2476%)\x20hue-rotate(330deg)\x20brightness(118%)\x20contrast(119%);\x0a\x20\x20\x20\x20}\x0a\x0a\x20\x20\x20\x20#mitek-voice-mic.mic-done\x20{\x0a\x20\x20\x20\x20\x20\x20filter:\x20invert(48%)\x20sepia(79%)\x20saturate(2476%)\x20hue-rotate(86deg)\x20brightness(118%)\x20contrast(119%);\x0a\x20\x20\x20\x20\x20\x20background-image:\x20url(\x27data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAABmJLR0QA/wD/AP+gvaeTAAADXUlEQVRoge3ZzWtdRRjH8Y8JbbRWbUEDhWpRpNi1fVHRLiq4cWPuRv+Baq0b3RVEG1Bc1ug/UXxr/wNBcCOKi9YXULRRRKOpmxqIsaVxMefqce7c3JlzpmIxPxjCuXee5/nOzcwzz8xhU5v6f+uGSn6msB9Hmr97sRs34wp+xTK+wYf4AOdxtVL8ztqFV/E91gvbdziB2/91auzEG1jNhN2oreI13DQh5n214Af4uQJ43L7GoTEx5/AH5vuATwu/+jiASziNoziAO7AF23AnHsQLOCP9nzvX2IyDH/brNIgbm8Ap8J9wXFiwudrZ2CwWwq83z/tK4KdxNgH+O05ie4mzSDN4Vhn8XGmQ1LRZwkOdkPNUDX5gFP4z3FWLNKFq8Lfhx8jRMu6pRZrQQCV4eNPonL8upg1hh41T3ckqmGlVhSeUB3Gq7JNtNlJ1+CmhTmk7PN4bM60S+FlhY5yog5HDS8o2qVyVwO/Gl8IOP1EnIqenK8DGKoG/FxeaPs/nOH83cnx0g75dKsSSVLlXWH/Dfm/nBDgfOT84pt/8BoHHqTTPPxb1/SgnyMXIKHXgmM8E6AMPe6L+F3IGsBYZbY2+39cBpOsOuy2yWakxAHhc2Jnb/a7gqYrwhGo1rgYmKmcKMT6TDDLgB/I0G9ku5xjlLuJJg+gLDw9E9udyjOI0+vSE/uMG0RcejkU+3ok7TCWMPomej0wIchZP4nLrsy3+ue1fFtbHmQm+Yj0aPX+cYxSXEr/JKyVSU6brL08oHlciX/tzDFPF3HOZQeNBdIUnnJXbDIvSMyapuJxewi2ZtsNB9IGf8feNxbC9UuIgdaApuY8ZZqGuejmKvdowFSm+jVjDwz2gcnXY6Fpa6OLoVqOH+ouu7aF+j9FryyXs6OpwIFyBtx1+3gSqrbvxRRTrKp7o63ghcrqOX/BIX8ctHRbKhDjOqRrOp6XvRdfwonSxl6sZvGS0gFzHe03sKpox/nL3Wzyj7NZiu5Dn41TZhp+pxP6XpvG60TXRrtXfEuqXQ0IlubVps81nx4RjYbzDtuf8KRV/+ZTmhMyQAujTlvS4CyrVDnVfMS3okSr7aJewxce1U05bbGyLd9i2ar5mvd/oa9bhwl7BD/hKKInfx6f+A69ZN7Wp611/AksDLCavB1AcAAAAAElFTkSuQmCC\x27);\x0a\x20\x20\x20\x20\x20\x20transition:\x20ease-in-out\x200.2s\x20all;\x0a\x20\x20\x20\x20}\x0a\x20\x20\x20\x20#mitek-voice-mic.mic-done\x20>\x20.mic-vol\x20{\x0a\x20\x20\x20\x20\x20\x20display:\x20none;\x0a\x20\x20\x20\x20}\x0a\x0a\x20\x20\x20\x20@keyframes\x20mic-volume-fluctuation\x20{\x0a\x20\x20\x20\x20\x20\x2025%\x20{\x0a\x20\x20\x20\x20\x20\x20\x20\x20height:\x208px;\x0a\x20\x20\x20\x20\x20\x20\x20\x20margin-top:\x2022px;\x0a\x20\x20\x20\x20\x20\x20}\x0a\x0a\x20\x20\x20\x20\x20\x2050%\x20{\x0a\x20\x20\x20\x20\x20\x20\x20\x20height:\x2010px;\x0a\x20\x20\x20\x20\x20\x20\x20\x20margin-top:\x2020px;\x0a\x20\x20\x20\x20\x20\x20}\x0a\x0a\x20\x20\x20\x20\x20\x20100%\x20{\x0a\x20\x20\x20\x20\x20\x20\x20\x20height:\x208px;\x0a\x20\x20\x20\x20\x20\x20\x20\x20margin-top:\x2022px;\x0a\x20\x20\x20\x20\x20\x20}\x0a\x20\x20\x20\x20}\x0a\x0a\x20\x20\x20\x20.mic-vol\x20{\x0a\x20\x20\x20\x20\x20\x20margin-left:\x2035%;\x0a\x20\x20\x20\x20\x20\x20width:\x2015px;\x0a\x20\x20\x20\x20\x20\x20height:\x208px;\x0a\x20\x20\x20\x20\x20\x20margin-top:\x2022px;\x0a\x20\x20\x20\x20\x20\x20border-radius:\x205px;\x0a\x20\x20\x20\x20\x20\x20border-top-right-radius:\x200;\x0a\x20\x20\x20\x20\x20\x20border-top-left-radius:\x200;\x0a\x20\x20\x20\x20\x20\x20background-color:\x20#d02525;\x0a\x20\x20\x20\x20\x20\x20display:\x20block;\x0a\x20\x20\x20\x20\x20\x20position:\x20absolute;\x0a\x20\x20\x20\x20\x20\x20animation-name:\x20mic-volume-fluctuation;\x0a\x20\x20\x20\x20\x20\x20animation-duration:\x2020ms;\x0a\x20\x20\x20\x20\x20\x20/*\x20animation-iteration-count:\x20infinite;\x20*/\x0a\x20\x20\x20\x20}\x0a\x20\x20\x20\x20.mic-muted-line\x20{\x0a\x20\x20\x20\x20\x20\x20border-radius:\x2030px;\x0a\x20\x20\x20\x20\x20\x20transform:\x20rotate(45deg);\x0a\x20\x20\x20\x20\x20\x20margin-top:\x2038%;\x0a\x20\x20\x20\x20\x20\x20border-top:\x203px\x20solid\x20white;\x0a\x20\x20\x20\x20}\x0a\x0a\x20\x20\x20\x20@keyframes\x20mic-volume-fluctuation-high\x20{\x0a\x20\x20\x20\x20\x20\x2025%\x20{\x0a\x20\x20\x20\x20\x20\x20\x20\x20height:\x2017px;\x0a\x20\x20\x20\x20\x20\x20\x20\x20margin-top:\x2013px;\x0a\x20\x20\x20\x20\x20\x20}\x0a\x0a\x20\x20\x20\x20\x20\x2050%\x20{\x0a\x20\x20\x20\x20\x20\x20\x20\x20height:\x2016px;\x0a\x20\x20\x20\x20\x20\x20\x20\x20margin-top:\x2014px;\x0a\x20\x20\x20\x20\x20\x20}\x0a\x0a\x20\x20\x20\x20\x20\x20100%\x20{\x0a\x20\x20\x20\x20\x20\x20\x20\x20height:\x2017px;\x0a\x20\x20\x20\x20\x20\x20\x20\x20margin-top:\x2013px;\x0a\x20\x20\x20\x20\x20\x20}\x0a\x20\x20\x20\x20}\x0a\x0a\x20\x20\x20\x20.mic-vol-high\x20{\x0a\x20\x20\x20\x20\x20\x20margin-left:\x2034%;\x0a\x20\x20\x20\x20\x20\x20width:\x2016px;\x0a\x20\x20\x20\x20\x20\x20height:\x2017px;\x0a\x20\x20\x20\x20\x20\x20margin-top:\x2013px;\x0a\x20\x20\x20\x20\x20\x20border-radius:\x205px;\x0a\x20\x20\x20\x20\x20\x20border-top-right-radius:\x200;\x0a\x20\x20\x20\x20\x20\x20border-top-left-radius:\x200;\x0a\x20\x20\x20\x20\x20\x20background-color:\x20#d02525;\x0a\x20\x20\x20\x20\x20\x20display:\x20block;\x0a\x20\x20\x20\x20\x20\x20position:\x20absolute;\x0a\x20\x20\x20\x20\x20\x20animation-name:\x20mic-volume-fluctuation-high;\x0a\x20\x20\x20\x20\x20\x20animation-duration:\x2020ms;\x0a\x20\x20\x20\x20}\x0a\x0a\x0a\x20\x20\x20\x20@keyframes\x20ripple-circle-animate\x20{\x0a\x20\x20\x20\x20\x20\x20from\x20{}\x0a\x0a\x20\x20\x20\x20\x20\x20to\x20{\x0a\x20\x20\x20\x20\x20\x20\x20\x20width:\x20140px;\x0a\x20\x20\x20\x20\x20\x20\x20\x20height:\x20140px;\x0a\x20\x20\x20\x20\x20\x20\x20\x20border-color:\x20transparent;\x0a\x20\x20\x20\x20\x20\x20\x20\x20border-width:\x202px;\x0a\x20\x20\x20\x20\x20\x20}\x0a\x20\x20\x20\x20}\x0a\x0a\x20\x20\x20\x20@keyframes\x20ripple-circle-animate2\x20{\x0a\x20\x20\x20\x20\x20\x20from\x20{}\x0a\x0a\x20\x20\x20\x20\x20\x20to\x20{\x0a\x20\x20\x20\x20\x20\x20\x20\x20width:\x20120px;\x0a\x20\x20\x20\x20\x20\x20\x20\x20height:\x20120px;\x0a\x20\x20\x20\x20\x20\x20\x20\x20border-color:\x20transparent;\x0a\x20\x20\x20\x20\x20\x20\x20\x20border-width:\x202px;\x0a\x20\x20\x20\x20\x20\x20}\x0a\x20\x20\x20\x20}\x0a\x0a\x20\x20\x20\x20.ripple-circle\x20{\x0a\x20\x20\x20\x20\x20\x20top:\x2080%;\x0a\x20\x20\x20\x20\x20\x20left:\x2050%;\x0a\x20\x20\x20\x20\x20\x20position:\x20absolute;\x0a\x20\x20\x20\x20\x20\x20transform:\x20translate(-50%,\x20-50%);\x0a\x20\x20\x20\x20\x20\x20display:\x20block;\x0a\x20\x20\x20\x20\x20\x20color:\x20white;\x0a\x20\x20\x20\x20\x20\x20height:\x20100px;\x0a\x20\x20\x20\x20\x20\x20width:\x20100px;\x0a\x20\x20\x20\x20\x20\x20border-radius:\x2050%;\x0a\x20\x20\x20\x20\x20\x20background-color:\x20transparent;\x0a\x20\x20\x20\x20\x20\x20border:\x201px\x20solid\x20white;\x0a\x20\x20\x20\x20\x20\x20animation-name:\x20ripple-circle-animate;\x0a\x20\x20\x20\x20\x20\x20animation-duration:\x202s;\x0a\x20\x20\x20\x20}\x0a\x0a\x20\x20\x20\x20.ripple-circle2\x20{\x0a\x20\x20\x20\x20\x20\x20top:\x2080%;\x0a\x20\x20\x20\x20\x20\x20left:\x2050%;\x0a\x20\x20\x20\x20\x20\x20position:\x20absolute;\x0a\x20\x20\x20\x20\x20\x20transform:\x20translate(-50%,\x20-50%);\x0a\x20\x20\x20\x20\x20\x20display:\x20block;\x0a\x20\x20\x20\x20\x20\x20color:\x20white;\x0a\x20\x20\x20\x20\x20\x20height:\x20100px;\x0a\x20\x20\x20\x20\x20\x20width:\x20100px;\x0a\x20\x20\x20\x20\x20\x20border-radius:\x2050%;\x0a\x20\x20\x20\x20\x20\x20background-color:\x20transparent;\x0a\x20\x20\x20\x20\x20\x20border:\x201px\x20solid\x20white;\x0a\x20\x20\x20\x20\x20\x20animation-name:\x20ripple-circle-animate2;\x0a\x20\x20\x20\x20\x20\x20animation-duration:\x201s;\x0a\x20\x20\x20\x20}\x0a\x0a\x20\x20.mitek-fade-in\x20{\x0a\x20\x20\x20\x20animation:\x20fadeIn\x200.3s;\x0a\x20\x20\x20\x20-webkit-animation:\x20fadeIn\x200.3s;\x0a\x20\x20\x20\x20-moz-animation:\x20fadeIn\x200.3s;\x0a\x20\x20\x20\x20-o-animation:\x20fadeIn\x200.3s;\x0a\x20\x20\x20\x20-ms-animation:\x20fadeIn\x200.3s;\x0a\x20\x20}\x0a\x20\x20@keyframes\x20fadeIn\x20{\x0a\x20\x200%\x20{opacity:0;}\x0a\x20\x20100%\x20{opacity:1;}\x0a}\x0a\x0a@-moz-keyframes\x20fadeIn\x20{\x0a\x20\x200%\x20{opacity:0;}\x0a\x20\x20100%\x20{opacity:1;}\x0a}\x0a\x0a@-webkit-keyframes\x20fadeIn\x20{\x0a\x20\x200%\x20{opacity:0;}\x0a\x20\x20100%\x20{opacity:1;}\x0a}\x0a\x0a@-o-keyframes\x20fadeIn\x20{\x0a\x20\x200%\x20{opacity:0;}\x0a\x20\x20100%\x20{opacity:1;}\x0a}\x0a\x0a@-ms-keyframes\x20fadeIn\x20{\x0a\x20\x200%\x20{opacity:0;}\x0a\x20\x20100%\x20{opacity:1;}\x0a}\x0a\x20\x20.mitek-generic-guide\x20{\x0a\x20\x20\x20\x20width:\x2080%;\x0a\x20\x20\x20\x20height:\x2080%;\x0a\x20\x20\x20\x20position:\x20absolute;\x0a\x20\x20\x20\x20top:\x2050%;\x0a\x20\x20\x20\x20left:\x2050%;\x0a\x20\x20\x20\x20z-index:\x202;\x0a\x20\x20\x20\x20border:\x203px\x20solid\x20white;\x0a\x20\x20\x20\x20box-shadow:\x200\x200\x200\x202000px\x20rgb(0\x200\x200\x20/\x2060%);\x0a\x20\x20\x20\x20touch-action:\x20none\x20!important;\x0a\x20\x20}\x0a\x0a\x20\x20#mitekGuide.active\x20{\x0a\x20\x20\x20\x20border-color:\x20green;\x0a\x20\x20\x20\x20border-width:7px;\x0a\x20\x20}\x0a\x20\x20.mitek-document-guide\x20{\x0a\x20\x20\x20\x20border-radius:\x2015px;\x0a\x20\x20}\x0a\x20\x20.mitek-selfie-guide\x20{\x0a\x20\x20\x20\x20border-radius:\x2050%;\x0a\x20\x20}\x0a\x20\x20.mirrored-video\x20{\x0a\x20\x20\x20\x20transform:\x20scaleX(-1);\x0a\x20\x20}\x0a\x0a\x20\x20.mitek-visible\x20{\x0a\x20\x20\x20\x20visibility:\x20visible\x20!important;\x0a\x20\x20}\x0a\x20\x20.mitek-center-offset\x20{\x0a\x20\x20\x20\x20transform:\x20translate(-50%,\x20-50%);\x0a\x20\x20}\x0a\x20\x20#mitekHintMessage.small\x20{\x0a\x20\x20\x20\x20font-size:\x201.2em;\x0a\x20\x20}\x0a\x20\x20#mitekHintMessage.medium\x20{\x0a\x20\x20\x20\x20font-size:\x201.7em;\x0a\x20\x20}\x0a\x20\x20#mitekHintMessage.large\x20{\x0a\x20\x20\x20\x20font-size:\x202.2em;\x0a}\x0a\x0a\x0a#mitekVideoRecordingIcon\x20{\x0a\x20\x20display:inline-block;\x0a\x20\x20animation:\x20mitekBlinker\x201s\x20cubic-bezier(.2,\x200,\x201,\x201)\x20infinite\x20alternate;\x0a\x20\x20width:.5em;\x0a\x20\x20height:.5em;\x0a\x20\x20border-radius:10px;\x0a\x20\x20background:\x20red;\x0a\x20\x20margin:\x200;\x0a\x20\x20position:\x20absolute;\x0a\x20\x20top:\x2050%;\x0a\x20\x20transform:\x20translateY(-50%);\x0a}\x0a\x0a@keyframes\x20mitekBlinker\x20{\x0a\x20\x20from\x20{\x20opacity:\x201;\x20}\x0a\x20\x20to\x20{\x20opacity:\x200;\x20}\x0a}\x0a#mitekVideoRecordingMessage\x20{\x0a\x20\x20position:absolute;\x0a\x20\x20top:\x2020px;\x0a\x20\x20left:\x2050%;\x0a\x20\x20z-index:\x20101;\x0a\x20\x20transform:\x20translate(-50%,\x20-50%);\x0a\x20\x20text-align:\x20center;\x0a\x20\x20color:\x20#000;\x0a\x20\x20background-color:rgba(255,255,255,\x20.8);\x0a\x20\x20opacity:\x200.8;\x0a\x20\x20border:\x201px\x20solid\x20#58CE54;\x0a\x20\x20min-width:100px;\x0a\x20\x20border-radius:\x2040px;\x0a\x20\x20padding-top:\x206px;\x0a\x20\x20padding-bottom:\x206px;\x0a\x20\x20padding-left:8px;\x0a\x20\x20padding-right:10px;\x0a}\x0a\x0a#mitekVideoRecordingMessage\x20span\x20{\x0a\x20\x20padding-left:\x2020px;\x0a}\x0a\x20",
                    "appStyleSheetElement"
                  );
                }
                [_0x4067e7(0x246)](_0x35d866, _0x2eb02e) {
                  const _0xa95e03 = _0x4067e7;
                  let _0x345284 = document[_0xa95e03(0x506)]("style");
                  return _0x345284["setAttribute"]("id", _0x2eb02e), (_0x345284[_0xa95e03(0x69a)] = _0x35d866), _0x345284;
                }
                [_0x4067e7(0x593)](_0x59b7a3) {
                  const _0x358c8d = _0x4067e7;
                  _0x358c8d(0x1ba) === document[_0x358c8d(0x25f)]
                    ? _0x33dbda["g"][_0x358c8d(0x307)]("load", () => {
                        _0x33dbda["g"]["document"]["body"]["appendChild"](_0x59b7a3);
                      })
                    : _0x33dbda["g"][_0x358c8d(0x2c6)]["body"]["appendChild"](_0x59b7a3);
                }
                [_0x4067e7(0x503)](_0x56fbd0) {
                  const _0x307656 = _0x4067e7;
                  let _0x15ed67 = document[_0x307656(0x1da)](_0x56fbd0["id"]);
                  if (_0x15ed67) {
                    let _0x41ea21 = _0x15ed67[_0x307656(0x2f7)];
                    null == _0x41ea21 || _0x41ea21[_0x307656(0x213)](_0x15ed67);
                  }
                }
                ["loadDefaultAppStyles"]() {
                  const _0x28aa2d = _0x4067e7;
                  this[_0x28aa2d(0x593)](this["appStyleSheetElement"]);
                }
                [_0x4067e7(0x259)]() {
                  const _0x588fbd = _0x4067e7;
                  this["removeStylesheet"](this[_0x588fbd(0x327)]);
                }
                [_0x4067e7(0x275)]() {}
                [_0x4067e7(0x554)]() {}
              })();
            var _0x39d015 = function (_0xa2f9b, _0x16f35e, _0x569c50, _0x500aa0) {
              return new (_0x569c50 || (_0x569c50 = Promise))(function (_0x521346, _0x3915be) {
                const _0x2bcfcd = a0_0x1b49;
                function _0x6dda0f(_0x29409b) {
                  try {
                    _0x35f89a(_0x500aa0["next"](_0x29409b));
                  } catch (_0x514b20) {
                    _0x3915be(_0x514b20);
                  }
                }
                function _0x2b21ec(_0x289d15) {
                  const _0x2f1771 = a0_0x1b49;
                  try {
                    _0x35f89a(_0x500aa0[_0x2f1771(0x3b2)](_0x289d15));
                  } catch (_0x3d0d16) {
                    _0x3915be(_0x3d0d16);
                  }
                }
                function _0x35f89a(_0x348b4d) {
                  const _0x1804bb = a0_0x1b49;
                  var _0x4d917e;
                  _0x348b4d[_0x1804bb(0x4f5)]
                    ? _0x521346(_0x348b4d[_0x1804bb(0x331)])
                    : ((_0x4d917e = _0x348b4d[_0x1804bb(0x331)]),
                      _0x4d917e instanceof _0x569c50
                        ? _0x4d917e
                        : new _0x569c50(function (_0xd0e074) {
                            _0xd0e074(_0x4d917e);
                          }))[_0x1804bb(0x429)](_0x6dda0f, _0x2b21ec);
                }
                _0x35f89a((_0x500aa0 = _0x500aa0["apply"](_0xa2f9b, _0x16f35e || []))[_0x2bcfcd(0x3e1)]());
              });
            };
            new _0x3da364(_0x4067e7(0x4d5));
            const _0x3569c6 = new (class {
                constructor() {
                  const _0x1c3bcd = _0x4067e7;
                  this[_0x1c3bcd(0x23a)] = !0x1;
                }
                ["runOnce"]() {
                  return _0x39d015(this, void 0x0, void 0x0, function* () {
                    const _0x20a109 = a0_0x1b49;
                    this[_0x20a109(0x23a)] || (yield this[_0x20a109(0x6e2)]());
                  });
                }
                ["init"]() {
                  return _0x39d015(this, void 0x0, void 0x0, function* () {
                    const _0x460a46 = a0_0x1b49;
                    try {
                      _0xd0ca4e["loadDefaultAppStyles"](), (this["once"] = !0x0);
                    } catch (_0x51b1fa) {
                      throw new _0x3b1c1e["Z"](_0x460a46(0x62f), new Error("unable\x20to\x20create\x20context"));
                    }
                  });
                }
              })(),
              _0x59068b = Object[_0x4067e7(0x70e)]({
                IMAGE_SMALLER_THAN_MIN_SIZE: { code: 0xfa1, type: _0x4067e7(0x40e), desc: _0x4067e7(0x330) },
                CORRUPT_IMAGE: { code: 0xfa2, type: "CORRUPT_IMAGE", desc: _0x4067e7(0x2a7) },
                UNSUPPORTED_IMAGE_FORMAT: {
                  code: 0xfa3,
                  type: "UNSUPPORTED_IMAGE_FORMAT",
                  desc: "Data\x20or\x20image\x20provided\x20format\x20not\x20supported",
                },
                INVALID_IMAGE_DATA: { code: 0xfa4, type: _0x4067e7(0x3f1), desc: _0x4067e7(0x242) },
                INVALID_STREAM_TRACK: { code: 0xfa5, type: _0x4067e7(0x475), desc: _0x4067e7(0x46d) },
                INVALID_LICENSE: { code: 0xfa6, type: _0x4067e7(0x696), desc: _0x4067e7(0x62b) },
                INVALID_LICENSE_EXPIRED: { code: 0xfa7, type: _0x4067e7(0x26a), desc: _0x4067e7(0x655) },
                INVALID_LICENSE_FEATURE: { code: 0xfa8, type: _0x4067e7(0x3a3), desc: _0x4067e7(0x701) },
                MIC_UNKNOWN_DEVICE_ISSUE: {
                  code: 0xfa9,
                  type: _0x4067e7(0x3e6),
                  desc: "Mic\x20or\x20voice\x20recording\x20unknown\x20device\x20issue",
                },
                INVALID_BARCODE_LICENSE: { code: 0xfc8, type: "INVALID_BARCODE_LICENSE", desc: _0x4067e7(0x1d3) },
                CAPTURE_USER_ABANDONMENT_TIMEOUT: { code: 0x1138, type: "CAPTURE_USER_ABANDONMENT_TIMEOUT", desc: _0x4067e7(0x5f2) },
                DEVICE_PERMISSION_DENIED: { code: 0x1011, type: _0x4067e7(0x33e), desc: _0x4067e7(0x5c0) },
                UNSUPPORTED_AUDIO_INPUT: { code: 0x1005, type: _0x4067e7(0x585), desc: _0x4067e7(0x32d) },
                PARAMETER_NOT_SET: { code: 0x1389, type: _0x4067e7(0x1e9), desc: _0x4067e7(0x1ec) },
                PARAMETER_TYPE_ERROR: { code: 0x138a, type: _0x4067e7(0x5aa), desc: _0x4067e7(0x21b) },
                PARAMETER_REQUIRED_DATA_NOT_PROVIDED: { code: 0x138b, type: _0x4067e7(0x2d1), desc: _0x4067e7(0x1f8) },
                OPTIONS_PARAMETER_INVALID_VALUE: { code: 0x138c, type: _0x4067e7(0x669), desc: _0x4067e7(0x55d) },
                EVENT_CALLBACK_INTEGRATION_ERROR: {
                  code: 0x152c,
                  type: "EVENT_CALLBACK_INTEGRATION_ERROR",
                  desc: "Integration\x20problem\x20caused\x20by\x20event\x20callback\x20code",
                },
                EVENT_SUBSCRIPTION_INTEGRATION_ERROR: { code: 0x152d, type: _0x4067e7(0x6d7), desc: _0x4067e7(0x5cf) },
                CONSTRAINT_NOT_SATISFIED: { code: 0x6f, type: _0x4067e7(0x267) },
                NO_CAMERA_FOUND: { code: 0x70, type: _0x4067e7(0x1c2) },
                CAMERA_PERMISSION_DENIED: { code: 0x71, type: _0x4067e7(0x615) },
                CAMERA_UNKNOWN_DEVICE_ISSUE: { code: 0x78, type: "CAMERA_UNKNOWN_DEVICE_ISSUE" },
                MEDIA_RECORDER_NOT_SUPPORTED: { code: 0x82, type: _0x4067e7(0x6fc) },
                UNKNOWN_METHOD: { code: 0x14b, type: "UNKNOWN_METHOD" },
                INVALID_COMMAND_SIGNATURE: { code: 0x14c, type: _0x4067e7(0x6fd), desc: "[str,fn]\x20expected" },
                USER_MEDIA_NOT_SUPPORTED: { code: 0x14d, type: _0x4067e7(0x38e) },
                WASM_NOT_SUPPORTED: { code: 0x14e, type: _0x4067e7(0x472) },
                DEVICE_NOT_SUPPORTED: { code: 0x14f, type: _0x4067e7(0x6b1) },
                WEBGL_NOT_SUPPORTED: { code: 0x150, type: "WEBGL_NOT_SUPPORTED" },
                UNKNOWN_ERROR: { code: 0x152, type: _0x4067e7(0x540), desc: "choose\x20valid\x20error" },
                WEBGL_SHADER_NOT_SUPPORTED: { code: 0x153, type: _0x4067e7(0x688) },
                INVALID_DOCUMENT_TYPE: { code: 0x190, type: _0x4067e7(0x6ad), desc: "Unrecognized\x20document\x20type" },
                USER_ACTION_EVENT_REQUIRED: { code: 0x195, type: _0x4067e7(0x247), desc: _0x4067e7(0x41c) },
                VIDEO_RECORDING_EXCEEDED_MAX_TIME: { code: 0x1f4, type: _0x4067e7(0x294) },
              }),
              _0x2c41d0 = class {
                constructor(_0x2ee7e6, _0x4792c4) {
                  const _0x32b342 = _0x4067e7;
                  (this["code"] = _0x2ee7e6[_0x32b342(0x4d0)]),
                    (this["type"] = _0x2ee7e6[_0x32b342(0x1f7)]),
                    (this["status"] = "failure"),
                    (this[_0x32b342(0x4e1)] = _0x4792c4);
                }
              };
            new _0x3da364(_0x4067e7(0x5bc));
            const _0x4b5d71 = new (class {
              [_0x4067e7(0x21f)](_0x458185, _0x51aa58) {
                const _0x1a283a = _0x4067e7;
                switch (_0x458185[_0x1a283a(0x416)]) {
                  case _0x1a283a(0x21c):
                    console[_0x1a283a(0x677)]({ SDKValidationError: _0x59068b["OPTIONS_PARAMETER_INVALID_VALUE"], field: _0x51aa58 });
                    break;
                  case _0x1a283a(0x4a8):
                    console[_0x1a283a(0x677)]({ SDKRuntimeWarning: _0x1a283a(0x4a8), field: _0x51aa58 });
                    break;
                  case _0x1a283a(0x71d):
                  case _0x1a283a(0x676):
                  case _0x1a283a(0x606):
                    console[_0x1a283a(0x677)]({ SDKValidationError: _0x59068b[_0x1a283a(0x6ab)], field: _0x51aa58 });
                    break;
                  case _0x1a283a(0x216):
                    console[_0x1a283a(0x677)]({ SDKValidationError: _0x59068b[_0x1a283a(0x575)], field: _0x51aa58 });
                    break;
                  case _0x1a283a(0x39e):
                    console["warn"]({ SDKValidationError: _0x59068b["INVALID_LICENSE_EXPIRED"] });
                    break;
                  default:
                    throw new _0x3b1c1e["Z"]("VALIDATOR_BAD_COMMAND_OPTIONS_VALUE_OR_TYPE", new Error(_0x458185[_0x1a283a(0x416)]));
                }
              }
              ["getRuntimeOutboundError"](_0x515943) {
                const _0x4d7c46 = _0x4067e7;
                switch (_0x515943[_0x4d7c46(0x416)]) {
                  case _0x4d7c46(0x1d6):
                  case _0x4d7c46(0x436):
                    return this["getRuntimeGumError"](_0x515943[_0x4d7c46(0x2b2)]);
                  case _0x4d7c46(0x1d7):
                    return new _0x2c41d0(_0x59068b[_0x4d7c46(0x540)], _0x515943[_0x4d7c46(0x2b2)]);
                  case "RUNTIME_VOICE_CONTEXT_UNKNOWN_ERROR":
                    return this[_0x4d7c46(0x66c)](_0x515943["originalError"]);
                  case _0x4d7c46(0x6c7):
                    return new _0x2c41d0(_0x59068b["USER_MEDIA_NOT_SUPPORTED"], _0x515943["originalError"]);
                  case _0x4d7c46(0x55e):
                    return new _0x2c41d0(_0x59068b[_0x4d7c46(0x1c2)], _0x515943[_0x4d7c46(0x2b2)]);
                  case "RUNTIME_CAPTURE_USER_ABANDONMENT_TIMEOUT":
                    return new _0x2c41d0(_0x59068b[_0x4d7c46(0x6a9)], _0x515943["originalError"]);
                  case "RUNTIME_GUM_ERROR_NO_AUDIO_INPUT_FOUND":
                    return new _0x2c41d0(_0x59068b[_0x4d7c46(0x585)], _0x515943[_0x4d7c46(0x2b2)]);
                  case _0x4d7c46(0x1ca):
                    return new _0x2c41d0(_0x59068b[_0x4d7c46(0x40e)], _0x515943[_0x4d7c46(0x2b2)]);
                  case _0x4d7c46(0x543):
                    return new _0x2c41d0(_0x59068b[_0x4d7c46(0x472)], _0x515943["originalError"]);
                  case _0x4d7c46(0x491):
                    return new _0x2c41d0(_0x59068b["WEBGL_NOT_SUPPORTED"], _0x515943["originalError"]);
                  case "INVALID_STREAM_TRACK":
                    return new _0x2c41d0(_0x59068b[_0x4d7c46(0x475)], _0x515943["originalError"]);
                  case _0x4d7c46(0x6cb):
                    return new _0x2c41d0(_0x59068b["EVENT_CALLBACK_INTEGRATION_ERROR"], _0x515943["originalError"]);
                  case _0x4d7c46(0x216):
                    return new _0x2c41d0(_0x59068b[_0x4d7c46(0x5aa)], _0x515943[_0x4d7c46(0x2b2)]);
                  case _0x4d7c46(0x6bd):
                    return new _0x2c41d0(_0x59068b[_0x4d7c46(0x6fc)], _0x515943[_0x4d7c46(0x2b2)]);
                  case "RUNTIME_SESSION_RECORDING_EXCEEDED_MAX_TIME":
                    return new _0x2c41d0(_0x59068b["VIDEO_RECORDING_EXCEEDED_MAX_TIME"], _0x515943[_0x4d7c46(0x2b2)]);
                  case _0x4d7c46(0x4ef):
                    return new _0x2c41d0(_0x59068b[_0x4d7c46(0x61e)], _0x515943[_0x4d7c46(0x2b2)]);
                  case "RUNTIME_INVALID_DIRECT_IMAGE_DATA_FORMAT":
                    return new _0x2c41d0(_0x59068b[_0x4d7c46(0x36e)], new Error());
                  case _0x4d7c46(0x676):
                    return new _0x2c41d0(_0x59068b["INVALID_COMMAND_SIGNATURE"], _0x515943["originalError"]);
                  case _0x4d7c46(0x374):
                    return new _0x2c41d0(_0x59068b[_0x4d7c46(0x6d7)], _0x515943["originalError"]);
                  case _0x4d7c46(0x6b7):
                    return new _0x2c41d0(_0x59068b[_0x4d7c46(0x696)], _0x515943["originalError"]);
                  case _0x4d7c46(0x4eb):
                    return new _0x2c41d0(_0x59068b[_0x4d7c46(0x26a)], _0x515943[_0x4d7c46(0x2b2)]);
                  case _0x4d7c46(0x2ab):
                    return new _0x2c41d0(_0x59068b["INVALID_LICENSE_FEATURE"], new Error());
                  case "VALIDATOR_INVALID_BARCODE_LICENSE":
                    return new _0x2c41d0(_0x59068b["INVALID_BARCODE_LICENSE"], _0x515943[_0x4d7c46(0x2b2)]);
                  case "RUNTIME_ERROR_EXTACTOR_FACTORY_MISSING_CASE":
                  case _0x4d7c46(0x2e6):
                    return new _0x2c41d0(_0x59068b[_0x4d7c46(0x540)], _0x515943[_0x4d7c46(0x2b2)]);
                  default:
                    return _0x515943[_0x4d7c46(0x2b2)] instanceof _0x3b1c1e["Z"]
                      ? this[_0x4d7c46(0x2e4)](_0x515943["originalError"])
                      : new _0x2c41d0(_0x59068b[_0x4d7c46(0x540)], _0x515943[_0x4d7c46(0x2b2)]);
                }
              }
              [_0x4067e7(0x60e)](_0x29f728) {
                const _0x1da2c5 = _0x4067e7;
                switch (_0x29f728[_0x1da2c5(0x1d9)]) {
                  case "NotAllowedError":
                  case _0x1da2c5(0x648):
                    return new _0x2c41d0(_0x59068b[_0x1da2c5(0x615)], _0x29f728);
                  case _0x1da2c5(0x5ef):
                    return new _0x2c41d0(_0x59068b[_0x1da2c5(0x267)], _0x29f728);
                  default:
                    return new _0x2c41d0(_0x59068b[_0x1da2c5(0x283)], _0x29f728);
                }
              }
              [_0x4067e7(0x66c)](_0x32c29f) {
                const _0x589ca0 = _0x4067e7;
                switch (_0x32c29f[_0x589ca0(0x1d9)]) {
                  case _0x589ca0(0x4ad):
                  case _0x589ca0(0x648):
                    return new _0x2c41d0(_0x59068b[_0x589ca0(0x33e)], _0x32c29f);
                  case _0x589ca0(0x5ef):
                    return new _0x2c41d0(_0x59068b[_0x589ca0(0x267)], _0x32c29f);
                  default:
                    return new _0x2c41d0(_0x59068b[_0x589ca0(0x3e6)], _0x32c29f);
                }
              }
            })();
            var _0x1462cc = _0x33dbda(0x157),
              _0x39b7ad = _0x33dbda(0x177),
              _0x475dac = function (_0x266ec0, _0x306790, _0x1bfd79, _0x31a3fb) {
                return new (_0x1bfd79 || (_0x1bfd79 = Promise))(function (_0x2fbb26, _0x3eb1d3) {
                  function _0x43d47b(_0x33bb5c) {
                    const _0x93c834 = a0_0x1b49;
                    try {
                      _0x70a09a(_0x31a3fb[_0x93c834(0x3e1)](_0x33bb5c));
                    } catch (_0x50a90f) {
                      _0x3eb1d3(_0x50a90f);
                    }
                  }
                  function _0x555988(_0x32a5e6) {
                    try {
                      _0x70a09a(_0x31a3fb["throw"](_0x32a5e6));
                    } catch (_0x1a3c09) {
                      _0x3eb1d3(_0x1a3c09);
                    }
                  }
                  function _0x70a09a(_0x31ace6) {
                    const _0x3d1770 = a0_0x1b49;
                    var _0x4406d8;
                    _0x31ace6[_0x3d1770(0x4f5)]
                      ? _0x2fbb26(_0x31ace6[_0x3d1770(0x331)])
                      : ((_0x4406d8 = _0x31ace6[_0x3d1770(0x331)]),
                        _0x4406d8 instanceof _0x1bfd79
                          ? _0x4406d8
                          : new _0x1bfd79(function (_0x35efed) {
                              _0x35efed(_0x4406d8);
                            }))[_0x3d1770(0x429)](_0x43d47b, _0x555988);
                  }
                  _0x70a09a((_0x31a3fb = _0x31a3fb["apply"](_0x266ec0, _0x306790 || []))["next"]());
                });
              };
            const _0x3bb09d = new (class {
              constructor() {
                const _0x4c2071 = _0x4067e7;
                this[_0x4c2071(0x386)] = new _0x2c3d54["Z"](new ImageData(0x2, 0x2), 0x5);
              }
              ["preloadDocuments"]() {
                return _0x475dac(this, void 0x0, void 0x0, function* () {
                  const _0x119766 = a0_0x1b49;
                  try {
                    if (!_0x409f64["Z"][_0x119766(0x63a)][_0x119766(0x218)][_0x119766(0x418)])
                      throw new _0x3b1c1e["Z"](_0x119766(0x543), new Error(_0x119766(0x543)));
                    const _0x48c07d = new _0x2e992f(
                      new _0x39b7ad["Z"](_0x119766(0x68c), _0x119766(0x33b), _0x119766(0x477)),
                      this[_0x119766(0x386)]
                    );
                    return !!(yield _0x436b1c[_0x119766(0x388)](_0x48c07d, this["snapShot"]["UID"] + _0x119766(0x6f1)));
                  } catch (_0x208f0b) {
                    if ("RUNTIME_WEBASSEMBLY_NOT_SUPPORTED" === _0x208f0b[_0x119766(0x2b2)][_0x119766(0x22b)]) throw _0x208f0b;
                    throw new _0x3b1c1e["Z"](_0x119766(0x302), new Error("RUNTIME_RECOGNIZER_FAILED"));
                  }
                });
              }
              ["preloadBarcode"]() {
                var _0x493d7f;
                return _0x475dac(this, void 0x0, void 0x0, function* () {
                  const _0x389795 = a0_0x1b49;
                  try {
                    if (!_0x409f64["Z"]["appConfig"][_0x389795(0x218)][_0x389795(0x418)])
                      throw new _0x3b1c1e["Z"](_0x389795(0x543), new Error("RUNTIME_WEBASSEMBLY_NOT_SUPPORTED"));
                    const _0x464134 = new _0x164cb1(new _0x39b7ad["Z"](_0x389795(0x68c), "DIRECT", _0x389795(0x477)), this["snapShot"]);
                    return !!(yield _0x2feff0["recognize"](_0x464134, this[_0x389795(0x386)][_0x389795(0x27f)] + _0x389795(0x2ba)));
                  } catch (_0x5736de) {
                    if (
                      _0x389795(0x543) ===
                      (null === (_0x493d7f = null == _0x5736de ? void 0x0 : _0x5736de[_0x389795(0x2b2)]) || void 0x0 === _0x493d7f
                        ? void 0x0
                        : _0x493d7f[_0x389795(0x22b)])
                    )
                      throw _0x5736de;
                    if (_0x389795(0x581) === (null == _0x5736de ? void 0x0 : _0x5736de[_0x389795(0x416)])) throw _0x5736de;
                    throw new _0x3b1c1e["Z"](_0x389795(0x302), new Error(_0x389795(0x302)));
                  }
                });
              }
              ["preloadSelfie"]() {
                return _0x475dac(this, void 0x0, void 0x0, function* () {
                  const _0x55177e = a0_0x1b49;
                  try {
                    const _0x1615d8 = new _0x79a66e(_0x55177e(0x477), this[_0x55177e(0x386)]);
                    return !!(yield _0x3de0ad[_0x55177e(0x388)](_0x1615d8, this[_0x55177e(0x386)][_0x55177e(0x27f)] + _0x55177e(0x3e7)));
                  } catch (_0x324426) {
                    throw new _0x3b1c1e["Z"](_0x55177e(0x302), new Error(_0x55177e(0x302)));
                  }
                });
              }
              [_0x4067e7(0x556)](_0x42bf5c) {
                return _0x475dac(this, void 0x0, void 0x0, function* () {
                  const _0x283f6f = a0_0x1b49;
                  let _0x24a871 = new Array();
                  try {
                    (_0x42bf5c["includes"](_0x1462cc["Z"][_0x283f6f(0x509)]) ||
                      _0x42bf5c[_0x283f6f(0x20d)](_0x1462cc["Z"][_0x283f6f(0x6e7)])) &&
                      _0x24a871[_0x283f6f(0x4a7)](this[_0x283f6f(0x6e3)]),
                      (_0x42bf5c[_0x283f6f(0x20d)](_0x1462cc["Z"][_0x283f6f(0x332)]) ||
                        _0x42bf5c[_0x283f6f(0x20d)](_0x1462cc["Z"]["ALL"])) &&
                        _0x24a871[_0x283f6f(0x4a7)](this["preloadSelfie"]),
                      (_0x42bf5c[_0x283f6f(0x20d)](_0x1462cc["Z"]["BARCODE"]) ||
                        _0x42bf5c[_0x283f6f(0x20d)](_0x1462cc["Z"][_0x283f6f(0x6e7)])) &&
                        _0x24a871["push"](this[_0x283f6f(0x481)]);
                    let _0x4c8386 = this[_0x283f6f(0x6f4)](_0x24a871);
                    this[_0x283f6f(0x63b)](_0x4c8386);
                  } catch (_0x78b14c) {
                    throw _0x78b14c;
                  }
                });
              }
              *[_0x4067e7(0x6f4)](_0x34c7c5) {
                const _0x1582a5 = _0x4067e7;
                for (const _0x1fb852 of _0x34c7c5) yield _0x1fb852[_0x1582a5(0x62d)](this);
              }
              [_0x4067e7(0x63b)](_0x2fb305) {
                const _0x56ef9c = () => {
                  const _0x30d005 = a0_0x1b49,
                    _0x526e43 = _0x2fb305[_0x30d005(0x3e1)]();
                  _0x526e43[_0x30d005(0x4f5)] ||
                    _0x526e43[_0x30d005(0x331)][_0x30d005(0x429)]((_0x41c597) => {
                      _0x56ef9c();
                    });
                };
                _0x56ef9c();
              }
            })();
            var _0x193191 = _0x33dbda(0x26),
              _0x1f33c2 = function (_0x4caace, _0x35a306, _0x53742e, _0x32e683) {
                return new (_0x53742e || (_0x53742e = Promise))(function (_0x4f5558, _0x520338) {
                  const _0x20375b = a0_0x1b49;
                  function _0x71d99a(_0x2bb11b) {
                    const _0x480764 = a0_0x1b49;
                    try {
                      _0x32db90(_0x32e683[_0x480764(0x3e1)](_0x2bb11b));
                    } catch (_0x264d99) {
                      _0x520338(_0x264d99);
                    }
                  }
                  function _0x2084e0(_0x59a1ac) {
                    const _0x6cf580 = a0_0x1b49;
                    try {
                      _0x32db90(_0x32e683[_0x6cf580(0x3b2)](_0x59a1ac));
                    } catch (_0x199f93) {
                      _0x520338(_0x199f93);
                    }
                  }
                  function _0x32db90(_0x5707b2) {
                    const _0x42727d = a0_0x1b49;
                    var _0x49996b;
                    _0x5707b2[_0x42727d(0x4f5)]
                      ? _0x4f5558(_0x5707b2[_0x42727d(0x331)])
                      : ((_0x49996b = _0x5707b2["value"]),
                        _0x49996b instanceof _0x53742e
                          ? _0x49996b
                          : new _0x53742e(function (_0x46c66a) {
                              _0x46c66a(_0x49996b);
                            }))[_0x42727d(0x429)](_0x71d99a, _0x2084e0);
                  }
                  _0x32db90((_0x32e683 = _0x32e683[_0x20375b(0x1d1)](_0x4caace, _0x35a306 || []))[_0x20375b(0x3e1)]());
                });
              };
            const _0x15fd3c = new _0x3da364("app:controller"),
              _0x411080 = new (class {
                constructor() {
                  const _0xb90805 = _0x4067e7;
                  (this[_0xb90805(0x67b)] = ["", _0xb90805(0x499), _0xb90805(0x50e), _0xb90805(0x254)]), this[_0xb90805(0x5e3)];
                }
                [_0x4067e7(0x273)](_0x36da12, _0x3759a5, _0x4aa525) {}
                ["logInternalError"](_0x51671c, _0x5a1b4f, _0x47cb4e) {
                  const _0x31faa8 = _0x4067e7;
                  _0x15fd3c[_0x31faa8(0x6cd)](_0x51671c, _0x5a1b4f, _0x47cb4e);
                }
                set [_0x4067e7(0x51b)](_0x1cea5e) {
                  const _0x4a36c5 = _0x4067e7;
                  this[_0x4a36c5(0x5e3)] = _0x1cea5e;
                }
                get ["currentContext"]() {
                  const _0x12f778 = _0x4067e7;
                  return this[_0x12f778(0x5e3)];
                }
                [_0x4067e7(0x3b5)](_0x222406, _0x12067d) {
                  const _0x39095a = _0x4067e7;
                  _0x39095a(0x241) === _0x222406
                    ? _0x1089cc["on"](_0x222406, _0x12067d)
                    : _0x1089cc[_0x39095a(0x23a)](_0x222406, _0x12067d);
                }
                [_0x4067e7(0x53b)](_0x3fbc05, _0xfc5dd6) {
                  var _0x3e9a84, _0x3656d2, _0x5d2575, _0x120fb7, _0x1814dd;
                  return _0x1f33c2(this, void 0x0, void 0x0, function* () {
                    const _0x41e412 = a0_0x1b49;
                    this[_0x41e412(0x707)]();
                    try {
                      switch ((_0x13336a["Z"]["validateExternalCommandName"](_0x3fbc05), _0x3fbc05)) {
                        case "SDK_STOP":
                        case _0x41e412(0x489):
                          return this[_0x41e412(0x2c2)](), 0x0;
                        case _0x41e412(0x700):
                          return this[_0x41e412(0x512)](), 0x0;
                        case _0x41e412(0x5a0):
                          try {
                            _0x13336a["Z"][_0x41e412(0x266)](_0xfc5dd6["mode"]),
                              _0x13336a["Z"][_0x41e412(0x2eb)](_0xfc5dd6["documentType"]),
                              _0x409f64["Z"][_0x41e412(0x311)]({ name: _0x3fbc05, params: _0xfc5dd6 }),
                              (_0x409f64["Z"]["publicPath"] =
                                null ===
                                  (_0x3656d2 =
                                    null ===
                                      (_0x3e9a84 =
                                        null === _0x409f64["Z"] || void 0x0 === _0x409f64["Z"]
                                          ? void 0x0
                                          : _0x409f64["Z"]["currentAction"]) || void 0x0 === _0x3e9a84
                                      ? void 0x0
                                      : _0x3e9a84["commandOptions"]) || void 0x0 === _0x3656d2
                                  ? void 0x0
                                  : _0x3656d2["mitekSDKPath"]);
                            const _0x240ae1 = "MANUAL_CAPTURE" === _0xfc5dd6[_0x41e412(0x53c)] ? _0x4d470d : _0x1ab059;
                            (this[_0x41e412(0x51b)] = new _0x240ae1()), this[_0x41e412(0x4a2)]();
                            const _0x1417b4 = yield this[_0x41e412(0x51b)][_0x41e412(0x33c)]();
                            return this[_0x41e412(0x626)](_0x1417b4), 0x0;
                          } catch (_0x587454) {
                            throw _0x587454 instanceof _0x3b1c1e["Z"] ? _0x587454 : new _0x3b1c1e["Z"](_0x41e412(0x654), _0x587454);
                          }
                        case _0x41e412(0x53f):
                          try {
                            _0x13336a["Z"]["validateExternalActionMode"](_0xfc5dd6["mode"]),
                              _0x13336a["Z"]["validateDocumentType"](_0xfc5dd6[_0x41e412(0x59a)]),
                              _0x409f64["Z"]["setupCurrentAction"]({ name: _0x3fbc05, params: _0xfc5dd6 }),
                              (_0x409f64["Z"][_0x41e412(0x5dd)] = _0x409f64["Z"]["currentAction"][_0x41e412(0x403)][_0x41e412(0x64d)]);
                            const _0x27aa2e = new _0x4d470d();
                            yield this[_0x41e412(0x4a2)]();
                            const _0x55ac3d = yield _0x27aa2e[_0x41e412(0x33c)]();
                            return this["sendSDKResultToIntegrator"](_0x55ac3d), 0x0;
                          } catch (_0x2cf7ab) {
                            throw _0x2cf7ab instanceof _0x3b1c1e["Z"] ? _0x2cf7ab : new _0x3b1c1e["Z"](_0x41e412(0x654), _0x2cf7ab);
                          }
                        case _0x41e412(0x336):
                          try {
                            let _0x50caed = Object[_0x41e412(0x70e)](
                              Object[_0x41e412(0x620)](Object[_0x41e412(0x620)]({}, _0xfc5dd6), {
                                mode: _0x41e412(0x587),
                                documentType: "VOICE",
                              })
                            );
                            _0x409f64["Z"][_0x41e412(0x311)]({ name: _0x3fbc05, params: _0x50caed }),
                              (_0x409f64["Z"]["publicPath"] = _0x409f64["Z"]["currentAction"][_0x41e412(0x403)][_0x41e412(0x64d)]);
                            const _0x2737fb = new _0x15df86();
                            yield this[_0x41e412(0x4a2)]();
                            const _0x24c987 = yield _0x2737fb[_0x41e412(0x33c)]();
                            return this[_0x41e412(0x626)](_0x24c987), 0x0;
                          } catch (_0x708dbe) {
                            throw _0x708dbe instanceof _0x3b1c1e["Z"] ? _0x708dbe : new _0x3b1c1e["Z"](_0x41e412(0x654), _0x708dbe);
                          }
                        case _0x41e412(0x1cc):
                          try {
                            let _0x4835e1 = _0x13336a["Z"]["validateStringOrObjForHintMessageText"](_0xfc5dd6),
                              _0x25679d =
                                (null === (_0x5d2575 = _0xfc5dd6[_0x41e412(0x4aa)]) || void 0x0 === _0x5d2575
                                  ? void 0x0
                                  : _0x5d2575[_0x41e412(0x527)]) || _0x409f64["Z"][_0x41e412(0x637)]["commandOptions"][_0x41e412(0x34d)],
                              _0x3ab95f =
                                (null === (_0x120fb7 = _0xfc5dd6[_0x41e412(0x4aa)]) || void 0x0 === _0x120fb7
                                  ? void 0x0
                                  : _0x120fb7["hintForceUpdate"]) || _0x409f64["Z"][_0x41e412(0x637)][_0x41e412(0x403)][_0x41e412(0x690)];
                            return (
                              _0x4835e1 && _0x25679d
                                ? this[_0x41e412(0x34f)](_0x4835e1, _0x25679d, _0x3ab95f)
                                : this["handleValidationErrorMessage"](
                                    new _0x3b1c1e["Z"](_0x41e412(0x216), new Error()),
                                    "hint\x20message"
                                  ),
                              0x0
                            );
                          } catch (_0x59cedc) {
                            return 0x2;
                          }
                        case _0x41e412(0x233):
                          try {
                            const _0x254f1e = _0x13336a["Z"][_0x41e412(0x3c9)](_0xfc5dd6),
                              _0x59338a = document["getElementById"](_0x41e412(0x44d));
                            return (
                              _0x254f1e &&
                                _0x59338a &&
                                (_0x59338a[_0x41e412(0x255)]["remove"](
                                  this[_0x41e412(0x67b)][0x1],
                                  this[_0x41e412(0x67b)][0x2],
                                  this[_0x41e412(0x67b)][0x3]
                                ),
                                _0x59338a[_0x41e412(0x255)][_0x41e412(0x5de)](this[_0x41e412(0x67b)][_0x254f1e])),
                              0x0
                            );
                          } catch (_0x31e98f) {
                            return 0x2;
                          }
                        case _0x41e412(0x689):
                          try {
                            return _0x13336a["Z"][_0x41e412(0x3fd)](null == _0xfc5dd6 ? void 0x0 : _0xfc5dd6[_0x41e412(0x380)])
                              ? (_0x13336a["Z"]["isString"](null == _0xfc5dd6 ? void 0x0 : _0xfc5dd6[_0x41e412(0x64d)]) &&
                                  (_0x409f64["Z"][_0x41e412(0x221)](null == _0xfc5dd6 ? void 0x0 : _0xfc5dd6["mitekSDKPath"]),
                                  (_0x409f64["Z"]["publicPath"] = null == _0xfc5dd6 ? void 0x0 : _0xfc5dd6[_0x41e412(0x64d)])),
                                yield _0x3bb09d[_0x41e412(0x556)](_0xfc5dd6[_0x41e412(0x380)]),
                                0x0)
                              : 0x2;
                          } catch (_0x56a1a3) {
                            let _0x38fc88;
                            return (
                              (_0x38fc88 =
                                _0x56a1a3 instanceof _0x3b1c1e["Z"]
                                  ? _0x56a1a3[_0x41e412(0x416)]
                                  : null === (_0x1814dd = null == _0x56a1a3 ? void 0x0 : _0x56a1a3[_0x41e412(0x2b2)]) ||
                                    void 0x0 === _0x1814dd
                                  ? void 0x0
                                  : _0x1814dd[_0x41e412(0x22b)]),
                              this["handleDirectSdkErrorToIntegrator"](_0x38fc88),
                              0x2
                            );
                          }
                        default:
                          return console[_0x41e412(0x677)](_0x41e412(0x4d6) + _0x3fbc05 + JSON[_0x41e412(0x502)](_0xfc5dd6)), 0x1;
                      }
                    } catch (_0x5ce73e) {
                      let _0x2f9f15 = _0x5ce73e instanceof _0x3b1c1e["Z"] ? _0x5ce73e : new _0x3b1c1e["Z"](_0x41e412(0x1d6), _0x5ce73e);
                      if (_0x41e412(0x6cb) === _0x2f9f15[_0x41e412(0x416)])
                        return (
                          console[_0x41e412(0x677)](_0x2f9f15[_0x41e412(0x2b2)]),
                          this["handleDirectSdkErrorToIntegrator"](_0x2f9f15[_0x41e412(0x416)]),
                          0x1
                        );
                      if (null === _0x409f64["Z"] || void 0x0 === _0x409f64["Z"] ? void 0x0 : _0x409f64["Z"][_0x41e412(0x637)]) {
                        const _0x5a82ee = new _0x2a0747();
                        _0x5a82ee[_0x41e412(0x44b)](this[_0x41e412(0x2e4)](_0x2f9f15), _0x5ce73e);
                        let _0x3ff00f = Object[_0x41e412(0x70e)](
                          new _0x3289d5(
                            _0x409f64["Z"][_0x41e412(0x637)][_0x41e412(0x452)],
                            _0x409f64["Z"]["currentAction"]["lastSnapshot"],
                            _0x5a82ee[_0x41e412(0x42f)],
                            _0x409f64["Z"][_0x41e412(0x637)][_0x41e412(0x514)],
                            _0x409f64["Z"][_0x41e412(0x637)][_0x41e412(0x274)]
                          )
                        );
                        this["sendSDKResultToIntegrator"](_0x3ff00f);
                      } else this[_0x41e412(0x29e)](_0x2f9f15[_0x41e412(0x416)]);
                      return 0x1;
                    }
                  });
                }
                [_0x4067e7(0x4a2)]() {
                  const _0x209d0a = _0x4067e7;
                  try {
                    _0x193191["Z"][_0x209d0a(0x2e9)]()[_0x209d0a(0x38b)]((_0xe496e8) => {
                      const _0x34d605 = _0x209d0a;
                      this[_0x34d605(0x21f)](new _0x3b1c1e["Z"](_0x34d605(0x4a8), _0xe496e8), _0x34d605(0x514));
                    });
                  } catch (_0x3449a3) {
                    throw new _0x3b1c1e["Z"](_0x209d0a(0x494), _0x3449a3);
                  }
                }
                ["handleDirectSdkErrorToIntegrator"](_0x43597f) {
                  const _0x139ac2 = _0x4067e7;
                  let _0x147457 = new _0x3b1c1e["Z"](_0x43597f, new Error(_0x43597f)),
                    _0x2fb0de = this[_0x139ac2(0x2e4)](_0x147457);
                  _0x1089cc[_0x139ac2(0x422)](_0x139ac2(0x71f), _0x2fb0de);
                }
                [_0x4067e7(0x57e)]() {
                  const _0x12661b = _0x4067e7;
                  this[_0x12661b(0x51b)] instanceof _0x1ab059 &&
                    (this[_0x12661b(0x51b)][_0x12661b(0x3a2)][_0x12661b(0x265)](),
                    this["currentContext"][_0x12661b(0x320)]["resetRecognizer"]());
                }
                [_0x4067e7(0x34f)](_0xf7b4f1, _0x2c1cb9, _0x9b839c) {
                  const _0x4ac620 = _0x4067e7;
                  if (!_0x409f64["Z"][_0x4ac620(0x637)][_0x4ac620(0x2c3)] || _0x9b839c) {
                    let _0x1b116b = document["getElementById"]("mitekHintMessage");
                    _0x1b116b && (_0x1b116b[_0x4ac620(0x4c9)] = _0xf7b4f1),
                      _0x409f64["Z"][_0x4ac620(0x5eb)](!0x0),
                      setTimeout(() => {
                        const _0x44869f = _0x4ac620;
                        _0x409f64["Z"][_0x44869f(0x5eb)](!0x1);
                      }, _0x2c1cb9);
                  }
                }
                [_0x4067e7(0x4dc)](_0x5ea98b) {
                  const _0x466299 = _0x4067e7;
                  _0x5ea98b[_0x466299(0x6e5)][_0x466299(0x6cd)] instanceof _0x2c41d0
                    ? _0x1089cc[_0x466299(0x422)](_0x466299(0x71f), _0x5ea98b[_0x466299(0x6e5)][_0x466299(0x6cd)])
                    : _0x1089cc[_0x466299(0x422)](
                        _0x466299(0x241),
                        new _0x279850(
                          _0x409f64["Z"][_0x466299(0x637)]["actionIdentifier"],
                          _0x5ea98b[_0x466299(0x6e5)][_0x466299(0x43f)][_0x466299(0x713)]
                        )
                      );
                }
                [_0x4067e7(0x49a)](_0xfd1845) {
                  const _0x3f7803 = _0x4067e7;
                  return (
                    (null == _0xfd1845 ? void 0x0 : _0xfd1845[_0x3f7803(0x6e5)]) instanceof _0x2a36e9 ||
                    (null == _0xfd1845 ? void 0x0 : _0xfd1845[_0x3f7803(0x6e5)]) instanceof _0x11e705
                  );
                }
                [_0x4067e7(0x626)](_0x4cb618) {
                  const _0x2b29f0 = _0x4067e7;
                  (_0x4cb618 = this[_0x2b29f0(0x50d)](_0x4cb618)),
                    this[_0x2b29f0(0x49a)](_0x4cb618) && this[_0x2b29f0(0x4dc)](_0x4cb618),
                    "VOICE" === _0x409f64["Z"][_0x2b29f0(0x637)][_0x2b29f0(0x452)][_0x2b29f0(0x245)]
                      ? _0x1089cc["emit"](_0x2b29f0(0x466), _0x4cb618)
                      : _0x1089cc[_0x2b29f0(0x422)](_0x2b29f0(0x3ec), _0x4cb618);
                }
                [_0x4067e7(0x456)]() {
                  const _0x451fa7 = _0x4067e7;
                  _0x1089cc["emit"](_0x451fa7(0x404), {});
                }
                [_0x4067e7(0x4c8)]() {
                  const _0x152292 = _0x4067e7;
                  _0x1089cc[_0x152292(0x422)](_0x152292(0x635), {});
                }
                [_0x4067e7(0x352)]() {
                  const _0x160675 = _0x4067e7;
                  _0x1089cc[_0x160675(0x422)](_0x160675(0x3d3), {});
                }
                ["sendEventFeedbackMessageToIntegrator"](_0x19cd51) {
                  const _0x2232f5 = _0x4067e7;
                  _0x2232f5(0x66f) !== _0x19cd51[_0x2232f5(0x713)] && _0x1089cc["emit"](_0x2232f5(0x241), _0x19cd51);
                }
                [_0x4067e7(0x6c3)]() {
                  const _0x5d930a = _0x4067e7;
                  _0x1089cc["emit"](_0x5d930a(0x68f), {});
                }
                ["sendVoiceRecordingStartedToIntegrator"]() {
                  const _0x44ecf5 = _0x4067e7;
                  _0x1089cc[_0x44ecf5(0x422)](_0x44ecf5(0x6a8), {});
                }
                ["sendVoiceProcessingEndedToIntegrator"]() {
                  _0x1089cc["emit"]("VOICE_PROCESSING_ENDED", {});
                }
                [_0x4067e7(0x21f)](_0x31af11, _0xd51f4b) {
                  const _0x455119 = _0x4067e7;
                  _0x4b5d71[_0x455119(0x21f)](_0x31af11, _0xd51f4b);
                }
                [_0x4067e7(0x63f)]() {
                  setTimeout(() => {
                    _0x1089cc["clearListeners"]();
                  }, 0x64);
                }
                ["forceAutocaptureToStopWithError"](_0x2e818a) {
                  _0x409f64["Z"]["setCurrentActionToForceStopWithReason"](_0x2e818a);
                }
                ["getRuntimeOutboundError"](_0x36ebcf) {
                  const _0x3a66a4 = _0x4067e7;
                  return _0x4b5d71[_0x3a66a4(0x2e4)](_0x36ebcf);
                }
                [_0x4067e7(0x2c2)]() {
                  const _0x5f4315 = _0x4067e7;
                  (null === _0x409f64["Z"] || void 0x0 === _0x409f64["Z"] ? void 0x0 : _0x409f64["Z"]["currentAction"]) &&
                    (_0x409f64["Z"][_0x5f4315(0x637)]["isStopped"] = !0x0);
                }
                [_0x4067e7(0x512)]() {
                  const _0x1a6cfc = _0x4067e7;
                  try {
                    _0x1089cc[_0x1a6cfc(0x5d5)]();
                  } catch (_0x6620de) {
                    if (null === _0x409f64["Z"] || void 0x0 === _0x409f64["Z"] ? void 0x0 : _0x409f64["Z"][_0x1a6cfc(0x637)])
                      throw new _0x3b1c1e["Z"](_0x1a6cfc(0x654), _0x6620de);
                  }
                }
                [_0x4067e7(0x707)]() {
                  const _0x18deb8 = _0x4067e7;
                  _0x3569c6[_0x18deb8(0x402)]()[_0x18deb8(0x38b)]((_0x190250) => {
                    const _0x4bcafb = _0x18deb8;
                    this[_0x4bcafb(0x21f)](new _0x3b1c1e["Z"](_0x4bcafb(0x62f), _0x190250), _0x4bcafb(0x2a9));
                  });
                }
                [_0x4067e7(0x50d)](_0x157d9f) {
                  const _0x27be91 = _0x4067e7,
                    _0x285a08 = Reflect[_0x27be91(0x438)](_0x157d9f);
                  for (const _0x24990e of _0x285a08) {
                    const _0x2af154 = _0x157d9f[_0x24990e];
                    ((_0x2af154 && "object" == typeof _0x2af154) || _0x27be91(0x2fc) == typeof _0x2af154) &&
                      this[_0x27be91(0x50d)](_0x2af154);
                  }
                  return Object[_0x27be91(0x70e)](_0x157d9f);
                }
              })();
          },
          0x26: (_0xe04c35, _0x839a51, _0x3c600f) => {
            const _0x9df687 = a0_0x1b49;
            _0x3c600f["d"](_0x839a51, { Z: () => _0x24828e });
            var _0x25320f = _0x3c600f(0x127),
              _0x1af12a = _0x3c600f(0x1b8);
            class _0x2fc249 {
              constructor() {
                const _0x17806e = a0_0x1b49;
                (this[_0x17806e(0x718)] = 0x9286),
                  (this["EXIF_DATE_TIME_ORIGINAL"] = 0x9003),
                  (this[_0x17806e(0x63c)] = 0x9011),
                  (this[_0x17806e(0x589)] = { "0th": {}, Exif: {}, GPS: {} });
              }
              get [_0x9df687(0x589)]() {
                const _0x2ef778 = _0x9df687;
                return this[_0x2ef778(0x37e)];
              }
              set [_0x9df687(0x589)](_0x59a328) {
                const _0x5742ef = _0x9df687;
                this[_0x5742ef(0x37e)] = _0x59a328;
              }
              static [_0x9df687(0x2e9)]() {
                const _0x775c15 = _0x9df687;
                var _0x9427ad, _0x49125a, _0x4c601f;
                return (null === (_0x9427ad = this[_0x775c15(0x716)]) || void 0x0 === _0x9427ad ? void 0x0 : _0x9427ad["load"]) &&
                  (null === (_0x49125a = this["piexif"]) || void 0x0 === _0x49125a ? void 0x0 : _0x49125a[_0x775c15(0x30c)]) &&
                  (null === (_0x4c601f = this["piexif"]) || void 0x0 === _0x4c601f ? void 0x0 : _0x4c601f[_0x775c15(0x5af)])
                  ? Promise[_0x775c15(0x57a)](!0x0)
                  : new Promise((_0xdd9a79, _0x33a84a) => {
                      const _0x8341a = _0x775c15;
                      _0x3c600f["e"](0x2e)
                        [_0x8341a(0x429)](_0x3c600f["t"][_0x8341a(0x23e)](_0x3c600f, 0x8, 0x17))
                        [_0x8341a(0x429)]((_0x270e60) => {
                          const _0x11ccaf = _0x8341a;
                          var _0x128d4;
                          (this[_0x11ccaf(0x716)] = _0x270e60),
                            _0x11ccaf(0x2fc) ==
                            typeof (null === (_0x128d4 = this["piexif"]) || void 0x0 === _0x128d4 ? void 0x0 : _0x128d4[_0x11ccaf(0x660)])
                              ? _0xdd9a79(!0x0)
                              : _0x33a84a(!0x1);
                        })
                        [_0x8341a(0x38b)]((_0xe60e69) => {
                          _0x33a84a(!0x1);
                        });
                    });
              }
              [_0x9df687(0x30e)](_0xf614eb) {
                const _0x130faf = _0x9df687;
                try {
                  this[_0x130faf(0x589)] = _0x2fc249[_0x130faf(0x716)]["load"](_0xf614eb);
                } catch (_0x560438) {
                  throw new _0x1af12a["Z"](_0x130faf(0x45e), new Error());
                }
              }
              [_0x9df687(0x5c6)](_0x106382) {
                const _0x5f3274 = _0x9df687;
                (this[_0x5f3274(0x589)][_0x5f3274(0x5d0)][this["EXIF_USER_COMMENT_TAG"]] = _0x106382["toString"]()),
                  (this["data"][_0x5f3274(0x5d0)][this[_0x5f3274(0x379)]] = new Date()["toISOString"]()[_0x5f3274(0x341)](".")[0x0]),
                  (this[_0x5f3274(0x589)][_0x5f3274(0x5d0)][this[_0x5f3274(0x63c)]] = _0x5f3274(0x287));
              }
              [_0x9df687(0x24f)](_0x8f7c19) {
                const _0x25f05f = _0x9df687;
                var _0x869fd2, _0x3d82da;
                try {
                  return null === (_0x869fd2 = _0x2fc249[_0x25f05f(0x716)]) || void 0x0 === _0x869fd2
                    ? void 0x0
                    : _0x869fd2[_0x25f05f(0x5af)](
                        null === (_0x3d82da = _0x2fc249[_0x25f05f(0x716)]) || void 0x0 === _0x3d82da
                          ? void 0x0
                          : _0x3d82da[_0x25f05f(0x30c)](this["data"]),
                        _0x8f7c19
                      );
                } catch (_0x6f9619) {
                  return (
                    _0x25320f["Z"][_0x25f05f(0x6eb)](_0x6f9619, _0x25f05f(0x262), "exif.ts"),
                    _0x25320f["Z"][_0x25f05f(0x21f)](new _0x1af12a["Z"](_0x25f05f(0x4a8), _0x6f9619), _0x25f05f(0x514)),
                    _0x8f7c19
                  );
                }
              }
            }
            const _0x24828e = _0x2fc249;
          },
          0x1b8: (_0x4f9efc, _0x3bba0b, _0x3e164c) => {
            _0x3e164c["d"](_0x3bba0b, { Z: () => _0x5b4861 });
            const _0x5b4861 = class {
              constructor(_0x55104e, _0x3a192a, _0x2828e7) {
                const _0x9c750f = a0_0x1b49;
                (this[_0x9c750f(0x416)] = _0x55104e),
                  (this[_0x9c750f(0x1d9)] = _0x55104e),
                  (this[_0x9c750f(0x2b2)] = _0x3a192a),
                  (this[_0x9c750f(0x414)] = _0x2828e7);
              }
            };
          },
          0x2e4: (_0x2aad95, _0x18da6c, _0x2fa3ca) => {
            const _0x49ca28 = a0_0x1b49;
            _0x2fa3ca["d"](_0x18da6c, { Z: () => _0x133334 });
            var _0x48cb03 = _0x2fa3ca(0x246),
              _0x7b2b45 = _0x2fa3ca(0x127),
              _0x4e7632 = _0x2fa3ca(0x1b8),
              _0x313733 = _0x2fa3ca(0x2e8),
              _0x2c6044 = _0x2fa3ca(0x141),
              _0x241e96 = function (_0x48299b, _0x14c8ba, _0x4c711b, _0x3817dd) {
                return new (_0x4c711b || (_0x4c711b = Promise))(function (_0x4570c6, _0x1d839f) {
                  const _0x39146c = a0_0x1b49;
                  function _0x33c827(_0x4fb0aa) {
                    const _0x3ebc57 = a0_0x1b49;
                    try {
                      _0x11bb5f(_0x3817dd[_0x3ebc57(0x3e1)](_0x4fb0aa));
                    } catch (_0x58de9b) {
                      _0x1d839f(_0x58de9b);
                    }
                  }
                  function _0x5487fd(_0x15614a) {
                    try {
                      _0x11bb5f(_0x3817dd["throw"](_0x15614a));
                    } catch (_0x2aaaf3) {
                      _0x1d839f(_0x2aaaf3);
                    }
                  }
                  function _0x11bb5f(_0x17e7cc) {
                    const _0xbf7efd = a0_0x1b49;
                    var _0x23f568;
                    _0x17e7cc[_0xbf7efd(0x4f5)]
                      ? _0x4570c6(_0x17e7cc[_0xbf7efd(0x331)])
                      : ((_0x23f568 = _0x17e7cc["value"]),
                        _0x23f568 instanceof _0x4c711b
                          ? _0x23f568
                          : new _0x4c711b(function (_0x5e3734) {
                              _0x5e3734(_0x23f568);
                            }))[_0xbf7efd(0x429)](_0x33c827, _0x5487fd);
                  }
                  _0x11bb5f((_0x3817dd = _0x3817dd[_0x39146c(0x1d1)](_0x48299b, _0x14c8ba || []))[_0x39146c(0x3e1)]());
                });
              };
            const _0x154911 = [
                _0x49ca28(0x598),
                "k991r/medVeib4zoNiot2zX2gaxyQnDTRUw90QTNOHPruTC/B/143B9Aqo85/blir38GLJJCIfh73Bu3DKnEmCAnq",
                "FwRsxTV1SV3ZItxjexgAw0tkU6KyaXK8iCHCnjLffomlyPDkBfRrpxXh3ERgE9PyPFScalDvF1NQutR/GVo3M8JGRlHvfEolQErUtGkuoJFQ5K1COX0RlDUZQ8v8y+w",
                _0x49ca28(0x35e),
                "G8/H9uCEeQ6q33NtIYyqaDdqLxWliksj722ldBz43DOQIDAQAB",
              ],
              _0x133334 = new (class {
                constructor() {
                  const _0x3f1d5d = _0x49ca28;
                  (this["_0xD1024"] = _0x154911[_0x3f1d5d(0x410)]("")),
                    (this[_0x3f1d5d(0x423)] = _0x2fa3ca["g"][_0x3f1d5d(0x3b3)][_0x3f1d5d(0x3de)]),
                    this[_0x3f1d5d(0x5d7)],
                    (this["_0x1C0d3v"] = !0x1),
                    (this["_0x16b0D"] = !0x1),
                    (this[_0x3f1d5d(0x441)] = [_0x3f1d5d(0x5a0), _0x3f1d5d(0x489), "PROCESS_FRAME", _0x3f1d5d(0x689), _0x3f1d5d(0x336)]),
                    (this[_0x3f1d5d(0x45c)] = !0x1);
                }
                set ["_0xBCA5E1"](_0x449b5b) {
                  this["_0xBCA5E"] = !0x0;
                }
                get ["_0xBCA5E1"]() {
                  const _0x493c5b = _0x49ca28;
                  return this[_0x493c5b(0x45c)];
                }
                [_0x49ca28(0x3a5)](_0x3b63d9) {
                  const _0x1daa02 = _0x49ca28,
                    _0x39609a = new ArrayBuffer(_0x3b63d9[_0x1daa02(0x5ab)]),
                    _0x6f4212 = new Uint8Array(_0x39609a);
                  for (let _0x26c199 = 0x0, _0x245147 = _0x3b63d9[_0x1daa02(0x5ab)]; _0x26c199 < _0x245147; _0x26c199++)
                    _0x6f4212[_0x26c199] = _0x3b63d9[_0x1daa02(0x2ed)](_0x26c199);
                  return _0x39609a;
                }
                [_0x49ca28(0x6d4)](_0x2a896f, _0xb168ba, _0x1e2c6d) {
                  return _0x241e96(this, void 0x0, void 0x0, function* () {
                    const _0x558a56 = a0_0x1b49;
                    return yield window[_0x558a56(0x3b6)][_0x558a56(0x3ad)][_0x558a56(0x6d8)](
                      "RSASSA-PKCS1-v1_5",
                      _0x2a896f,
                      _0xb168ba,
                      _0x1e2c6d
                    );
                  });
                }
                [_0x49ca28(0x389)](_0x122878) {
                  return _0x241e96(this, void 0x0, void 0x0, function* () {
                    const _0x5da2b5 = a0_0x1b49,
                      _0x35cb83 = window[_0x5da2b5(0x583)](_0x122878),
                      _0x1dc3f2 = this[_0x5da2b5(0x3a5)](_0x35cb83);
                    return _0x2fa3ca["g"][_0x5da2b5(0x3b6)]["subtle"]["importKey"](
                      _0x5da2b5(0x290),
                      _0x1dc3f2,
                      { name: _0x5da2b5(0x285), hash: "SHA-256" },
                      !0x0,
                      ["verify"]
                    );
                  });
                }
                ["_0xFD"](_0xd50eff) {
                  const _0x11ce34 = _0x49ca28;
                  var _0x216438;
                  const _0x169e99 = JSON["parse"](_0xd50eff);
                  this[_0x11ce34(0x2bc)] &&
                    ((this["_0xBCD7"] = null == _0x169e99 ? void 0x0 : _0x169e99[_0x11ce34(0x6bf)]),
                    (this[_0x11ce34(0x3dc)] =
                      null === (_0x216438 = null == _0x169e99 ? void 0x0 : _0x169e99[_0x11ce34(0x4ce)]) || void 0x0 === _0x216438
                        ? void 0x0
                        : _0x216438[_0x11ce34(0x605)]),
                    (this[_0x11ce34(0x20a)] = new Date(null == _0x169e99 ? void 0x0 : _0x169e99[_0x11ce34(0x2e1)])),
                    (this[_0x11ce34(0x433)] = parseInt(_0x169e99[_0x11ce34(0x568)], 0x10) || 0x0),
                    (this[_0x11ce34(0x608)] = null == _0x169e99 ? void 0x0 : _0x169e99[_0x11ce34(0x720)]),
                    (this["_0xDC0d3"] = _0x169e99));
                }
                ["_0xBF857"]() {
                  const _0x146e05 = _0x49ca28,
                    _0x12be60 = this[_0x146e05(0x423)][_0x146e05(0x341)](".")[_0x146e05(0x297)](-0x2)[_0x146e05(0x410)]("."),
                    _0x2741f8 = this[_0x146e05(0x3dc)]["filter"]((_0x122f32) => _0x122f32[_0x146e05(0x20d)](_0x12be60));
                  return (
                    [_0x146e05(0x298), ...this["_0xDA857"]]["includes"](this[_0x146e05(0x423)]) ||
                    this[_0x146e05(0x3dc)][_0x146e05(0x20d)](String[_0x146e05(0x48c)](0x2a)) ||
                    _0x2741f8["length"] > 0x0
                  );
                }
                ["_0xBF3xD"]() {
                  const _0x5934b9 = _0x49ca28,
                    _0x5cb2b4 = new Date(),
                    _0x127958 = (this[_0x5934b9(0x20a)]["getTime"]() - _0x5cb2b4[_0x5934b9(0x214)]()) / 0x5265c00,
                    _0x20a911 = _0x127958 + this[_0x5934b9(0x433)] + 0x1;
                  return (
                    _0x127958 < 0x0 &&
                      _0x20a911 > 0x0 &&
                      ((this["_0x16b0D"] = !0x0),
                      _0x7b2b45["Z"]["handleValidationErrorMessage"](new _0x4e7632["Z"](_0x5934b9(0x39e), new Error()), "License")),
                    _0x20a911 > 0x0
                  );
                }
                [_0x49ca28(0x2cd)](_0x3f449a) {
                  _0x3f449a && (this["_0xBCD7"] = _0x3f449a);
                }
                ["vnx"](_0x2f02dc, _0x3e6f68) {
                  return _0x241e96(this, void 0x0, void 0x0, function* () {
                    const _0x885a61 = a0_0x1b49;
                    try {
                      let _0x3880e7 = this[_0x885a61(0x3a5)](_0x3e6f68),
                        _0x455cef = atob(_0x2f02dc),
                        _0x2a6bd2 = this[_0x885a61(0x3a5)](_0x455cef);
                      const _0x3c8d7b = yield this["inP"](this[_0x885a61(0x6de)]),
                        _0x2c62e6 = yield this["verifyMessage"](_0x3c8d7b, _0x2a6bd2, _0x3880e7);
                      switch (((this[_0x885a61(0x2bc)] = _0x2c62e6), this[_0x885a61(0x596)](_0x3e6f68), !0x1)) {
                        case this[_0x885a61(0x602)]():
                          return new _0x313733["Z"](!0x0, "VALIDATOR_LICENSE_EXPIRED");
                        case this[_0x885a61(0x52c)]():
                        case this[_0x885a61(0x2bc)]:
                          return new _0x313733["Z"](!0x0, "VALIDATOR_INVALID_LICENSE");
                        default:
                          return new _0x313733["Z"](!0x1);
                      }
                    } catch (_0x26f27a) {
                      return new _0x313733["Z"](!0x0, "VALIDATOR_INVALID_LICENSE");
                    }
                  });
                }
                ["hasFeature"](_0x3f6ba5) {
                  const _0x573dfc = _0x49ca28;
                  try {
                    return this[_0x573dfc(0x608)][_0x573dfc(0x20d)](_0x3f6ba5);
                  } catch (_0x5a3f6b) {
                    return !0x1;
                  }
                }
                [_0x49ca28(0x497)]() {
                  return this["_0xBCD7"];
                }
                [_0x49ca28(0x484)]() {
                  return _0x241e96(this, void 0x0, void 0x0, function* () {
                    const _0x2e6c79 = a0_0x1b49,
                      _0x312f3f = _0x48cb03["Z"][_0x2e6c79(0x5dd)] + "mitek_license.png";
                    return (yield this[_0x2e6c79(0x1bc)](_0x312f3f)) ? Promise[_0x2e6c79(0x57a)](_0x312f3f) : Promise[_0x2e6c79(0x57a)]("");
                  });
                }
                [_0x49ca28(0x1bc)](_0x20f83a) {
                  return _0x241e96(this, void 0x0, void 0x0, function* () {
                    const _0x11a650 = a0_0x1b49;
                    if (!_0x2c6044["Z"][_0x11a650(0x28c)](_0x20f83a)) return !0x1;
                    try {
                      return !!(yield fetch(_0x20f83a))["ok"];
                    } catch (_0x4c1e61) {
                      return !0x1;
                    }
                  });
                }
                [_0x49ca28(0x5c2)](_0x300688) {
                  const _0x30456d = _0x49ca28;
                  switch (_0x300688) {
                    case _0x30456d(0x381):
                    case "CHECK_FRONT":
                      return _0x30456d(0x50c);
                    case _0x30456d(0x692):
                    case _0x30456d(0x68c):
                    case "PASSPORT":
                      return "id";
                    case _0x30456d(0x434):
                      return _0x30456d(0x35d);
                    case _0x30456d(0x2d4):
                    case _0x30456d(0x533):
                      return _0x30456d(0x49b);
                    case _0x30456d(0x332):
                      return _0x30456d(0x3d5);
                    case _0x30456d(0x268):
                      return _0x30456d(0x63e);
                    default:
                      return _0x300688;
                  }
                }
                [_0x49ca28(0x2a5)](_0x33eeea) {
                  const _0x161371 = _0x49ca28;
                  let _0x478695 = new Array();
                  try {
                    if (null == _0x33eeea ? void 0x0 : _0x33eeea["documentType"]) {
                      let _0xb0ed4f = new Array();
                      _0xb0ed4f[_0x161371(0x4a7)](this[_0x161371(0x5c2)](null == _0x33eeea ? void 0x0 : _0x33eeea["documentType"])),
                        _0xb0ed4f[_0x161371(0x672)]((_0x143244) => {
                          const _0x221206 = _0x161371;
                          this[_0x221206(0x6ca)](_0x143244) || _0x478695[_0x221206(0x4a7)](_0x143244);
                        });
                    }
                  } catch (_0x1b9fbb) {
                    throw new _0x4e7632["Z"](_0x161371(0x6b7), _0x1b9fbb, _0x161371(0x4b9));
                  }
                  return _0x478695;
                }
                [_0x49ca28(0x2bb)](_0x1621f3) {
                  const _0x5e3281 = _0x49ca28;
                  return this["getInvalidLicenseFeatures"](_0x1621f3)["length"] > 0x0
                    ? new _0x313733["Z"](!0x0, _0x5e3281(0x2ab))
                    : new _0x313733["Z"](!0x1);
                }
              })();
          },
          0x2e8: (_0x149782, _0x38f61b, _0x19082c) => {
            _0x19082c["d"](_0x38f61b, { Z: () => _0x1b4edf });
            const _0x1b4edf = class {
              constructor(_0x3d83c4, _0x4a82d0) {
                const _0x5b9c47 = a0_0x1b49;
                (this[_0x5b9c47(0x28d)] = _0x3d83c4), _0x4a82d0 && (this[_0x5b9c47(0x51a)] = _0x4a82d0);
              }
            };
          },
          0x117: (_0x318462, _0x333825, _0x50a427) => {
            const _0x3e9836 = a0_0x1b49;
            _0x50a427["d"](_0x333825, { Z: () => _0x42c209 });
            var _0xe6ff0b = _0x50a427(0x1b8),
              _0xdc5776 = _0x50a427(0x170),
              _0x565f77 = _0x50a427(0x141),
              _0x3d5a97 = function (_0x17e4b2, _0x238af5, _0x3bbae5, _0x452e2f) {
                return new (_0x3bbae5 || (_0x3bbae5 = Promise))(function (_0x461d61, _0x4b4b75) {
                  const _0x5dac16 = a0_0x1b49;
                  function _0x120127(_0x5530c6) {
                    const _0x1b1c84 = a0_0x1b49;
                    try {
                      _0x1ba695(_0x452e2f[_0x1b1c84(0x3e1)](_0x5530c6));
                    } catch (_0x37e392) {
                      _0x4b4b75(_0x37e392);
                    }
                  }
                  function _0x1f68b2(_0x5ab809) {
                    const _0xb4ef84 = a0_0x1b49;
                    try {
                      _0x1ba695(_0x452e2f[_0xb4ef84(0x3b2)](_0x5ab809));
                    } catch (_0x3fffb5) {
                      _0x4b4b75(_0x3fffb5);
                    }
                  }
                  function _0x1ba695(_0x2f3d0d) {
                    const _0x11a514 = a0_0x1b49;
                    var _0x10cca8;
                    _0x2f3d0d["done"]
                      ? _0x461d61(_0x2f3d0d[_0x11a514(0x331)])
                      : ((_0x10cca8 = _0x2f3d0d[_0x11a514(0x331)]),
                        _0x10cca8 instanceof _0x3bbae5
                          ? _0x10cca8
                          : new _0x3bbae5(function (_0x27c0b2) {
                              _0x27c0b2(_0x10cca8);
                            }))[_0x11a514(0x429)](_0x120127, _0x1f68b2);
                  }
                  _0x1ba695((_0x452e2f = _0x452e2f[_0x5dac16(0x1d1)](_0x17e4b2, _0x238af5 || []))[_0x5dac16(0x3e1)]());
                });
              };
            const _0x48cf5f = new (class {
              constructor() {
                const _0x5b2a10 = a0_0x1b49;
                var _0x5e4dac;
                (this[_0x5b2a10(0x3ad)] =
                  null === (_0x5e4dac = null === window || void 0x0 === window ? void 0x0 : window[_0x5b2a10(0x3b6)]) ||
                  void 0x0 === _0x5e4dac
                    ? void 0x0
                    : _0x5e4dac[_0x5b2a10(0x3ad)]),
                  (this["algoSpecs"] = { name: _0x5b2a10(0x326), modulusLength: 0x100, hash: { name: _0x5b2a10(0x5b2) } }),
                  (this[_0x5b2a10(0x3d9)] = _0x5b2a10(0x32a));
              }
              [_0x3e9836(0x5dc)](_0x1c8789) {
                const _0x43cc2d = _0x3e9836;
                for (
                  var _0x566472 = window[_0x43cc2d(0x583)](_0x1c8789),
                    _0x5e23b7 = _0x566472[_0x43cc2d(0x5ab)],
                    _0x37826e = new Uint8Array(_0x5e23b7),
                    _0x4fe8d1 = 0x0;
                  _0x4fe8d1 < _0x5e23b7;
                  _0x4fe8d1++
                )
                  _0x37826e[_0x4fe8d1] = _0x566472["charCodeAt"](_0x4fe8d1);
                return _0x37826e[_0x43cc2d(0x603)];
              }
              [_0x3e9836(0x529)](_0x5c0e3d) {
                const _0x3aaa81 = _0x3e9836;
                for (
                  var _0x321d89 = "", _0x40d095 = new Uint8Array(_0x5c0e3d), _0x1e2472 = _0x40d095["byteLength"], _0x1a5e93 = 0x0;
                  _0x1a5e93 < _0x1e2472;
                  _0x1a5e93++
                )
                  _0x321d89 += String[_0x3aaa81(0x48c)](_0x40d095[_0x1a5e93]);
                return window[_0x3aaa81(0x286)](_0x321d89);
              }
              [_0x3e9836(0x56b)](_0x1bf5d1) {
                return _0x3d5a97(this, void 0x0, void 0x0, function* () {
                  const _0x2f5724 = a0_0x1b49;
                  if (_0x2f5724(0x3df) == _0x1bf5d1[_0x2f5724(0x1f7)]) return _0x1bf5d1;
                  const _0x2afe55 = this[_0x2f5724(0x5dc)](_0x1bf5d1);
                  return yield this[_0x2f5724(0x3ad)][_0x2f5724(0x6be)](_0x2f5724(0x290), _0x2afe55, this[_0x2f5724(0x577)], !0x1, [
                    "encrypt",
                  ]);
                });
              }
              [_0x3e9836(0x6fb)](_0x484b32) {
                return _0x3d5a97(this, void 0x0, void 0x0, function* () {
                  const _0x1bcedf = a0_0x1b49;
                  if (_0x1bcedf(0x455) == _0x484b32[_0x1bcedf(0x1f7)]) return _0x484b32;
                  const _0x512b59 = this[_0x1bcedf(0x5dc)](_0x484b32);
                  return yield this[_0x1bcedf(0x3ad)][_0x1bcedf(0x6be)]("pkcs8", _0x512b59, this["algoSpecs"], !0x1, [_0x1bcedf(0x686)]);
                });
              }
              [_0x3e9836(0x37b)](_0x4dc813, _0x5463d1) {
                return _0x3d5a97(this, void 0x0, void 0x0, function* () {
                  const _0x2dc1ac = a0_0x1b49;
                  let _0x344eb4 = this[_0x2dc1ac(0x723)](_0x4dc813);
                  return yield this["subtle"][_0x2dc1ac(0x37b)]({ name: _0x2dc1ac(0x326) }, _0x5463d1, _0x344eb4);
                });
              }
              ["emb6F"](_0x34003a, _0x59da1b) {
                return _0x3d5a97(this, void 0x0, void 0x0, function* () {
                  const _0x2ecc44 = a0_0x1b49;
                  if (_0x34003a["length"] > 0xbe) throw new _0xe6ff0b["Z"]("RUNTIME_CRYPT_MODULE_UNKNOWN_ERROR", new Error());
                  try {
                    let _0x4e734a = yield this["encrypt"](_0x34003a, _0x59da1b),
                      _0x16320a = new Uint8Array(_0x4e734a);
                    return this[_0x2ecc44(0x529)](_0x16320a);
                  } catch (_0x1132c9) {
                    throw new _0xe6ff0b["Z"](_0x2ecc44(0x1f2), _0x1132c9);
                  }
                });
              }
              [_0x3e9836(0x71c)](_0x196d7c, _0xba46be) {
                return _0x3d5a97(this, void 0x0, void 0x0, function* () {
                  const _0x52443c = a0_0x1b49;
                  let _0x555fd9 = this[_0x52443c(0x5dc)](_0x196d7c);
                  try {
                    let _0x632e01 = yield this[_0x52443c(0x3ad)]["decrypt"]({ name: _0x52443c(0x326) }, _0xba46be, _0x555fd9);
                    return this[_0x52443c(0x646)](_0x632e01);
                  } catch (_0xf62b5) {
                    throw new _0xe6ff0b["Z"](_0x52443c(0x1f2), new Error());
                  }
                });
              }
              [_0x3e9836(0x723)](_0x16cedd) {
                const _0x2c8c39 = _0x3e9836;
                if (_0x2c8c39(0x621) != typeof _0x16cedd) throw new _0xe6ff0b["Z"](_0x2c8c39(0x1f2), new Error());
                return new TextEncoder()[_0x2c8c39(0x333)](_0x16cedd);
              }
              [_0x3e9836(0x646)](_0x15d329) {
                const _0x188778 = _0x3e9836;
                if (!_0x15d329) throw new _0xe6ff0b["Z"](_0x188778(0x1f2), new Error(_0x188778(0x1f2)));
                return new TextDecoder()["decode"](_0x15d329);
              }
            })();
            var _0x54794d = _0x50a427(0x246),
              _0x567b09 = function (_0x1eb50d, _0x2e3dc7, _0x488e0c, _0x5aa263) {
                return new (_0x488e0c || (_0x488e0c = Promise))(function (_0x212c6e, _0x3b57d6) {
                  const _0x593e2b = a0_0x1b49;
                  function _0x2c5242(_0x536101) {
                    const _0x14ffa5 = a0_0x1b49;
                    try {
                      _0x54b9f0(_0x5aa263[_0x14ffa5(0x3e1)](_0x536101));
                    } catch (_0x44fc6e) {
                      _0x3b57d6(_0x44fc6e);
                    }
                  }
                  function _0x131cdf(_0x205ea1) {
                    const _0x1786e1 = a0_0x1b49;
                    try {
                      _0x54b9f0(_0x5aa263[_0x1786e1(0x3b2)](_0x205ea1));
                    } catch (_0xf6e989) {
                      _0x3b57d6(_0xf6e989);
                    }
                  }
                  function _0x54b9f0(_0x13f35c) {
                    const _0x3e1e8d = a0_0x1b49;
                    var _0xb61742;
                    _0x13f35c["done"]
                      ? _0x212c6e(_0x13f35c["value"])
                      : ((_0xb61742 = _0x13f35c[_0x3e1e8d(0x331)]),
                        _0xb61742 instanceof _0x488e0c
                          ? _0xb61742
                          : new _0x488e0c(function (_0x5abe0f) {
                              _0x5abe0f(_0xb61742);
                            }))[_0x3e1e8d(0x429)](_0x2c5242, _0x131cdf);
                  }
                  _0x54b9f0((_0x5aa263 = _0x5aa263[_0x593e2b(0x1d1)](_0x1eb50d, _0x2e3dc7 || []))["next"]());
                });
              };
            class _0x401e4d {
              constructor() {}
              static ["getOrSetDeviceId"]() {
                const _0x1f0448 = _0x3e9836;
                try {
                  return (
                    _0x565f77["Z"][_0x1f0448(0x2cc)](localStorage["getItem"](_0x1f0448(0x703))) ||
                      localStorage[_0x1f0448(0x368)](_0x1f0448(0x703), this[_0x1f0448(0x55b)]()),
                    localStorage[_0x1f0448(0x3aa)](_0x1f0448(0x703))
                  );
                } catch (_0x5b7f93) {
                  throw new _0xe6ff0b["Z"](_0x1f0448(0x654), new Error("invalid\x20persistance"));
                }
              }
              static ["generateUniqueId"]() {
                const _0x11e982 = _0x3e9836;
                let _0x3f4529 = _0x11e982(0x390);
                return (
                  "1000000020004000800010"["replace"](
                    /[0-9]/g,
                    (_0x29e9c4) => _0x3f4529[Math[_0x11e982(0x6b9)](Math[_0x11e982(0x56a)]() * _0x3f4529[_0x11e982(0x5ab)])]
                  ) + Date[_0x11e982(0x3f5)]()[_0x11e982(0x406)](0x10)
                );
              }
              static [_0x3e9836(0x61d)]() {
                const _0x20b524 = _0x3e9836;
                localStorage[_0x20b524(0x3c4)](_0x20b524(0x703));
              }
              static [_0x3e9836(0x39d)](_0x1bf1bb) {
                const _0xdd78d8 = _0x3e9836;
                let _0x4e366f = JSON[_0xdd78d8(0x502)](_0x1bf1bb);
                return (_0x4e366f = _0x4e366f[_0xdd78d8(0x6a5)](/[^\x00-\x7F]/g, "?")), _0x4e366f[_0xdd78d8(0x240)](/.{1,190}/g);
              }
              static [_0x3e9836(0x4d7)](_0x4b22b8) {
                return _0x567b09(this, void 0x0, void 0x0, function* () {
                  const _0xfa889c = a0_0x1b49;
                  let _0x287367,
                    _0x2364e8,
                    _0x44963f = yield _0x48cf5f[_0xfa889c(0x56b)](_0x48cf5f[_0xfa889c(0x3d9)]),
                    _0x113470 = [];
                  for (let _0x5755e9 of _0x4b22b8)
                    (_0x287367 = yield _0x48cf5f[_0xfa889c(0x37b)](_0x5755e9, _0x44963f)),
                      (_0x2364e8 = _0x48cf5f[_0xfa889c(0x529)](_0x287367)),
                      _0x113470["push"](_0x2364e8);
                  let _0x3aa0e2 = JSON["stringify"](_0x113470);
                  return btoa(_0x3aa0e2);
                });
              }
              static [_0x3e9836(0x4fa)]() {
                const _0x5bba3b = _0x3e9836;
                return {
                  id: this[_0x5bba3b(0x562)](),
                  timestamp: Date[_0x5bba3b(0x3f5)](),
                  web: {
                    deviceType: _0xdc5776["Z"]["isMobile"]() ? _0x5bba3b(0x477) : _0x5bba3b(0x24a),
                    viewportW: _0xdc5776["Z"][_0x5bba3b(0x35b)](),
                    userAgent: _0xdc5776["Z"][_0x5bba3b(0x2c5)],
                  },
                };
              }
              static [_0x3e9836(0x3d0)](_0x315166) {
                return _0x567b09(this, void 0x0, void 0x0, function* () {
                  const _0x4733ef = a0_0x1b49,
                    _0x516b8f = _0x315166["getVideoTracks"]()[0x0],
                    _0x42e6c1 = null == _0x516b8f ? void 0x0 : _0x516b8f[_0x4733ef(0x642)](),
                    _0x597777 = yield navigator[_0x4733ef(0x1e2)]["enumerateDevices"]();
                  return {
                    web: {
                      trackInfo: JSON["stringify"](
                        Object[_0x4733ef(0x620)](Object[_0x4733ef(0x620)]({}, _0x42e6c1), {
                          label: null == _0x516b8f ? void 0x0 : _0x516b8f["label"],
                        })
                      ),
                      otherDevices: JSON[_0x4733ef(0x502)](
                        _0x597777[_0x4733ef(0x6c0)]((_0x14f90c) => ({ kind: _0x14f90c[_0x4733ef(0x313)], label: _0x14f90c["label"] }))
                      ),
                    },
                  };
                });
              }
              static [_0x3e9836(0x23c)]() {
                const _0x482da7 = _0x3e9836;
                return {
                  hash: "",
                  web: {
                    deviceType: _0xdc5776["Z"]["isMobile"]() ? _0x482da7(0x477) : _0x482da7(0x24a),
                    viewportW: _0xdc5776["Z"][_0x482da7(0x35b)](),
                    userAgent: _0xdc5776["Z"][_0x482da7(0x2c5)],
                    mode: _0x54794d["Z"][_0x482da7(0x637)]["actionIdentifier"][_0x482da7(0x400)],
                  },
                };
              }
              static [_0x3e9836(0x487)](_0x4ae6f4) {
                var _0x418545, _0x1df1ac, _0xd75fba;
                return _0x567b09(this, void 0x0, void 0x0, function* () {
                  const _0x34f187 = a0_0x1b49;
                  try {
                    return (
                      (null === (_0x418545 = null == _0x4ae6f4 ? void 0x0 : _0x4ae6f4[_0x34f187(0x6e5)]) || void 0x0 === _0x418545
                        ? void 0x0
                        : _0x418545[_0x34f187(0x1e3)]) &&
                        (_0x34f187(0x621) ==
                        typeof (null === (_0x1df1ac = null == _0x4ae6f4 ? void 0x0 : _0x4ae6f4[_0x34f187(0x6e5)]) || void 0x0 === _0x1df1ac
                          ? void 0x0
                          : _0x1df1ac[_0x34f187(0x248)])
                          ? (_0x4ae6f4["response"][_0x34f187(0x1e3)]["hash"] = yield this[_0x34f187(0x1d4)](
                              _0x4ae6f4[_0x34f187(0x6e5)][_0x34f187(0x248)]
                            ))
                          : (_0x4ae6f4[_0x34f187(0x6e5)][_0x34f187(0x1e3)][_0x34f187(0x535)] = _0x34f187(0x6b8))),
                      (_0x4ae6f4[_0x34f187(0x6e5)][_0x34f187(0x1e3)] = yield this["getEncryptedRTSSignals"](
                        _0x4ae6f4[_0x34f187(0x6e5)][_0x34f187(0x1e3)]
                      )),
                      _0x4ae6f4
                    );
                  } catch (_0x42dfcb) {
                    throw (
                      ((null === (_0xd75fba = null == _0x4ae6f4 ? void 0x0 : _0x4ae6f4[_0x34f187(0x6e5)]) || void 0x0 === _0xd75fba
                        ? void 0x0
                        : _0xd75fba[_0x34f187(0x1e3)]) && (_0x4ae6f4[_0x34f187(0x6e5)]["RTS"] = ""),
                      new _0xe6ff0b["Z"]("RUNTIME_UNKNOWN_ERROR", _0x42dfcb))
                    );
                  }
                });
              }
              static [_0x3e9836(0x463)](_0x2c8a35, _0x55e660) {
                const _0x241f63 = _0x3e9836,
                  _0x1cb338 = Object[_0x241f63(0x620)](_0x55e660["web"], null == _0x2c8a35 ? void 0x0 : _0x2c8a35["web"]);
                return { hash: _0x55e660[_0x241f63(0x535)], web: _0x1cb338 };
              }
              static [_0x3e9836(0x3a7)](_0x292728) {
                return _0x567b09(this, void 0x0, void 0x0, function* () {
                  const _0x178abe = a0_0x1b49,
                    _0x173fac = yield crypto[_0x178abe(0x3ad)][_0x178abe(0x310)](_0x178abe(0x59f), _0x292728);
                  return Array[_0x178abe(0x547)](new Uint8Array(_0x173fac))
                    [_0x178abe(0x6c0)]((_0x529f33) => _0x529f33[_0x178abe(0x406)](0x10)[_0x178abe(0x6c8)](0x2, "0"))
                    [_0x178abe(0x410)]("");
                });
              }
              static [_0x3e9836(0x5dc)](_0x374cfc) {
                const _0x5abbc5 = _0x3e9836,
                  _0x3718f5 = window[_0x5abbc5(0x583)](_0x374cfc),
                  _0x242db8 = _0x3718f5["length"],
                  _0x3e7940 = new Uint8Array(_0x242db8);
                for (let _0x49bee0 = 0x0; _0x49bee0 < _0x242db8; _0x49bee0++) _0x3e7940[_0x49bee0] = _0x3718f5[_0x5abbc5(0x2ed)](_0x49bee0);
                return _0x3e7940[_0x5abbc5(0x603)];
              }
              static [_0x3e9836(0x1d4)](_0x5f55bc) {
                return _0x567b09(this, void 0x0, void 0x0, function* () {
                  const _0x3e1bc1 = a0_0x1b49,
                    _0x407e11 = _0x5f55bc[_0x3e1bc1(0x341)](",")[0x1],
                    _0xf82306 = this[_0x3e1bc1(0x5dc)](_0x407e11);
                  return yield this["calculateSHA256"](_0xf82306);
                });
              }
              static [_0x3e9836(0x702)](_0xcc155a) {
                return _0x567b09(this, void 0x0, void 0x0, function* () {
                  const _0x1e1be6 = a0_0x1b49,
                    _0x2b46ff = _0x401e4d["convertObjectToStringBlocks"](_0xcc155a);
                  try {
                    return yield _0x401e4d[_0x1e1be6(0x4d7)](_0x2b46ff);
                  } catch (_0x299c1c) {
                    throw new _0xe6ff0b["Z"](_0x1e1be6(0x1f2), _0x299c1c);
                  }
                });
              }
              static [_0x3e9836(0x70a)]() {
                return _0x567b09(this, void 0x0, void 0x0, function* () {
                  const _0xc4f77c = a0_0x1b49;
                  let _0x3c9618 = _0x401e4d[_0xc4f77c(0x39d)](_0x401e4d[_0xc4f77c(0x4fa)]());
                  try {
                    return yield _0x401e4d[_0xc4f77c(0x4d7)](_0x3c9618);
                  } catch (_0x4871dd) {
                    throw new _0xe6ff0b["Z"](_0xc4f77c(0x1f2), _0x4871dd);
                  }
                });
              }
            }
            const _0x42c209 = _0x401e4d;
          },
          0x2b: (_0x5b3dfe, _0x38b85d, _0x39c3d1) => {
            _0x39c3d1["d"](_0x38b85d, { Z: () => _0x1e9673 });
            let _0x4165dd = 0x0;
            const _0x1e9673 = class {
              constructor(_0x1101d1, _0xd7df75) {
                const _0x3c4431 = a0_0x1b49;
                (this[_0x3c4431(0x248)] = _0x1101d1),
                  (this["snapshotLabel"] = _0xd7df75),
                  (this[_0x3c4431(0x27f)] = (_0x4165dd++)[_0x3c4431(0x406)]() + "_" + new Date()["getTime"]());
              }
            };
          },
          0x35e: (_0x1736bc, _0x5054fb, _0x40dced) => {
            const _0x2a5f90 = a0_0x1b49;
            _0x40dced["d"](_0x5054fb, { Z: () => _0x1ff273 });
            var _0x231fca = _0x40dced(0x246);
            class _0x403c7d {
              constructor(_0x104647) {
                const _0x4a60f0 = a0_0x1b49;
                this[_0x4a60f0(0x4d0)] = _0x104647;
              }
              [_0x2a5f90(0x4df)]() {
                const _0x3e7ef9 = _0x2a5f90;
                return Date["now"]() - _0x231fca["Z"][_0x3e7ef9(0x637)]["startTime"];
              }
              [_0x2a5f90(0x3c2)](_0x349564) {
                const _0x34f306 = _0x2a5f90,
                  _0x4c9367 = { [this[_0x34f306(0x4d0)]]: [this[_0x34f306(0x4df)](), _0x349564] };
                _0x231fca["Z"][_0x34f306(0x37d)](_0x4c9367);
              }
            }
            const _0x1ff273 = new (class {
              constructor() {
                const _0x5579a5 = _0x2a5f90;
                (this[_0x5579a5(0x2b0)] = new _0x403c7d("PL")),
                  (this[_0x5579a5(0x46e)] = new _0x403c7d("SC")),
                  (this[_0x5579a5(0x6f2)] = new _0x403c7d("PC")),
                  (this[_0x5579a5(0x308)] = new _0x403c7d("VC")),
                  (this[_0x5579a5(0x520)] = new _0x403c7d("VP")),
                  (this[_0x5579a5(0x5f8)] = new _0x403c7d("VL")),
                  (this[_0x5579a5(0x71e)] = new _0x403c7d("TC")),
                  (this[_0x5579a5(0x304)] = new _0x403c7d("EI")),
                  (this[_0x5579a5(0x344)] = new _0x403c7d("QX")),
                  (this[_0x5579a5(0x1dc)] = new _0x403c7d("QW")),
                  (this[_0x5579a5(0x1d5)] = new _0x403c7d("QH")),
                  (this[_0x5579a5(0x4cd)] = new _0x403c7d("LP")),
                  (this[_0x5579a5(0x6e6)] = new _0x403c7d("QC")),
                  (this["CV_MEASURE_MIN_WIDTH"] = new _0x403c7d("QM")),
                  (this["CV_ERROR_FOCUS"] = new _0x403c7d("QF")),
                  (this[_0x5579a5(0x4d3)] = new _0x403c7d("QD")),
                  (this[_0x5579a5(0x3d8)] = new _0x403c7d("TF")),
                  (this["CV_ERROR_SKEW"] = new _0x403c7d("QS")),
                  (this[_0x5579a5(0x55c)] = new _0x403c7d("HF")),
                  (this["CV_ERROR_MIN_PADDING"] = new _0x403c7d("MP")),
                  (this[_0x5579a5(0x1cf)] = new _0x403c7d("QE")),
                  (this[_0x5579a5(0x573)] = new _0x403c7d("QQ")),
                  (this[_0x5579a5(0x70b)] = new _0x403c7d("SU")),
                  (this[_0x5579a5(0x651)] = new _0x403c7d("IS")),
                  (this[_0x5579a5(0x4c6)] = new _0x403c7d("NB")),
                  (this[_0x5579a5(0x4d2)] = new _0x403c7d("GD")),
                  (this[_0x5579a5(0x5b7)] = new _0x403c7d("FC")),
                  (this[_0x5579a5(0x607)] = new _0x403c7d("C")),
                  (this[_0x5579a5(0x2ea)] = new _0x403c7d("MC")),
                  (this[_0x5579a5(0x5e7)] = new _0x403c7d("NF")),
                  (this["BRIGHTNESS_FAILED"] = new _0x403c7d("BF")),
                  (this["SHAPRNESS_FAILED"] = new _0x403c7d("SF")),
                  (this["AUTOCAPTURE_TIME"] = new _0x403c7d("MT")),
                  (this[_0x5579a5(0x450)] = new _0x403c7d("MF")),
                  (this[_0x5579a5(0x3c7)] = new _0x403c7d("RP")),
                  (this[_0x5579a5(0x2b3)] = new _0x403c7d("MH")),
                  (this[_0x5579a5(0x54d)] = new _0x403c7d("MW")),
                  (this[_0x5579a5(0x2d3)] = new _0x403c7d("MV")),
                  (this[_0x5579a5(0x3a8)] = new _0x403c7d("MB")),
                  (this[_0x5579a5(0x46a)] = new _0x403c7d("MS")),
                  (this[_0x5579a5(0x446)] = new _0x403c7d("LC")),
                  (this["CV_ERROR_ASPECT_RATIO"] = new _0x403c7d("AR")),
                  (this[_0x5579a5(0x611)] = new _0x403c7d("BB")),
                  (this[_0x5579a5(0x1f6)] = new _0x403c7d("CD")),
                  (this["AUTOCAPTURE_FRAME_PROCESSING_STARTED"] = new _0x403c7d("FP")),
                  (this[_0x5579a5(0x5bd)] = new _0x403c7d(_0x5579a5(0x1b9))),
                  (this[_0x5579a5(0x2dd)] = new _0x403c7d("FST")),
                  (this[_0x5579a5(0x395)] = new _0x403c7d(_0x5579a5(0x666))),
                  (this[_0x5579a5(0x2e7)] = new _0x403c7d(_0x5579a5(0x417))),
                  (this[_0x5579a5(0x4e3)] = new _0x403c7d("GF")),
                  (this[_0x5579a5(0x232)] = new _0x403c7d("SA")),
                  (this["MANUAL_CAPTURE_START"] = new _0x403c7d("SS"));
              }
            })();
          },
          0x141: (_0x1edb71, _0x182dd0, _0x1e61a0) => {
            const _0x2f4d54 = a0_0x1b49;
            _0x1e61a0["d"](_0x182dd0, { Z: () => _0x3a7773 });
            var _0x2a55af = _0x1e61a0(0x35e);
            const _0x5e1e5c = new (class {
              constructor() {
                const _0x57a21a = a0_0x1b49;
                (this[_0x57a21a(0x5da)] = Object["freeze"]({
                  CAMERA_DISPLAY_STARTED: _0x57a21a(0x635),
                  IMAGE_CAPTURED: _0x57a21a(0x3d3),
                  FRAME_CAPTURE_RESULT: "FRAME_CAPTURE_RESULT",
                  FRAME_PROCESSING_ENDED: _0x57a21a(0x5a4),
                  FRAME_PROCESSING_FEEDBACK: _0x57a21a(0x241),
                  FRAME_PROCESSING_STARTED: _0x57a21a(0x404),
                  VOICE_PROCESSING_STARTED: _0x57a21a(0x68f),
                  VOICE_RECORDING_STARTED: "VOICE_RECORDING_STARTED",
                  VOICE_CAPTURE_RESULT: _0x57a21a(0x466),
                  SDK_ERROR: _0x57a21a(0x71f),
                  SDK_READY: _0x57a21a(0x56f),
                })),
                  (this[_0x57a21a(0x27b)] = Object[_0x57a21a(0x70e)]({
                    CAPTURE_AND_PROCESS_FRAME: _0x57a21a(0x5a0),
                    PROCESS_FRAME: _0x57a21a(0x53f),
                    CAPTURE_FRAME: "CAPTURE_FRAME",
                    CAPTURE_AND_PROCESS_VOICE: _0x57a21a(0x336),
                    SDK_START: _0x57a21a(0x65c),
                    SDK_STOP: _0x57a21a(0x224),
                    SDK_QUIT: _0x57a21a(0x65d),
                    SDK_REMOVE_LISTENERS: _0x57a21a(0x700),
                    SHOW_HINT: _0x57a21a(0x1cc),
                    HIDE_HINT: _0x57a21a(0x3bb),
                    HINT_MESSAGE_SIZE: _0x57a21a(0x233),
                    COMPONENT_PRELOAD: _0x57a21a(0x689),
                  })),
                  (this[_0x57a21a(0x3e8)] = Object[_0x57a21a(0x70e)]({
                    MANUAL_CAPTURE: _0x57a21a(0x609),
                    AUTO_CAPTURE: _0x57a21a(0x587),
                    DIRECT: _0x57a21a(0x33b),
                  })),
                  (this[_0x57a21a(0x49c)] = Object[_0x57a21a(0x70e)]({
                    FACING_THE_ENVIRNOMENT: _0x57a21a(0x69d),
                    FACING_THE_USER: _0x57a21a(0x1ee),
                  })),
                  (this[_0x57a21a(0x205)] = Object["freeze"]({
                    DL_FRONT: _0x57a21a(0x68c),
                    DL_BACK: "DL_BACK",
                    PDF417_BARCODE: _0x57a21a(0x2d4),
                    QR_BARCODE: "QR_BARCODE",
                    CHECK_FRONT: _0x57a21a(0x717),
                    CHECK_BACK: _0x57a21a(0x381),
                    PASSPORT: _0x57a21a(0x478),
                    DOCUMENT: _0x57a21a(0x434),
                    SELFIE: _0x57a21a(0x332),
                    VOICE: _0x57a21a(0x268),
                  })),
                  (this["actionTypeAnalyzerCategories"] = Object["freeze"]({
                    COREVISION: [
                      this[_0x57a21a(0x205)][_0x57a21a(0x68c)],
                      this["actionTypes"][_0x57a21a(0x692)],
                      this[_0x57a21a(0x205)]["CHECK_BACK"],
                      this[_0x57a21a(0x205)][_0x57a21a(0x717)],
                      this[_0x57a21a(0x205)]["PASSPORT"],
                      this[_0x57a21a(0x205)][_0x57a21a(0x434)],
                    ],
                    BARCODE: [this[_0x57a21a(0x205)][_0x57a21a(0x2d4)], this[_0x57a21a(0x205)][_0x57a21a(0x533)]],
                    SELFIE: [this[_0x57a21a(0x205)]["SELFIE"]],
                  })),
                  (this[_0x57a21a(0x679)] = Object[_0x57a21a(0x70e)]({
                    DL_FRONT: 0xa,
                    DL_BACK: 0x14,
                    PDF417_BARCODE: 0x14,
                    QR_BARCODE: 0x14,
                    CHECK_FRONT: 0x32,
                    CHECK_BACK: 0x3c,
                    PASSPORT: 0x46,
                    DOCUMENT: 0x64,
                  })),
                  (this[_0x57a21a(0x2b8)] = Object[_0x57a21a(0x70e)]({ MOBILE: _0x57a21a(0x477), DESKTOP: _0x57a21a(0x24a) })),
                  (this[_0x57a21a(0x215)] = Object[_0x57a21a(0x70e)]({ IMAGE_DATA: _0x57a21a(0x629), DATA_URL: _0x57a21a(0x5fc) })),
                  (this["faceAPIEmotions"] = Object["freeze"]({
                    NEUTRAL: _0x57a21a(0x4a5),
                    HAPPY: "happy",
                    SAD: "sad",
                    ANGRY: _0x57a21a(0x30a),
                    FEARFUL: _0x57a21a(0x3fc),
                    DISGUSTED: _0x57a21a(0x4ff),
                    SURPRISED: _0x57a21a(0x5ec),
                  })),
                  (this["mibiDataUXPEventLoggers"] = _0x2a55af["Z"]);
              }
            })();
            var _0x2d4569 = _0x1e61a0(0x1b8),
              _0x4c010e = _0x1e61a0(0x127),
              _0x489f82 = _0x1e61a0(0x2e4),
              _0x36b82c = _0x1e61a0(0x157),
              _0x3b4928 = _0x1e61a0(0x2e8),
              _0xf1ffb2 = function (_0x2044ae, _0x36fada, _0x322c54, _0x408d18) {
                return new (_0x322c54 || (_0x322c54 = Promise))(function (_0x44c6f0, _0x2167f3) {
                  const _0x3fa449 = a0_0x1b49;
                  function _0x59e054(_0x3fc9ae) {
                    const _0x2529f0 = a0_0x1b49;
                    try {
                      _0x6e5fcc(_0x408d18[_0x2529f0(0x3e1)](_0x3fc9ae));
                    } catch (_0x363a3b) {
                      _0x2167f3(_0x363a3b);
                    }
                  }
                  function _0x5ba418(_0x8486b7) {
                    const _0x8322ee = a0_0x1b49;
                    try {
                      _0x6e5fcc(_0x408d18[_0x8322ee(0x3b2)](_0x8486b7));
                    } catch (_0x8259ad) {
                      _0x2167f3(_0x8259ad);
                    }
                  }
                  function _0x6e5fcc(_0x378e0a) {
                    const _0x334c79 = a0_0x1b49;
                    var _0x3d62a5;
                    _0x378e0a[_0x334c79(0x4f5)]
                      ? _0x44c6f0(_0x378e0a[_0x334c79(0x331)])
                      : ((_0x3d62a5 = _0x378e0a[_0x334c79(0x331)]),
                        _0x3d62a5 instanceof _0x322c54
                          ? _0x3d62a5
                          : new _0x322c54(function (_0x26e62e) {
                              _0x26e62e(_0x3d62a5);
                            }))[_0x334c79(0x429)](_0x59e054, _0x5ba418);
                  }
                  _0x6e5fcc((_0x408d18 = _0x408d18["apply"](_0x2044ae, _0x36fada || []))[_0x3fa449(0x3e1)]());
                });
              };
            const _0x3a7773 = new (class {
              constructor() {
                const _0x2d4a6d = a0_0x1b49;
                this[_0x2d4a6d(0x6c4)] = _0x5e1e5c;
              }
              [_0x2f4d54(0x3ca)](_0x26cefb) {
                return _0x26cefb in _0x5e1e5c["eventNames"];
              }
              [_0x2f4d54(0x3be)](_0x5da659) {
                const _0x5135ce = _0x2f4d54;
                if (!(_0x5da659 in _0x5e1e5c[_0x5135ce(0x27b)])) throw new _0x2d4569["Z"]("VALIDATOR_BAD_EXTERNAL_CMD_NAME", new Error());
              }
              [_0x2f4d54(0x2eb)](_0x40cae9) {
                const _0x4b545f = _0x2f4d54;
                if (!(_0x40cae9 in _0x5e1e5c[_0x4b545f(0x205)])) throw new _0x2d4569["Z"]("VALIDATOR_BAD_DOC_TYPE", new Error());
              }
              ["validateSnapshot"](_0x581c27) {
                const _0x2e3381 = _0x2f4d54;
                if (!_0x581c27) throw new _0x2d4569["Z"](_0x2e3381(0x26c), new Error());
              }
              [_0x2f4d54(0x266)](_0x5687e3) {
                const _0x4a956f = _0x2f4d54;
                if (!(_0x5687e3 in _0x5e1e5c[_0x4a956f(0x3e8)])) throw new _0x2d4569["Z"](_0x4a956f(0x5f4), new Error());
              }
              [_0x2f4d54(0x517)](_0x581a46) {
                const _0x28e92e = _0x2f4d54;
                var _0x31f163;
                try {
                  return this[_0x28e92e(0x28c)](_0x581a46)
                    ? _0x581a46
                    : _0x28e92e(0x621) ==
                      typeof (null === (_0x31f163 = _0x581a46[_0x28e92e(0x4aa)]) || void 0x0 === _0x31f163
                        ? void 0x0
                        : _0x31f163[_0x28e92e(0x70f)])
                    ? _0x581a46[_0x28e92e(0x4aa)][_0x28e92e(0x70f)]
                    : (_0x4c010e["Z"][_0x28e92e(0x21f)](
                        new _0x2d4569["Z"]("VALIDATOR_BAD_EXTERNAL_CMD_PARAM_TYPE", new Error()),
                        "hint\x20message"
                      ),
                      null);
                } catch (_0x1292ba) {
                  _0x4c010e["Z"][_0x28e92e(0x21f)](new _0x2d4569["Z"](_0x28e92e(0x216), new Error()), _0x28e92e(0x521));
                }
              }
              ["validateHintMessageSizeParams"](_0x487d4f) {
                const _0x4cbb8f = _0x2f4d54;
                try {
                  return this[_0x4cbb8f(0x40a)](_0x487d4f) && _0x487d4f >= 0x1 && _0x487d4f <= 0x3
                    ? _0x487d4f
                    : (_0x4c010e["Z"][_0x4cbb8f(0x21f)](new _0x2d4569["Z"](_0x4cbb8f(0x216), new Error()), _0x4cbb8f(0x4a0)), null);
                } catch (_0x1c4a9f) {
                  _0x4c010e["Z"]["handleValidationErrorMessage"](new _0x2d4569["Z"](_0x4cbb8f(0x216), new Error()), _0x4cbb8f(0x4a0));
                }
              }
              [_0x2f4d54(0x4fc)](_0xc4e9e0) {
                return "function" == typeof _0xc4e9e0;
              }
              [_0x2f4d54(0x3d7)](_0x4f3f34, _0x28754b) {
                try {
                  return !(_0x4f3f34["width"] < _0x28754b || _0x4f3f34["height"] < _0x28754b);
                } catch (_0x995522) {
                  return !0x1;
                }
              }
              ["is"](_0x44fc75) {
                return void 0x0 !== _0x44fc75;
              }
              [_0x2f4d54(0x553)](_0x302402) {
                const _0x37a09d = _0x2f4d54;
                return !this[_0x37a09d(0x40a)](_0x302402) || !this[_0x37a09d(0x28c)](_0x302402);
              }
              [_0x2f4d54(0x711)](_0x23df91) {
                return void 0x0 !== _0x23df91;
              }
              [_0x2f4d54(0x28c)](_0x686ba8) {
                const _0x27dc5a = _0x2f4d54;
                return this["is"](_0x686ba8) && _0x27dc5a(0x621) == typeof _0x686ba8;
              }
              [_0x2f4d54(0x40a)](_0x390ca0) {
                return "number" == typeof _0x390ca0;
              }
              [_0x2f4d54(0x279)](_0x206677) {
                const _0x38f33b = _0x2f4d54;
                return this["is"](_0x206677) && _0x38f33b(0x449) == typeof _0x206677;
              }
              [_0x2f4d54(0x4fd)](_0xec573a) {
                const _0x76b897 = _0x2f4d54;
                return /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{4})$/[_0x76b897(0x3b4)](_0xec573a);
              }
              [_0x2f4d54(0x2aa)](_0x7920b6) {
                const _0x462c9b = _0x2f4d54;
                return this["is"](_0x7920b6) && _0x7920b6 in this[_0x462c9b(0x6c4)][_0x462c9b(0x27b)];
              }
              [_0x2f4d54(0x237)](_0x2de9bc) {
                const _0x2d48bf = _0x2f4d54;
                return this["is"](_0x2de9bc) && _0x2de9bc in this[_0x2d48bf(0x6c4)][_0x2d48bf(0x3e8)];
              }
              ["isActionType"](_0x3c6f1c) {
                const _0x5bf2e3 = _0x2f4d54;
                try {
                  return this["is"](_0x3c6f1c) && _0x3c6f1c in this[_0x5bf2e3(0x6c4)][_0x5bf2e3(0x205)];
                } catch (_0x199c1f) {
                  return !0x1;
                }
              }
              [_0x2f4d54(0x588)](_0x422af1, _0x2eb7a8, _0xf3468c) {
                try {
                  return this["is"](_0xf3468c) && _0xf3468c >= _0x422af1 && _0xf3468c <= _0x2eb7a8;
                } catch (_0x5550cb) {
                  return !0x1;
                }
              }
              [_0x2f4d54(0x6f6)](_0x1ba15b, _0x2767cf = []) {
                const _0x2efb58 = _0x2f4d54;
                try {
                  if (!(_0x1ba15b instanceof File)) return !0x1;
                  return (
                    _0x2767cf[_0x2efb58(0x5ab)] ? new RegExp(_0x2efb58(0x57f) + _0x2767cf[_0x2efb58(0x410)]("|") + ")") : /image\/.*/
                  )[_0x2efb58(0x3b4)](_0x1ba15b[_0x2efb58(0x1f7)]);
                } catch (_0x4acc2f) {
                  return !0x1;
                }
              }
              [_0x2f4d54(0x610)](_0x1bafc2) {
                const _0x2c1d5d = _0x2f4d54;
                try {
                  return this["isValidImageFileType"](_0x1bafc2, ["jpg", _0x2c1d5d(0x4b6), _0x2c1d5d(0x6ce)]);
                } catch (_0x418df0) {
                  return !0x1;
                }
              }
              [_0x2f4d54(0x439)](_0x13bbd3) {
                const _0x77d350 = _0x2f4d54;
                try {
                  return (
                    ("string" == typeof _0x13bbd3 && _0x13bbd3[_0x77d350(0x5d1)]()["length"] > 0x0) ||
                    _0x13bbd3 instanceof ImageData ||
                    _0x13bbd3 instanceof File
                  );
                } catch (_0x1ca6f8) {
                  return !0x1;
                }
              }
              [_0x2f4d54(0x2cc)](_0x23cd7d) {
                const _0x11dc28 = _0x2f4d54;
                switch (!0x0) {
                  case _0x11dc28(0x621) != typeof _0x23cd7d:
                  case 0x21 !== _0x23cd7d[_0x11dc28(0x5ab)]:
                  case null !== _0x23cd7d[_0x11dc28(0x240)](/[^A-Za-z0-9+/]/g):
                    return !0x1;
                  default:
                    return !0x0;
                }
              }
              [_0x2f4d54(0x3fd)](_0x2f0c39) {
                const _0x1dd8c6 = _0x2f4d54;
                return (
                  !(
                    !Array[_0x1dd8c6(0x357)](_0x2f0c39) ||
                    !_0x2f0c39["every"]((_0x5bf295) => Object[_0x1dd8c6(0x426)](_0x36b82c["Z"])["includes"](_0x5bf295))
                  ) ||
                  (_0x4c010e["Z"][_0x1dd8c6(0x21f)](new _0x2d4569["Z"](_0x1dd8c6(0x216), new Error()), _0x1dd8c6(0x380)),
                  _0x4c010e["Z"]["handleDirectSdkErrorToIntegrator"](_0x1dd8c6(0x216)),
                  !0x1)
                );
              }
              [_0x2f4d54(0x2bf)](_0x2e15ff) {
                var _0x3f1d8b;
                return _0xf1ffb2(this, void 0x0, void 0x0, function* () {
                  const _0x4df39b = a0_0x1b49;
                  if (_0x489f82["Z"][_0x4df39b(0x67a)]) return this[_0x4df39b(0x470)](_0x2e15ff);
                  let _0x41b88a,
                    _0x26c263,
                    _0x157b0c,
                    _0x25f9ae = new _0x3b4928["Z"](!0x0, _0x4df39b(0x6b7)),
                    _0xb7c502 = new _0x3b4928["Z"](!0x0, _0x4df39b(0x2ab));
                  const _0x5acbb6 = new Array();
                  try {
                    const _0x383097 = atob(
                      null === (_0x3f1d8b = null == _0x2e15ff ? void 0x0 : _0x2e15ff["options"]) || void 0x0 === _0x3f1d8b
                        ? void 0x0
                        : _0x3f1d8b["license"]
                    );
                    (_0x41b88a = JSON[_0x4df39b(0x53d)](_0x383097)),
                      (_0x26c263 = _0x41b88a["signature"] || ""),
                      (_0x157b0c = JSON["stringify"](null == _0x41b88a ? void 0x0 : _0x41b88a[_0x4df39b(0x38a)]));
                  } catch (_0x26abb0) {
                    return _0x5acbb6["push"]("SIGNATURE_INVALID_UNABLE_TO_PARSE"), _0x25f9ae;
                  }
                  _0x26c263 || _0x5acbb6[_0x4df39b(0x4a7)]("SIGNATURE_NOT_FOUND"), _0x157b0c || _0x5acbb6["push"](_0x4df39b(0x649));
                  const _0xf28efe = yield _0x489f82["Z"][_0x4df39b(0x1c4)](_0x26c263, _0x157b0c);
                  switch (
                    (this["isValidBase64"](null == _0x41b88a ? void 0x0 : _0x41b88a["barcodeWebLicense"]) &&
                      _0x489f82["Z"]["bcx"](null == _0x41b88a ? void 0x0 : _0x41b88a[_0x4df39b(0x6bf)]),
                    _0xf28efe[_0x4df39b(0x28d)]
                      ? _0x5acbb6["push"](_0x4df39b(0x6f8))
                      : ((_0xb7c502 = this[_0x4df39b(0x470)](_0x2e15ff)),
                        _0xb7c502["isFailure"] && _0x5acbb6[_0x4df39b(0x4a7)]("PERMISSIONS_NOT_MET")),
                    _0x5acbb6[0x0])
                  ) {
                    case _0x4df39b(0x680):
                      return _0xb7c502;
                    case _0x4df39b(0x469):
                    case _0x4df39b(0x649):
                    case _0x4df39b(0x392):
                    case _0x4df39b(0x6f8):
                      return _0x25f9ae;
                    default:
                      return (_0x489f82["Z"][_0x4df39b(0x67a)] = !0x0), new _0x3b4928["Z"](!0x1);
                  }
                });
              }
              [_0x2f4d54(0x470)](_0x3bc0d8) {
                return _0x489f82["Z"]["getPermissionsCheck"](_0x3bc0d8);
              }
            })();
          },
          0x157: (_0x387034, _0x261411, _0x44c8e8) => {
            var _0x265741;
            _0x44c8e8["d"](_0x261411, { Z: () => _0x3a0b2c }),
              (function (_0x50f1b0) {
                const _0x325b18 = a0_0x1b49;
                (_0x50f1b0[_0x325b18(0x332)] = "SELFIE"),
                  (_0x50f1b0[_0x325b18(0x509)] = _0x325b18(0x509)),
                  (_0x50f1b0[_0x325b18(0x612)] = _0x325b18(0x612)),
                  (_0x50f1b0[_0x325b18(0x6e7)] = "ALL");
              })(_0x265741 || (_0x265741 = {}));
            const _0x3a0b2c = _0x265741;
          },
          0x170: (_0x23dd02, _0xc02fee, _0x5847a0) => {
            const _0x3074be = a0_0x1b49;
            _0x5847a0["d"](_0xc02fee, { Z: () => _0x1024e9 });
            var _0x4235ef = function (_0x27836d, _0xcdde1b, _0x439905, _0x721a1e) {
              return new (_0x439905 || (_0x439905 = Promise))(function (_0x49e540, _0x10c5b5) {
                const _0x4172a0 = a0_0x1b49;
                function _0x57c7ae(_0x3940e7) {
                  const _0x3657d6 = a0_0x1b49;
                  try {
                    _0x208cfa(_0x721a1e[_0x3657d6(0x3e1)](_0x3940e7));
                  } catch (_0x113a02) {
                    _0x10c5b5(_0x113a02);
                  }
                }
                function _0x45afe3(_0x29e760) {
                  try {
                    _0x208cfa(_0x721a1e["throw"](_0x29e760));
                  } catch (_0x358808) {
                    _0x10c5b5(_0x358808);
                  }
                }
                function _0x208cfa(_0x3f49ce) {
                  const _0x5c1f6c = a0_0x1b49;
                  var _0x3e7165;
                  _0x3f49ce[_0x5c1f6c(0x4f5)]
                    ? _0x49e540(_0x3f49ce[_0x5c1f6c(0x331)])
                    : ((_0x3e7165 = _0x3f49ce[_0x5c1f6c(0x331)]),
                      _0x3e7165 instanceof _0x439905
                        ? _0x3e7165
                        : new _0x439905(function (_0x16ac2f) {
                            _0x16ac2f(_0x3e7165);
                          }))[_0x5c1f6c(0x429)](_0x57c7ae, _0x45afe3);
                }
                _0x208cfa((_0x721a1e = _0x721a1e[_0x4172a0(0x1d1)](_0x27836d, _0xcdde1b || []))[_0x4172a0(0x3e1)]());
              });
            };
            const _0x1024e9 = new (class {
              get [_0x3074be(0x2c5)]() {
                const _0x3e6d01 = _0x3074be;
                return window[_0x3e6d01(0x1b8)]["userAgent"];
              }
              [_0x3074be(0x52b)]() {
                const _0x3d87aa = _0x3074be;
                return /Android/i[_0x3d87aa(0x3b4)](window[_0x3d87aa(0x1b8)][_0x3d87aa(0x2c5)]);
              }
              [_0x3074be(0x4b1)]() {
                const _0x322641 = _0x3074be;
                return (
                  void 0x0 !== window["orientation"] || -0x1 !== window[_0x322641(0x1b8)]["userAgent"][_0x322641(0x6ba)](_0x322641(0x211))
                );
              }
              [_0x3074be(0x32b)]() {
                const _0x16ec1e = _0x3074be;
                return (
                  _0x5847a0["g"][_0x16ec1e(0x1b8)][_0x16ec1e(0x2c5)][_0x16ec1e(0x20d)]("Safari") &&
                  !_0x5847a0["g"][_0x16ec1e(0x1b8)][_0x16ec1e(0x2c5)][_0x16ec1e(0x20d)](_0x16ec1e(0x1de))
                );
              }
              [_0x3074be(0x656)]() {
                const _0x2cd4b7 = _0x3074be;
                return !!navigator["userAgent"][_0x2cd4b7(0x240)](/iPhone/i);
              }
              [_0x3074be(0x546)](_0x975a27) {
                const _0x45d6d9 = _0x3074be;
                let _0x345daf;
                switch (_0x975a27) {
                  case 0x140:
                  case 0x177:
                  case 0x19e:
                  case 0x186:
                    _0x345daf = [_0x45d6d9(0x4b5)];
                    break;
                  case 0x189:
                    _0x345daf = [_0x45d6d9(0x3c6)];
                    break;
                  case 0x1ae:
                    _0x345daf = [_0x45d6d9(0x3d6)];
                    break;
                  case 0x1ac:
                    _0x345daf = [_0x45d6d9(0x4b5)];
                    break;
                  default:
                    _0x345daf = ["Back\x20Ultra\x20Wide\x20Camera", _0x45d6d9(0x4b5)];
                }
                return _0x345daf;
              }
              [_0x3074be(0x35b)]() {
                const _0x3c923e = _0x3074be;
                return window[_0x3c923e(0x52d)][_0x3c923e(0x657)];
              }
              [_0x3074be(0x576)]() {
                const _0x5232e6 = _0x3074be;
                let _0x142ef4 = window["screen"][_0x5232e6(0x657)];
                return this[_0x5232e6(0x656)]() && (0x189 === _0x142ef4 || 0x1ae === _0x142ef4);
              }
              ["getDeviceFrontCameraLabels"]() {
                return ["Front\x20Camera"];
              }
              [_0x3074be(0x2fa)]() {
                const _0x5d3cf7 = _0x3074be;
                return /MSIE|Trident/[_0x5d3cf7(0x3b4)](window[_0x5d3cf7(0x1b8)][_0x5d3cf7(0x2c5)]);
              }
              ["supportsWasm"]() {
                const _0x5c483b = _0x3074be;
                return _0x5c483b(0x52a) != typeof WebAssembly;
              }
              [_0x3074be(0x4a9)]() {
                const _0x167f56 = _0x3074be;
                try {
                  this["canvasForWebGLCheck"] = document[_0x167f56(0x506)](_0x167f56(0x5ca));
                  const _0x42a6f1 = !(
                    !_0x5847a0["g"][_0x167f56(0x228)] ||
                    (!this[_0x167f56(0x5c3)][_0x167f56(0x5c4)](_0x167f56(0x6fe)) &&
                      !this["canvasForWebGLCheck"][_0x167f56(0x5c4)](_0x167f56(0x5b0)))
                  );
                  return (this["canvasForWebGLCheck"] = null), _0x42a6f1;
                } catch (_0x130a69) {
                  return !0x1;
                }
              }
              [_0x3074be(0x2a1)]() {
                const _0x52961b = _0x3074be;
                try {
                  return void 0x0 !== navigator[_0x52961b(0x1e2)] && void 0x0 !== navigator[_0x52961b(0x1e2)][_0x52961b(0x324)];
                } catch (_0xc0d0e) {
                  return !0x1;
                }
              }
              [_0x3074be(0x29f)]() {
                return _0x4235ef(this, void 0x0, void 0x0, function* () {
                  const _0x211539 = a0_0x1b49;
                  try {
                    const _0x51468e = yield navigator[_0x211539(0x1e2)]["enumerateDevices"]();
                    return (
                      _0x51468e[_0x211539(0x25c)]((_0x155042) => _0x211539(0x41f) === _0x155042[_0x211539(0x313)])[_0x211539(0x5ab)] > 0x0
                    );
                  } catch (_0x591293) {
                    return !0x1;
                  }
                });
              }
              [_0x3074be(0x647)]() {
                return _0x4235ef(this, void 0x0, void 0x0, function* () {
                  const _0x194c50 = a0_0x1b49;
                  try {
                    const _0x3f9659 = yield navigator[_0x194c50(0x1e2)][_0x194c50(0x4a3)]();
                    return (
                      _0x3f9659[_0x194c50(0x25c)]((_0x48e547) => _0x194c50(0x41f) === _0x48e547[_0x194c50(0x313)]),
                      _0x3f9659[_0x194c50(0x5ab)] > 0x0
                    );
                  } catch (_0x494c92) {
                    return !0x1;
                  }
                });
              }
            })();
          },
        },
        _0x3f3347 = {};
      function _0xf3b81e(_0xc0eaae) {
        const _0x59d585 = a0_0x1b49;
        var _0x4c7bec = _0x3f3347[_0xc0eaae];
        if (void 0x0 !== _0x4c7bec) return _0x4c7bec[_0x59d585(0x4f7)];
        var _0x2c1e2f = (_0x3f3347[_0xc0eaae] = { id: _0xc0eaae, loaded: !0x1, exports: {} });
        return (
          _0x5ee5b8[_0xc0eaae](_0x2c1e2f, _0x2c1e2f[_0x59d585(0x4f7)], _0xf3b81e),
          (_0x2c1e2f[_0x59d585(0x4bf)] = !0x0),
          _0x2c1e2f[_0x59d585(0x4f7)]
        );
      }
      (_0xf3b81e["m"] = _0x5ee5b8),
        (_0xf3b81e["n"] = (_0x2b2b9b) => {
          const _0x4b73f9 = a0_0x1b49;
          var _0xcbc119 = _0x2b2b9b && _0x2b2b9b[_0x4b73f9(0x41d)] ? () => _0x2b2b9b[_0x4b73f9(0x4e4)] : () => _0x2b2b9b;
          return _0xf3b81e["d"](_0xcbc119, { a: _0xcbc119 }), _0xcbc119;
        }),
        (_0xd181eb = Object[_0x1cb34a(0x249)]
          ? (_0x3784cc) => Object[_0x1cb34a(0x249)](_0x3784cc)
          : (_0x46f02c) => _0x46f02c[_0x1cb34a(0x1f1)]),
        (_0xf3b81e["t"] = function (_0x9bdbf2, _0x5e6346) {
          const _0x4e257f = _0x1cb34a;
          if ((0x1 & _0x5e6346 && (_0x9bdbf2 = this(_0x9bdbf2)), 0x8 & _0x5e6346)) return _0x9bdbf2;
          if (_0x4e257f(0x6c1) == typeof _0x9bdbf2 && _0x9bdbf2) {
            if (0x4 & _0x5e6346 && _0x9bdbf2[_0x4e257f(0x41d)]) return _0x9bdbf2;
            if (0x10 & _0x5e6346 && _0x4e257f(0x2fc) == typeof _0x9bdbf2["then"]) return _0x9bdbf2;
          }
          var _0x38ac2c = Object["create"](null);
          _0xf3b81e["r"](_0x38ac2c);
          var _0x2af9e5 = {};
          _0x49de7c = _0x49de7c || [null, _0xd181eb({}), _0xd181eb([]), _0xd181eb(_0xd181eb)];
          for (
            var _0x28414f = 0x2 & _0x5e6346 && _0x9bdbf2;
            _0x4e257f(0x6c1) == typeof _0x28414f && !~_0x49de7c[_0x4e257f(0x6ba)](_0x28414f);
            _0x28414f = _0xd181eb(_0x28414f)
          )
            Object[_0x4e257f(0x4a1)](_0x28414f)[_0x4e257f(0x672)]((_0x1a94d7) => (_0x2af9e5[_0x1a94d7] = () => _0x9bdbf2[_0x1a94d7]));
          return (_0x2af9e5[_0x4e257f(0x4e4)] = () => _0x9bdbf2), _0xf3b81e["d"](_0x38ac2c, _0x2af9e5), _0x38ac2c;
        }),
        (_0xf3b81e["d"] = (_0x1ebed2, _0x1462a4) => {
          const _0x4d90b1 = _0x1cb34a;
          for (var _0x4a4afc in _0x1462a4)
            _0xf3b81e["o"](_0x1462a4, _0x4a4afc) &&
              !_0xf3b81e["o"](_0x1ebed2, _0x4a4afc) &&
              Object[_0x4d90b1(0x4cf)](_0x1ebed2, _0x4a4afc, { enumerable: !0x0, get: _0x1462a4[_0x4a4afc] });
        }),
        (_0xf3b81e["f"] = {}),
        (_0xf3b81e["e"] = (_0x2d9971) =>
          Promise["all"](
            Object[_0x1cb34a(0x426)](_0xf3b81e["f"])["reduce"](
              (_0x2687d8, _0x10a604) => (_0xf3b81e["f"][_0x10a604](_0x2d9971, _0x2687d8), _0x2687d8),
              []
            )
          )),
        (_0xf3b81e["u"] = (_0x4ee2ca) =>
          (({
            0x2e: _0x1cb34a(0x716),
            0xc0: _0x1cb34a(0x2ec),
            0xce: _0x1cb34a(0x4c2),
            0x123: _0x1cb34a(0x31b),
            0x196: _0x1cb34a(0x4e5),
            0x279: _0x1cb34a(0x5cb),
          }[_0x4ee2ca] || _0x4ee2ca) + _0x1cb34a(0x2d9))),
        (_0xf3b81e["g"] = (function () {
          const _0x184411 = _0x1cb34a;
          if (_0x184411(0x6c1) == typeof globalThis) return globalThis;
          try {
            return this || new Function(_0x184411(0x27e))();
          } catch (_0x28eaa7) {
            if (_0x184411(0x6c1) == typeof window) return window;
          }
        })()),
        (_0xf3b81e["hmd"] = (_0x3fa54d) => (
          (_0x3fa54d = Object[_0x1cb34a(0x3fe)](_0x3fa54d))[_0x1cb34a(0x55a)] || (_0x3fa54d[_0x1cb34a(0x55a)] = []),
          Object["defineProperty"](_0x3fa54d, _0x1cb34a(0x4f7), {
            enumerable: !0x0,
            set: () => {
              const _0x42da65 = _0x1cb34a;
              throw new Error(_0x42da65(0x638) + _0x3fa54d["id"]);
            },
          }),
          _0x3fa54d
        )),
        (_0xf3b81e["o"] = (_0x59282a, _0x452c1e) => Object[_0x1cb34a(0x2a8)][_0x1cb34a(0x5a9)]["call"](_0x59282a, _0x452c1e)),
        (_0x5dd476 = {}),
        (_0xf3b81e["l"] = (_0x18c9d4, _0x29b508, _0x2eda2f, _0x4a1ba8) => {
          const _0x4d646f = _0x1cb34a;
          if (_0x5dd476[_0x18c9d4]) _0x5dd476[_0x18c9d4][_0x4d646f(0x4a7)](_0x29b508);
          else {
            var _0x12339d, _0x158ef3;
            if (void 0x0 !== _0x2eda2f)
              for (
                var _0xcbc98d = document[_0x4d646f(0x59b)](_0x4d646f(0x5e4)), _0x30a904 = 0x0;
                _0x30a904 < _0xcbc98d[_0x4d646f(0x5ab)];
                _0x30a904++
              ) {
                var _0x2b25c0 = _0xcbc98d[_0x30a904];
                if (
                  _0x2b25c0[_0x4d646f(0x59e)](_0x4d646f(0x27c)) == _0x18c9d4 ||
                  _0x2b25c0[_0x4d646f(0x59e)](_0x4d646f(0x670)) == _0x4d646f(0x682) + _0x2eda2f
                ) {
                  _0x12339d = _0x2b25c0;
                  break;
                }
              }
            _0x12339d ||
              ((_0x158ef3 = !0x0),
              ((_0x12339d = document[_0x4d646f(0x506)](_0x4d646f(0x5e4)))["charset"] = _0x4d646f(0x209)),
              (_0x12339d[_0x4d646f(0x601)] = 0x78),
              _0xf3b81e["nc"] && _0x12339d["setAttribute"](_0x4d646f(0x1bb), _0xf3b81e["nc"]),
              _0x12339d[_0x4d646f(0x584)](_0x4d646f(0x670), "mitekScienceSDK:" + _0x2eda2f),
              (_0x12339d[_0x4d646f(0x27c)] = _0x18c9d4)),
              (_0x5dd476[_0x18c9d4] = [_0x29b508]);
            var _0x12217e = (_0x5c0191, _0x2385c2) => {
                const _0x35a4aa = _0x4d646f;
                (_0x12339d[_0x35a4aa(0x4be)] = _0x12339d[_0x35a4aa(0x507)] = null), clearTimeout(_0x50cecd);
                var _0x5cee8f = _0x5dd476[_0x18c9d4];
                if (
                  (delete _0x5dd476[_0x18c9d4],
                  _0x12339d[_0x35a4aa(0x2f7)] && _0x12339d["parentNode"][_0x35a4aa(0x213)](_0x12339d),
                  _0x5cee8f && _0x5cee8f[_0x35a4aa(0x672)]((_0x595612) => _0x595612(_0x2385c2)),
                  _0x5c0191)
                )
                  return _0x5c0191(_0x2385c2);
              },
              _0x50cecd = setTimeout(_0x12217e["bind"](null, void 0x0, { type: _0x4d646f(0x601), target: _0x12339d }), 0x1d4c0);
            (_0x12339d[_0x4d646f(0x4be)] = _0x12217e[_0x4d646f(0x23e)](null, _0x12339d[_0x4d646f(0x4be)])),
              (_0x12339d[_0x4d646f(0x507)] = _0x12217e[_0x4d646f(0x23e)](null, _0x12339d[_0x4d646f(0x507)])),
              _0x158ef3 && document[_0x4d646f(0x706)][_0x4d646f(0x625)](_0x12339d);
          }
        }),
        (_0xf3b81e["r"] = (_0x1d8732) => {
          const _0x3ca5a7 = _0x1cb34a;
          _0x3ca5a7(0x52a) != typeof Symbol &&
            Symbol[_0x3ca5a7(0x483)] &&
            Object[_0x3ca5a7(0x4cf)](_0x1d8732, Symbol[_0x3ca5a7(0x483)], { value: _0x3ca5a7(0x5b5) }),
            Object[_0x3ca5a7(0x4cf)](_0x1d8732, _0x3ca5a7(0x41d), { value: !0x0 });
        }),
        (() => {
          const _0x12c55d = _0x1cb34a;
          var _0x572c63;
          _0xf3b81e["g"]["importScripts"] && (_0x572c63 = _0xf3b81e["g"][_0x12c55d(0x3b3)] + "");
          var _0x2d1c81 = _0xf3b81e["g"][_0x12c55d(0x2c6)];
          if (
            !_0x572c63 &&
            _0x2d1c81 &&
            (_0x2d1c81[_0x12c55d(0x490)] && (_0x572c63 = _0x2d1c81[_0x12c55d(0x490)][_0x12c55d(0x27c)]), !_0x572c63)
          ) {
            var _0x4bd256 = _0x2d1c81[_0x12c55d(0x59b)]("script");
            if (_0x4bd256["length"]) {
              for (var _0x2f69e0 = _0x4bd256[_0x12c55d(0x5ab)] - 0x1; _0x2f69e0 > -0x1 && !_0x572c63; )
                _0x572c63 = _0x4bd256[_0x2f69e0--][_0x12c55d(0x27c)];
            }
          }
          if (!_0x572c63) throw new Error(_0x12c55d(0x5d9));
          (_0x572c63 = _0x572c63[_0x12c55d(0x6a5)](/#.*$/, "")
            [_0x12c55d(0x6a5)](/\?.*$/, "")
            [_0x12c55d(0x6a5)](/\/[^\/]+$/, "/")),
            (_0xf3b81e["p"] = _0x572c63 + "mitekSDK/");
        })(),
        (() => {
          const _0x8cd912 = _0x1cb34a;
          var _0x23af43 = { 0x8f: 0x0 };
          _0xf3b81e["f"]["j"] = (_0x4e0316, _0x396974) => {
            const _0x52d2ec = a0_0x1b49;
            var _0x1c7dee = _0xf3b81e["o"](_0x23af43, _0x4e0316) ? _0x23af43[_0x4e0316] : void 0x0;
            if (0x0 !== _0x1c7dee) {
              if (_0x1c7dee) _0x396974["push"](_0x1c7dee[0x2]);
              else {
                var _0x56d3d9 = new Promise((_0x4599c8, _0x26de59) => (_0x1c7dee = _0x23af43[_0x4e0316] = [_0x4599c8, _0x26de59]));
                _0x396974[_0x52d2ec(0x4a7)]((_0x1c7dee[0x2] = _0x56d3d9));
                var _0x48af39 = _0xf3b81e["p"] + _0xf3b81e["u"](_0x4e0316),
                  _0x4ab862 = new Error();
                _0xf3b81e["l"](
                  _0x48af39,
                  (_0x4afbe2) => {
                    const _0x43f187 = _0x52d2ec;
                    if (
                      _0xf3b81e["o"](_0x23af43, _0x4e0316) &&
                      (0x0 !== (_0x1c7dee = _0x23af43[_0x4e0316]) && (_0x23af43[_0x4e0316] = void 0x0), _0x1c7dee)
                    ) {
                      var _0x5ad4b6 =
                          _0x4afbe2 && (_0x43f187(0x660) === _0x4afbe2[_0x43f187(0x1f7)] ? "missing" : _0x4afbe2[_0x43f187(0x1f7)]),
                        _0xda6b2d = _0x4afbe2 && _0x4afbe2["target"] && _0x4afbe2["target"][_0x43f187(0x27c)];
                      (_0x4ab862[_0x43f187(0x22b)] =
                        _0x43f187(0x30d) + _0x4e0316 + "\x20failed.\x0a(" + _0x5ad4b6 + ":\x20" + _0xda6b2d + ")"),
                        (_0x4ab862["name"] = _0x43f187(0x355)),
                        (_0x4ab862["type"] = _0x5ad4b6),
                        (_0x4ab862[_0x43f187(0x5b8)] = _0xda6b2d),
                        _0x1c7dee[0x1](_0x4ab862);
                    }
                  },
                  _0x52d2ec(0x4ee) + _0x4e0316,
                  _0x4e0316
                );
              }
            }
          };
          var _0x4fb407 = (_0x45f2d4, _0x5ad0bc) => {
              const _0x5f0591 = a0_0x1b49;
              var _0x684085,
                _0x1e65b8,
                [_0x4a7e8d, _0x10994e, _0x566505] = _0x5ad0bc,
                _0x2113e5 = 0x0;
              if (_0x4a7e8d[_0x5f0591(0x5a2)]((_0x37eb2c) => 0x0 !== _0x23af43[_0x37eb2c])) {
                for (_0x684085 in _0x10994e) _0xf3b81e["o"](_0x10994e, _0x684085) && (_0xf3b81e["m"][_0x684085] = _0x10994e[_0x684085]);
                if (_0x566505) _0x566505(_0xf3b81e);
              }
              for (_0x45f2d4 && _0x45f2d4(_0x5ad0bc); _0x2113e5 < _0x4a7e8d[_0x5f0591(0x5ab)]; _0x2113e5++)
                (_0x1e65b8 = _0x4a7e8d[_0x2113e5]),
                  _0xf3b81e["o"](_0x23af43, _0x1e65b8) && _0x23af43[_0x1e65b8] && _0x23af43[_0x1e65b8][0x0](),
                  (_0x23af43[_0x1e65b8] = 0x0);
            },
            _0x33cd91 = (window[_0x8cd912(0x31d)] = window[_0x8cd912(0x31d)] || []);
          _0x33cd91[_0x8cd912(0x672)](_0x4fb407[_0x8cd912(0x23e)](null, 0x0)),
            (_0x33cd91[_0x8cd912(0x4a7)] = _0x4fb407[_0x8cd912(0x23e)](null, _0x33cd91["push"]["bind"](_0x33cd91)));
        })();
      var _0x500c9b = {};
      return (
        (() => {
          const _0x154348 = _0x1cb34a;
          _0xf3b81e["r"](_0x500c9b),
            _0xf3b81e["d"](_0x500c9b, { __gli__: () => _0x4b82ab, cmd: () => _0x1631b7, getVersion: () => _0x28144a, on: () => _0x1c82ab });
          var _0xaccdee = _0xf3b81e(0x127),
            _0x18df44 = _0xf3b81e(0x2e4),
            _0x299ddb = _0xf3b81e(0x141),
            _0x19aff6 = function (_0x13a37a, _0x20cd2c, _0x4abeec, _0x3a5559) {
              return new (_0x4abeec || (_0x4abeec = Promise))(function (_0x1aa3d9, _0x3d9876) {
                const _0x4ed525 = a0_0x1b49;
                function _0x4b36e3(_0x281a43) {
                  const _0x118434 = a0_0x1b49;
                  try {
                    _0x400ad9(_0x3a5559[_0x118434(0x3e1)](_0x281a43));
                  } catch (_0x43cf13) {
                    _0x3d9876(_0x43cf13);
                  }
                }
                function _0x3f95fb(_0xc82ea7) {
                  const _0x1b51c6 = a0_0x1b49;
                  try {
                    _0x400ad9(_0x3a5559[_0x1b51c6(0x3b2)](_0xc82ea7));
                  } catch (_0xa128f) {
                    _0x3d9876(_0xa128f);
                  }
                }
                function _0x400ad9(_0x115b0d) {
                  const _0x88cd24 = a0_0x1b49;
                  var _0x3b9f17;
                  _0x115b0d[_0x88cd24(0x4f5)]
                    ? _0x1aa3d9(_0x115b0d[_0x88cd24(0x331)])
                    : ((_0x3b9f17 = _0x115b0d[_0x88cd24(0x331)]),
                      _0x3b9f17 instanceof _0x4abeec
                        ? _0x3b9f17
                        : new _0x4abeec(function (_0x47ca20) {
                            _0x47ca20(_0x3b9f17);
                          }))[_0x88cd24(0x429)](_0x4b36e3, _0x3f95fb);
                }
                _0x400ad9((_0x3a5559 = _0x3a5559[_0x4ed525(0x1d1)](_0x13a37a, _0x20cd2c || []))[_0x4ed525(0x3e1)]());
              });
            };
          const _0x27bb7d = new (class {
            constructor() {
              const _0x2ec916 = a0_0x1b49;
              (this[_0x2ec916(0x1d9)] = _0x2ec916(0x536)), (this[_0x2ec916(0x2be)] = _0x2ec916(0x5d4));
            }
            ["on"](_0x5054ee, _0xbf8fb8) {
              const _0x2b513a = a0_0x1b49;
              return _0x299ddb["Z"][_0x2b513a(0x3ca)](_0x5054ee) && _0x299ddb["Z"]["ValidateOnCallbackIsFunction"](_0xbf8fb8)
                ? (_0xaccdee["Z"][_0x2b513a(0x3b5)](_0x5054ee, _0xbf8fb8), _0x2b513a(0x2e2) + _0x5054ee)
                : (_0xaccdee["Z"]["handleDirectSdkErrorToIntegrator"]("VALIDATOR_BAD_COMMAND_OPTIONS_VALUE_OR_TYPE"),
                  _0x2b513a(0x5c9) + _0x5054ee);
            }
            [_0x154348(0x53b)](_0x3c47c3, _0x3d7d80) {
              return _0x19aff6(this, void 0x0, void 0x0, function* () {
                const _0x4c33c7 = a0_0x1b49;
                let _0xa4e4c6 = !0x0;
                try {
                  if (
                    (_0x299ddb["Z"][_0x4c33c7(0x2aa)](_0x3c47c3) ||
                      (_0xaccdee["Z"]["handleDirectSdkErrorToIntegrator"](_0x4c33c7(0x676)), (_0xa4e4c6 = !0x1)),
                    _0x18df44["Z"][_0x4c33c7(0x441)]["includes"](_0x3c47c3))
                  ) {
                    const _0x382ce1 = yield _0x299ddb["Z"]["ivl"](_0x3d7d80);
                    _0x382ce1[_0x4c33c7(0x28d)] &&
                      _0x382ce1[_0x4c33c7(0x51a)] &&
                      (_0xaccdee["Z"]["handleDirectSdkErrorToIntegrator"](_0x382ce1[_0x4c33c7(0x51a)]), (_0xa4e4c6 = !0x1));
                  }
                  _0xa4e4c6 && _0xaccdee["Z"][_0x4c33c7(0x53b)](_0x3c47c3, _0x3d7d80);
                } catch (_0x45e5c2) {
                  _0xaccdee["Z"][_0x4c33c7(0x29e)](_0x4c33c7(0x654));
                }
              });
            }
            [_0x154348(0x48b)]() {
              const _0x1fef97 = _0x154348;
              return _0x1fef97(0x350);
            }
            [_0x154348(0x498)]() {
              const _0x2d0b3e = _0x154348;
              try {
                return {
                  a: _0x18df44["Z"]["_0xDA857"],
                  b: _0x18df44["Z"][_0x2d0b3e(0x20a)],
                  c: _0x18df44["Z"][_0x2d0b3e(0x5d7)],
                  d: _0x18df44["Z"][_0x2d0b3e(0x67a)],
                };
              } catch (_0x3e99ab) {
                return {};
              }
            }
          })();
          function _0x1c82ab(_0xc28c41, _0x509744) {
            return _0x27bb7d["on"](_0xc28c41, _0x509744);
          }
          function _0x1631b7(_0x272b24, _0x44829a) {
            const _0x466939 = _0x154348;
            return _0x27bb7d[_0x466939(0x53b)](_0x272b24, _0x44829a);
          }
          function _0x28144a() {
            const _0x178fb2 = _0x154348;
            return _0x27bb7d[_0x178fb2(0x48b)]();
          }
          function _0x4b82ab() {
            const _0x29f9b3 = _0x154348;
            return _0x27bb7d[_0x29f9b3(0x498)]();
          }
        })(),
        _0x500c9b
      );
    })()
  );
